/*!
 * @maptalks/reshader.gl v0.107.4
 * LICENSE : UNLICENSED
 * (c) 2016-2025 maptalks.com
 */
import { mat4 as e, vec3 as t, vec4 as n, mat3 as r, vec2 as i, quat as o } from "gl-matrix";

export { glMatrix, mat2, mat2d, mat3, mat4, quat, quat2, vec2, vec3, vec4 } from "gl-matrix";

import { buildTangents as a, packTangentFrame as s, buildNormals as c } from "@maptalks/tbn-packer";

const l = function() {
    if ("undefined" != typeof globalThis) return globalThis;
    if ("undefined" != typeof self) return self;
    if ("undefined" != typeof window) return window;
    if ("undefined" != typeof global) return global;
    throw new Error("unable to locate global object");
};

function f() {
    return l().maptalks_gltf_loader;
}

function d(e) {
    return !u(e) && ("string" == typeof e || null !== e.constructor && e.constructor === String);
}

function u(e) {
    return null == e;
}

function h(e) {
    return !u(e);
}

function m(e) {
    return !u(e) && ("function" == typeof e || null !== e.constructor && e.constructor === Function);
}

function v(e, ...t) {
    return Object.assign(e, ...t), e;
}

function _(e, ...t) {
    for (let n = 0; n < t.length; n++) {
        const r = t[n];
        for (const t in r) null != r[t] && (e[t] = r[t]);
    }
    return e;
}

function g(e) {
    return "number" == typeof e && !isNaN(e);
}

function x(e, t, n) {
    return e * (1 - n) + t * n;
}

function p(e) {
    return Array.isArray(e) || e instanceof Uint8Array || e instanceof Int8Array || e instanceof Uint16Array || e instanceof Int16Array || e instanceof Uint32Array || e instanceof Int32Array || e instanceof Uint8ClampedArray || e instanceof Float32Array || e instanceof Float64Array;
}

function b(e) {
    return (e = Math.abs(e)) < 128 ? Int8Array : e < 32768 ? Int16Array : Float32Array;
}

function y(e, t, n) {
    return Math.min(n, Math.max(t, e));
}

function A(e) {
    return e && e.hasExtension("oes_vertex_array_object");
}

function S(e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
}

function T(e) {
    if (e.data) {
        if (e.data.BYTES_PER_ELEMENT) return e.data.length * e.data.BYTES_PER_ELEMENT;
        if (e.data.length) return 4 * e.data.length;
    } else {
        if (e.BYTES_PER_ELEMENT) return e.length * e.BYTES_PER_ELEMENT;
        if (e.length) return 4 * e.length;
        if (e.buffer && e.buffer.destroy) return e.buffer._buffer.byteLength;
    }
    return 0;
}

function M(e) {
    return e.width * e.height * C(e.format) * O(e.type) * ("textureCube" === e._reglType ? 6 : 1);
}

function O(e) {
    return "uint8" === e ? 1 : "uint16" === e || "float16" === e || "half float" === e ? 2 : "uint32" === e || "float" === e || "float32" === e ? 4 : 0;
}

function C(e) {
    return "depth" === e || "alpha" === e || "luminance" === e ? 1 : "luminance alpha" === e || "depth stencil" === e ? 2 : "srgba" === e || "rgb5 a1" === e || "rgba" === e.substring(0, 4) ? 4 : "srgb" === e || "rgb" === e.substring(0, 3) ? 3 : 1;
}

function E(e) {
    if (!e.componentType) return !1;
    const t = f().GLTFLoader.getTypedArrayCtor(e.componentType);
    return e.byteStride > 0 && e.byteStride !== e.itemSize * t.BYTES_PER_ELEMENT;
}

function P(e) {
    return e && (e.stride > 0 || E(e));
}

function w(e) {
    let t = 0;
    const n = e && e.length || 0;
    if (!n) return t;
    let r;
    for (let i = 0; i < n; i++) r = e.charCodeAt(i), t = (t << 5) - t + r, t |= 0;
    return t;
}

function I(e) {
    return !(e & e - 1) && 0 !== e;
}

function R(e) {
    return Math.pow(2, Math.floor(Math.log(e) / Math.LN2));
}

function D(e, t, n) {
    if (p(e)) return I(t) && I(n) ? e : function(e, t, n) {
        let r = t, i = n;
        I(t) || (r = R(t)), I(n) || (i = R(n));
        const o = new ImageData(new Uint8ClampedArray(e), t, n), a = document.createElement("canvas");
        a.width = t, a.height = n, a.getContext("2d").putImageData(o, 0, 0);
        const s = document.createElement("canvas");
        s.width = r, s.height = i, s.getContext("2d").drawImage(a, 0, 0, t, n, 0, 0, i, i), 
        console.warn(`Texture's size is not power of two, resize from (${t}, ${n}) to (${r}, ${i})`);
        let c = document.getElementById("_debug_resize_canvas");
        return c || (c = document.createElement("canvas"), c.id = "_debug_resize_canvas", 
        document.body.appendChild(c)), c.width = r, c.height = i, c.getContext("2d").drawImage(s, 0, 0), 
        s;
    }(e, t, n);
    if (I(e.width) && I(e.height)) return e;
    n = e.height, I(t = e.width) || (t = R(t)), I(n) || (n = R(n));
    const r = document.createElement("canvas");
    r.width = t, r.height = n, r.getContext("2d").drawImage(e, 0, 0, t, n);
    const i = e.src, o = i.lastIndexOf("/") + 1, a = i.substring(o);
    return console.warn(`Texture(${a})'s size is not power of two, resize from (${e.width}, ${e.height}) to (${t}, ${n})`), 
    r;
}

function H(e) {
    return e._gl instanceof WebGL2RenderingContext;
}

var F = Object.freeze({
    __proto__: null,
    clamp: y,
    defined: h,
    extend: v,
    extendWithoutNil: _,
    getBufferSize: T,
    getPosArrayType: b,
    getSupportedFormats: function(e) {
        return {
            etc: !!e.getExtension("WEBGL_compressed_texture_etc"),
            etc1: !!e.getExtension("WEBGL_compressed_texture_etc1"),
            s3tc: !!e.getExtension("WEBGL_compressed_texture_s3tc"),
            pvrtc: !!e.getExtension("WEBGL_compressed_texture_pvrtc"),
            astc: !!e.getExtension("WEBGL_compressed_texture_astc"),
            bc7: !!e.getExtension("EXT_texture_compression_bptc")
        };
    },
    getTexMemorySize: M,
    getTextureByteWidth: O,
    getTextureChannels: C,
    hasOwn: S,
    hashCode: w,
    interpolate: x,
    isArray: p,
    isFunction: m,
    isInStride: E,
    isInterleaved: P,
    isNil: u,
    isNumber: g,
    isPowerOfTwo: I,
    isString: d,
    isSupportVAO: A,
    isTextureDestroyed: function(e) {
        return !e._texture || !e._texture.texture;
    },
    lerp: function(e, t, n, r) {
        for (let i = 0; i < e.length; i++) e[i] = t[i] + r * (n[i] - t[i]);
        return e;
    },
    log2: function(e) {
        return Math.log2(e);
    },
    normalize: function(e, t) {
        let n = 0;
        for (let e = 0, r = t.length; e < r; e++) n += t[e];
        for (let r = 0, i = t.length; r < i; r++) e[r] = t[r] / n;
        return e;
    },
    resizeToPowerOfTwo: D,
    set: function(e, t) {
        for (let n = 0; n < e.length; n++) e[n] = t[n];
        return e;
    },
    supportNPOT: H
});

function N(e) {
    return class extends e {
        on(e, t) {
            return this._events || (this._events = {
                type: [ t ]
            }), this._events[e] = this._events[e] || [], this._events[e].push(t), this;
        }
        once(e, t) {
            return this.on(e, this._wrapOnce(e, t));
        }
        off(e, t) {
            return this._events && this._events[e] ? (this._events[e].splice(this._events[e].indexOf(t), 1), 
            this) : this;
        }
        fire(e, t = {}) {
            if (!this._events || !this._events[e]) return this;
            t.target || (t.target = this);
            const n = this._events[e].slice(0);
            for (const e of n) e(t);
            return this;
        }
        _wrapOnce(e, t) {
            const n = this;
            let r = !1;
            return function i(o) {
                r || (r = !0, t(o), n.off(e, i));
            };
        }
    };
}

const L = "__reshader_disposed";

var k = Object.freeze({
    __proto__: null,
    KEY_DISPOSED: L,
    WEBGL_EXTENSIONS: [ "ANGLE_instanced_arrays", "OES_element_index_uint", "OES_standard_derivatives" ],
    WEBGL_OPTIONAL_EXTENSIONS: [ "OES_vertex_array_object", "OES_texture_half_float", "OES_texture_half_float_linear", "OES_texture_float", "OES_texture_float_linear", "WEBGL_depth_texture", "EXT_shader_texture_lod", "EXT_texture_filter_anisotropic" ]
});

const B = "_reshader_refCount";

let z = class {};

class G extends(N(z)){
    constructor(e, t) {
        if (super(), m(e)) {
            this._texture = e, e = this.config = {};
            for (const t in this._texture) S(this._texture, t) && (m(this._texture[t]) || (e[t] = this._texture[t]));
        } else if (this.config = e || {}, this.resLoader = t, (e.url || e.promise) && !e.data) {
            this._loading = !0;
            const n = this;
            let r;
            if (e.promise) r = e.promise; else {
                let n;
                n = e.arrayBuffer ? t.getArrayBuffer : t.get, r = n.call(t, e.url);
            }
            e.data = t.getDefaultTexture(e.url), this.promise = r, r.then((e => (delete this.promise, 
            n._loading = !1, n.config ? (n.onLoad(e), Array.isArray(e) || (e = [ e ]), n.fire("complete", {
                target: this,
                resources: e
            }), e) : e))).catch((e => {
                console.error("error when loading texture image.", e), n.fire("error", {
                    target: this,
                    error: e
                });
            }));
        }
    }
    onLoad(e) {}
    isReady() {
        return !this._loading;
    }
    set(e, t) {
        return this.config[e] = t, this.dirty = !0, this;
    }
    get(e) {
        return this.config[e];
    }
    createREGLTexture(e) {
        return null;
    }
    getREGLTexture(e) {
        return this._texture || (this._texture = this.createREGLTexture(e), this.config.persistent || (this.config.data && (this.config.data instanceof ImageBitmap || (this.config.data = [])), 
        this.config.image && (this.config.image.array = []), this.config.mipmap && delete this.config.mipmap)), 
        this.dirty && this._updateREGL(), this._texture;
    }
    getMemorySize() {
        if (!this.config) return 0;
        const {width: e, height: t, type: n, format: r} = this.config;
        return e * t * O(n || "uint8") * C(r || "rgba");
    }
    _updateREGL() {
        this._texture && !this._texture[L] && this._texture(this.config), this.dirty = !1;
    }
    dispose() {
        this.config && this.config.url && (URL.revokeObjectURL(this.config.url), this.resLoader.disposeRes(this.config.url)), 
        this.config && this.config.data instanceof ImageBitmap && (this.config.data.close(), 
        this.config.data = []), this._texture && !this._texture[L] && (this._texture[B] && this._texture[B]--, 
        this._texture[B] || (this._texture.destroy(), this._texture[L] = !0, delete this._texture)), 
        delete this.resLoader, delete this._regl;
        const e = this.config && this.config.url;
        delete this.config, e && this.fire("disposed", {
            target: this,
            url: e
        });
    }
    _needPowerOf2(e) {
        if (H(e)) return !1;
        const t = this.config;
        return t.wrap && "clamp" !== t.wrap || t.wrapS && "clamp" !== t.wrapS || t.wrapT && "clamp" !== t.wrapT || t.min && "nearest" !== t.min && "linear" !== t.min;
    }
}

const V = e.identity([]), U = e.identity([]);

class j {
    constructor(e, t) {
        this.min = e || [ 1 / 0, 1 / 0, 1 / 0 ], this.max = t || [ -1 / 0, -1 / 0, -1 / 0 ], 
        this.updateVertex();
    }
    static copy(e, n) {
        t.copy(e.min, n.min), t.copy(e.max, n.max);
        for (let r = 0; r < n.vertex.length; r++) t.copy(e.vertex[r], n.vertex[r]);
        return e;
    }
    combine(e) {
        if (!e) return this;
        let t, n;
        return Array.isArray(e) ? (t = e[0], n = e[1]) : (t = e.min, n = e.max), t[0] < this.min[0] && (this.min[0] = t[0], 
        this._dirty = !0), t[1] < this.min[1] && (this.min[1] = t[1], this._dirty = !0), 
        t[2] < this.min[2] && (this.min[2] = t[2], this._dirty = !0), n[0] > this.max[0] && (this.max[0] = n[0], 
        this._dirty = !0), n[1] > this.max[1] && (this.max[1] = n[1], this._dirty = !0), 
        n[2] > this.max[2] && (this.max[2] = n[2], this._dirty = !0), this;
    }
    dirty() {
        return this._dirty = !0, this;
    }
    getCenter() {
        return this.center || (this.center = [ 0, 0, 0 ], this._dirty = !0), this._dirty && (t.add(this.center, this.min, this.max), 
        t.scale(this.center, this.center, .5)), this._dirty = !1, this.center;
    }
    containPoint(e) {
        const t = this.min, n = this.max;
        return t[0] <= e[0] && t[1] <= e[1] && t[2] <= e[2] && n[0] >= e[0] && n[1] >= e[1] && n[2] >= e[2];
    }
    isFinite() {
        const e = this.min, t = this.max;
        return isFinite(e[0]) && isFinite(e[1]) && isFinite(e[2]) && isFinite(t[0]) && isFinite(t[1]) && isFinite(t[2]);
    }
    updateVertex() {
        if (!this.vertex) {
            this.vertex = [];
            for (let e = 0; e < 8; e++) this.vertex.push([ 0, 0, 0 ]);
        }
        return this.vertex[0][0] = this.min[0], this.vertex[0][1] = this.min[1], this.vertex[0][2] = this.min[2], 
        this.vertex[1][0] = this.min[0], this.vertex[1][1] = this.min[1], this.vertex[1][2] = this.max[2], 
        this.vertex[2][0] = this.min[0], this.vertex[2][1] = this.max[1], this.vertex[2][2] = this.max[2], 
        this.vertex[3][0] = this.min[0], this.vertex[3][1] = this.max[1], this.vertex[3][2] = this.min[2], 
        this.vertex[4][0] = this.max[0], this.vertex[4][1] = this.min[1], this.vertex[4][2] = this.min[2], 
        this.vertex[5][0] = this.max[0], this.vertex[5][1] = this.min[1], this.vertex[5][2] = this.max[2], 
        this.vertex[6][0] = this.max[0], this.vertex[6][1] = this.max[1], this.vertex[6][2] = this.max[2], 
        this.vertex[7][0] = this.max[0], this.vertex[7][1] = this.max[1], this.vertex[7][2] = this.min[2], 
        this.vertex;
    }
    copy(e) {
        return e ? j.copy(e, this) : new j(this.min.slice(), this.max.slice());
    }
    equals(e) {
        if (!t.equals(this.min, e.min) || !t.equals(this.max, e.max)) return !1;
        const n = e.vertex;
        for (let e = 0; e < this.vertex.length; e++) if (!t.equals(n[e], this.vertex[e])) return !1;
        return !0;
    }
    transform(n, r) {
        if (n = n || U, (r = r || U)[1] || r[2] || r[4] || r[6] || r[8] || r[9]) {
            const i = this.vertex, o = e.multiply(V, r, n);
            for (let e = 0; e < i.length; e++) t.transformMat4(this.vertex[e], this.vertex[e], o);
            const a = this.vertex.map((e => e[0])), s = this.vertex.map((e => e[1])), c = this.vertex.map((e => e[2])), l = Math.min(...a), f = Math.max(...a), d = Math.min(...s), u = Math.max(...s), h = Math.min(...c), m = Math.max(...c);
            t.set(this.min, l, d, h), t.set(this.max, f, u, m);
        } else {
            const i = e.multiply(V, r, n);
            t.transformMat4(this.min, this.min, i), t.transformMat4(this.max, this.max, i);
        }
        return this;
    }
}

const X = [], W = {
    5120: "int8",
    5122: "int16",
    5124: "int32",
    5121: "uint8",
    5123: "uint16",
    5125: "uint32",
    5126: "float"
}, q = {
    5120: 1,
    5122: 2,
    5124: 4,
    5121: 1,
    5123: 2,
    5125: 4,
    5126: 4
}, K = {
    positionSize: 3,
    primitive: "triangles",
    positionAttribute: "aPosition",
    normalAttribute: "aNormal",
    uv0Attribute: "aTexCoord",
    uv1Attribute: "aTexCoord1",
    color0Attribute: "aColor0",
    tangentAttribute: "aTangent",
    pickingIdAttribute: "aPickingId",
    textureCoordMatrixAttribute: "aTextureCoordMatrix"
};

let J = 1;

const Y = "_reshader_refCount";

class Z {
    constructor(e, t, n, r) {
        this._version = 0, this.data = e, this.elements = t, this.desc = v({}, K, r);
        const i = this._getPosAttritute();
        this.data[this.desc.positionAttribute] = i, n || (this.elements ? n = $(this.elements) : i && i.length ? n = i.length / this.desc.positionSize : i && i.interleavedArray ? n = i.interleavedArray.length / this.desc.positionSize : i && i.array && (n = i.array.length / this.desc.positionSize)), 
        this.count = n, this.elements || (this.elements = n), this.properties = {}, this._buffers = {}, 
        this._vao = {}, this.getVertexCount(), this._prepareData(!0), this.updateBoundingBox();
    }
    set version(e) {
        throw new Error("Geometry.version is read only.");
    }
    get version() {
        return this._version;
    }
    _getPosAttritute() {
        return this.data[this.desc.positionAttribute];
    }
    _prepareData(e) {
        if (!this.data) return;
        const t = this._buffers || {};
        for (const n in this.data) {
            const r = this.data[n];
            if (r) if (r.buffer && r.buffer.destroy) {
                const t = r.buffer;
                t[Y] || (t[Y] = 0), e && t[Y]++;
            } else if (r && r.array) if (E(r)) {
                let e = r.array.buffer.__id;
                e || (e = r.array.buffer.__id = J++), this.data[n] = {
                    buffer: e,
                    offset: r.byteOffset,
                    stride: r.byteStride,
                    type: W[r.componentType],
                    size: r.itemSize,
                    count: r.count,
                    componentType: r.componentType
                }, t[e] || (t[e] = {
                    data: r.array.buffer
                });
            } else this.data[n] = r.array;
        }
        this._buffers = t;
        const n = this.elements;
        n && n.array && (this.elements = n.array);
    }
    getAttrData(e) {
        const t = e.key, n = !this._reglData || !this._reglData[t];
        if (this._reglData || (this._reglData = {}), n) {
            const e = this._reglData[t] = {}, n = this.data, {positionAttribute: r, normalAttribute: i, uv0Attribute: o, uv1Attribute: a, tangentAttribute: s, color0Attribute: c, pickingIdAttribute: l, textureCoordMatrixAttribute: f} = this.desc;
            v(e, this.data), e.aPosition = n[r], n[i] && (e.aNormal = n[i]), n[o] && (e.aTexCoord = n[o]), 
            n[a] && (e.aTexCoord1 = n[a]), n[s] && (e.aTangent = n[s]), n[c] && (e.aColor0 = n[c]), 
            n[l] && (e.aPickingId = n[l]), n[f] && (e.aTextureCoordMatrix = n[f]);
        }
        return this._reglData[t];
    }
    getREGLData(e, t, n) {
        this.getAttrData(t);
        const r = !this._reglData || !this._reglData[t.key];
        if (A(e) && !n) {
            const n = t && t.key || "default";
            if (!this._vao[n] || r || this._vao[n].dirty) {
                const r = this._reglData[t.key], i = this._vertexCount, o = [];
                for (let e = 0; e < t.length; e++) {
                    const n = t[e].name, a = r[n] && r[n].buffer;
                    if (a && a.destroy) o.push(void 0 !== r[n].stride ? r[n] : a); else {
                        const e = r[n];
                        if (!e) {
                            o.push(this.desc.fillEmptyDataInMissingAttribute ? new Uint8Array(4 * i) : X);
                            continue;
                        }
                        const t = (e.data && p(e.data) ? e.data.length : e.length) / i;
                        e.data ? (e.dimension = t, o.push(e)) : o.push({
                            data: e,
                            dimension: t
                        });
                    }
                }
                const a = {
                    attributes: o,
                    primitive: this.getPrimitive()
                };
                if (this.elements && !g(this.elements)) if (this.elements.destroy) a.elements = this.elements; else {
                    a.elements = {
                        primitive: this.getPrimitive(),
                        data: this.elements
                    };
                    const e = this.getElementsType(this.elements);
                    e && (a.elements.type = e);
                }
                this._vao[n] ? this._vao[n].vao(a) : this._vao[n] = {
                    vao: e.vao(a)
                };
            }
            return delete this._vao[n].dirty, this._vao[n];
        }
        return this._reglData[t.key];
    }
    _isAttrChanged(e) {
        if (e === this._activeAttributes) return !1;
        if (e.length !== this._activeAttributes.length) return !0;
        for (let t = 0; t < e.length; t++) if (e[t] !== this._activeAttributes[t]) return !0;
        return !1;
    }
    generateBuffers(e) {
        const t = this._buffers;
        for (const n in t) t[n].buffer || (t[n].buffer = e.buffer(t[n].data)), delete t[n].data;
        const n = this.desc.positionAttribute, r = this.desc.altitudeAttribute, i = this.data, o = this._vertexCount, a = {};
        for (const s in i) if (i[s]) {
            if (void 0 === i[s].buffer || i[s].buffer instanceof ArrayBuffer) {
                const t = i[s].data ? i[s] : {
                    data: i[s]
                };
                t.dimension = (i[s].data ? i[s].data : i[s]).length / o;
                const c = e.buffer(t);
                c[Y] = 1, a[s] = {
                    buffer: c
                }, s !== n && s !== r || (a[s].array = i[s]);
            } else i[s].buffer.destroy ? a[s] = i[s] : t[i[s].buffer] && (a[s] = v({}, i[s]), 
            a[s].buffer = t[i[s].buffer].buffer);
            (this.desc.static || s !== n) && delete i[s].array;
        }
        if (this.data = a, delete this._reglData, this.elements && !g(this.elements)) {
            const t = {
                primitive: this.getPrimitive(),
                data: this.elements
            }, n = this.getElementsType(this.elements);
            if (n && (t.type = n), !this.desc.static && !this.elements.destroy) {
                const e = this.elements;
                this.indices = new Uint16Array(e.length);
                for (let t = 0; t < e.length; t++) this.indices[t] = e[t];
            }
            this.elements = this.elements.destroy ? this.elements : e.elements(t);
            const r = this.elements;
            r[Y] || (r[Y] = 0), r[Y]++;
        }
    }
    getVertexCount() {
        const {positionAttribute: e, positionSize: t, color0Attribute: n} = this.desc;
        let r = this.data[e];
        r.data && (r = r.data), r.array && (r = r.array), p(r) ? this._vertexCount = Math.ceil(r.length / t) : r && void 0 !== r.count && (this._vertexCount = r.count);
        const i = n;
        if (this.data[i]) {
            const e = this.data[i].data || this.data[i].array || this.data[i];
            Array.isArray(e) ? this._color0Size = e.length / this._vertexCount : e && e.count ? this._color0Size = e.count / this._vertexCount : this.data[i].buffer && this.data[i].buffer.destroy && (this._color0Size = this.data[i].buffer._buffer.dimension);
        }
        return this._vertexCount;
    }
    getColor0Size() {
        return this._color0Size || 0;
    }
    addBuffer(e, t) {
        return this._buffers[e] = {
            data: t
        }, delete this._reglData, this._deleteVAO(), this;
    }
    updateBuffer(e, t) {
        if (!this._buffers[e]) throw new Error(`invalid buffer ${e} in geometry`);
        return this._buffers[e].buffer ? this._buffers[e].buffer.subdata(t) : this._buffers[e].data = t, 
        delete this._reglData, this._deleteVAO(), this;
    }
    deleteData(e) {
        const t = this.data[e];
        return t ? (this._incrVersion(), t.buffer && t.buffer.destroy && t.buffer.destroy(), 
        delete this.data[e], delete this._reglData, this._markVAODirty(!1), this) : this;
    }
    updateData(e, t) {
        const n = this.data[e];
        if (!n) return this;
        let r;
        return this._incrVersion(), this.data[e] = t, n.buffer && n.buffer.destroy && (r = n), 
        e === this.desc.positionAttribute && this.updateBoundingBox(), this.getVertexCount(), 
        r && (r.buffer(t), this.data[e] = r), this._prepareData(!1), this.desc.positionAttribute === e && (this._posDirty = !0), 
        delete this._reglData, this;
    }
    updateSubData(e, t, n) {
        const r = this.data[e];
        if (!r) return this;
        let i;
        if (this._incrVersion(), r.buffer && r.buffer.destroy && (i = r), e === this.desc.positionAttribute && this._updateSubBoundingBox(t), 
        i) {
            const e = q[i.buffer._buffer.dtype];
            if (t.BYTES_PER_ELEMENT !== e) {
                const n = function(e, t) {
                    if (e instanceof Uint8Array || e instanceof Uint16Array || e instanceof Uint32Array || e instanceof Uint8ClampedArray) return 1 === t ? Uint8Array : 2 === t ? Uint16Array : Uint32Array;
                    if (e instanceof Int8Array || e instanceof Int16Array || e instanceof Int32Array) return 1 === t ? Int8Array : 2 === t ? Int16Array : Int32Array;
                    if (e instanceof Float32Array || e instanceof Float64Array) return 4 === t ? Float32Array : Float64Array;
                    return null;
                }(t, e);
                t = new n(t);
            }
            i.buffer.subdata(t, n * e);
        } else {
            const r = this.data[e].data ? this.data[e].data : this.data[e];
            for (let e = 0; e < t.length; e++) r[n + e] = t[e];
        }
        return this._prepareData(!1), this.desc.positionAttribute === e && (this._posDirty = !0), 
        delete this._reglData, this;
    }
    getPrimitive() {
        return this.desc.primitive;
    }
    getElements() {
        return this.elements;
    }
    setElements(e, t) {
        if (!e) throw new Error("elements data is invalid");
        this._incrVersion();
        const n = this.elements;
        return this.count = void 0 === t ? $(e) : t, this.elements = e && e.destroy ? e : n.destroy ? n(e) : e, 
        this._markVAODirty(!0), this;
    }
    deleteElements() {
        return this.elements && 0 !== this.elements.length ? (this._incrVersion(), this.elements && this.elements.destroy && !this.elements[L] && (this.elements.destroy(), 
        this.elements[L] = 1), this.elements = [], this._markVAODirty(!0), this) : this;
    }
    _markVAODirty(e) {
        if (this._vao) {
            for (const t in this._vao) e ? this._vao[t].vao.destroy() : this._vao[t].dirty = !0;
            e && (this._vao = {});
        }
    }
    setDrawCount(e) {
        return this._incrVersion(), this.count1 = e, this;
    }
    getDrawCount() {
        return this.count1 >= 0 ? this.count1 : this.count;
    }
    setDrawOffset(e) {
        return this._incrVersion(), this.offset = e, this;
    }
    getDrawOffset() {
        return this.offset || 0;
    }
    dispose() {
        if (this._deleteVAO(), this._forEachBuffer((e => {
            if (!e[L]) {
                let t = e[Y];
                t && t--, t <= 0 ? (e[L] = !0, e.destroy()) : e[Y] = t;
            }
        })), this.properties) {
            const e = this.properties.oldElementsBeforeHighlight;
            e && !e[L] && e.destroy && (e.destroy(), e[L] = !0), delete this.properties.oldElementsBeforeHighlight, 
            delete this.properties.hasInvisible;
        }
        this.data = {}, this._buffers = {}, delete this._reglData, this.count = 0, this.elements = [], 
        delete this._tempPosArray, this._disposed = !0;
    }
    isDisposed() {
        return !!this._disposed;
    }
    updateBoundingBox() {
        let e = this.boundingBox;
        e || (e = this.boundingBox = new j);
        let n, r, i = this.data[this.desc.positionAttribute];
        if (p(i) || (i.data ? i = i.data : P(i) ? i = this._getAttributeData(this.desc.positionAttribute) : i.array && (n = i.min, 
        r = i.max, i = i.array)), i && i.length) {
            const o = e.min, a = e.max;
            if (n && r) t.set(o, ...n), t.set(a, ...r); else {
                t.set(o, i[0], i[1], i[2]), t.set(a, i[0], i[1], i[2]);
                for (let e = 3; e < i.length; ) {
                    const t = i[e++], n = i[e++], r = i[e++];
                    t < o[0] && (o[0] = t), n < o[1] && (o[1] = n), r < o[2] && (o[2] = r), t > a[0] && (a[0] = t), 
                    n > a[1] && (a[1] = n), r > a[2] && (a[2] = r);
                }
            }
            e.updateVertex(), e.dirty();
        }
    }
    _updateSubBoundingBox(e) {
        const t = this.boundingBox, n = t.min, r = t.max, i = this.desc.positionSize;
        for (let t = 0; t < e.length; ) {
            const o = e[t++], a = e[t++];
            let s = 0;
            3 === i && (s = e[t++]), o < n[0] && (n[0] = o), a < n[1] && (n[1] = a), s < n[2] && (n[2] = s), 
            o > r[0] && (r[0] = o), a > r[1] && (r[1] = a), s > r[2] && (r[2] = s);
        }
        t.updateVertex(), t.dirty();
    }
    _getAttributeData(e) {
        const t = f(), n = this.data[e] && this.data[e].array ? this.data[e].array : this.data[e], r = n.buffer;
        if (P(n)) {
            const i = this._buffers[r] ? this._buffers[r].data : n.array, {count: o, size: a, stride: s, offset: c, componentType: l} = n, f = t.GLTFLoader.getTypedArrayCtor(l);
            if ((0 === s || s === a * f.BYTES_PER_ELEMENT) && c % f.BYTES_PER_ELEMENT == 0) return new f(i, c, o * a);
            if (e === this.desc.positionAttribute) return !this._tempPosArray || this._tempPosArray && this._tempPosArray.length < a * o ? (this._tempPosArray = new f(a * o), 
            t.GLTFLoader.readInterleavedArray(this._tempPosArray, i, o, a, s, c, l)) : this._posDirty ? (this._posDirty = !1, 
            t.GLTFLoader.readInterleavedArray(this._tempPosArray, i, o, a, s, c, l)) : this._tempPosArray;
            {
                const e = new f(a * o);
                return t.GLTFLoader.readInterleavedArray(e, i, o, a, s, c, l);
            }
        }
        return n;
    }
    createTangent(e = "aTangent") {
        this._incrVersion();
        const {normalAttribute: r, positionAttribute: i, uv0Attribute: o} = this.desc, c = this._getAttributeData(r), l = this._getAttributeData(i), f = a(l, c, this.data[o], this.elements), d = this.data[e] = new Float32Array(f.length), u = [ 0, 0, 0, 0 ], h = [ 0, 0, 0 ], m = [ 0, 0, 0, 0 ];
        for (let e = 0; e < f.length; e += 4) {
            const r = e / 4 * 3;
            t.set(h, c[r], c[r + 1], c[r + 2]), n.set(u, f[e], f[e + 1], f[e + 2], f[e + 3]), 
            s(m, h, u), n.copy(d.subarray(e, e + 4), m);
        }
        delete this._reglData;
    }
    createNormal(e = "aNormal") {
        this._incrVersion();
        const t = this._getAttributeData(this.desc.positionAttribute);
        this.data[e] = c(t.array || t, this.elements), delete this._reglData;
    }
    createBarycentric(e = "aBarycentric") {
        if ("triangles" !== this.desc.primitive) throw new Error("Primitive must be triangles to create bary centric data");
        this._incrVersion();
        const t = new Uint8Array(3 * this._vertexCount);
        for (let e = 0, n = this.elements.length; e < n; ) for (let n = 0; n < 3; n++) {
            t[3 * this.elements[e++] + n] = 1;
        }
        this.data[e] = t, delete this._reglData;
    }
    buildUniqueVertex() {
        this._incrVersion();
        const e = this.data, t = this.elements;
        if (!p(t)) throw new Error("elements must be array to build unique vertex.");
        const n = Object.keys(e), r = {};
        let i = e[this.desc.positionAttribute];
        if (i = i.length ? i : i.array, !p(i)) throw new Error(this.desc.positionAttribute + " must be array to build unique vertex.");
        const o = this._vertexCount, a = t.length;
        for (let t = 0; t < n.length; t++) {
            const i = n[t], s = p(e[i]) ? e[i] : e[i].array, c = s.length / o;
            if (!p(s)) throw new Error(i + " must be array to build unique vertex.");
            r[i] = s, e[i] = new s.constructor(a * c);
        }
        let s = 0;
        for (let i = 0; i < a; i++) {
            const a = t[i];
            for (let t = 0; t < n.length; t++) {
                const i = n[t], c = e[i], l = r[i].length / o;
                for (let e = 0; e < l; e++) c[s * l + e] = r[i][a * l + e];
            }
            t[i] = s++;
        }
        i = this.data[this.desc.positionAttribute], this._vertexCount = Math.ceil(i.length / this.desc.positionSize), 
        delete this._reglData;
    }
    getMemorySize() {
        let e = 0;
        for (const t in this.data) S(this.data, t) && (e += T(this.data[t]));
        if (this.elements) {
            const t = this.elements;
            t.destroy ? e += t._elements.buffer.byteLength : t.BYTES_PER_ELEMENT ? e += t.length * t.BYTES_PER_ELEMENT : t.length && (e += 4 * t.length);
        }
        return e;
    }
    _deleteVAO() {
        for (const e in this._vao) this._vao[e].vao.destroy();
        this._vao = {};
    }
    _forEachBuffer(e) {
        this.elements && this.elements.destroy && e(this.elements);
        for (const t in this.data) S(this.data, t) && this.data[t] && this.data[t].buffer && this.data[t].buffer.destroy && e(this.data[t].buffer);
        for (const t in this._buffers) S(this._buffers, t) && this._buffers[t] && this._buffers[t].buffer && this._buffers[t].buffer.destroy && e(this._buffers[t].buffer);
    }
    getElementsType(e) {
        return e instanceof Uint8Array ? "uint8" : e instanceof Uint16Array ? "uint16" : e instanceof Uint32Array ? "uint32" : void 0;
    }
    _incrVersion() {
        this._version++;
    }
}

function $(e) {
    if (g(e)) return e;
    if (void 0 !== e.count) return e.count;
    if (e.destroy) return e._elements.vertCount;
    if (void 0 !== e.length) return e.length;
    if (e.data) return e.data.length;
    throw new Error("invalid elements length");
}

const Q = [ "points", "lines", "line strip", "line loop", "triangles", "triangle strip", "triangle fan" ];

function ee(e) {
    return Q[e];
}

const te = {
    5121: "uint8",
    5123: "uint16",
    5125: "uint32",
    5126: "float",
    36193: "half float"
};

function ne(e) {
    return te[e];
}

const re = {
    6406: "alpha",
    6407: "rgb",
    6408: "rgba",
    6409: "luminance",
    6410: "luminance alpha",
    33776: "rgb s3tc dxt1",
    33777: "rgba s3tc dxt1",
    33778: "rgba s3tc dxt3",
    33779: "rgba s3tc dxt5",
    35840: "rgb pvrtc 4bppv1",
    35841: "rgb pvrtc 2bppv1",
    35842: "rgba pvrtc 4bppv1",
    35843: "rgba pvrtc 2bppv1",
    35986: "rgb atc",
    35987: "rgba atc explicit alpha",
    34798: "rgba atc interpolated alpha",
    36196: "rgb etc1"
};

function ie(e) {
    return re[e];
}

const oe = {
    9729: "linear",
    9728: "nearest"
};

function ae(e) {
    return oe[e];
}

const se = {
    9729: "linear",
    9728: "nearest",
    9984: "nearest mipmap nearest",
    9985: "linear mipmap nearest",
    9986: "nearest mipmap linear",
    9987: "linear mipmap linear"
};

function ce(e) {
    return se[e];
}

const le = {
    10497: "repeat",
    33071: "clamp",
    33648: "mirror"
};

function fe(e) {
    return le[e];
}

const de = "__reshader_webgl_buffer", ue = "__reshader_webgl_tex";

function he(e, t, n) {
    let r;
    if (p(t) ? t.buffer && void 0 !== t.byteOffset && (r = t) : t.array && t.array.buffer && void 0 !== t.array.byteOffset && (r = t.array), 
    !r) return null;
    const i = r.buffer, o = r.byteOffset;
    i[de] || (i[de] = {});
    let a = i[de][o];
    if (!a) {
        const t = {};
        n && v(t, n), t.data = r, a = e.buffer(t), i[de][o] = a;
    }
    return a;
}

function me(e, t) {
    const n = t.data;
    if (!n || !n.buffer) return e.texture(t);
    const r = n.buffer, i = n.byteOffset;
    r[ue] || (r[ue] = {});
    let o = r[ue][i];
    return o || (o = e.texture(t), r[ue][i] = o), o;
}

var ve = Object.freeze({
    __proto__: null,
    getMaterialFormat: ie,
    getMaterialType: ne,
    getPrimitive: ee,
    getTextureMagFilter: ae,
    getTextureMinFilter: ce,
    getTextureWrap: fe,
    getUniqueREGLBuffer: he,
    getUniqueTexture: me
});

const _e = [ 0, 0, 0 ], ge = [ 0, 0, 0 ], xe = [ 0, 0, 0 ], pe = [], be = [], ye = [], Ae = [ "a", "b", "c" ];

class Se extends Z {
    constructor(e, t, n, r) {
        super(e, t, n, {
            primitive: ee(1),
            positionAttribute: r.positionAttribute
        });
    }
    _getPosAttritute() {
        const e = this.data[this.desc.positionAttribute];
        if (!e.length) return [];
        const t = Math.pow(10, 4), n = Math.cos(Math.PI / 180 * .8), r = this.elements, i = e.length ? e : e.array, o = r.length ? r ? r.length : i.length / 3 : r, a = [ 0, 0, 0 ], s = new Array(3), c = {}, l = [], f = new Te;
        for (let e = 0; e < o; e += 3) {
            r.length ? (a[0] = r[e], a[1] = r[e + 1], a[2] = r[e + 2]) : (a[0] = e, a[1] = e + 1, 
            a[2] = e + 2), f.a = Me(pe, i, a[0]), f.b = Me(be, i, a[1]), f.c = Me(ye, i, a[2]);
            const o = f.getNormal(), d = f.a, u = f.b, h = f.c;
            if (s[0] = `${Math.round(d[0] * t)},${Math.round(d[1] * t)},${Math.round(d[2] * t)}`, 
            s[1] = `${Math.round(u[0] * t)},${Math.round(u[1] * t)},${Math.round(u[2] * t)}`, 
            s[2] = `${Math.round(h[0] * t)},${Math.round(h[1] * t)},${Math.round(h[2] * t)}`, 
            s[0] !== s[1] && s[1] !== s[2] && s[2] !== s[0]) for (let e = 0; e < 3; e++) this._calEdgeData(e, a, f, c, s, n, o, l);
        }
        for (const e in c) if (c[e]) {
            const {index0: t, index1: n} = c[e];
            l.push(i[3 * t], i[3 * t + 1], i[3 * t + 2]), l.push(i[3 * n], i[3 * n + 1], i[3 * n + 2]);
        }
        return this.elements = this._createElements(l), l;
    }
    _calEdgeData(e, n, r, i, o, a, s, c) {
        const l = (e + 1) % 3, f = o[e], d = o[l], u = r[Ae[e]], h = r[Ae[l]], m = `${f}_${d}`, v = `${d}_${f}`;
        if (v in i && i[v]) {
            t.dot(s, i[v].normal) <= a && (c.push(u[0], u[1], u[2]), c.push(h[0], h[1], h[2])), 
            i[v] = null;
        } else m in i || (i[m] = {
            index0: n[e],
            index1: n[l],
            normal: t.copy([ 0, 0, 0 ], s)
        });
    }
    _createElements(e) {
        const t = [], n = e.length / 3;
        for (let e = 0; e < n; e++) t.push(e);
        return t;
    }
}

class Te {
    constructor(e = [ 0, 0, 0 ], t = [ 0, 0, 0 ], n = [ 0, 0, 0 ]) {
        this.a = e, this.b = t, this.c = n;
    }
    getNormal() {
        const e = t.sub(_e, this.a, this.b), n = t.sub(ge, this.a, this.c);
        t.cross(xe, e, n);
        const r = t.length(xe);
        return t.set(xe, xe[0] / r, xe[1] / r, xe[2] / r);
    }
}

function Me(e, n, r) {
    return t.set(e, n[3 * r], n[3 * r + 1], n[3 * r + 2]);
}

class Oe {}

class Ce extends(N(Oe)){
    constructor(e = {}, t) {
        super(), this._version = 0, this._propVerion = 0, this.uniforms = _({}, t || {}, e);
        for (const t in e) {
            const n = Object.getOwnPropertyDescriptor(e, t).get;
            n && Object.defineProperty(this.uniforms, t, {
                get: n
            });
        }
        this.unlit = !1, this._reglUniforms = {}, this.refCount = 0, this._bindedOnTextureComplete = (...e) => this._onTextureComplete.call(this, ...e), 
        this._genUniformKeys(), this._checkTextures();
    }
    set version(e) {
        throw new Error("Material.version is read only.");
    }
    get version() {
        return this._version;
    }
    get propVersion() {
        return this._propVerion;
    }
    set doubleSided(e) {
        this.uniforms.doubleSided = e;
    }
    get doubleSided() {
        return !!this.uniforms.doubleSided;
    }
    isReady() {
        return this._loadingCount <= 0;
    }
    set(e, t) {
        const n = u(this.uniforms[e]) && !u(t) || !u(this.uniforms[e]) && u(t);
        if (this.uniforms[e] && this.isTexture(e) && this.uniforms[e].dispose(), u(t)) u(this.uniforms[e]) || delete this.uniforms[e]; else if (this.uniforms[e] = t, 
        this._reglUniforms) {
            const n = Object.getOwnPropertyDescriptor(this._reglUniforms, e);
            n && !n.get && (this._propVerion++, this._reglUniforms[e] = t);
        }
        return this.isTexture(e) && this._checkTextures(), n && (this._genUniformKeys(), 
        this._incrVersion()), this;
    }
    setFunctionUniform(e, t) {
        return this._genUniformKeys(), this._incrVersion(), Object.defineProperty(this.uniforms, e, {
            enumerable: !0,
            get: t
        }), this;
    }
    hasFunctionUniform(e) {
        return !!this.uniforms && Object.prototype.hasOwnProperty.call(this.uniforms, e);
    }
    get(e) {
        return this.uniforms[e];
    }
    isDirty() {
        return this._uniformVer !== this.version;
    }
    appendDefines(e, t) {
        const n = this.uniforms;
        return n ? (n.jointTexture && (e.HAS_SKIN = 1), n.morphWeights1 && (e.HAS_MORPH = 1), 
        (n.khr_offset || n.khr_rotation || n.khr_scale) && (e.HAS_KHR_TEXTURE_TRANSFORM = 1), 
        e) : e;
    }
    hasSkinAnimation() {
        return !!(this.uniforms && this.uniforms.jointTexture && this.uniforms.skinAnimation);
    }
    getUniforms(e) {
        if (this._reglUniforms && !this.isDirty()) return this._reglUniforms;
        const t = this.uniforms, n = {};
        for (const r in t) if (this.isTexture(r)) Object.defineProperty(n, r, {
            enumerable: !0,
            configurable: !0,
            get: function() {
                return t[r].getREGLTexture(e);
            }
        }); else {
            Object.getOwnPropertyDescriptor(t, r).get ? Object.defineProperty(n, r, {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    return t[r];
                }
            }) : n[r] = t[r];
        }
        return this._reglUniforms = n, this._uniformVer = this.version, n;
    }
    isTexture(e) {
        return this.uniforms[e] instanceof G;
    }
    dispose() {
        for (const e in this.uniforms) {
            const t = this.uniforms[e];
            t && (t.dispose ? t.dispose() : t.destroy && !t[L] && (t.destroy(), t[L] = !0));
        }
        delete this.uniforms, delete this._reglUniforms, delete this._bindedOnTextureComplete, 
        this._disposed = !0;
    }
    isDisposed() {
        return !!this._disposed;
    }
    _checkTextures() {
        this._loadingCount = 0;
        for (const e in this.uniforms) if (this.isTexture(e)) {
            const t = this.uniforms[e];
            t.isReady() || (this._loadingCount++, t.on("complete", this._bindedOnTextureComplete));
        }
    }
    _onTextureComplete() {
        this._loadingCount--, this._incrVersion(), this._loadingCount <= 0 && (this._disposed || this.fire("complete"));
    }
    getUniformKeys() {
        return this._uniformKeys;
    }
    _genUniformKeys() {
        const e = [];
        for (const t in this.uniforms) S(this.uniforms, t) && !u(this.uniforms[t]) && e.push(t);
        this._uniformKeys = e.join();
    }
    _incrVersion() {
        this._version++;
    }
    getMemorySize() {
        const e = this.uniforms;
        let t = 0;
        for (const n in e) this.isTexture(n) ? t += e[n].getMemorySize() : this.uniforms[n] && this.uniforms[n].destroy && (t += M(this.uniforms[n]));
        return t;
    }
}

const Ee = {
    time: 0,
    seeThrough: !0,
    thickness: .03,
    fill: [ 1, .5137254902, .98, 1 ],
    stroke: [ .7019607843, .9333333333, .2274509804, 1 ],
    dashEnabled: !1,
    dashAnimate: !1,
    dashRepeats: 1,
    dashLength: .8,
    dashOverlap: !0,
    insideAltColor: !1,
    squeeze: !1,
    squeezeMin: .5,
    squeezeMax: 1,
    dualStroke: !1,
    secondThickness: .05,
    opacity: 1,
    noiseEnable: !1
};

class Pe extends Ce {
    constructor(e) {
        super(e, Ee);
    }
}

const we = {
    baseColorFactor: [ 1, 1, 1, 1 ],
    materialShininess: 32,
    environmentExposure: 1,
    specularStrength: 32,
    opacity: 1,
    extrusionOpacity: 0,
    extrusionOpacityRange: [ 0, 1.8 ],
    baseColorTexture: null,
    normalTexture: null,
    emissiveTexture: null,
    occlusionTexture: null,
    uvScale: [ 1, 1 ],
    uvOffset: [ 0, 0 ],
    alphaTest: 0
};

class Ie extends Ce {
    constructor(e) {
        super(e, we);
    }
    static convertFrom(e) {
        const t = {};
        for (const n in we) t[n] = e.get(n);
        return new Ie(t);
    }
    appendDefines(e, t) {
        super.appendDefines(e, t);
        const n = this.uniforms;
        n.extrusionOpacity && (e.HAS_EXTRUSION_OPACITY = 1), t.data[t.desc.colorAttribute] && (e.HAS_COLOR = 1);
        return t.data[t.desc.color0Attribute] && (e.HAS_COLOR0 = 1, e.COLOR0_SIZE = t.getColor0Size()), 
        t.data.aVertexColorType && (e.HAS_VERTEX_COLOR = 1), t.data[t.desc.tangentAttribute] ? e.HAS_TANGENT = 1 : t.data[t.desc.normalAttribute] && (e.HAS_NORMAL = 1), 
        t.data[t.desc.uv0Attribute] ? (n.baseColorTexture && (e.HAS_BASECOLOR_MAP = 1), 
        n.occlusionTexture && t.data[t.desc.uv1Attribute] && (e.HAS_AO_MAP = 1), n.emissiveTexture && (e.HAS_EMISSIVE_MAP = 1), 
        n.normalTexture && (e.HAS_NORMAL_MAP = 1), (e.HAS_BASECOLOR_MAP || e.HAS_AO_MAP || e.HAS_EMISSIVE_MAP || e.HAS_NORMAL_MAP) && (e.HAS_MAP = 1), 
        e) : e;
    }
}

const Re = {
    baseColorFactor: [ 1, 1, 1, 1 ],
    uvScale: [ 1, 1 ],
    uvOffset: [ 0, 0 ],
    opacity: 1,
    envMapExposure: 128,
    emissiveFactor: [ .1, .1, .1 ],
    specularFactor: [ 0, 0, 0 ],
    envRotationSin: 0,
    envRotationCos: 1,
    reflectivity: .01,
    themingColor: [ 0, 0, 0, 0 ],
    exposureBias: .6
};

class De extends Ce {
    constructor(e) {
        super(e, Re);
    }
    appendDefines(e, t) {
        super.appendDefines(e, t);
        const n = this.uniforms;
        n.extrusionOpacity && (e.HAS_EXTRUSION_OPACITY = 1), t.data[t.desc.colorAttribute] && (e.HAS_COLOR = 1);
        return t.data[t.desc.color0Attribute] && (e.HAS_COLOR0 = 1, e.COLOR0_SIZE = t.getColor0Size()), 
        t.data[t.desc.uv0Attribute] ? (n.baseColorTexture && (e.HAS_BASECOLOR_MAP = 1), 
        n.occlusionTexture && t.data[t.desc.uv1Attribute] && (e.HAS_AO_MAP = 1), n.emissiveTexture && (e.HAS_EMISSIVE_MAP = 1), 
        n.normalTexture && (e.HAS_NORMAL_MAP = 1), (e.HAS_BASECOLOR_MAP || e.HAS_AO_MAP || e.HAS_EMISSIVE_MAP || e.HAS_NORMAL_MAP) && (e.HAS_MAP = 1), 
        e.ALPHATEST = .01, e.GAMMA_INPUT = 1, e.GAMMA_FACTOR = 1, e.TONEMAP_OUTPUT = 1, 
        e.ENVMAP_MODE_REFLECTION = 1, e.ENV_RGBM = 1, e.IRR_RGBM = 1, e) : e;
    }
}

const He = {
    diffuseFactor: [ 1, 1, 1, 1 ],
    specularFactor: [ 1, 1, 1 ],
    glossinessFactor: 1,
    diffuseTexture: null,
    specularGlossinessTexture: null,
    normalTexture: null,
    emissiveTexture: null,
    occlusionTexture: null
};

function Fe(e) {
    return class extends e {
        constructor(...e) {
            let t = e[0];
            t = v({}, He, t || {}), super(t, e);
        }
        appendDefines(e, t) {
            if (super.appendDefines(e, t), e.SHADING_MODEL_SPECULAR_GLOSSINESS = 1, !t.data[t.desc.uv0Attribute]) return e;
            const n = this.uniforms;
            return n.diffuseTexture && (e.HAS_DIFFUSE_MAP = 1), n.specularGlossinessTexture && (e.HAS_SPECULARGLOSSINESS_MAP = 1), 
            (e.HAS_SPECULARGLOSSINESS_MAP || e.HAS_DIFFUSE_MAP) && (e.HAS_MAP = 1), e;
        }
    };
}

class Ne extends(Fe(Ie)){}

const Le = new Array(16);

let ke = 0;

class Be {
    constructor(t, n, r = {}) {
        this._version = 0, this._geometry = t, this._material = n, this.transparent = !!r.transparent, 
        this.bloom = !!r.bloom, this.ssr = !!r.ssr, this._castShadow = u(r.castShadow) || r.castShadow, 
        this.needUpdateShadow = !1, this.picking = !!r.picking, this.disableVAO = !!r.disableVAO, 
        this.uniforms = {}, this._localTransform = e.identity(new Array(16)), this._positionMatrix = e.identity(new Array(16)), 
        this.properties = {}, this._dirtyUniforms = !0, this._dirtyGeometry = !0, Object.defineProperty(this, "uuid", {
            value: ke++
        }), ke > Number.MAX_VALUE - 10 && (ke = 0);
    }
    set material(e) {
        this._material !== e && this.setMaterial(e);
    }
    get material() {
        return this._material;
    }
    set version(e) {
        throw new Error("Mesh.version is read only.");
    }
    get version() {
        return this._version;
    }
    get geometry() {
        return this._geometry;
    }
    set geometry(e) {
        this._geometry !== e && (this._incrVersion(), this._dirtyGeometry = !0), this._geometry = e;
    }
    set localTransform(t) {
        this._prevTMat || (this._prevTMat = new Array(16)), Array.isArray(t) && !e.exactEquals(this._prevTMat, t) && (this._incrVersion(), 
        this._prevTMat = e.copy(this._prevTMat, t)), this._localTransform = t;
    }
    get localTransform() {
        return m(this._localTransform) ? this._localTransform() : this._localTransform;
    }
    set positionMatrix(t) {
        this._prevPMat || (this._prevPMat = new Array(16)), Array.isArray(t) && !e.exactEquals(this._prevPMat, t) && (this._incrVersion(), 
        this._prevPMat = e.copy(this._prevPMat, t)), this._positionMatrix = t;
    }
    get positionMatrix() {
        return m(this._positionMatrix) ? this._positionMatrix() : this._positionMatrix;
    }
    get config() {
        return this._options || (this._options = {}), this._options.transparent = this.transparent, 
        this._options.castShadow = this.castShadow, this._options.bloom = this.bloom, this._options.ssr = this.ssr, 
        this._options.picking = this.picking, this._options;
    }
    get defines() {
        return this._getDefines();
    }
    set defines(e) {
        this.setDefines(e);
    }
    get castShadow() {
        return this._castShadow && (!this.material || !this.material.unlit);
    }
    set castShadow(e) {
        this._castShadow = e;
    }
    setMaterial(e) {
        return this._material = e, this._dirtyUniforms = !0, delete this._materialVer, this.dirtyDefines = !0, 
        this;
    }
    setParent(e) {
        return this.parent = e, this;
    }
    setLocalTransform(e) {
        return this.localTransform = e, this;
    }
    setPositionMatrix(e) {
        this.positionMatrix = e;
    }
    setUniform(e, t) {
        return this._updateUniformState(e), this.uniforms[e] = t, this;
    }
    setFunctionUniform(e, t) {
        return this._updateUniformState(e), Object.defineProperty(this.uniforms, e, {
            enumerable: !0,
            get: t
        }), this;
    }
    hasFunctionUniform(e) {
        return !!this.uniforms && Object.prototype.hasOwnProperty.call(this.uniforms, e);
    }
    _updateUniformState(e) {
        void 0 === this.uniforms[e] ? this._dirtyUniforms = !0 : (this._dirtyProps = this._dirtyProps || [], 
        this._dirtyProps.push(e));
    }
    getUniform(e) {
        return this.uniforms[e];
    }
    getDefines() {
        const e = {};
        return v(e, this._getDefines()), this._material && this._geometry && this._material.appendDefines(e, this._geometry), 
        e;
    }
    _getDefines() {
        this._defines || (this._defines = {});
        const e = this._geometry, t = e.data[e.desc.positionAttribute], n = e.data[e.desc.uv0Attribute], r = e.data[e.desc.normalAttribute];
        return t && t.quantization && (this._defines.HAS_DRACO_POSITION = 1), n && n.quantization && (this._defines.HAS_DRACO_TEXCOORD = 1), 
        r && r.quantization && (this._defines.HAS_DRACO_NORMAL = 1), this._defines;
    }
    setDefines(e) {
        const t = this._bakDefines;
        return this._defines = e, this.dirtyDefines = this.dirtyDefines || !!t != !!e || !function(e, t) {
            if (!e && !t) return !0;
            const n = Object.getOwnPropertyNames(e), r = Object.getOwnPropertyNames(t);
            if (n.length !== r.length) return !1;
            for (let r = 0; r < n.length; r++) if (e[n[r]] !== t[n[r]]) return !1;
            return !0;
        }(t, e), this.dirtyDefines && (this._bakDefines = v({}, e)), this;
    }
    hasSkinAnimation() {
        return this._material && this._material.hasSkinAnimation();
    }
    _getDefinesKey() {
        return this.dirtyDefines = !1, this._createDefinesKey(this.getDefines());
    }
    getCommandKey(e) {
        if (!this._commandKey || this.dirtyDefines || this._material && this._materialKeys !== this._material.getUniformKeys()) {
            let e = this._getDefinesKey();
            e += "_" + (g(this.getElements()) ? "count" : "elements"), e += "_" + +!!this.disableVAO, 
            this._material && (e += "_" + +!!this._material.doubleSided), this._commandKey = e, 
            this._material && (this._materialKeys = this._material.getUniformKeys());
        }
        return this._commandKey;
    }
    getUniforms(e) {
        if (this._dirtyUniforms || this._dirtyGeometry || this._material && this._materialVer !== this._material.version) {
            this._uniformDescriptors = new Set, this._realUniforms = {}, this._prepareUniformsForDraco();
            const t = this.uniforms;
            for (const e in this.uniforms) if (S(this.uniforms, e)) {
                Object.getOwnPropertyDescriptor(t, e).get ? (this._uniformDescriptors.add(e), Object.defineProperty(this._realUniforms, e, {
                    enumerable: !0,
                    configurable: !0,
                    get: function() {
                        return t[e];
                    }
                })) : this._realUniforms[e] = t[e];
            }
            if (this._material) {
                const t = this._material.getUniforms(e);
                for (const e in t) if (S(t, e) && !S(this._realUniforms, e)) {
                    Object.getOwnPropertyDescriptor(t, e).get ? (this._uniformDescriptors.add(e), Object.defineProperty(this._realUniforms, e, {
                        enumerable: !0,
                        configurable: !0,
                        get: function() {
                            return t[e];
                        }
                    })) : void 0 === this._realUniforms[e] && (this._realUniforms[e] = t[e]);
                }
            }
            this._dirtyUniforms = !1, this._dirtyGeometry = !1, this._materialVer = this._material && this._material.version, 
            this._materialPropVer = this._material && this._material.propVersion, this._dirtyProps = null;
        } else if (this._dirtyProps || this._material && this._material.propVersion !== this._materialPropVer) {
            if (this._dirtyProps) for (const e of this._dirtyProps) this._realUniforms[e] = this.uniforms[e];
            if (this._material && this._material.propVersion !== this._materialPropVer) {
                const t = this._material.getUniforms(e);
                for (const e in t) if (S(t, e) && !this._uniformDescriptors.has(e)) {
                    Object.getOwnPropertyDescriptor(t, e).get || this._realUniforms[e] === t[e] || (this._realUniforms[e] = t[e]);
                }
                this._materialPropVer = this._material.propVersion;
            }
            this._dirtyProps = null;
        }
        return this._realUniforms.modelMatrix = this.localTransform, this._realUniforms.positionMatrix = this.positionMatrix, 
        this._realUniforms;
    }
    _prepareUniformsForDraco() {
        const e = this._geometry, t = e.data[e.desc.positionAttribute], n = e.data[e.desc.uv0Attribute], r = e.data[e.desc.normalAttribute];
        if (t && t.quantization) {
            const e = t.quantization, n = e.range / (1 << e.quantizationBits);
            this._realUniforms.minValues_pos = e.minValues, this._realUniforms.gltf_u_dec_position_normConstant = n;
        }
        if (n && n.quantization) {
            const e = n.quantization;
            this._realUniforms.minValues_tex = e.minValues;
            this._realUniforms.gltf_u_dec_texcoord_0_normConstant = e.range / (1 << e.quantizationBits);
        }
        if (r && r.quantization) {
            this._realUniforms.gltf_u_dec_normal_rangeConstant = (1 << r.quantization.quantizationBits) - 1;
        }
    }
    getMaterial() {
        return this._material;
    }
    getElements() {
        return this._geometry.getElements();
    }
    _getREGLAttrData(e, t) {
        return this._geometry.getREGLData(e, t, this.disableVAO);
    }
    getREGLProps(e, t) {
        const n = this.getUniforms(e);
        return v(n, this._getREGLAttrData(e, t)), A(e) && !this.disableVAO || (n.elements = this._geometry.getElements()), 
        n.meshProperties = this.properties, n.geometryProperties = this._geometry.properties, 
        n.meshConfig = this.config, n.count = this._geometry.getDrawCount(), n.offset = this._geometry.getDrawOffset(), 
        n.primitive = this._geometry.getPrimitive(), n;
    }
    dispose() {
        return delete this._geometry, delete this._material, this.uniforms = null, this;
    }
    isValid() {
        return this._geometry && !this._geometry.isDisposed() && (!this._material || !this._material.isDisposed());
    }
    getBoundingBox() {
        return this._geometry ? (this._bbox || this.updateBoundingBox(), e.multiply(Le, this.localTransform, this.positionMatrix), 
        e.exactEquals(Le, this._currentTransform) && this._geometry.boundingBox.equals(this._geoBox) || this.updateBoundingBox(), 
        this._bboxArr) : null;
    }
    updateBoundingBox() {
        const n = this._geometry.boundingBox;
        this._bbox || (this._bbox = new j), this._bboxArr || (this._bboxArr = [ [ 0, 0, 0 ], [ 0, 0, 0 ] ]), 
        this._geoBox || (this._geoBox = new j), j.copy(this._bbox, n), this._bbox.updateVertex(), 
        "InstancedMesh" === this.constructor.name ? (this._bbox.transform(this.localTransform, this.positionMatrix), 
        this._currentTransform = e.multiply(this._currentTransform || new Array(16), this.positionMatrix, this.localTransform)) : (this._bbox.transform(this.positionMatrix, this.localTransform), 
        this._currentTransform = e.multiply(this._currentTransform || new Array(16), this.localTransform, this.positionMatrix)), 
        j.copy(this._geoBox, n), t.copy(this._bboxArr[0], this._bbox.min), t.copy(this._bboxArr[1], this._bbox.max);
    }
    _createDefinesKey(e) {
        const t = [];
        for (const n in e) t.push(n, e[n]);
        return t.join(",");
    }
    _incrVersion() {
        this._version++;
    }
    getMemorySize() {
        return (this.geometry && this.geometry.getMemorySize() || 0) + (this.material && this.material.getMemorySize() || 0);
    }
    getWorldTransform() {
        const t = this.parent;
        return t ? e.multiply(new Array(16), t.getWorldTransform(), this.localTransform) : this.localTransform;
    }
}

class ze extends Be {
    constructor(e, t, n, r, i = {}) {
        super(n, r, i), this._instanceCount = t, this.instancedData = e || {}, this._checkInstancedProp(), 
        this._vao = {};
    }
    get instanceCount() {
        return this._instanceCount;
    }
    set instanceCount(e) {
        this._incrVersion(), this._instanceCount = e;
    }
    getMemorySize() {
        return super.getMemorySize() + this._getInstanceMemorySize();
    }
    _getInstanceMemorySize() {
        let e = 0;
        for (const t in this.instancedData) S(this.instancedData, t) && (e += T(this.instancedData[t]));
        return e;
    }
    _checkInstancedProp() {
        for (const e in this.instancedData) if (this.geometry.data[e]) throw new Error(`Duplicate attribute ${e} defined in geometry and instanced data`);
    }
    _getREGLAttrData(e, t) {
        const n = this.geometry.getAttrData(t);
        if (A(e)) {
            const r = t.key;
            if (!this._vao[r] || this._vao[r].dirty) {
                const i = t.map((e => e.name)), o = [];
                for (let e = 0; e < i.length; e++) {
                    const t = n[i[e]];
                    o.push(t && t.buffer || this.instancedData[i[e]]);
                }
                const a = {
                    attributes: o,
                    primitive: this.geometry.getPrimitive()
                };
                this._vao[r] ? this._vao[r].vao(a) : this._vao[r] = {
                    vao: e.vao(a)
                }, delete this._vao[r].dirty;
            }
            return this._vao[r];
        }
        return n;
    }
    getDefines() {
        const e = super.getDefines();
        return e.HAS_INSTANCE = 1, e;
    }
    getCommandKey(e) {
        return "i_" + super.getCommandKey(e);
    }
    updateInstancedData(e, t) {
        const n = this.instancedData[e];
        if (this._incrVersion(), this.instancedData[e] = t, n && n.buffer && n.buffer.destroy && n.buffer.destroy(), 
        this._vao) for (const e in this._vao) this._vao[e].dirty = !0;
        return this;
    }
    generateInstancedBuffers(e) {
        const t = this.instancedData, n = {};
        for (const r in t) {
            if (!t[r]) continue;
            const i = t[r];
            void 0 !== i.buffer && i.buffer.destroy ? (n[r] = i, n[r].divisor && (n[r].divisor = 1)) : n[r] = t[r].destroy ? {
                buffer: t[r],
                divisor: 1
            } : {
                buffer: e.buffer({
                    data: t[r],
                    dimension: t[r].length / this._instanceCount
                }),
                divisor: 1
            };
        }
        return this.instancedData = n, this;
    }
    getREGLProps(e, t) {
        const n = super.getREGLProps(e, t);
        return A(e) || v(n, this.instancedData), n.elements = this.geometry.getElements(), 
        n.instances = this._instanceCount, n;
    }
    disposeInstancedData() {
        const e = this.instancedData;
        if (e) for (const t in e) {
            if (!e[t]) continue;
            const n = e[t].destroy ? e[t] : e[t].buffer;
            n.destroy && !n[L] && (n[L] = 1, n.destroy());
        }
        this.instancedData = {};
        for (const e in this._vao) this._vao[e].vao.destroy();
        this._vao = {};
    }
}

const Ge = {};

class Ve {
    constructor(e) {
        this.regl = e;
    }
    render(e, t, n, r) {
        e.setUniforms(t || Ge), e.setFramebuffer(r);
        let i = 0;
        if (n) {
            const {opaques: t, transparents: r} = n.getSortedMeshes();
            i += e.draw(this.regl, t), i += e.draw(this.regl, r);
        } else i += e.draw(this.regl);
        return i;
    }
    clear(e) {
        this.regl.clear(e);
    }
}

const Ue = {
    getArrayBuffer: (e, t) => Ue.get(e, {
        responseType: "arraybuffer"
    }, t),
    get: function(e, t, n) {
        const r = Ue._getClient(n);
        if (r.open("GET", e, !0), t) {
            for (const e in t.headers) r.setRequestHeader(e, t.headers[e]);
            r.withCredentials = "include" === t.credentials, t.responseType && (r.responseType = t.responseType);
        }
        return r.send(null), r;
    },
    _wrapCallback: function(e, t) {
        return function() {
            if (4 === e.readyState) if (200 === e.status) if ("arraybuffer" === e.responseType) {
                0 === e.response.byteLength ? t(new Error("http status 200 returned without content.")) : t(null, {
                    data: e.response,
                    cacheControl: e.getResponseHeader("Cache-Control"),
                    expires: e.getResponseHeader("Expires"),
                    contentType: e.getResponseHeader("Content-Type")
                });
            } else t(null, e.responseText); else t(new Error(e.statusText + "," + e.status));
        };
    },
    _getClient: function(e) {
        let t;
        try {
            t = new XMLHttpRequest;
        } catch (e) {
            try {
                t = new ActiveXObject("Msxml2.XMLHTTP");
            } catch (e) {
                try {
                    t = new ActiveXObject("Microsoft.XMLHTTP");
                } catch (e) {}
            }
        }
        return t.onreadystatechange = Ue._wrapCallback(t, e), t;
    }
};

class je {
    constructor(e, t) {
        this.defaultTexture = e, this.defaultCubeTexture = new Array(6), this.urlModifier = t, 
        this.resources = {};
    }
    setURLModifier(e) {
        this.urlModifier = e;
    }
    get(e) {
        return Array.isArray(e) ? this._loadImages(e) : this._loadImage(e);
    }
    getArrayBuffer(e) {
        if (Array.isArray(e)) {
            const t = e.map((e => this.getArrayBuffer(e)));
            return Promise.all(t);
        }
        return new Promise(((t, n) => {
            let r = e;
            this.urlModifier && (r = this.urlModifier(e)), Ue.getArrayBuffer(r, ((r, i) => {
                r ? n(r) : t({
                    url: e,
                    data: i
                });
            }));
        }));
    }
    disposeRes(e) {
        return Array.isArray(e) ? e.forEach((e => this._disposeOne(e))) : this._disposeOne(e), 
        this;
    }
    isLoading() {
        return this._count && this._count > 0;
    }
    getDefaultTexture(e) {
        return Array.isArray(e) ? this._getBlankTextures(e.length) : this.defaultTexture;
    }
    _disposeOne(e) {
        const t = this.resources;
        t[e] && (t[e].count--, t[e].count <= 0 && delete t[e]);
    }
    _loadImage(e) {
        const t = this.resources;
        if (t[e]) return Promise.resolve({
            url: e,
            data: t[e].image
        });
        return new Promise(((n, r) => {
            const i = new Image;
            i.crossOrigin = "anonymous", i.onload = function() {
                t[e] = {
                    image: i,
                    count: 1
                }, n({
                    url: e,
                    data: i
                });
            }, i.onerror = function(e) {
                r(e);
            }, i.onabort = function() {
                r(`image(${e}) loading aborted.`);
            }, i.src = this.urlModifier ? this.urlModifier(e) : e;
        }));
    }
    _loadImages(e) {
        const t = e.map((e => this._loadImage(e)));
        return Promise.all(t);
    }
    _getBlankTextures(e) {
        const t = new Array(e);
        for (let e = 0; e < 6; e++) t.push(this.defaultTexture);
        return t;
    }
}

class Xe extends(N(je)){}

const We = [ 0, 0, 0 ], qe = [ 0, 0, 0 ];

let Ke, Je = 0;

function Ye(e, n) {
    return t.transformMat4(We, e.geometry.boundingBox.getCenter(), e.localTransform), 
    t.transformMat4(qe, n.geometry.boundingBox.getCenter(), n.localTransform), t.dist(qe, Ke) - t.dist(We, Ke);
}

class Ze {
    constructor(e) {
        this._id = Je++, this.sortedMeshes = {}, this.setMeshes(e), this.dirty();
    }
    setMeshes(e) {
        if (this.clear(), !e || Array.isArray(e) && !e.length || e === this.meshes) return this;
        e = Array.isArray(e) ? e : [ e ], this.meshes = [];
        for (let t = 0; t < e.length; t++) {
            const n = e[t];
            n && (n._scenes = n._scenes || {}, n._scenes[this._id] = 1, this.meshes.push(n));
        }
        return this.dirty(), this;
    }
    addMesh(e) {
        if (!e || Array.isArray(e) && !e.length) return this;
        if (Array.isArray(e)) e.forEach((e => {
            const t = e._scenes = e._scenes || {};
            t[this._id] || (t[this._id] = 1, this.meshes.push(e), this.dirty());
        })); else {
            const t = e._scenes = e._scenes || {};
            t[this._id] || (t[this._id] = 1, this.meshes.push(e), this.dirty());
        }
        return this;
    }
    removeMesh(e) {
        if (!e || Array.isArray(e) && !e.length) return this;
        if (Array.isArray(e)) {
            let t = !1;
            for (let n = 0; n < e.length; n++) {
                const r = e[n]._scenes;
                r && r[this._id] && (t = !0, this.dirty(), delete r[this._id]);
            }
            t && (this.meshes = this.meshes.filter((t => e.indexOf(t) < 0)));
        } else {
            const t = e._scenes;
            if (!t || !t[this._id]) return this;
            const n = this.meshes.indexOf(e);
            n >= 0 && this.meshes.splice(n, 1), delete t[this._id], this.dirty();
        }
        return this;
    }
    getMeshes() {
        return this.meshes || [];
    }
    clear() {
        if (this.meshes) for (let e = 0; e < this.meshes.length; e++) delete this.meshes[e]._scenes[this._id];
        return this.meshes = [], this.sortedMeshes.opaques = [], this.sortedMeshes.transparents = [], 
        this;
    }
    dirty() {
        return this._dirty = !0, this;
    }
    sortMeshes(e) {
        const t = this.meshes;
        this.sortFunction && t.sort(this.sortFunction);
        let n = this.sortedMeshes.transparents;
        if (this._dirty) {
            const e = this.sortedMeshes.opaques = [];
            n = this.sortedMeshes.transparents = [];
            for (let r = 0, i = t.length; r < i; r++) t[r].transparent ? n.push(t[r]) : e.push(t[r]);
        }
        e && n.length > 1 && (Ke = e, n.sort(Ye)), this._dirty = !1;
    }
    getSortedMeshes() {
        return this._dirty && this.sortMeshes(), this.sortedMeshes || {};
    }
}

const $e = String.fromCharCode, Qe = 8, et = 32767;

function tt(e, t, n, r) {
    if (e[3] > 0) {
        const i = Math.pow(2, e[3] - 128 - 8 + r);
        t[n + 0] = e[0] * i, t[n + 1] = e[1] * i, t[n + 2] = e[2] * i;
    } else t[n + 0] = 0, t[n + 1] = 0, t[n + 2] = 0;
    return t[n + 3] = 1, t;
}

function nt(e, t, n, r) {
    let i = 0, o = 0, a = r;
    for (;a > 0; ) if (e[o][0] = t[n++], e[o][1] = t[n++], e[o][2] = t[n++], e[o][3] = t[n++], 
    1 === e[o][0] && 1 === e[o][1] && 1 === e[o][2]) {
        for (let t = e[o][3] << i >>> 0; t > 0; t--) (c = e[o])[0] = (s = e[o - 1])[0], 
        c[1] = s[1], c[2] = s[2], c[3] = s[3], o++, a--;
        i += 8;
    } else o++, a--, i = 0;
    var s, c;
    return n;
}

function rt(e, t, n, r) {
    if (r < Qe | r > et) return nt(e, t, n, r);
    let i = t[n++];
    if (2 !== i) return nt(e, t, n - 1, r);
    if (e[0][1] = t[n++], e[0][2] = t[n++], i = t[n++], (e[0][2] << 8 >>> 0 | i) >>> 0 !== r) return null;
    for (let i = 0; i < 4; i++) for (let o = 0; o < r; ) {
        let r = t[n++];
        if (r > 128) {
            r = (127 & r) >>> 0;
            const a = t[n++];
            for (;r--; ) e[o++][i] = a;
        } else for (;r--; ) e[o++][i] = t[n++];
    }
    return n;
}

function it(e, t = 0) {
    const n = new Uint8Array(e), r = n.length;
    if ("#?" !== function(e, t, n) {
        let r = "";
        for (let i = t; i < n; i++) r += $e(e[i]);
        return r;
    }(n, 0, 2)) return null;
    for (var i = 2; i < r && ("\n" !== $e(n[i]) || "\n" !== $e(n[i + 1])); i++) ;
    if (i >= r) return null;
    i += 2;
    let o = "";
    for (;i < r; i++) {
        const e = $e(n[i]);
        if ("\n" === e) break;
        o += e;
    }
    const a = o.split(" "), s = parseInt(a[1]), c = parseInt(a[3]);
    if (!c || !s) return null;
    let l = i + 1;
    const f = [];
    for (let e = 0; e < c; e++) {
        f[e] = [];
        for (let t = 0; t < 4; t++) f[e][t] = 0;
    }
    const d = new Float32Array(c * s * 4);
    let u = 0;
    for (let e = 0; e < s; e++) {
        if (l = rt(f, n, l, c), !l) return null;
        for (let e = 0; e < c; e++) tt(f[e], d, u, t), u += 4;
    }
    return {
        width: c,
        height: s,
        pixels: d
    };
}

const ot = at();

function at() {
    const e = new ArrayBuffer(4), t = new Float32Array(e), n = new Uint32Array(e), r = new Uint32Array(512), i = new Uint32Array(512);
    for (let e = 0; e < 256; ++e) {
        const t = e - 127;
        t < -27 ? (r[e] = 0, r[256 | e] = 32768, i[e] = 24, i[256 | e] = 24) : t < -14 ? (r[e] = 1024 >> -t - 14, 
        r[256 | e] = 1024 >> -t - 14 | 32768, i[e] = -t - 1, i[256 | e] = -t - 1) : t <= 15 ? (r[e] = t + 15 << 10, 
        r[256 | e] = t + 15 << 10 | 32768, i[e] = 13, i[256 | e] = 13) : t < 128 ? (r[e] = 31744, 
        r[256 | e] = 64512, i[e] = 24, i[256 | e] = 24) : (r[e] = 31744, r[256 | e] = 64512, 
        i[e] = 13, i[256 | e] = 13);
    }
    const o = new Uint32Array(2048), a = new Uint32Array(64), s = new Uint32Array(64);
    for (let e = 1; e < 1024; ++e) {
        let t = e << 13, n = 0;
        for (;!(8388608 & t); ) t <<= 1, n -= 8388608;
        t &= -8388609, n += 947912704, o[e] = t | n;
    }
    for (let e = 1024; e < 2048; ++e) o[e] = 939524096 + (e - 1024 << 13);
    for (let e = 1; e < 31; ++e) a[e] = e << 23;
    a[31] = 1199570944, a[32] = 2147483648;
    for (let e = 33; e < 63; ++e) a[e] = 2147483648 + (e - 32 << 23);
    a[63] = 3347054592;
    for (let e = 1; e < 64; ++e) 32 !== e && (s[e] = 1024);
    return {
        floatView: t,
        uint32View: n,
        baseTable: r,
        shiftTable: i,
        mantissaTable: o,
        exponentTable: a,
        offsetTable: s
    };
}

const st = {
    toHalfFloat: function(e) {
        Math.abs(e) > 65504 && console.warn("THREE.DataUtils.toHalfFloat(): Value out of range."), 
        e = y(e, -65504, 65504), ot.floatView[0] = e;
        const t = ot.uint32View[0], n = t >> 23 & 511;
        return ot.baseTable[n] + ((8388607 & t) >> ot.shiftTable[n]);
    },
    fromHalfFloat: function(e) {
        const t = e >> 10;
        return ot.uint32View[0] = ot.mantissaTable[ot.offsetTable[t] + (1023 & e)] + ot.exponentTable[t], 
        ot.floatView[0];
    }
};

class ct extends G {
    onLoad({data: e}) {
        const t = this.config;
        if (t) {
            if (t.hdr) {
                if (!(e = it(e.data, 0))) throw new Error("Invalid hdr data" + (t.url ? ":" + t.url : ""));
                {
                    const n = new Uint16Array(e.pixels.length);
                    for (let t = 0; t < e.pixels.length; t++) n[t] = Math.min(st.toHalfFloat(e.pixels[t]), 65504);
                    t.data = n, t.type = "float16", t.colorSpace = "browser", t.min = "linear", t.mag = "linear";
                }
            } else t.data = e;
            t.width = t.width || e.width, t.height = t.height || e.height, this._regl && this._checkNPOT(this._regl), 
            this._updateREGL();
        }
    }
    createREGLTexture(e) {
        if (this._regl = e, this._checkNPOT(e), p(this.config.data) || p(this.config.mipmap)) {
            const t = me(e, this.config);
            return t[B] || (t[B] = 0), t[B]++, t;
        }
        return e.texture(this.config);
    }
    _checkNPOT(e) {
        const t = this.config;
        t.data && this._needPowerOf2(e) && (t.data instanceof Image ? (t.data = D(t.data), 
        t.width = t.data.width, t.height = t.data.height) : t.hdr || !p(t.data) || I(t.width) && I(t.height) || (t.data = D(t.data, t.width, t.height), 
        t.width = t.data.width, t.height = t.data.height));
    }
}

class lt extends Z {
    constructor(e) {
        super({
            aPosition: new (b(e = e || 0))([ -1, -1, e, 1, -1, e, -1, 1, e, 1, 1, e ]),
            aNormal: new Int8Array([ 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1 ])
        }, new Uint16Array([ 0, 1, 3, 3, 2, 0 ]));
    }
}

const ft = {
    vsm_shadow_vert: "\nuniform mat4 shadow_lightProjViewModelMatrix;\nvarying vec4 shadow_vLightSpacePos;\nvoid shadow_computeShadowPars(vec4 position) {\n    shadow_vLightSpacePos = shadow_lightProjViewModelMatrix * position;\n}",
    vsm_shadow_frag: "\nuniform sampler2D shadow_shadowMap;\nuniform float shadow_opacity;\nuniform vec3 shadow_color;\n#if defined(USE_ESM)\n    uniform float esm_shadow_threshold;\n#endif\nvarying vec4 shadow_vLightSpacePos;\n#ifdef PACK_FLOAT\n    #include <common_pack_float>\n#endif\n#if defined(USE_ESM)\nfloat esm(vec3 projCoords, vec4 shadowTexel) {\n    float compare = projCoords.z;\n    float c = 120.0;\n    #ifdef PACK_FLOAT\n        float depth = common_decodeDepth(shadowTexel);\n        if (depth >= 1.0 - 1E-6 || compare <= depth) {\n            return 1.0;\n        }\n    #else\n        float depth = shadowTexel.r;\n    #endif\n    depth = exp(-c * min(compare - depth, 0.05));\n    return clamp(depth, esm_shadow_threshold, 1.0);\n}\n#endif\n#if defined(USE_VSM)\nfloat vsm_shadow_chebyshevUpperBound(vec3 projCoords, vec4 shadowTexel){\n    vec2 moments = shadowTexel.rg;\n    float distance = projCoords.z;\n    if (distance >= 1.0 || distance <= moments.x)\n        return 1.0 ;\n    float variance = moments.y - (moments.x * moments.x);\n    variance = max(variance, 0.00002);\n    float d = distance - moments.x;\n    float p_max = variance / (variance + d * d);\n    return p_max;\n}\n#endif\nfloat shadow_computeShadow_coeff(sampler2D shadowMap, vec3 projCoords) {\n    vec2 uv = projCoords.xy;\n    vec4 shadowTexel = texture2D(shadowMap, uv);\n    #if defined(USE_ESM)\n        float esm_coeff = esm(projCoords, shadowTexel);\n        float coeff = esm_coeff * esm_coeff;\n    #endif\n    #if defined(USE_VSM)\n        float vsm_coeff = vsm_shadow_chebyshevUpperBound(projCoords, shadowTexel);\n        float coeff = vsm_coeff;\n    #endif\n    return 1.0 - (1.0 - coeff) * shadow_opacity;\n}\nfloat shadow_computeShadow() {\n    vec3 projCoords = shadow_vLightSpacePos.xyz / shadow_vLightSpacePos.w;\n    projCoords = projCoords * 0.5 + 0.5;\n    if(projCoords.z >= 1.0 || projCoords.x < 0.0 || projCoords.x > 1.0 || projCoords.y < 0.0 || projCoords.y > 1.0) return 1.0;\n    return shadow_computeShadow_coeff(shadow_shadowMap, projCoords);\n}\nvec3 shadow_blend(vec3 color, float coeff) {\n    color = color * coeff + shadow_color * shadow_opacity * (1.0 - coeff);\n    return color;\n}",
    fbo_picking_vert: "\n#ifdef ENABLE_PICKING\n#if HAS_PICKING_ID == 1\nattribute float aPickingId;\n#elif HAS_PICKING_ID == 2\nuniform float uPickingId;\n#endif\nvarying float vPickingId;\nvarying float vFbo_picking_viewZ;\nvarying float vFbo_picking_visible;\n#endif\nvarying float vFbo_picking_fragDepth;\nvoid fbo_picking_setData(float viewPosZ, bool visible) {\n    #ifdef ENABLE_PICKING\n    #if HAS_PICKING_ID == 1\n       vPickingId = aPickingId;\n    #elif HAS_PICKING_ID == 2\n        vPickingId = uPickingId;\n    #endif\n        vFbo_picking_viewZ = viewPosZ;\n    #endif\n    vFbo_picking_visible = visible ? 1.0 : 0.0;\n    vFbo_picking_fragDepth = viewPosZ + 1.0;\n}",
    common_pack_float: "const float COMMON_FLOAT_MAX =  1.70141184e38;\nconst float COMMON_FLOAT_MIN = 1.17549435e-38;\nfloat common_packFloat(vec4 val){\n    vec4 scl = floor(255.0 * val + 0.5);\n    float sgn = (scl.a < 128.0) ? 1.0 : -1.0;\n    float exn = mod(scl.a * 2.0, 256.0) + floor(scl.b / 128.0) - 127.0;\n    float man = 1.0 +\n        (scl.r / 8388608.0) +\n        (scl.g / 32768.0) +\n        mod(scl.b, 128.0) / 128.0;\n    return sgn * man * pow(2.0, exn);\n}\nvec4 common_unpackFloat(highp float v) {\n    highp float av = abs(v);\n    if(av < COMMON_FLOAT_MIN) {\n        return vec4(0.0, 0.0, 0.0, 0.0);\n    } else if(v > COMMON_FLOAT_MAX) {\n        return vec4(127.0, 128.0, 0.0, 0.0) / 255.0;\n    } else if(v < -COMMON_FLOAT_MAX) {\n        return vec4(255.0, 128.0, 0.0, 0.0) / 255.0;\n    }\n    highp vec4 c = vec4(0,0,0,0);\n    highp float e = floor(log2(av));\n    highp float m = av * pow(2.0, -e) - 1.0;\n    c[1] = floor(128.0 * m);\n    m -= c[1] / 128.0;\n    c[2] = floor(32768.0 * m);\n    m -= c[2] / 32768.0;\n    c[3] = floor(8388608.0 * m);\n    highp float ebias = e + 127.0;\n    c[0] = floor(ebias / 2.0);\n    ebias -= c[0] * 2.0;\n    c[1] += floor(ebias) * 128.0;\n    c[0] += 128.0 * step(0.0, -v);\n    return c / 255.0;\n}\nvec4 common_encodeDepth(const in float depth) {\n    float alpha = 1.0;\n    vec4 pack = vec4(0.0);\n    pack.a = alpha;\n    const vec3 code = vec3(1.0, 255.0, 65025.0);\n    pack.rgb = vec3(code * depth);\n    pack.gb = fract(pack.gb);\n    pack.rg -= pack.gb * (1.0 / 256.0);\n    pack.b -= mod(pack.b, 4.0 / 255.0);\n    return pack;\n}\nfloat common_decodeDepth(const in vec4 pack) {\n    return pack.r + pack.g / 255.0;\n}",
    invert_matrix: "mat4 invert_matrix(mat4 matrix) {\n    #if __VERSION__ == 300\n        return inverse(matrix);\n    #else\n        vec4 vector1 = matrix[0], vector2 = matrix[1], vector3 = matrix[2], vector4 = matrix[3];\n        float a00 = vector1.x, a01 = vector1.y, a02 = vector1.z, a03 = vector1.w;\n        float a10 = vector2.x, a11 = vector2.y, a12 = vector2.z, a13 = vector2.w;\n        float a20 = vector3.x, a21 = vector3.y, a22 = vector3.z, a23 = vector3.w;\n        float a30 = vector4.x, a31 = vector4.y, a32 = vector4.z, a33 = vector4.w;\n        float b00 = a00 * a11 - a01 * a10;\n        float b01 = a00 * a12 - a02 * a10;\n        float b02 = a00 * a13 - a03 * a10;\n        float b03 = a01 * a12 - a02 * a11;\n        float b04 = a01 * a13 - a03 * a11;\n        float b05 = a02 * a13 - a03 * a12;\n        float b06 = a20 * a31 - a21 * a30;\n        float b07 = a20 * a32 - a22 * a30;\n        float b08 = a20 * a33 - a23 * a30;\n        float b09 = a21 * a32 - a22 * a31;\n        float b10 = a21 * a33 - a23 * a31;\n        float b11 = a22 * a33 - a23 * a32;\n        float det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;\n        det = 1.0 / det;\n        mat4 m = mat4(\n            (a11 * b11 - a12 * b10 + a13 * b09) * det,\n            (a02 * b10 - a01 * b11 - a03 * b09) * det,\n            (a31 * b05 - a32 * b04 + a33 * b03) * det,\n            (a22 * b04 - a21 * b05 - a23 * b03) * det,\n            (a12 * b08 - a10 * b11 - a13 * b07) * det,\n            (a00 * b11 - a02 * b08 + a03 * b07) * det,\n            (a32 * b02 - a30 * b05 - a33 * b01) * det,\n            (a20 * b05 - a22 * b02 + a23 * b01) * det,\n            (a10 * b10 - a11 * b08 + a13 * b06) * det,\n            (a01 * b08 - a00 * b10 - a03 * b06) * det,\n            (a30 * b04 - a31 * b02 + a33 * b00) * det,\n            (a21 * b02 - a20 * b04 - a23 * b00) * det,\n            (a11 * b07 - a10 * b09 - a12 * b06) * det,\n            (a00 * b09 - a01 * b07 + a02 * b06) * det,\n            (a31 * b01 - a30 * b03 - a32 * b00) * det,\n            (a20 * b03 - a21 * b01 + a22 * b00) * det\n        );\n        return m;\n    #endif\n}\nmat4 transpose_matrix(mat4 matrix) {\n    #if __VERSION__ == 300\n        return transpose(matrix);\n    #else\n        vec4 vector1 = matrix[0], vector2 = matrix[1], vector3 = matrix[2], vector4 = matrix[3];\n        float a01 = vector1.y, a02 = vector1.z, a03 = vector1.w;\n        float a12 = vector2.z, a13 = vector2.w;\n        float a23 = vector3.w;\n        mat4 m = mat4(\n            vector1.x,\n            vector2.x,\n            vector3.x,\n            vector4.x,\n            a01,\n            vector2.y,\n            vector3.y,\n            vector4.y,\n            a02,\n            a12,\n            vector3.z,\n            vector4.z,\n            a03,\n            a13,\n            a23,\n            vector4.w\n        );\n        return m;\n    #endif\n}",
    get_output: "#include <invert_matrix>\n#include <draco_decode_vert>\n#ifdef HAS_INSTANCE\n    #include <instance_vert>\n    #ifdef HAS_INSTANCE_COLOR\n        varying vec4 vInstanceColor;\n    #endif\n#endif\n#ifdef HAS_SKIN\n    uniform int skinAnimation;\n    #include <skin_vert>\n#endif\n#include <mask_vert>\n#ifdef HAS_MORPH\n    attribute vec3 POSITION0;\n    attribute vec3 POSITION1;\n    attribute vec3 POSITION2;\n    attribute vec3 POSITION3;\n    attribute vec3 POSITION4;\n    attribute vec3 POSITION5;\n    attribute vec3 POSITION6;\n    attribute vec3 POSITION7;\n    #ifdef HAS_MORPHNORMALS\n        attribute vec3 NORMAL0;\n        attribute vec3 NORMAL1;\n        attribute vec3 NORMAL2;\n        attribute vec3 NORMAL3;\n    #endif\n    uniform vec4 morphWeights1;\n    uniform vec4 morphWeights2;\n#endif\n#ifdef HAS_TERRAIN_ALTITUDE\nattribute float aTerrainAltitude;\n#endif\nmat4 getPositionMatrix() {\n    mat4 worldMatrix;\n    #ifdef HAS_INSTANCE\n        #ifdef HAS_INSTANCE_COLOR\n            vInstanceColor = instance_getInstanceColor();\n        #endif\n        mat4 attributeMatrix = instance_getAttributeMatrix();\n        #ifdef HAS_SKIN\n            if (skinAnimation == 1) {\n                worldMatrix = attributeMatrix * positionMatrix * skin_getSkinMatrix();\n            } else {\n                worldMatrix = attributeMatrix * positionMatrix;\n            }\n        #else\n            worldMatrix = attributeMatrix * positionMatrix;\n        #endif\n    #else\n        #ifdef HAS_SKIN\n            if (skinAnimation == 1) {\n                worldMatrix = skin_getSkinMatrix() * positionMatrix;\n            } else {\n                worldMatrix = positionMatrix;\n            }\n        #else\n            worldMatrix = positionMatrix;\n        #endif\n    #endif\n    return worldMatrix;\n}\n#ifdef HAS_MIN_ALTITUDE\nuniform float minAltitude;\n#endif\nvec4 getPosition(vec3 aPosition) {\n    vec3 position = decode_getPosition(aPosition);\n    #ifdef HAS_MORPH\n        vec4 POSITION = vec4(position + morphWeights1[0] * POSITION0 + morphWeights1[1] * POSITION1 + morphWeights1[2] * POSITION2 + morphWeights1[3] * POSITION3\n        + morphWeights2[0] * POSITION4 + morphWeights2[1] * POSITION5 + morphWeights2[2] * POSITION6 + morphWeights2[3] * POSITION7\n        , 1.0);\n    #else\n        vec4 POSITION = vec4(position, 1.0);\n    #endif\n    #ifdef HAS_TERRAIN_ALTITUDE\n        POSITION.z += aTerrainAltitude * 100.0;\n    #endif\n    #ifdef HAS_MIN_ALTITUDE\n        POSITION.z += minAltitude * 100.0;\n    #endif\n    return POSITION;\n}\nvec3 appendMorphNormal(vec3 NORMAL) {\n    #ifdef HAS_MORPHNORMALS\n        vec3 normal = NORMAL + morphWeights1[0] * NORMAL0 + morphWeights1[1] * NORMAL1 + morphWeights1[2] * NORMAL2 + morphWeights1[3] * NORMAL3;\n    #else\n        vec3 normal = NORMAL;\n    #endif\n    return normal;\n}",
    instance_vert: "attribute vec4 instance_vectorA;\nattribute vec4 instance_vectorB;\nattribute vec4 instance_vectorC;\n#ifdef HAS_INSTANCE_TERRAIN_ALTITUDE\nattribute float aTerrainAltitude;\nuniform float terrainAltitudeScale;\n#endif\nmat4 instance_getAttributeMatrix() {\n    mat4 mat =  mat4(\n        instance_vectorA.x, instance_vectorB.x, instance_vectorC.x, 0.0,\n        instance_vectorA.y, instance_vectorB.y, instance_vectorC.y, 0.0,\n        instance_vectorA.z, instance_vectorB.z, instance_vectorC.z, 0.0,\n        instance_vectorA.w, instance_vectorB.w, instance_vectorC.w, 1.0\n    );\n    #ifdef HAS_INSTANCE_TERRAIN_ALTITUDE\n        mat4 terrainMat = mat4(\n            1., 0., 0., 0.,\n            0., 1., 0., 0.,\n            0., 0., 1., 0.,\n            0., 0., aTerrainAltitude * terrainAltitudeScale, 1.\n        );\n        mat = terrainMat * mat;\n    #endif\n    return mat;\n}\n#ifdef HAS_INSTANCE_HIGHLIGHT\n    attribute vec4 highlight_color;\n#endif\n#ifdef HAS_INSTANCE_COLOR\n   \n    attribute vec4 instance_color;\n    vec4 instance_getInstanceColor() {\n        vec4 color = instance_color;\n        #ifdef HAS_INSTANCE_HIGHLIGHT\n            color = instance_color * highlight_color;\n        #endif\n        return color;\n    }\n#endif",
    skin_vert: "attribute vec4 WEIGHTS_0;\nattribute vec4 JOINTS_0;\nuniform sampler2D jointTexture;\nuniform vec2 jointTextureSize;\nuniform float numJoints;\n#define ROW0_U ((0.5 + 0.0) / 4.)\n#define ROW1_U ((0.5 + 1.0) / 4.)\n#define ROW2_U ((0.5 + 2.0) / 4.)\n#define ROW3_U ((0.5 + 3.0) / 4.)\nmat4 skin_getBoneMatrix(float jointNdx) {\n    float v = (jointNdx + 0.5) / numJoints;\n    return mat4(\n        texture2D(jointTexture, vec2(ROW0_U, v)),\n        texture2D(jointTexture, vec2(ROW1_U, v)),\n        texture2D(jointTexture, vec2(ROW2_U, v)),\n        texture2D(jointTexture, vec2(ROW3_U, v)));\n}\nmat4 skin_getSkinMatrix() {\n        mat4 skinMatrix = skin_getBoneMatrix(JOINTS_0[0]) * WEIGHTS_0[0] +\n                        skin_getBoneMatrix(JOINTS_0[1]) * WEIGHTS_0[1] +\n                        skin_getBoneMatrix(JOINTS_0[2]) * WEIGHTS_0[2] +\n                        skin_getBoneMatrix(JOINTS_0[3]) * WEIGHTS_0[3];\n        return skinMatrix;\n}",
    heatmap_render_vert: "#ifdef HAS_HEATMAP\nvarying vec2 heatmap_vTexCoord;\nvoid heatmap_compute(mat4 matrix, vec3 position) {\n    vec4 pos = matrix * vec4(position.xy, 0., 1.);\n    heatmap_vTexCoord = (1. + pos.xy / pos.w) / 2.;\n}\n#endif",
    heatmap_render_frag: "#ifdef HAS_HEATMAP\nuniform sampler2D heatmap_inputTexture;\nuniform sampler2D heatmap_colorRamp;\nuniform float heatmap_heatmapOpacity;\nvarying vec2 heatmap_vTexCoord;\nvec4 heatmap_getColor(vec4 color) {\n    float t = texture2D(heatmap_inputTexture, heatmap_vTexCoord).r;\n    vec4 heatmapColor = texture2D(heatmap_colorRamp, vec2(t, 0.5)) * heatmap_heatmapOpacity;\n    return color * (1.0 - heatmapColor.a) + heatmapColor * heatmapColor.a;\n}\n#endif",
    line_extrusion_vert: "#ifdef IS_LINE_EXTRUSION\n    #define ALTITUDE_SCALE 32767.0;\n    #define EXTRUDE_SCALE 63.0;\n    attribute vec2 aExtrude;\n    #ifdef HAS_LINE_WIDTH\n        attribute float aLineWidth;\n    #else\n        uniform float lineWidth;\n    #endif\n    #ifdef HAS_LINE_HEIGHT\n        attribute float aLineHeight;\n    #else\n        uniform float lineHeight;\n    #endif\n    uniform float linePixelScale;\n    vec3 getLineExtrudePosition(vec3 position) {\n        #ifdef HAS_LINE_WIDTH\n            float lineWidth = aLineWidth / 2.0;\n        #endif\n        #ifdef HAS_LINE_HEIGHT\n            float lineHeight = aLineHeight / 10.0;\n        #endif\n        float halfwidth = lineWidth / 2.0;\n        float outset = halfwidth;\n        vec2 dist = outset * aExtrude / EXTRUDE_SCALE;\n        position.z *= lineHeight / ALTITUDE_SCALE;\n        return position + vec3(dist, 0.0) * linePixelScale;\n    }\n#endif",
    gl2_vert: "#if __VERSION__ == 300\n    #define texture2D texture\n    #define varying out\n    #define attribute in\n#endif",
    gl2_frag: "#if __VERSION__ == 300\n    #define varying in\n    #define gl_FragDepthEXT gl_FragDepth\n    #define texture2D texture\n    #define textureCube texture\n    #define texture2DProj textureProj\n    #define texture2DLodEXT textureLod\n    #define texture2DProjLodEXT textureProjLod\n    #define textureCubeLodEXT textureLod\n    #define texture2DGradEXT textureGrad\n    #define texture2DProjGradEXT textureProjGrad\n    #define textureCubeGradEXT textureGrad\n    out vec4 glFragColor;\n#else\n    vec4 glFragColor;\n#endif",
    hsv_frag: "\nconst mediump vec4 HSV_K0 = vec4(0.0, -1.0 / 3.0, 2.0 / 3.0, -1.0);\nconst mediump vec4 HSV_K1 = vec4(1.0, 2.0 / 3.0, 1.0 / 3.0, 3.0);\nconst mediump float HSV_E = 1.0e-10;\nvec3 hsv_rgb2hsv(vec3 c) {\n    vec4 K = HSV_K0;\n    vec4 p = mix(vec4(c.bg, K.wz), vec4(c.gb, K.xy), step(c.b, c.g));\n    vec4 q = mix(vec4(p.xyw, c.r), vec4(c.r, p.yzx), step(p.x, c.r));\n    float d = q.x - min(q.w, q.y);\n    float e = HSV_E;\n    return vec3(abs(q.z + (q.w - q.y) / (6.0 * d + e)), d / (q.x + e), q.x);\n}\nvec3 hsv_hsv2rgb(vec3 c) {\n    vec4 K = HSV_K1;\n    vec3 p = abs(fract(c.xxx + K.xyz) * 6.0 - K.www);\n    return c.z * mix(K.xxx, clamp(p - K.xxx, 0.0, 1.0), c.y);\n}\nvec4 hsv_apply(vec4 c, vec3 hsvOffset) {\n    vec3 hsv = hsv_rgb2hsv(c.rgb);\n    hsv += hsv * hsvOffset;\n    hsv = clamp(hsv, 0.0, 1.0);\n    return vec4(hsv_hsv2rgb(hsv), c.a);\n}\nvec3 hsv_apply(vec3 c, vec3 hsvOffset) {\n    vec3 hsv = hsv_rgb2hsv(c.rgb);\n    hsv += hsv * hsvOffset;\n    hsv = clamp(hsv, 0.0, 1.0);\n    return hsv_hsv2rgb(hsv);\n}\nmat4 contrastMatrix(float contrast)\n{\n    float t = (1.0 - contrast) / 2.0;\n    return mat4(\n        contrast, 0., 0., 0.,\n        0., contrast, 0., 0.,\n        0., 0., contrast, 0.,\n        t, t, t, 1\n    );\n}",
    snow_frag: "#ifdef HAS_SNOW\n    float lerp(float a, float b, float w) {\n        return a + w * (b - a);\n    }\n    vec3 snow(vec4 sceneColor, vec3 normalColor, float height) {\n        float snowIntense = normalColor.b;\n        vec3 fixedC = vec3(1.0, 1.0, 1.0);\n        if (height < 1.0) {\n            float r = lerp(0.5, fixedC.x, snowIntense);\n            float g = lerp(0.5, fixedC.y, snowIntense);\n            float b = lerp(0.5, fixedC.z, snowIntense);\n            return vec3(r, g, b);\n        } else {\n            float r = lerp(sceneColor.r, fixedC.x, snowIntense);\n            float g = lerp(sceneColor.g, fixedC.y, snowIntense);\n            float b = lerp(sceneColor.b, fixedC.z, snowIntense);\n            return vec3(r, g, b);\n        }\n    }\n#endif",
    draco_decode_vert: "#if defined(HAS_TANGENT)\n    attribute vec4 aTangent;\n#elif defined(HAS_NORMAL)\n    #ifdef HAS_DRACO_NORMAL\n        attribute vec2 aNormal;\n        uniform float gltf_u_dec_normal_rangeConstant;\n    #else\n        attribute vec3 aNormal;\n    #endif\n#endif\n#ifdef HAS_DRACO_POSITION\n    uniform float gltf_u_dec_position_normConstant;\n    uniform vec3 minValues_pos;\n    vec3 decodeDracoPosition(vec3 aPosition) {\n        return minValues_pos + aPosition * gltf_u_dec_position_normConstant;\n    }\n#endif\n#ifdef HAS_DRACO_TEXCOORD\n    uniform vec2 minValues_tex;\n    uniform float gltf_u_dec_texcoord_0_normConstant;\n    vec2 decodeDracoTexcoord(vec2 aTexCoord) {\n        return minValues_tex + aTexCoord * gltf_u_dec_texcoord_0_normConstant;\n    }\n#endif\n#ifdef HAS_WEB3D_quantized_attributes_TEXCOORD\n    uniform mat3 decodeMatrix;\n#endif\n#ifdef HAS_DRACO_NORMAL\n    float czm_signNotZero(float value) {\n        return value >= 0.0 ? 1.0 : -1.0;\n    }\n    vec2 czm_signNotZero(vec2 value) {\n        return vec2(czm_signNotZero(value.x), czm_signNotZero(value.y));\n    }\n    vec3 decodeDracoNormal(vec2 encoded, float range)\n    {\n        if (encoded.x == 0.0 && encoded.y == 0.0) {\n            return vec3(0.0, 0.0, 0.0);\n        }\n        encoded = encoded / range * 2.0 - 1.0;\n        vec3 v = vec3(encoded.x, encoded.y, 1.0 - abs(encoded.x) - abs(encoded.y));\n        if (v.z < 0.0) {\n            v.xy = (1.0 - abs(v.yx)) * czm_signNotZero(v.xy);\n        }\n        return normalize(v);\n    }\n    vec3 decode_getNormal(vec2 aNormal) {\n        return decodeDracoNormal(aNormal, gltf_u_dec_normal_rangeConstant).zxy;\n    }\n#endif\n#ifdef HAS_COMPRESSED_INT16\n    #ifdef HAS_COMPRESSED_INT16_POSITION\n      uniform vec2 compressedPositionRange;\n    #endif\n    #ifdef HAS_COMPRESSED_INT16_TEXCOORD_0\n      uniform vec2 compressedTexcoordRange_0;\n    #endif\n    #ifdef HAS_COMPRESSED_INT16_TEXCOORD_1\n      uniform vec2 compressedTexcoordRange_1;\n    #endif\n    #ifdef HAS_COMPRESSED_INT16_NORMAL\n      uniform vec2 compressedNormalRange;\n    #endif\n    #ifdef HAS_COMPRESSED_INT16_RATIO\n      uniform float compressed_ratio;\n    #endif\n    float int16ToFloat32(float value, vec2 range) {\n        float v = (value >= 32768.0) ? -(65536.0 - value) / 32768.0 : value / 32767.0;\n        return (v + 1.0) * (range.y - range.x) / 2.0 + range.x;\n    }\n#endif\nvec3 decode_getPosition(vec3 aPosition) {\n    vec3 position = aPosition;\n    #if defined(HAS_COMPRESSED_INT16) && defined(HAS_COMPRESSED_INT16_POSITION)\n        float x = int16ToFloat32(aPosition.x, compressedPositionRange);\n        float y = int16ToFloat32(aPosition.y, compressedPositionRange);\n        float z = int16ToFloat32(aPosition.z, compressedPositionRange);\n        #ifdef HAS_COMPRESSED_INT16_RATIO\n          position = vec3(x / compressed_ratio, y / compressed_ratio, z);\n        #else\n          position = vec3(x, y, z);\n        #endif\n    #endif\n    #ifdef HAS_DRACO_POSITION\n        return decodeDracoPosition(position);\n    #else\n        return position;\n    #endif\n}\nvec2 decode_getTexcoord(vec2 aTexCoord) {\n    vec2 texcoord = aTexCoord;\n    #if defined(HAS_COMPRESSED_INT16) && (defined(HAS_COMPRESSED_INT16_TEXCOORD_0) || defined(HAS_COMPRESSED_INT16_TEXCOORD_1))\n        float x = int16ToFloat32(aTexCoord.x, compressedTexcoordRange_0);\n        float y = int16ToFloat32(aTexCoord.y, compressedTexcoordRange_0);\n        texcoord = vec2(x, y);\n    #endif\n    #ifdef HAS_DRACO_TEXCOORD\n        return decodeDracoTexcoord(texcoord);\n    #elif defined(HAS_WEB3D_quantized_attributes_TEXCOORD)\n        vec3 web3dTexcoord = decodeMatrix * vec3(texcoord, 1.0);\n        return vec2(web3dTexcoord.x, web3dTexcoord.y);\n    #else\n        return texcoord;\n    #endif\n}\nvec3 decode_getNormal(vec3 aNormal) {\n    #ifdef HAS_COMPRESSED_INT16_NORMAL\n        aNormal.x = int16ToFloat32(aNormal.x, compressedNormalRange);\n        aNormal.y = int16ToFloat32(aNormal.y, compressedNormalRange);\n        aNormal.z = int16ToFloat32(aNormal.z, compressedNormalRange);\n    #endif\n    return aNormal;\n}",
    highlight_vert: "#if defined(HAS_HIGHLIGHT_COLOR)\n    attribute vec4 aHighlightColor;\n    varying vec4 vHighlightColor;\n#endif\n#if defined(HAS_HIGHLIGHT_OPACITY)\n    attribute float aHighlightOpacity;\n    varying float vHighlightOpacity;\n#endif\nvoid highlight_setVarying() {\n    #if defined(HAS_HIGHLIGHT_COLOR)\n        vHighlightColor = aHighlightColor / 255.0;\n    #endif\n    #if defined(HAS_HIGHLIGHT_OPACITY)\n        vHighlightOpacity = aHighlightOpacity / 255.0;\n    #endif\n}",
    highlight_frag: "#if defined(HAS_HIGHLIGHT_COLOR)\n\tvarying vec4 vHighlightColor;\n#endif\n#if defined(HAS_HIGHLIGHT_OPACITY)\n    varying float vHighlightOpacity;\n#endif\nvec4 highlight_blendColor(vec4 color) {\n\tvec4 outColor;\n\t#if defined(HAS_HIGHLIGHT_COLOR)\n\t\tcolor.rgb = color.rgb * (1.0 - vHighlightColor.a) + vHighlightColor.rgb * vHighlightColor.a;\n\t\t#ifndef HAS_HIGHLIGHT_COLOR_POINT\n        \tcolor.a = color.a * (1.0 - vHighlightColor.a) + vHighlightColor.a;\n        #endif\n        outColor = color;\n\t#else\n\t\toutColor = color;\n\t#endif\n\t#if defined(HAS_HIGHLIGHT_OPACITY)\n\t\toutColor *= vHighlightOpacity;\n\t#endif\n\treturn outColor;\n}",
    mask_vert: "#ifdef HAS_MASK_EXTENT\n    uniform vec4 mask_extent;\n    uniform sampler2D mask_colorExtent;\n    uniform sampler2D mask_modeExtent;\n    uniform float mask_maskMode;\n    uniform float mask_hasFlatOut;\n    uniform mat4 viewMatrix;\n    uniform float mask_heightRatio;\n    uniform float mask_heightOffset;\n    varying vec4 vWorldPosition;\n    varying vec2 vUVInExtent;\n    varying float vHeightRatio;\n    varying float vHeightOffset;\n    const float CLIPINSIDE_MODE = 0.2;\n    const float FLATINSIDE_MODE = 0.3;\n    const float FLATOUTSIDE_MODE = 0.4;\n    const float ELEVATE_MODE = 0.7;\n    float random (vec2 st) {\n        return fract(sin(dot(st.xy,vec2(12.9898,78.233)))*43758.5453123) * 0.1;\n    }\n    bool isInExtent(vec4 color) {\n        return length(color.rgb) > 0.0;\n    }\n    float getFlatHeight(float maskMode, float flatHeight, float height) {\n      if (maskMode <= ELEVATE_MODE && maskMode > 0.6) {\n          return flatHeight + height;\n      } else {\n        return flatHeight;\n      }\n    }\n    vec4 getNoErrorPosition(vec4 position, vec4 wPosition) {\n      vec4 realPos = modelViewMatrix * position;      vec4 pos = viewMatrix * wPosition;      vec4 tempPos = viewMatrix * modelMatrix * position;      float deltaX = realPos.x - tempPos.x;\n      float deltaY = realPos.y - tempPos.y;\n      float deltaZ = realPos.z - tempPos.z;\n      pos.x = pos.x + deltaX;\n      pos.y = pos.y + deltaY;\n      pos.z = pos.z + deltaZ;\n      return pos;\n    }\n    vec4 getMaskPosition(vec4 position, mat4 modelMatrix) {\n        vWorldPosition = modelMatrix * position;\n        float w = mask_extent.z - mask_extent.x;\n        float h = mask_extent.y - mask_extent.w;\n        vec2 uvInExtent = vec2((vWorldPosition.x - mask_extent.x) / abs(w), 1.0 - (vWorldPosition.y - mask_extent.w) / h);\n        vec4 extentColor = texture2D(mask_colorExtent, uvInExtent);\n        vec3 maskOptionColor = texture2D(mask_modeExtent, uvInExtent).rgb;\n        float maskMode = maskOptionColor.r;\n        float flatHeight = maskOptionColor.g / mask_heightRatio + mask_heightOffset;\n        float height = getFlatHeight(maskMode, flatHeight, vWorldPosition.z);\n        vec4 wPosition = vec4(vWorldPosition.x, vWorldPosition.y, height, vWorldPosition.w);\n        vUVInExtent = uvInExtent;\n        vHeightRatio = mask_heightRatio;\n        vHeightOffset = mask_heightOffset;\n        if (maskMode <= FLATOUTSIDE_MODE && maskMode > FLATINSIDE_MODE) {\n            return modelViewMatrix * position;;\n        } else if (mask_hasFlatOut == 1.0) {\n            return getNoErrorPosition(position, wPosition);\n        }\n        if (isInExtent(extentColor) == true && maskMode <= FLATINSIDE_MODE && maskMode > CLIPINSIDE_MODE) {\n            return getNoErrorPosition(position, wPosition);\n        } if (isInExtent(extentColor) == true && maskMode <= ELEVATE_MODE && maskMode > 0.6) {\n            return getNoErrorPosition(position, wPosition);\n        } else {\n            return modelViewMatrix * position;\n        }\n    }\n#endif",
    mask_frag: "#ifdef HAS_MASK_EXTENT\n    uniform sampler2D mask_colorExtent;\n    uniform sampler2D mask_modeExtent;\n    uniform float mask_hasClipOut;\n    varying float vHeightRatio;\n    varying float vHeightOffset;\n    varying vec2 vUVInExtent;\n    varying vec4 vWorldPosition;\n    const float CLIPINSIDE_MODE = 0.1;\n    const float CLIPOUTSIDE_MODE = 0.2;\n    const float FLATINSIDE_MODE = 0.3;\n    const float FLATOUTSIDE_MODE = 0.4;\n    const float COLOR_MODE = 0.5;\n    const float VIDEO_MODE = 0.6;\n    bool isInExtent(vec4 color) {\n        return length(color.rgb) > 0.0;\n    }\n    vec4 setMask(vec4 glFragColor) {\n        vec4 extentColor = texture2D(mask_colorExtent, vUVInExtent);\n        vec4 modeColor = texture2D(mask_modeExtent, vUVInExtent);\n        float maskMode = modeColor.r;\n        float minHeight = modeColor.b / vHeightRatio + vHeightOffset;\n        float maxHeight = modeColor.a / vHeightRatio + vHeightOffset;\n        if (maskMode > CLIPINSIDE_MODE && maskMode <= CLIPOUTSIDE_MODE) {\n            if (minHeight == 0.0 && maxHeight == 0.0) {\n                return glFragColor;\n            } else if (vWorldPosition.z >= minHeight && vWorldPosition.z <= maxHeight) {\n                return glFragColor;\n            } else {\n              discard;\n            }\n        } else if (mask_hasClipOut == 1.0) {\n            discard;\n        }\n        if (isInExtent(extentColor) == true && maskMode <= CLIPINSIDE_MODE && maskMode > 0.0) {\n            if (minHeight == 0.0 && maxHeight == 0.0) {\n                discard;\n            } else if (vWorldPosition.z >= minHeight && vWorldPosition.z <= maxHeight) {\n                discard;\n            } else {\n              return glFragColor;\n            }\n        } else if (isInExtent(extentColor) == true && maskMode <= VIDEO_MODE && maskMode > FLATOUTSIDE_MODE) {\n            if (minHeight == 0.0 && maxHeight == 0.0) {\n                glFragColor = vec4(mix(extentColor.rgb, glFragColor.rgb, 1.0 - extentColor.a), glFragColor.a);\n            } else if (vWorldPosition.z >= minHeight && vWorldPosition.z <= maxHeight) {\n                glFragColor = vec4(mix(extentColor.rgb, glFragColor.rgb, 1.0 - extentColor.a), glFragColor.a);\n            }\n        }\n        return glFragColor;\n    }\n#endif",
    computeTexcoord_frag: "#ifdef HAS_KHR_TEXTURE_TRANSFORM\n    uniform vec2 khr_offset;\n    uniform float khr_rotation;\n    uniform vec2 khr_scale;\n    vec2 khr_tex_transformTexCoord(vec2 texCoords, vec2 offset, float rotation, vec2 scale) {\n        rotation = -rotation;\n        mat3 transform = mat3(\n        cos(rotation) * scale.x, sin(rotation) * scale.x, 0.0, -sin(rotation) * scale.y, cos(rotation) * scale.y, 0.0, offset.x, offset.y, 1.0);\n        vec2 transformedTexCoords = (transform * vec3(fract(texCoords), 1.0)).xy;\n        return transformedTexCoords;\n    }\n#endif\nvarying highp vec2 vTexCoord;\n#ifdef HAS_I3S_UVREGION\n    varying vec4 vUvRegion;\n#endif\nvec2 computeTexCoord(vec2 texCoord) {\n    #ifdef HAS_I3S_UVREGION\n        vec2 atlasScale = vUvRegion.zw - vUvRegion.xy;\n        vec2 uvAtlas = fract(texCoord) * atlasScale + vUvRegion.xy;\n        return uvAtlas;\n    #elif defined(HAS_KHR_TEXTURE_TRANSFORM)\n        return khr_tex_transformTexCoord(texCoord, khr_offset, khr_rotation, khr_scale);\n    #else\n        return texCoord;\n    #endif\n}",
    terrain_normal_frag: "#ifdef HAS_TERRAIN_NORMAL\n    uniform sampler2D terrainHeightTexture;\n    uniform vec2 terrainHeightMapResolution;\n    uniform vec2 terrainResolution;\n    uniform vec4 terrainUnpackFactors;\n    float getHeight(vec2 uv) {\n        vec4 color = texture2D(terrainHeightTexture, uv) * 255.0;\n        color.a = -1.0;\n        return dot(color, terrainUnpackFactors) / 4.0;\n    }\n    vec3 convertTerrainHeightToNormalMap(vec2 uv) {\n        uv.y = 1.0 - uv.y;\n        vec2 epsilon = 1.0 / terrainHeightMapResolution;\n        float a = getHeight(uv + vec2(-epsilon.x, -epsilon.y));\n        float b = getHeight(uv + vec2(0, -epsilon.y));\n        float c = getHeight(uv + vec2(epsilon.x, -epsilon.y));\n        float d = getHeight(uv + vec2(-epsilon.x, 0));\n        float e = getHeight(uv + vec2(epsilon.x, 0));\n        float f = getHeight(uv + vec2(-epsilon.x, epsilon.y));\n        float g = getHeight(uv + vec2(0, epsilon.y));\n        float h = getHeight(uv + vec2(epsilon.x, epsilon.y));\n        vec2 dxy = vec2(\n            (c + e + e + h) - (a + d + d + f),\n            (f + g + g + h) - (a + b + b + c)\n        );\n        return normalize(vec3(dxy / epsilon, terrainResolution ));\n    }\n#endif",
    vertex_color_vert: "#ifdef HAS_VERTEX_COLOR\nattribute float aVertexColorType;\nuniform vec4 vertexColorsOfType[VERTEX_TYPES_COUNT];\nvarying vec4 vertexColor_color;\nvoid vertexColor_update() {\n    vertexColor_color = vertexColorsOfType[int(aVertexColorType)];\n}\n#endif\n//用于识别顶点颜色类型: topPolygonFill 还是 bottomPolygonFill",
    vertex_color_frag: "#ifdef HAS_VERTEX_COLOR\nvarying vec4 vertexColor_color;\nvec4 vertexColor_get() {\n\treturn vertexColor_color;\n}\n#endif",
    excavate_vert: "#ifdef HAS_EXCAVATE_ANALYSIS\n  uniform vec4 excavateExtent;\n  varying vec2 vCoordinateTexcoord;\n  varying float vHeight;\n  float getWorldHeight() {\n    vec4 wPosition = modelMatrix * getPosition(aPosition);\n    return wPosition.z;\n  }\n  vec2 getCoordinateTexcoord() {\n    mat4 localPositionMatrix = getPositionMatrix();\n    vec4 wPosition = modelMatrix * localPositionMatrix * getPosition(aPosition);\n    float x = (wPosition.x - excavateExtent.x) / (excavateExtent.z - excavateExtent.x);\n    float y = (wPosition.y - excavateExtent.y) / (excavateExtent.w - excavateExtent.y);\n    return vec2(x, y);\n  }\n#endif",
    excavate_frag: "#ifdef HAS_EXCAVATE_ANALYSIS\n  uniform sampler2D heightmap;\n  uniform float excavateHeight;\n  varying vec2 vCoordinateTexcoord;\n  varying float vHeight;\n  const vec2 range = vec2(-100.0, 1000.0);\n  float decodeHeight(const in vec4 pack) {\n      return pack.r + pack.g / 255.0;\n  }\n  vec4 excavateColor(vec4 fragColor) {\n      float samplerHeight = decodeHeight(texture2D(heightmap, vCoordinateTexcoord));\n      float realHeight = samplerHeight * (range.y - range.x) + range.x;\n      if(realHeight < range.x || realHeight > range.y) {\n          realHeight = 0.0;\n      }\n      if(vHeight > realHeight) {\n          discard;\n      }\n      return fragColor;\n  }\n#endif",
    srgb_frag: "vec3 linearTosRGB(const in vec3 color) {\n    return vec3( color.r < 0.0031308 ? color.r * 12.92 : 1.055 * pow(color.r, 1.0/2.4) - 0.055, color.g < 0.0031308 ? color.g * 12.92 : 1.055 * pow(color.g, 1.0/2.4) - 0.055, color.b < 0.0031308 ? color.b * 12.92 : 1.055 * pow(color.b, 1.0/2.4) - 0.055);\n}\nvec3 sRGBToLinear(const in vec3 color) {\n    return vec3( color.r < 0.04045 ? color.r * (1.0 / 12.92) : pow((color.r + 0.055) * (1.0 / 1.055), 2.4), color.g < 0.04045 ? color.g * (1.0 / 12.92) : pow((color.g + 0.055) * (1.0 / 1.055), 2.4), color.b < 0.04045 ? color.b * (1.0 / 12.92) : pow((color.b + 0.055) * (1.0 / 1.055), 2.4));\n}"
};

var dt = {
    register(e, t) {
        if (ft[e]) throw new Error(`Key of ${e} is already registered in ShaderLib.`);
        ft[e] = t;
    },
    compile: e => ht(e)
};

const ut = /^[ \t]*#include +<([\w\d.]+)>/gm;

function ht(e) {
    return e.replace(ut, mt);
}

function mt(e, t) {
    const n = ft[t];
    if (!n) throw new Error("Can not resolve #include <" + t + ">");
    return ht(n);
}

const vt = "function", _t = "array";

let gt = 0;

const xt = {};

class pt {
    constructor({vert: e, frag: t, uniforms: n, defines: r, extraCommandProps: i}) {
        this.vert = e, this.frag = t;
        const o = gt++;
        Object.defineProperty(this, "uid", {
            enumerable: !0,
            configurable: !1,
            get: () => o
        }), this.shaderDefines = r && v({}, r) || {}, n = this.uniforms = (n || []).slice(), 
        this.contextDesc = {};
        for (let e = 0, t = n.length; e < t; e++) {
            const t = n[e];
            if (d(t)) if (t.indexOf("[") > 0) {
                const {name: e, len: n} = bt(t);
                this.contextDesc[e] = {
                    name: e,
                    type: "array",
                    length: n
                };
            } else this.contextDesc[t] = null; else if (t.name.indexOf("[") > 0) {
                const {name: e, len: n} = bt(t.name);
                this.contextDesc[e] = {
                    name: e,
                    type: "array",
                    length: n,
                    fn: t.fn
                };
            } else this.contextDesc[t.name] = t;
        }
        this.extraCommandProps = i && v({}, i) || {}, this.commands = {}, this._compileSource();
    }
    set shaderDefines(e) {
        this._shaderDefines = e, this.dkey = Object.keys(this._shaderDefines).join();
    }
    get shaderDefines() {
        return this._shaderDefines || {};
    }
    setDefines(e) {
        this.shaderDefines = e;
    }
    setFramebuffer(e) {
        return this.context.framebuffer = e, this;
    }
    appendDescUniforms(e, t) {
        const n = t, r = this.contextDesc;
        for (const i in r) if (r[i]) if ("array" === r[i].type) {
            const o = i, a = r[i].length;
            let s = t[i];
            if (r[i].fn && (s = r[i].fn(null, t)), !s) continue;
            if (s.length !== a) throw new Error(`${o} uniform's length is not ${a}`);
            n[o] = n[o] || {};
            for (let t = 0; t < a; t++) n[o][`${t}`] = s[t].getREGLTexture ? s[t].getREGLTexture(e) : s[t];
        } else "function" === r[i].type && (Object.getOwnPropertyDescriptor(n, i) || Object.defineProperty(n, i, {
            configurable: !1,
            enumerable: !0,
            get: function() {
                return r[i].fn(null, t);
            }
        }));
        return n;
    }
    setUniforms(e) {
        if (e.modelMatrix || e.positionMatrix) throw new Error("modelMatrix or positionMatrix is reserved uniform name for Mesh, please change to another name");
        return this.contextKeys = e ? Object.keys(e).join() : null, this.context = e, this;
    }
    getVersion(e, t) {
        if ("#version" === t.substring(0, 8)) return "";
        return 0 === e.limits.version.indexOf("WebGL 2.0") && 300 === this.version ? "#version 300 es\n" : "#version 100\n";
    }
    getActiveVars(e, t, n, r) {
        const i = r;
        if (xt[i]) return xt[i];
        const o = e._gl, a = o.createProgram(), s = o.createShader(35633);
        o.shaderSource(s, t), o.compileShader(s);
        const c = o.createShader(35632);
        o.shaderSource(c, n), o.compileShader(c), o.attachShader(a, c), o.attachShader(a, s), 
        o.linkProgram(a);
        const l = o.getProgramParameter(a, 35721), f = [];
        for (let e = 0; e < l; ++e) {
            const t = o.getActiveAttrib(a, e);
            t && f.push({
                name: t.name,
                type: t.type
            });
        }
        const d = o.getProgramParameter(a, 35718), u = [];
        for (let e = 0; e < d; ++e) {
            const t = o.getActiveUniform(a, e);
            let n = t.name;
            t.name.indexOf("[") > 0 && (n = n.replace("[0]", "")), u.push(n);
        }
        return o.deleteProgram(a), o.deleteShader(s), o.deleteShader(c), xt[i] = {
            activeUniforms: u,
            activeAttributes: f
        }, xt[i];
    }
    createREGLCommand(e, t, n, r, i, o = {}) {
        const a = A(e) && !i, s = v({}, this.shaderDefines || {}, t || {}), c = this._insertDefines(this.vert, s), l = this.getVersion(e, c) + c, f = this._insertDefines(this.frag, s), d = this.getVersion(e, f) + f, u = w(l) + "_" + w(d), {activeAttributes: h, activeUniforms: m} = this.getActiveVars(e, l, d, u), _ = {};
        h.forEach(((t, n) => {
            const r = t.name;
            _[r] = a ? n : e.prop(r);
        }));
        const x = {};
        m.forEach((t => {
            x[t] = e.prop(t);
        }));
        const p = this.contextDesc;
        for (const t in p) if (p[t] && p[t].type === vt) x[t] = p[t].fn; else if (p[t] && p[t].type === _t) {
            const n = p[t].name, r = p[t].length;
            for (let t = 0; t < r; t++) {
                const r = `${n}[${t}]`;
                x[r] = e.prop(r);
            }
        } else x[t] = e.prop(t);
        const b = {
            vert: l,
            frag: d,
            uniforms: x,
            attributes: _
        };
        a && (b.vao = e.prop("vao")), a && !r || !n || g(n) || (b.elements = e.prop("elements")), 
        b.count = e.prop("count"), b.offset = e.prop("offset"), b.primitive = e.prop("primitive"), 
        b.framebuffer = e.prop("framebuffer"), r && (b.instances = e.prop("instances")), 
        v(b, this.extraCommandProps, o);
        const y = e(b);
        return h.key = h.map((e => e.name)).join(), y.activeAttributes = h, y;
    }
    dispose() {
        for (const e in this.commands) {
            const t = this.commands[e];
            t && (t.destroy && !t[L] && (t[L] = !0, t.destroy()));
        }
        this.commands = {}, delete this.vert, delete this.frag;
    }
    _insertDefines(e, t) {
        const n = [];
        for (const e in t) S(t, e) && !m(t[e]) && n.push(`#define ${e} ${t[e]}\n`);
        return n.join("") + e;
    }
    _compileSource() {
        this.vert = dt.compile(this.vert), this.frag = dt.compile(this.frag);
    }
}

function bt(e) {
    const t = e.indexOf("["), n = e.indexOf("]");
    return {
        name: e.substring(0, t),
        len: +e.substring(t + 1, n)
    };
}

class yt extends pt {
    draw(e, t) {
        if (!t || !t.length) return 0;
        const n = [];
        let r, i = 0;
        for (let o = 0, a = t.length; o < a; o++) {
            if (!t[o].isValid()) {
                o === a - 1 && r && n.length && r(n);
                continue;
            }
            if (!t[o].geometry.getDrawCount() || !this._runFilter(t[o])) {
                o === a - 1 && r && n.length && r(n);
                continue;
            }
            const s = this.getMeshCommand(e, t[o]);
            n.length && r !== s && (r(n), n.length = 0);
            const c = t[o].getREGLProps(e, s.activeAttributes);
            this._ensureContextDefines(c), c.shaderContext = this.context, this.appendDescUniforms(e, c), 
            n.push(c), i++, o < a - 1 ? r = s : o === a - 1 && s(n);
        }
        return i;
    }
    _ensureContextDefines(e) {
        if (this.context && (e.contextKeys || (e.contextKeys = {}), e.contextKeys[this.uid] !== this.contextKeys)) {
            for (const t in this.context) "framebuffer" === t || Object.getOwnPropertyDescriptor(e, t) || Object.defineProperty(e, t, {
                configurable: !1,
                enumerable: !0,
                get: function() {
                    return this.shaderContext[t];
                }
            });
            Object.getOwnPropertyDescriptor(e, "framebuffer") || Object.defineProperty(e, "framebuffer", {
                configurable: !1,
                enumerable: !0,
                get: function() {
                    return this.targetFramebuffer || this.shaderContext && this.shaderContext.framebuffer;
                }
            }), e.contextKeys[this.uid] = this.contextKeys;
        }
    }
    _runFilter(e) {
        const t = this.filter;
        if (!t) return !0;
        if (Array.isArray(t)) {
            for (let n = 0; n < t.length; n++) if (!t[n](e)) return !1;
            return !0;
        }
        return t(e);
    }
    getMeshCommand(e, t) {
        this._cmdKeys || (this._cmdKeys = {});
        const n = this.dkey || "default";
        let r = this._cmdKeys[n];
        r || (r = this._cmdKeys[n] = {});
        const i = t.getCommandKey(e);
        r[i] || (r[i] = n + "_" + t.getCommandKey(e));
        const o = r[i];
        let a = this.commands[o];
        if (!a) {
            const n = t.getDefines(), r = t.getMaterial(), i = {};
            if (r) {
                r.doubleSided && this.extraCommandProps && (i.cull = {
                    enable: !1
                });
            }
            a = this.commands[o] = this.createREGLCommand(e, n, t.getElements(), t instanceof ze, t.disableVAO, i);
        }
        return a;
    }
}

class At extends yt {
    constructor(t = {}) {
        let n = t.extraCommandProps || {};
        const r = [];
        n = v({}, n, {
            blend: {
                enable: !0,
                func: {
                    src: "src alpha",
                    dst: "one minus src alpha"
                },
                equation: "add"
            },
            sample: {
                alpha: !0
            }
        }), super({
            vert: "#include <gl2_vert>\nattribute vec3 aPosition;\nattribute vec3 aBarycentric;\nvarying vec3 vBarycentric;\nuniform mat4 modelMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 projMatrix;\nuniform mat4 positionMatrix;\nvarying vec3 vPosition;\n#include <get_output>\nvoid main() {\n  mat4 c = getPositionMatrix();\n  vec4 d = getPosition(aPosition);\n#ifdef HAS_MASK_EXTENT\ngl_Position = projMatrix * getMaskPosition(c * d, modelMatrix);\n#else\ngl_Position = projMatrix * modelViewMatrix * c * d;\n#endif\nvBarycentric = aBarycentric;\n  vPosition = aPosition;\n}",
            frag: "#if __VERSION__ == 100\n#ifdef GL_OES_standard_derivatives\n#extension GL_OES_standard_derivatives : enable\n#endif\n#endif\nprecision mediump float;\n#include <gl2_frag>\nvarying vec3 vBarycentric;\nuniform float time;\nuniform float thickness;\nuniform float secondThickness;\nuniform float dashRepeats;\nuniform float dashLength;\nuniform bool dashOverlap;\nuniform bool dashEnabled;\nuniform bool dashAnimate;\nuniform bool seeThrough;\nuniform bool insideAltColor;\nuniform bool dualStroke;\nuniform bool squeeze;\nuniform float squeezeMin;\nuniform float squeezeMax;\nuniform vec4 stroke;\nuniform vec4 fill;\nuniform float opacity;\nuniform bool noiseEnable;\nvarying vec3 vPosition;\n#ifdef HAS_INSTANCE\nvarying vec4 vInstanceColor;\n#endif\n#include <mask_frag>\n#define F4 0.309016994374947451\n#define halfDist 0.5\nvec4 c(vec4 x) {\n  return x - floor(x * (1. / 289.)) * 289.;\n}\nfloat c(float x) {\n  return x - floor(x * (1. / 289.)) * 289.;\n}\nvec4 d(vec4 x) {\n  return c((x * 34. + 1.) * x);\n}\nfloat d(float x) {\n  return c((x * 34. + 1.) * x);\n}\nvec4 e(vec4 r) {\n  return 1.79284291400159 - .85373472095314 * r;\n}\nfloat e(float r) {\n  return 1.79284291400159 - .85373472095314 * r;\n}\nvec4 f(float h, vec4 i) {\n  const vec4 k = vec4(1., 1., 1., -1.);\n  vec4 p, s;\n  p.xyz = floor(fract(vec3(h) * i.xyz) * 7.) * i.z - 1.;\n  p.w = 1.5 - dot(abs(p.xyz), k.xyz);\n  s = vec4(lessThan(p, vec4(.0)));\n  p.xyz = p.xyz + (s.xyz * 2. - 1.) * s.www;\n  return p;\n}\nfloat l(vec4 m) {\n  const vec4 n = vec4(.138196601125011, .276393202250021, .414589803375032, -.447213595499958);\n  vec4 o = floor(m + dot(m, vec4(F4)));\n  vec4 u = m - o + dot(o, n.xxxx);\n  vec4 A;\n  vec3 B = step(u.yzw, u.xxx);\n  vec3 D = step(u.zww, u.yyz);\n  A.x = B.x + B.y + B.z;\n  A.yzw = 1. - B;\n  A.y += D.x + D.y;\n  A.zw += 1. - D.xy;\n  A.z += D.z;\n  A.w += 1. - D.z;\n  vec4 E = clamp(A, .0, 1.);\n  vec4 F = clamp(A - 1., .0, 1.);\n  vec4 G = clamp(A - 2., .0, 1.);\n  vec4 H = u - G + n.xxxx;\n  vec4 I = u - F + n.yyyy;\n  vec4 J = u - E + n.zzzz;\n  vec4 K = u + n.wwww;\n  o = c(o);\n  float L = d(d(d(d(o.w) + o.z) + o.y) + o.x);\n  vec4 M = d(d(d(d(o.w + vec4(G.w, F.w, E.w, 1.)) + o.z + vec4(G.z, F.z, E.z, 1.)) + o.y + vec4(G.y, F.y, E.y, 1.)) + o.x + vec4(G.x, F.x, E.x, 1.));\n  vec4 i = vec4(1. / 294., 1. / 49., 1. / 7., .0);\n  vec4 N = f(L, i);\n  vec4 O = f(M.x, i);\n  vec4 P = f(M.y, i);\n  vec4 Q = f(M.z, i);\n  vec4 R = f(M.w, i);\n  vec4 S = e(vec4(dot(N, N), dot(O, O), dot(P, P), dot(Q, Q)));\n  N *= S.x;\n  O *= S.y;\n  P *= S.z;\n  Q *= S.w;\n  R *= e(dot(R, R));\n  vec3 T = max(.6 - vec3(dot(u, u), dot(H, H), dot(I, I)), .0);\n  vec2 U = max(.6 - vec2(dot(J, J), dot(K, K)), .0);\n  T = T * T;\n  U = U * U;\n  return 49. * (dot(T * T, vec3(dot(N, u), dot(O, H), dot(P, I))) + dot(U * U, vec2(dot(Q, J), dot(R, K))));\n}\nconst float V = 3.14159265359;\nfloat W(float X, float Y) {\n  float Z = fwidth(Y) * halfDist;\n  return smoothstep(X - Z, X + Z, Y);\n}\nvec4 ba(vec3 bb) {\n  float bc = min(min(bb.x, bb.y), bb.z);\n  float bd = .0;\n  if(noiseEnable)\n    bd += l(vec4(vPosition.xyz * 80.0, time * halfDist)) * .12;\n  bc += bd;\n  float be = max(bb.x, bb.y);\n  if(bb.y < bb.x && bb.y < bb.z) {\n    be = 1. - be;\n  }\n  float bf = thickness;\n  if(squeeze) {\n    bf *= mix(squeezeMin, squeezeMax, (1. - sin(be * V)));\n  }\n  if(dashEnabled) {\n    float bg = 1. / dashRepeats * dashLength / 2.;\n    if(!dashOverlap) {\n      bg += 1. / dashRepeats / 2.;\n    }\n    if(dashAnimate) {\n      bg += time * .22;\n    }\n    float bh = fract((be + bg) * dashRepeats);\n    bf *= 1. - W(dashLength, bh);\n  }\n  float bi = 1. - W(bf, bc);\n#ifdef HAS_INSTANCE\nvec4 bj = vInstanceColor;\n#else\nvec4 bj = stroke;\n#endif\nvec4 bk = vec4(.0);\n  if(seeThrough) {\n    bk = vec4(bj.xyz, bi);\n    if(insideAltColor && !gl_FrontFacing) {\n      bk.rgb = fill.xyz;\n    }\n  } else {\n    vec3 bl = mix(fill.xyz, bj.xyz, bi);\n    bk.a = fill.a;\n    if(dualStroke) {\n      float bm = 1. - W(secondThickness, bc);\n      vec3 bn = mix(fill.xyz, stroke.xyz, abs(bm - bi));\n      bk.rgb = bn;\n    } else {\n      bk.rgb = bl;\n    }\n  }\n  return bk;\n}\nvoid main() {\n  glFragColor = ba(vBarycentric);\n  glFragColor *= halfDist + opacity;\n#ifdef HAS_MASK_EXTENT\nglFragColor = setMask(glFragColor);\n#endif\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}",
            uniforms: [ {
                name: "modelViewMatrix",
                type: "function",
                fn: (t, n) => e.multiply(r, n.viewMatrix, n.modelMatrix)
            } ],
            extraCommandProps: n
        }), this.version = 300;
    }
}

class St extends yt {
    constructor(t = {}) {
        const n = [], i = [], o = t.uniforms, a = [ {
            name: "modelNormalMatrix",
            type: "function",
            fn: function(e, t) {
                return r.fromMat4(n, t.modelMatrix);
            }
        }, {
            name: "modelViewMatrix",
            type: "function",
            fn: function(t, n) {
                return e.multiply(i, n.viewMatrix, n.modelMatrix);
            }
        } ];
        o && a.push(...o), super({
            vert: t.vert || "#include <gl2_vert>\nattribute vec3 aPosition;\n#include <line_extrusion_vert>\n#ifdef HAS_MAP\nuniform vec2 uvScale;\nuniform vec2 uvOffset;\nattribute vec2 aTexCoord;\nvarying vec2 vTexCoord;\n#ifdef HAS_I3S_UVREGION\nattribute vec4 uvRegion;\nvarying vec4 vUvRegion;\n#endif\n#if defined(HAS_AO_MAP)\nattribute vec2 aTexCoord1;\nvarying vec2 vTexCoord1;\n#endif\n#endif\n#if defined(HAS_COLOR)\nattribute vec4 aColor;\nvarying vec4 vColor;\n#elif defined(HAS_COLOR0)\n#if COLOR0_SIZE == 3\nattribute vec3 aColor0;\n#else\nattribute vec4 aColor0;\n#endif\nvarying vec4 vColor;\n#endif\nvarying vec3 vFragPos;\nvarying vec3 vNormal;\nuniform mat4 projMatrix;\nuniform mat3 modelNormalMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 modelMatrix;\nuniform mat4 positionMatrix;\nuniform vec2 halton;\nuniform vec2 outSize;\nuniform mat4 projViewMatrix;\n#include <highlight_vert>\n#include <get_output>\n#include <heatmap_render_vert>\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_vert>\n#endif\n#ifdef HAS_EXTRUSION_OPACITY\nattribute float aExtrusionOpacity;\nvarying float vExtrusionOpacity;\n#endif\n#if defined(HAS_TANGENT)\nvarying vec4 vTangent;\n#endif\nvoid c(const highp vec4 q, out highp vec3 d) {\n  d = vec3(.0, .0, 1.) + vec3(2., -2., -2.) * q.x * q.zwx + vec3(2., 2., -2.) * q.y * q.wzy;\n}\nvoid c(const highp vec4 q, out highp vec3 d, out highp vec3 t) {\n  c(q, d);\n  t = vec3(1., .0, .0) + vec3(-2., 2., -2.) * q.y * q.yxw + vec3(-2., 2., 2.) * q.z * q.zwx;\n}\n#include <vertex_color_vert>\nvoid main() {\n  \n#ifdef IS_LINE_EXTRUSION\nvec4 e = getPosition(getLineExtrudePosition(aPosition));\n#else\nvec4 e = getPosition(aPosition);\n#endif\nmat4 f = getPositionMatrix();\n  vFragPos = vec3(modelMatrix * f * e);\n#if defined(HAS_NORMAL) || defined(HAS_TANGENT)\nmat3 h = modelNormalMatrix * mat3(f);\n  vec3 i;\n#if defined(HAS_TANGENT)\nvec3 t;\n  c(aTangent, i, t);\n  vTangent = vec4(h * t, aTangent.w);\n#else\ni = decode_getNormal(aNormal);\n#endif\nvec3 j = appendMorphNormal(i);\n  vNormal = normalize(h * j);\n#else\nvNormal = vec3(.0);\n#endif\nmat4 k = projMatrix;\n  k[2].xy += halton.xy / outSize.xy;\n#ifdef HAS_MASK_EXTENT\ngl_Position = k * getMaskPosition(f * e, modelMatrix);\n#else\ngl_Position = k * modelViewMatrix * f * e;\n#endif\n#ifdef HAS_MAP\nvec2 l = decode_getTexcoord(aTexCoord);\n  vTexCoord = l * uvScale + uvOffset;\n#endif\n#ifdef HAS_AO_MAP\nvec2 m = decode_getTexcoord(aTexCoord1);\n  vTexCoord1 = m * uvScale + uvOffset;\n#endif\n#ifdef HAS_EXTRUSION_OPACITY\nvExtrusionOpacity = aExtrusionOpacity;\n#endif\n#if defined(HAS_COLOR)\nvColor = aColor / 255.;\n#elif defined(HAS_COLOR0)\n#if COLOR0_SIZE == 3\nvColor = vec4(aColor0 / 255., 1.);\n#else\nvColor = aColor0 / 255.;\n#endif\n#endif\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nshadow_computeShadowPars(f * e);\n#endif\n#ifdef HAS_HEATMAP\nheatmap_compute(projMatrix * modelViewMatrix * f, e);\n#endif\n#ifdef HAS_I3S_UVREGION\nvUvRegion = uvRegion / 65535.;\n#endif\nhighlight_setVarying();\n#ifdef HAS_VERTEX_COLOR\nvertexColor_update();\n#endif\n}",
            frag: t.frag || "precision mediump float;\n#include <gl2_frag>\nuniform vec4 baseColorFactor;\nuniform float materialShininess;\nuniform float environmentExposure;\nuniform float specularStrength;\nuniform vec3 light0_viewDirection;\nuniform vec3 ambientColor;\nuniform vec4 light0_diffuse;\nuniform vec3 lightSpecular;\nuniform vec3 cameraPosition;\nuniform float alphaTest;\n#ifdef HAS_TOON\nuniform float toons;\nuniform float specularToons;\n#endif\n#ifdef HAS_TANGENT\nvarying vec4 vTangent;\n#endif\n#ifdef HAS_MAP\n#include <computeTexcoord_frag>\n#endif\nvarying vec3 vNormal;\nvarying vec3 vFragPos;\n#ifdef HAS_INSTANCE_COLOR\nvarying vec4 vInstanceColor;\n#endif\n#ifdef HAS_BASECOLOR_MAP\nuniform sampler2D baseColorTexture;\n#endif\n#ifdef HAS_EXTRUSION_OPACITY\nuniform vec2 extrusionOpacityRange;\nvarying float vExtrusionOpacity;\n#endif\n#if defined(HAS_COLOR) || defined(HAS_COLOR0)\nvarying vec4 vColor;\n#elif defined(IS_LINE_EXTRUSION)\nuniform vec4 lineColor;\n#else\nuniform vec4 polygonFill;\n#endif\n#ifdef HAS_LAYER_OPACITY\nuniform float layerOpacity;\n#endif\n#ifdef IS_LINE_EXTRUSION\nuniform float lineOpacity;\n#else\nuniform float polygonOpacity;\n#endif\n#ifdef HAS_AO_MAP\nuniform sampler2D occlusionTexture;\nvarying vec2 vTexCoord1;\n#endif\n#ifdef HAS_NORMAL_MAP\nuniform sampler2D normalTexture;\n#endif\n#ifdef HAS_EMISSIVE_MAP\nuniform sampler2D emissiveTexture;\n#endif\n#ifdef SHADING_MODEL_SPECULAR_GLOSSINESS\nuniform vec4 diffuseFactor;\nuniform vec3 specularFactor;\n#ifdef HAS_DIFFUSE_MAP\nuniform sampler2D diffuseTexture;\n#endif\n#ifdef HAS_SPECULARGLOSSINESS_MAP\nuniform sampler2D specularGlossinessTexture;\n#endif\n#endif\n#include <heatmap_render_frag>\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_frag>\n#endif\n#include <highlight_frag>\n#include <mask_frag>\n#include <vertex_color_frag>\nvec3 c() {\n  \n#if defined(HAS_NORMAL_MAP)\nvec3 d = normalize(vNormal);\n  vec3 e = texture2D(normalTexture, computeTexCoord(vTexCoord)).xyz * 2. - 1.;\n#if defined(HAS_TANGENT)\nvec3 t = normalize(vTangent.xyz);\n  vec3 b = normalize(cross(d, t) * sign(vTangent.w));\n  mat3 f = mat3(t, b, d);\n  return normalize(f * e);\n#else\nreturn normalize(e);\n#endif\n#else\nreturn normalize(vNormal);\n#endif\n}\nvec4 h() {\n  \n#if defined(HAS_BASECOLOR_MAP)\nreturn texture2D(baseColorTexture, computeTexCoord(vTexCoord));\n#elif defined(HAS_DIFFUSE_MAP)\nreturn texture2D(diffuseTexture, computeTexCoord(vTexCoord));\n#elif defined(SHADING_MODEL_SPECULAR_GLOSSINESS)\nreturn diffuseFactor;\n#else\nreturn baseColorFactor;\n#endif\n}\nvec3 i() {\n  \n#if defined(HAS_SPECULARGLOSSINESS_MAP)\nreturn texture2D(specularGlossinessTexture, computeTexCoord(vTexCoord)).rgb;\n#elif defined(SHADING_MODEL_SPECULAR_GLOSSINESS)\nreturn specularFactor;\n#else\nreturn vec3(1.);\n#endif\n}\nvoid main() {\n  vec4 j = h();\n  vec3 k = environmentExposure * ambientColor * j.rgb;\n#ifdef HAS_INSTANCE_COLOR\nk *= vInstanceColor.rgb;\n#endif\nvec3 l = c();\n  vec3 m = normalize(-light0_viewDirection);\n  float o = max(dot(l, m), .0);\n#ifdef HAS_TOON\nfloat u = floor(o * toons);\n  o = u / toons;\n#endif\nvec3 v = light0_diffuse.rgb * o * j.rgb;\n#if defined(HAS_COLOR) || defined(HAS_COLOR0)\nvec3 A = vColor.rgb;\n#elif defined(IS_LINE_EXTRUSION)\nvec3 A = lineColor.rgb;\n#else\nvec3 A = polygonFill.rgb;\n#endif\n#ifdef HAS_INSTANCE_COLOR\nA *= vInstanceColor.rgb;\n#endif\nk *= A.rgb;\n  v *= A.rgb;\n  vec3 B = normalize(cameraPosition - vFragPos);\n  vec3 C = normalize(m + B);\n  float D = pow(max(dot(l, C), .0), materialShininess);\n#ifdef HAS_TOON\nfloat E = floor(D * specularToons);\n  D = E / specularToons;\n#endif\nvec3 F = specularStrength * lightSpecular * D * i();\n#ifdef HAS_OCCLUSION_MAP\nfloat G = texture2D(occlusionTexture, computeTexCoord(vTexCoord1)).r;\n  k *= G;\n#endif\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nfloat H = shadow_computeShadow();\n  v = shadow_blend(v, H).rgb;\n  F = shadow_blend(F, H).rgb;\n  k = shadow_blend(k, H).rgb;\n#endif\nvec3 I = k + v + F;\n#ifdef HAS_EMISSIVE_MAP\nvec3 J = texture2D(emissiveTexture, computeTexCoord(vTexCoord)).rgb;\n  I += J;\n#endif\n#ifdef IS_LINE_EXTRUSION\nglFragColor = vec4(I, lineOpacity * j.a);\n#else\nglFragColor = vec4(I, polygonOpacity * j.a);\n#endif\n#if defined(HAS_COLOR) || defined(HAS_COLOR0)\nfloat K = vColor.a;\n#elif defined(IS_LINE_EXTRUSION)\nfloat K = lineColor.a;\n#else\nfloat K = polygonFill.a;\n#endif\nglFragColor *= K;\n#ifdef HAS_EXTRUSION_OPACITY\nfloat L = extrusionOpacityRange.x;\n  float M = extrusionOpacityRange.y;\n  float N = L + vExtrusionOpacity * (M - L);\n  N = clamp(N, .0, 1.);\n  glFragColor *= N;\n#endif\nif(glFragColor.a < alphaTest) {\n    discard;\n  }\n#ifdef HAS_VERTEX_COLOR\nglFragColor *= vertexColor_get();\n#endif\n#ifdef HAS_HEATMAP\nglFragColor = heatmap_getColor(glFragColor);\n#endif\nglFragColor = highlight_blendColor(glFragColor);\n#ifdef HAS_LAYER_OPACITY\nglFragColor *= layerOpacity;\n#endif\n#ifdef HAS_MASK_EXTENT\nglFragColor = setMask(glFragColor);\n#endif\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}",
            uniforms: a,
            defines: t.defines || {},
            extraCommandProps: t.extraCommandProps || {}
        }), this.version = 300;
    }
    getGeometryDefines(e) {
        const t = {};
        return e.data[e.desc.tangentAttribute] ? t.HAS_TANGENT = 1 : e.data[e.desc.normalAttribute] && (t.HAS_NORMAL = 1), 
        t;
    }
}

class Tt extends yt {
    constructor(t = {}) {
        const n = [];
        super({
            vert: "attribute vec3 aPosition;\n#ifdef HAS_COLOR0\nattribute vec4 aColor0;\nvarying vec4 vColor;\n#endif\nuniform mat4 modelMatrix;\nuniform mat4 projMatrix;\nuniform mat4 positionMatrix;\nuniform mat4 projViewModelMatrix;\nuniform float pointSize;\n#if defined(HAS_MAP)\nattribute vec2 aTexCoord;\nvarying vec2 vTexCoord;\n#endif\n#include <get_output>\n#include <heatmap_render_vert>\n#ifdef HAS_FLOODANALYSE\nvarying float vHeight;\n#endif\nvoid main() {\n  vec4 c = getPosition(aPosition);\n  mat4 d = getPositionMatrix();\n  gl_PointSize = pointSize;\n#ifdef HAS_MASK_EXTENT\ngl_Position = projMatrix * getMaskPosition(d * c, modelMatrix);\n#else\ngl_Position = projViewModelMatrix * d * c;\n#endif\n#ifdef HAS_COLOR0\nvColor = aColor0 / 255.;\n#endif\n#ifdef HAS_MAP\nvTexCoord = aTexCoord;\n#endif\n#ifdef HAS_HEATMAP\nheatmap_compute(projMatrix * modelViewMatrix * d, c);\n#endif\n}",
            frag: "precision mediump float;\n#include <gl2_frag>\n#if defined(HAS_COLOR0)\nvarying vec4 vColor;\n#endif\n#include <heatmap_render_frag>\nuniform vec4 baseColorFactor;\n#if defined(HAS_MAP)\n#if defined(HAS_ALBEDO_MAP)\nuniform sampler2D baseColorTexture;\n#endif\n#if defined(HAS_DIFFUSE_MAP)\nuniform sampler2D diffuseTexture;\n#endif\nvarying vec2 vTexCoord;\n#endif\n#include <mask_frag>\nvoid main() {\n  \n#ifdef HAS_COLOR0\nglFragColor = vColor * baseColorFactor;\n#else\nglFragColor = vec4(1.) * baseColorFactor;\n#endif\n#ifdef HAS_MAP\n#ifdef HAS_ALBEDO_MAP\nglFragColor *= texture2D(baseColorTexture, vTexCoord);\n#endif\n#ifdef HAS_DIFFUSE_MAP\nglFragColor *= texture2D(diffuseTexture, vTexCoord);\n#endif\n#endif\n#ifdef HAS_HEATMAP\nglFragColor = heatmap_getColor(glFragColor);\n#endif\n#ifdef HAS_MASK_EXTENT\nglFragColor = setMask(glFragColor);\n#endif\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}",
            uniforms: [ {
                name: "projViewModelMatrix",
                type: "function",
                fn: (t, r) => e.multiply(n, r.projViewMatrix, r.modelMatrix)
            } ],
            defines: t.defines || {},
            extraCommandProps: t.extraCommandProps || {}
        });
    }
}

var Mt = "#if __VERSION__ == 300\n#define attribute in\n#define varying out\n#endif\nattribute vec2 aPosition;\nattribute vec2 aTexCoord;\nvarying vec2 vTexCoord;\nvoid main() {\n  gl_Position = vec4(aPosition, 0., 1.);\n  vTexCoord = aTexCoord;\n}";

const Ot = new Int8Array([ -1, 1, -1, -1, 1, 1, 1, 1, -1, -1, 1, -1 ]), Ct = new Uint8Array([ 0, 1, 0, 0, 1, 1, 1, 1, 0, 0, 1, 0 ]);

class Et extends yt {
    constructor(e) {
        e.vert = e.vert || Mt, e.extraCommandProps = e.extraCommandProps || {}, e.extraCommandProps.depth || (e.extraCommandProps.depth = {
            enable: !1,
            mask: !1
        }), e.extraCommandProps.stencil || (e.extraCommandProps.stencil = {
            enable: !1
        }), super(e);
    }
    draw(e) {
        return this._quadMesh || this._createQuadMesh(e), super.draw(e, this._quadMesh);
    }
    getMeshCommand(e) {
        const t = this.dkey || "";
        return this.commands[t + "_quad"] || (this.commands[t + "_quad"] = this.createREGLCommand(e, null, this._quadMesh[0].getElements())), 
        this.commands[t + "_quad"];
    }
    _createQuadMesh(e) {
        const t = new Z({
            aPosition: Ot,
            aTexCoord: Ct
        }, null, Ot.length / 2, {
            positionSize: 2,
            primitive: "triangles"
        });
        t.generateBuffers(e), this._quadMesh = [ new Be(t) ];
    }
    dispose() {
        if (this._quadMesh) {
            const e = this._quadMesh[0];
            e.geometry.dispose(), e.dispose();
        }
        return delete this._quadMesh, super.dispose();
    }
}

class Pt extends Et {
    constructor() {
        super({
            vert: Mt,
            frag: "#define SHADER_NAME FXAA\nprecision mediump float;\nvarying vec2 vTexCoord;\nuniform float enableFXAA;\nuniform float enableToneMapping;\nuniform float enableSharpen;\nuniform vec2 resolution;\nuniform sampler2D textureSource;\n#ifdef HAS_NOAA_TEX\nuniform sampler2D noAaTextureSource;\n#endif\n#ifdef HAS_POINT_TEX\nuniform sampler2D pointTextureSource;\n#endif\n#ifdef HAS_TAA_TEX\nuniform sampler2D taaTextureSource;\n#ifdef HAS_FXAA_TEX\nuniform sampler2D fxaaTextureSource;\n#endif\n#endif\nuniform float pixelRatio;\nuniform float sharpFactor;\n#ifdef HAS_OUTLINE_TEX\nuniform sampler2D textureOutline;\nuniform float enableOutline;\nuniform float highlightFactor;\nuniform float outlineFactor;\nuniform float outlineWidth;\nuniform vec3 outlineColor;\n#endif\nvec2 c;\nvec4 d(vec2 e) {\n  \n#ifdef HAS_TAA_TEX\nvec4 f = texture2D(textureSource, e);\n  vec4 taa = texture2D(taaTextureSource, e);\n#ifdef HAS_FXAA_TEX\nvec4 h = texture2D(fxaaTextureSource, e);\n#else\nvec4 h = vec4(.0);\n#endif\nvec4 i = taa + f * (1. - taa.a);\n  return h + i * (1. - h.a);\n#else\nreturn texture2D(textureSource, e);\n#endif\n}\nvec3 j(const in vec3 k, const float l) {\n  vec2 m = pixelRatio / resolution.xy;\n  float n = .0;\n  vec4 o = texture2D(textureSource, c + m * vec2(-1., -1.));\n  o.rgb = mix(vec3(.0), o.rgb, sign(o.a));\n  n += mix(.0, 1., sign(o.a));\n  vec4 u = texture2D(textureSource, c + m * vec2(1.));\n  u.rgb = mix(vec3(.0), u.rgb, sign(u.a));\n  n += mix(.0, 1., sign(u.a));\n  vec4 v = texture2D(textureSource, c + m * vec2(1., -1.));\n  v.rgb = mix(vec3(.0), v.rgb, sign(v.a));\n  n += mix(.0, 1., sign(v.a));\n  vec4 A = texture2D(textureSource, c + m * vec2(-1., 1.));\n  A.rgb = mix(vec3(.0), A.rgb, sign(A.a));\n  n += mix(.0, 1., sign(A.a));\n  return k + l * (n * k - o.rgb - v.rgb - A.rgb - u.rgb);\n}\nvec4 B(const in vec4 k) {\n  return vec4(j(k.rgb, sharpFactor), k.a);\n}\nvec3 C(const vec3 x) {\n  const float a = 2.51;\n  const float b = .03;\n  const float D = 2.43;\n  const float E = .59;\n  const float F = .14;\n  return (x * (a * x + b)) / (x * (D * x + E) + F);\n}\nvec3 G(vec3 k) {\n  k = k / (k + vec3(1.));\n  return k = pow(k, vec3(1. / 2.2));\n}\n#ifdef HAS_OUTLINE_TEX\nvec4 H() {\n  float I = 2.;\n  float J = 1.;\n  float K = pixelRatio / resolution[0] * outlineWidth;\n  float L = pixelRatio / resolution[1] * outlineWidth;\n  vec4 M = (texture2D(textureOutline, c + vec2(K, L)));\n  vec4 N = (texture2D(textureOutline, c + vec2(K, .0)));\n  vec4 O = (texture2D(textureOutline, c + vec2(K, -L)));\n  vec4 P = (texture2D(textureOutline, c + vec2(.0, -L)));\n  vec4 Q = (texture2D(textureOutline, c + vec2(-K, -L)));\n  vec4 R = (texture2D(textureOutline, c + vec2(-K, .0)));\n  vec4 S = (texture2D(textureOutline, c + vec2(-K, L)));\n  vec4 T = (texture2D(textureOutline, c + vec2(.0, L)));\n  vec4 U = -I * R + I * N + -J * S + J * M + -J * Q + J * O;\n  vec4 V = -I * P + I * T + -J * Q + J * S + -J * O + J * M;\n  float W = sqrt(dot(V, V) + dot(U, U));\n  bool X = W < 1. / 65025.;\n  vec3 Y = (texture2D(textureOutline, c)).r * outlineColor;\n  if(Y == vec3(.0) || (highlightFactor == .0 && X)) {\n    return vec4(.0);\n  }\n  float Z = X ? highlightFactor : min(1., sqrt(W) * outlineFactor);\n  return Z * vec4(Y, 1.);\n}\nvec4 ba(const in vec4 k) {\n  vec4 H = H();\n  return H + vec4(k) * (1. - H.a);\n}\n#endif\nvoid main() {\n  c = vTexCoord;\n  vec4 k;\n  if(enableFXAA == 1.) {\n    \n  } else {\n    k = d(vTexCoord);\n  }\n  if(enableSharpen == 1.) {\n    k = B(k);\n  }\n#if defined(HAS_NOAA_TEX) || defined(HAS_POINT_TEX)\nvec4 bb = vec4(.0);\n  vec4 bc = vec4(.0);\n#ifdef HAS_POINT_TEX\nbb = texture2D(pointTextureSource, vTexCoord);\n#endif\n#ifdef HAS_NOAA_TEX\nbc = texture2D(noAaTextureSource, vTexCoord);\n#endif\nvec4 bd = bb + bc * (1. - bb.a);\n  k = bd + k * (1. - bd.a);\n#endif\nif(enableToneMapping == 1.) {\n    k.rgb = G(k.rgb);\n  }\n#ifdef HAS_OUTLINE_TEX\nk = ba(k);\n#endif\ngl_FragColor = k;\n}",
            extraCommandProps: {
                viewport: {
                    x: 0,
                    y: 0,
                    width: (e, t) => t.resolution[0],
                    height: (e, t) => t.resolution[1]
                }
            }
        });
    }
    getMeshCommand(e, t) {
        const n = this.dkey || "";
        return this.commands[n + "_fxaa"] || (this.commands[n + "_fxaa"] = this.createREGLCommand(e, null, t.getElements())), 
        this.commands[n + "_fxaa"];
    }
}

class wt extends Et {
    constructor({blurOffset: e}) {
        super({
            vert: Mt,
            frag: "precision highp float;\nvarying vec2 vTexCoord;\nuniform sampler2D textureSource;\nuniform vec2 resolution;\nuniform float ignoreTransparent;\nvoid main() {\n  vec4 c = vec4(.0);\n  float d = .0;\n  for(int x = -BOXBLUR_OFFSET; x <= BOXBLUR_OFFSET; ++x)\n    for(int y = -BOXBLUR_OFFSET; y <= BOXBLUR_OFFSET; ++y) {\n      vec2 e = vTexCoord.st + vec2(float(x) / resolution.x, float(y) / resolution.y);\n      e = clamp(e, .0, 1.);\n      vec4 f = texture2D(textureSource, e);\n      float h;\n      if(ignoreTransparent == 1.) {\n        h = sign(f.a);\n      } else {\n        h = 1.;\n      }\n      d += h;\n      c += h * f;\n    }\n  gl_FragColor = c / max(d, 1.) * clamp(sign(d - 1.), .0, 1.);\n}",
            defines: {
                BOXBLUR_OFFSET: e || 2
            },
            extraCommandProps: {
                viewport: {
                    x: 0,
                    y: 0,
                    width: (e, t) => t.resolution[0],
                    height: (e, t) => t.resolution[1]
                }
            }
        }), this._blurOffset = e || 2;
    }
    getMeshCommand(e, t) {
        const n = "box_blur_" + this._blurOffset;
        return this.commands[n] || (this.commands[n] = this.createREGLCommand(e, null, t.getElements())), 
        this.commands[n];
    }
}

class It extends Et {
    constructor() {
        super({
            vert: Mt,
            frag: "precision mediump float;\nvarying vec2 vTexCoord;\nuniform vec2 resolution;\nuniform sampler2D textureSource;\nuniform float enableVignette;\nuniform float enableGrain;\nuniform float enableLut;\nuniform float timeGrain;\nuniform float grainFactor;\nuniform vec2 lensRadius;\nuniform float frameMod;\nuniform sampler2D lookupTable;\n#include <srgb_frag>\nfloat c(const in vec2 d) {\n  vec3 e = fract(vec3(d.xyx) * .1031);\n  e += dot(e, e.yzx + 19.19);\n  return fract((e.x + e.y) * e.z);\n}\nfloat f() {\n  float h = c(gl_FragCoord.xy + 1000.0 * fract(timeGrain));\n  float i = h * 2. - 1.;\n  h = i * inversesqrt(abs(i));\n  h = max(-1., h);\n  h = h - sign(i) + .5;\n  return (h + .5) * .5;\n}\nvec4 j(const in vec4 k) {\n  float l = f();\n  return vec4(mix(k.rgb, k.rgb * (k.rgb + (1. - k.rgb) * 2. * l), grainFactor), k.a);\n}\nfloat m(const in vec2 d, const in float n) {\n  vec3 o = vec3(.06711056, .00583715, 52.9829189);\n  return fract(o.z * fract(dot(d.xy + n * vec2(47., 17.) * .695, o.xy)));\n}\nfloat u() {\n  vec2 v = lensRadius;\n  v.y = min(v.y, v.x - 1e-4);\n  float A = m(gl_FragCoord.xy, frameMod);\n  A = (v.x - v.y) * (v.x + v.y) * .07 * (A - .5);\n  return smoothstep(v.x, v.y, A + distance(vTexCoord, vec2(.5)));\n}\nvec4 B(const in vec4 k) {\n  float l = u();\n  return vec4(linearTosRGB(sRGBToLinear(k.rgb) * l), clamp(k.a + (1. - l), .0, 1.));\n}\nvec4 C(in vec4 D, in sampler2D E) {\n  mediump float F = D.b * 63.;\n  mediump vec2 G;\n  G.y = floor(floor(F) / 8.);\n  G.x = floor(F) - G.y * 8.;\n  mediump vec2 H;\n  H.y = floor(ceil(F) / 8.);\n  H.x = ceil(F) - H.y * 8.;\n  highp vec2 I;\n  I.x = G.x * .125 + .5 / 512. + (.125 - 1. / 512.) * D.r;\n  I.y = G.y * .125 + .5 / 512. + (.125 - 1. / 512.) * D.g;\n#ifdef LUT_FLIP_Y\nI.y = 1. - I.y;\n#endif\nhighp vec2 J;\n  J.x = H.x * .125 + .5 / 512. + (.125 - 1. / 512.) * D.r;\n  J.y = H.y * .125 + .5 / 512. + (.125 - 1. / 512.) * D.g;\n#ifdef LUT_FLIP_Y\nJ.y = 1. - J.y;\n#endif\nlowp vec4 K = texture2D(E, I);\n  lowp vec4 L = texture2D(E, J);\n  lowp vec4 M = mix(K, L, fract(F));\n  return M;\n}\nvoid main() {\n  vec4 k = texture2D(textureSource, vTexCoord);\n  if(enableLut == 1.) {\n    k = C(k, lookupTable);\n  }\n  if(enableVignette == 1.) {\n    k = B(k);\n  }\n  if(enableGrain == 1.) {\n    k = j(k);\n  }\n  gl_FragColor = k;\n}",
            extraCommandProps: {
                viewport: {
                    x: 0,
                    y: 0,
                    width: (e, t) => t.resolution[0],
                    height: (e, t) => t.resolution[1]
                }
            }
        });
    }
    getMeshCommand(e, t) {
        return this.commands.postprocess || (this.commands.postprocess = this.createREGLCommand(e, null, t.getElements())), 
        this.commands.postprocess;
    }
}

const Rt = [ [ .263385, -.0252475 ], [ -.38545, .054485 ], [ -.139795, -.5379925 ], [ -.2793775, .6875475 ], [ .7139025, .4710925 ], [ .90044, -.16422 ], [ .4481775, -.82799 ], [ -.9253375, -.2910625 ], [ .3468025, 1.02292 ], [ -1.13742, .33522 ], [ -.7676225, -.9123175 ], [ -.2005775, -1.1774125 ], [ -.926525, .96876 ], [ 1.12909, -.7500325 ], [ .9603, 1.14625 ] ], Dt = Rt.length, Ht = [ 0, 0 ];

for (let e = 0; e < Rt.length; e++) Ht[0] += Rt[e][0], Ht[1] += Rt[e][1];

Ht[0] /= Dt, Ht[1] /= Dt;

class Ft {
    constructor(e) {
        this._frameNum = 0, this._ratio = e || .05, this._avg = [ Ht[0] * this._ratio, Ht[1] * this._ratio ];
    }
    getRatio() {
        return this._ratio;
    }
    setRatio(e) {
        this._ratio !== e && (this._ratio = e, this.reset()), this._avg = [ Ht[0] * this._ratio, Ht[1] * this._ratio ];
    }
    getAverage() {
        return this._avg;
    }
    reset() {
        this._frameNum = 0;
    }
    getJitter(e) {
        const t = this._frameNum % Dt, n = this._ratio;
        return i.set(e, Rt[t][0] * n, Rt[t][1] * n), e;
    }
    frame() {
        this._frameNum++, this._frameNum % Dt == 0 && (this._frameNum = 0);
    }
    getSampleCount() {
        return Dt;
    }
}

class Nt {
    constructor(e, t, n = 5) {
        this._regl = e, this._renderer = new Ve(e), this._inputRGBM = t, this._level = n;
    }
    render(e, t) {
        this._initShaders(), this._createTextures(e), this._blur(e, t || 0);
        const n = {
            blurTex0: this._blur01Tex,
            blurTex1: this._blur11Tex,
            blurTex2: this._blur21Tex,
            blurTex3: this._blur31Tex,
            blurTex4: this._blur41Tex
        };
        return this._level > 5 && (n.blurTex5 = this._blur51Tex, n.blurTex6 = this._blur61Tex), 
        n;
    }
    _blur(e, t) {
        let n = this._blurUniforms;
        n || (n = this._blurUniforms = {
            rgbmRange: 7,
            blurDir: [ 0, 0 ],
            outSize: [ 0, 0 ],
            pixelRatio: [ 1, 1 ],
            outputSize: [ 0, 0 ]
        }), i.set(n.outSize, e.width, e.height), this._blurOnce(this._blur0Shader, e, this._blur00FBO, this._blur01FBO, .5, t), 
        this._blurOnce(this._blur1Shader, this._blur01FBO.color[0], this._blur10FBO, this._blur11FBO, .5), 
        this._blurOnce(this._blur2Shader, this._blur11FBO.color[0], this._blur20FBO, this._blur21FBO, .5), 
        this._blurOnce(this._blur3Shader, this._blur21FBO.color[0], this._blur30FBO, this._blur31FBO, .5), 
        this._blurOnce(this._blur4Shader, this._blur31FBO.color[0], this._blur40FBO, this._blur41FBO, .5), 
        this._level > 5 && (this._blurOnce(this._blur5Shader, this._blur41FBO.color[0], this._blur50FBO, this._blur51FBO, .5), 
        this._blurOnce(this._blur6Shader, this._blur51FBO.color[0], this._blur60FBO, this._blur51FBO, .5));
    }
    _blurOnce(e, t, n, r, o, a) {
        const s = Math.ceil(o * t.width), c = Math.ceil(o * t.height);
        n.width === s && n.height === c || n.resize(s, c), r.width === s && r.height === c || r.resize(s, c);
        const l = this._blurUniforms;
        l.luminThreshold = a, l.TextureBlurInput = t, l.inputRGBM = +this._inputRGBM, i.set(l.blurDir, 0, 1), 
        i.set(l.outputSize, n.width, n.height), this._renderer.render(e, l, null, n), l.luminThreshold = 0, 
        l.inputRGBM = 1, i.set(l.blurDir, 1, 0), l.TextureBlurInput = n.color[0], this._renderer.render(e, l, null, r);
    }
    dispose() {
        this._blur0Shader && (this._blur0Shader.dispose(), delete this._blur0Shader, this._blur1Shader.dispose(), 
        this._blur2Shader.dispose(), this._blur3Shader.dispose(), this._blur4Shader.dispose(), 
        this._blur5Shader && (this._blur5Shader.dispose(), this._blur6Shader.dispose(), 
        delete this._blur5Shader)), this._blur00Tex && (delete this._blur00Tex, this._blur00FBO.destroy(), 
        this._blur01FBO.destroy(), this._blur10FBO.destroy(), this._blur11FBO.destroy(), 
        this._blur20FBO.destroy(), this._blur21FBO.destroy(), this._blur30FBO.destroy(), 
        this._blur31FBO.destroy(), this._blur40FBO.destroy(), this._blur41FBO.destroy(), 
        this._blur50FBO && (this._blur50FBO.destroy(), this._blur51FBO.destroy(), this._blur60FBO.destroy(), 
        this._blur61FBO.destroy()));
    }
    _createTextures(e) {
        if (this._blur00Tex) return;
        let t = e.width, n = e.height;
        this._blur00Tex = this._createColorTex(e, t, n), this._blur00FBO = this._createBlurFBO(this._blur00Tex), 
        this._blur01Tex = this._createColorTex(e), this._blur01FBO = this._createBlurFBO(this._blur01Tex), 
        t = Math.ceil(t / 2), n = Math.ceil(n / 2), this._blur10Tex = this._createColorTex(e, t, n), 
        this._blur10FBO = this._createBlurFBO(this._blur10Tex), this._blur11Tex = this._createColorTex(e, t, n), 
        this._blur11FBO = this._createBlurFBO(this._blur11Tex), t = Math.ceil(t / 2), n = Math.ceil(n / 2), 
        this._blur20Tex = this._createColorTex(e, t, n), this._blur20FBO = this._createBlurFBO(this._blur20Tex), 
        this._blur21Tex = this._createColorTex(e, t, n), this._blur21FBO = this._createBlurFBO(this._blur21Tex), 
        t = Math.ceil(t / 2), n = Math.ceil(n / 2), this._blur30Tex = this._createColorTex(e, t, n), 
        this._blur30FBO = this._createBlurFBO(this._blur30Tex), this._blur31Tex = this._createColorTex(e, t, n), 
        this._blur31FBO = this._createBlurFBO(this._blur31Tex), t = Math.ceil(t / 2), n = Math.ceil(n / 2), 
        this._blur40Tex = this._createColorTex(e, t, n), this._blur40FBO = this._createBlurFBO(this._blur40Tex), 
        this._blur41Tex = this._createColorTex(e, t, n), this._blur41FBO = this._createBlurFBO(this._blur41Tex), 
        this._level > 5 && (t = Math.ceil(t / 2), n = Math.ceil(n / 2), this._blur50Tex = this._createColorTex(e, t, n), 
        this._blur50FBO = this._createBlurFBO(this._blur50Tex), this._blur51Tex = this._createColorTex(e, t, n), 
        this._blur51FBO = this._createBlurFBO(this._blur51Tex), t = Math.ceil(t / 2), n = Math.ceil(n / 2), 
        this._blur60Tex = this._createColorTex(e, t, n), this._blur60FBO = this._createBlurFBO(this._blur60Tex), 
        this._blur61Tex = this._createColorTex(e, t, n), this._blur61FBO = this._createBlurFBO(this._blur61Tex));
    }
    _createColorTex(e, t, n) {
        return this._regl.texture({
            min: "linear",
            mag: "linear",
            type: "uint8",
            width: t || e.width,
            height: n || e.height
        });
    }
    _createBlurFBO(e) {
        return this._regl.framebuffer({
            width: e.width,
            height: e.height,
            colors: [ e ],
            depth: !1,
            stencil: !1
        });
    }
    _initShaders() {
        if (!this._blur0Shader) {
            const e = {
                vert: Mt,
                extraCommandProps: {
                    viewport: {
                        x: 0,
                        y: 0,
                        width: (e, t) => t.outputSize[0],
                        height: (e, t) => t.outputSize[1]
                    }
                },
                frag: "#version 100\nprecision highp float;\nuniform float rgbmRange;\nuniform sampler2D TextureBlurInput;\nuniform sampler2D TextureInput;\nuniform vec2 blurDir;\nuniform vec2 pixelRatio;\nuniform vec2 outputSize;\nuniform float inputRGBM;\nuniform float luminThreshold;\n#define SHADER_NAME GAUSSIAN_BLUR0\nconst vec3 c = vec3(.2126, .7152, .0722);\nfloat d(const in vec3 e) {\n  return dot(e, c);\n}\nvec4 f(vec4 e) {\n  float h = max(sign(d(e.rgb) - luminThreshold), .0);\n  return e * h;\n}\nvec2 i;\nvec4 j(const in vec3 e, const in float k) {\n  vec4 l;\n  vec3 m = e / k;\n  l.a = clamp(max(max(m.r, m.g), max(m.b, 1e-6)), .0, 1.);\n  l.a = ceil(l.a * 255.) / 255.;\n  l.rgb = m / l.a;\n  return l;\n}\nvec3 n(const in vec4 e, const in float k) {\n  if(inputRGBM == .0)\n    return e.rgb;\n  return k * e.rgb * e.a;\n}\nvec4 o() {\n  vec3 u = .375 * (f(vec4(n(texture2D(TextureBlurInput, i.xy), rgbmRange), 1.))).rgb;\n  vec2 v;\n  vec2 A = pixelRatio.xy * blurDir.xy / outputSize.xy;\n  v = A * 1.2;\n  u += .3125 * (f(vec4(n(texture2D(TextureBlurInput, i.xy + v.xy), rgbmRange), 1.))).rgb;\n  u += .3125 * (f(vec4(n(texture2D(TextureBlurInput, i.xy - v.xy), rgbmRange), 1.))).rgb;\n  return vec4(u, 1.);\n}\nvoid main(void) {\n  i = gl_FragCoord.xy / outputSize.xy;\n  vec4 e = o();\n  e = j(e.rgb, rgbmRange);\n  gl_FragColor = e;\n}"
            };
            this._blur0Shader = new Et(e), e.frag = "#version 100\nprecision highp float;\nuniform float rgbmRange;\nuniform sampler2D TextureBlurInput;\nuniform sampler2D TextureInput;\nuniform vec2 blurDir;\nuniform vec2 pixelRatio;\nuniform vec2 outputSize;\n#define SHADER_NAME GAUSSIAN_BLUR1\nvec2 c;\nvec4 d(const in vec3 e, const in float f) {\n  if(f <= .0)\n    return vec4(e, 1.);\n  vec4 h;\n  vec3 i = e / f;\n  h.a = clamp(max(max(i.r, i.g), max(i.b, 1e-6)), .0, 1.);\n  h.a = ceil(h.a * 255.) / 255.;\n  h.rgb = i / h.a;\n  return h;\n}\nvec3 j(const in vec4 e, const in float f) {\n  if(f <= .0)\n    return e.rgb;\n  return f * e.rgb * e.a;\n}\nvec4 k() {\n  vec3 l = .3125 * (vec4(j(texture2D(TextureBlurInput, c.xy), rgbmRange), 1.)).rgb;\n  vec2 m;\n  vec2 n = pixelRatio.xy * blurDir.xy / outputSize.xy;\n  m = n * 1.2857142857142858;\n  l += .328125 * (vec4(j(texture2D(TextureBlurInput, c.xy + m.xy), rgbmRange), 1.)).rgb;\n  l += .328125 * (vec4(j(texture2D(TextureBlurInput, c.xy - m.xy), rgbmRange), 1.)).rgb;\n  return vec4(l, 1.);\n}\nvoid main(void) {\n  c = gl_FragCoord.xy / outputSize.xy;\n  vec4 e = k();\n  e = d(e.rgb, rgbmRange);\n  gl_FragColor = e;\n}", 
            this._blur1Shader = new Et(e), e.frag = "#version 100\nprecision highp float;\nuniform float rgbmRange;\nuniform sampler2D TextureBlurInput;\nuniform sampler2D TextureInput;\nuniform vec2 blurDir;\nuniform vec2 pixelRatio;\nuniform vec2 outputSize;\n#define SHADER_NAME GAUSSIAN_BLUR2\nvec2 c;\nvec4 d(const in vec3 e, const in float f) {\n  if(f <= .0)\n    return vec4(e, 1.);\n  vec4 h;\n  vec3 i = e / f;\n  h.a = clamp(max(max(i.r, i.g), max(i.b, 1e-6)), .0, 1.);\n  h.a = ceil(h.a * 255.) / 255.;\n  h.rgb = i / h.a;\n  return h;\n}\nvec3 j(const in vec4 e, const in float f) {\n  if(f <= .0)\n    return e.rgb;\n  return f * e.rgb * e.a;\n}\nvec4 k() {\n  vec3 l = .2734375 * (vec4(j(texture2D(TextureBlurInput, c.xy), rgbmRange), 1.)).rgb;\n  vec2 m;\n  vec2 n = pixelRatio.xy * blurDir.xy / outputSize.xy;\n  m = n * 1.3333333333333333;\n  l += .328125 * (vec4(j(texture2D(TextureBlurInput, c.xy + m.xy), rgbmRange), 1.)).rgb;\n  l += .328125 * (vec4(j(texture2D(TextureBlurInput, c.xy - m.xy), rgbmRange), 1.)).rgb;\n  m = n * 3.111111111111111;\n  l += .03515625 * (vec4(j(texture2D(TextureBlurInput, c.xy + m.xy), rgbmRange), 1.)).rgb;\n  l += .03515625 * (vec4(j(texture2D(TextureBlurInput, c.xy - m.xy), rgbmRange), 1.)).rgb;\n  return vec4(l, 1.);\n}\nvoid main(void) {\n  c = gl_FragCoord.xy / outputSize.xy;\n  vec4 e = k();\n  e = d(e.rgb, rgbmRange);\n  gl_FragColor = e;\n}", 
            this._blur2Shader = new Et(e), e.frag = "#version 100\nprecision highp float;\nuniform float rgbmRange;\nuniform sampler2D TextureBlurInput;\nuniform sampler2D TextureInput;\nuniform vec2 blurDir;\nuniform vec2 pixelRatio;\nuniform vec2 outputSize;\n#define SHADER_NAME GAUSSIAN_BLUR3\nvec2 c;\nvec4 d(const in vec3 e, const in float f) {\n  if(f <= .0)\n    return vec4(e, 1.);\n  vec4 h;\n  vec3 i = e / f;\n  h.a = clamp(max(max(i.r, i.g), max(i.b, 1e-6)), .0, 1.);\n  h.a = ceil(h.a * 255.) / 255.;\n  h.rgb = i / h.a;\n  return h;\n}\nvec3 j(const in vec4 e, const in float f) {\n  if(f <= .0)\n    return e.rgb;\n  return f * e.rgb * e.a;\n}\nvec4 k() {\n  vec3 l = .24609375 * (vec4(j(texture2D(TextureBlurInput, c.xy), rgbmRange), 1.)).rgb;\n  vec2 m;\n  vec2 n = pixelRatio.xy * blurDir.xy / outputSize.xy;\n  m = n * 1.3636363636363635;\n  l += .322265625 * (vec4(j(texture2D(TextureBlurInput, c.xy + m.xy), rgbmRange), 1.)).rgb;\n  l += .322265625 * (vec4(j(texture2D(TextureBlurInput, c.xy - m.xy), rgbmRange), 1.)).rgb;\n  m = n * 3.1818181818181817;\n  l += .0537109375 * (vec4(j(texture2D(TextureBlurInput, c.xy + m.xy), rgbmRange), 1.)).rgb;\n  l += .0537109375 * (vec4(j(texture2D(TextureBlurInput, c.xy - m.xy), rgbmRange), 1.)).rgb;\n  return vec4(l, 1.);\n}\nvoid main(void) {\n  c = gl_FragCoord.xy / outputSize.xy;\n  vec4 e = k();\n  e = d(e.rgb, rgbmRange);\n  gl_FragColor = e;\n}", 
            this._blur3Shader = new Et(e), e.frag = "#version 100\nprecision highp float;\nuniform float rgbmRange;\nuniform sampler2D TextureBlurInput;\nuniform sampler2D TextureInput;\nuniform vec2 blurDir;\nuniform vec2 pixelRatio;\nuniform vec2 outputSize;\n#define SHADER_NAME GAUSSIAN_BLUR4\nvec2 c;\nvec4 d(const in vec3 e, const in float f) {\n  if(f <= .0)\n    return vec4(e, 1.);\n  vec4 h;\n  vec3 i = e / f;\n  h.a = clamp(max(max(i.r, i.g), max(i.b, 1e-6)), .0, 1.);\n  h.a = ceil(h.a * 255.) / 255.;\n  h.rgb = i / h.a;\n  return h;\n}\nvec3 j(const in vec4 e, const in float f) {\n  if(f <= .0)\n    return e.rgb;\n  return f * e.rgb * e.a;\n}\nvec4 k() {\n  vec3 l = .2255859375 * (vec4(j(texture2D(TextureBlurInput, c.xy), rgbmRange), 1.)).rgb;\n  vec2 m;\n  vec2 n = pixelRatio.xy * blurDir.xy / outputSize.xy;\n  m = n * 1.3846153846153846;\n  l += .314208984375 * (vec4(j(texture2D(TextureBlurInput, c.xy + m.xy), rgbmRange), 1.)).rgb;\n  l += .314208984375 * (vec4(j(texture2D(TextureBlurInput, c.xy - m.xy), rgbmRange), 1.)).rgb;\n  m = n * 3.230769230769231;\n  l += .06982421875 * (vec4(j(texture2D(TextureBlurInput, c.xy + m.xy), rgbmRange), 1.)).rgb;\n  l += .06982421875 * (vec4(j(texture2D(TextureBlurInput, c.xy - m.xy), rgbmRange), 1.)).rgb;\n  m = n * 5.076923076923077;\n  l += .003173828125 * (vec4(j(texture2D(TextureBlurInput, c.xy + m.xy), rgbmRange), 1.)).rgb;\n  l += .003173828125 * (vec4(j(texture2D(TextureBlurInput, c.xy - m.xy), rgbmRange), 1.)).rgb;\n  return vec4(l, 1.);\n}\nvoid main(void) {\n  c = gl_FragCoord.xy / outputSize.xy;\n  vec4 e = k();\n  e = d(e.rgb, rgbmRange);\n  gl_FragColor = e;\n}", 
            this._blur4Shader = new Et(e), this._level > 5 && (e.frag = "precision highp float;\nuniform float rgbmRange;\nuniform sampler2D TextureBlurInput;\nuniform sampler2D TextureInput;\nuniform vec2 blurDir;\nuniform vec2 outSize;\nuniform vec2 pixelRatio;\nuniform vec2 outputSize;\n#define SHADER_NAME GAUSSIAN_BLUR5\nvec2 c;\nvec4 d(const in vec3 e, const in float f) {\n  if(f <= .0)\n    return vec4(e, 1.);\n  vec4 h;\n  vec3 i = e / f;\n  h.a = clamp(max(max(i.r, i.g), max(i.b, 1e-6)), .0, 1.);\n  h.a = ceil(h.a * 255.) / 255.;\n  h.rgb = i / h.a;\n  return h;\n}\nvec3 j(const in vec4 e, const in float f) {\n  if(f <= .0)\n    return e.rgb;\n  return f * e.rgb * e.a;\n}\nvec4 k() {\n  vec3 l = .20947265625 * (vec4(j(texture2D(TextureBlurInput, c.xy), rgbmRange), 1.)).rgb;\n  vec2 m;\n  vec2 n = pixelRatio.xy * blurDir.xy / outputSize.xy;\n  n *= outSize.y * .00075;\n  m = n * 1.4;\n  l += .30548095703125 * (vec4(j(texture2D(TextureBlurInput, c.xy + m.xy), rgbmRange), 1.)).rgb;\n  l += .30548095703125 * (vec4(j(texture2D(TextureBlurInput, c.xy - m.xy), rgbmRange), 1.)).rgb;\n  m = n * 3.2666666666666666;\n  l += .08331298828125 * (vec4(j(texture2D(TextureBlurInput, c.xy + m.xy), rgbmRange), 1.)).rgb;\n  l += .08331298828125 * (vec4(j(texture2D(TextureBlurInput, c.xy - m.xy), rgbmRange), 1.)).rgb;\n  m = n * 5.133333333333334;\n  l += .00640869140625 * (vec4(j(texture2D(TextureBlurInput, c.xy + m.xy), rgbmRange), 1.)).rgb;\n  l += .00640869140625 * (vec4(j(texture2D(TextureBlurInput, c.xy - m.xy), rgbmRange), 1.)).rgb;\n  return vec4(l, 1.);\n}\nvoid main(void) {\n  c = gl_FragCoord.xy / outputSize.xy;\n  vec4 e = k();\n  e = d(e.rgb, rgbmRange);\n  gl_FragColor = e;\n}", 
            this._blur5Shader = new Et(e), e.frag = "#version 100\nprecision highp float;\nuniform float rgbmRange;\nuniform sampler2D TextureBlurInput;\nuniform sampler2D TextureInput;\nuniform vec2 blurDir;\nuniform vec2 outSize;\nuniform vec2 pixelRatio;\nuniform vec2 outputSize;\n#define SHADER_NAME GAUSSIAN_BLUR6\nvec2 c;\nvec4 d(const in vec3 e, const in float f) {\n  if(f <= .0)\n    return vec4(e, 1.);\n  vec4 h;\n  vec3 i = e / f;\n  h.a = clamp(max(max(i.r, i.g), max(i.b, 1e-6)), .0, 1.);\n  h.a = ceil(h.a * 255.) / 255.;\n  h.rgb = i / h.a;\n  return h;\n}\nvec3 j(const in vec4 e, const in float f) {\n  if(f <= .0)\n    return e.rgb;\n  return f * e.rgb * e.a;\n}\nvec4 k() {\n  vec3 l = .196380615234375 * (vec4(j(texture2D(TextureBlurInput, c.xy), rgbmRange), 1.)).rgb;\n  vec2 m;\n  vec2 n = pixelRatio.xy * blurDir.xy / outputSize.xy;\n  n *= outSize.y * .00075;\n  m = n * 1.411764705882353;\n  l += .2967529296875 * (vec4(j(texture2D(TextureBlurInput, c.xy + m.xy), rgbmRange), 1.)).rgb;\n  l += .2967529296875 * (vec4(j(texture2D(TextureBlurInput, c.xy - m.xy), rgbmRange), 1.)).rgb;\n  m = n * 3.2941176470588234;\n  l += .09442138671875 * (vec4(j(texture2D(TextureBlurInput, c.xy + m.xy), rgbmRange), 1.)).rgb;\n  l += .09442138671875 * (vec4(j(texture2D(TextureBlurInput, c.xy - m.xy), rgbmRange), 1.)).rgb;\n  m = n * 5.176470588235294;\n  l += .0103759765625 * (vec4(j(texture2D(TextureBlurInput, c.xy + m.xy), rgbmRange), 1.)).rgb;\n  l += .0103759765625 * (vec4(j(texture2D(TextureBlurInput, c.xy - m.xy), rgbmRange), 1.)).rgb;\n  return vec4(l, 1.);\n}\nvoid main(void) {\n  c = gl_FragCoord.xy / outputSize.xy;\n  vec4 e = k();\n  e = d(e.rgb, rgbmRange);\n  gl_FragColor = e;\n}", 
            this._blur6Shader = new Et(e));
        }
    }
}

class Lt {
    constructor(e) {
        this._regl = e, this._renderer = new Ve(e);
    }
    render(e, t, n, r, i, o, a, s, c) {
        this._initShaders(), this._createTextures(e);
        const l = this._blurPass.render(t, n);
        return this._combine(e, l, t, r, i, o, a, s, c);
    }
    _combine(e, t, n, r, o, a, s, c, l) {
        l || this._combineTex.width === e.width && this._combineTex.height === e.height || this._combineFBO.resize(e.width, e.height);
        let f = this._combineUniforms;
        const {blurTex0: d, blurTex1: u, blurTex2: h, blurTex3: m, blurTex4: v} = t;
        f || (f = this._combineUniforms = {
            bloomFactor: 0,
            bloomRadius: 0,
            rgbmRange: 7,
            TextureBloomBlur1: d,
            TextureBloomBlur2: u,
            TextureBloomBlur3: h,
            TextureBloomBlur4: m,
            TextureBloomBlur5: v,
            TextureInput: null,
            TextureSource: null,
            outputSize: [ 0, 0 ]
        }), f.noAaTextureSource = a, f.pointTextureSource = s, f.enableAA = c, f.bloomFactor = r, 
        f.bloomRadius = o, f.TextureInput = n, f.TextureSource = e, i.set(f.outputSize, e.width, e.height);
        const _ = {};
        return a ? _.HAS_NOAA_TEX = 1 : delete _.HAS_NOAA_TEX, s ? _.HAS_POINT_TEX = 1 : delete _.HAS_POINT_TEX, 
        this._combineShader.setDefines(_), this._renderer.render(this._combineShader, f, null, l ? null : this._combineFBO), 
        l ? null : this._combineTex;
    }
    dispose() {
        this._combineFBO && (this._combineFBO.destroy(), delete this._combineFBO), this._blurPass && (this._blurPass.dispose(), 
        delete this._blurPass), delete this._uniforms;
    }
    _createTextures(e) {
        if (this._combineTex) return;
        this._combineTex = this._createColorTex(e, e.width, e.height, "uint8"), this._combineFBO = this._createBlurFBO(this._combineTex);
    }
    _createColorTex(e, t, n, r) {
        return this._renderer.regl.texture({
            min: "linear",
            mag: "linear",
            type: r,
            width: t || e.width,
            height: n || e.height
        });
    }
    _createBlurFBO(e) {
        return this._renderer.regl.framebuffer({
            width: e.width,
            height: e.height,
            colors: [ e ],
            depth: !1,
            stencil: !1
        });
    }
    _initShaders() {
        if (!this._combineShader) {
            const e = {
                x: 0,
                y: 0,
                width: (e, t) => t.outputSize[0],
                height: (e, t) => t.outputSize[1]
            };
            this._blurPass = new Nt(this._regl, !1), this._combineShader = new Et({
                vert: Mt,
                frag: "precision highp float;\nuniform float bloomFactor;\nuniform float bloomRadius;\nuniform float rgbmRange;\nuniform sampler2D TextureBloomBlur1;\nuniform sampler2D TextureBloomBlur2;\nuniform sampler2D TextureBloomBlur3;\nuniform sampler2D TextureBloomBlur4;\nuniform sampler2D TextureBloomBlur5;\nuniform sampler2D TextureInput;\nuniform sampler2D TextureSource;\n#ifdef HAS_NOAA_TEX\nuniform sampler2D noAaTextureSource;\n#endif\n#ifdef HAS_POINT_TEX\nuniform sampler2D pointTextureSource;\n#endif\nuniform float enableAA;\nuniform vec2 outputSize;\n#define SHADER_NAME bloomCombine\nvec2 c;\n#include <srgb_frag>\nvec3 d(const in vec4 e, const in float f) {\n  if(f <= .0)\n    return e.rgb;\n  return f * e.rgb * e.a;\n}\nfloat h(const float i, const float j) {\n  return mix(i, j * 2. - i, bloomRadius);\n}\nvec4 k() {\n  vec3 l = vec3(.0);\n  const float m = .6;\n  const float n = 1.1;\n  const float o = .9;\n  const float u = .6;\n  const float v = .3;\n  const float A = .1;\n  l += (vec4(d(texture2D(TextureBloomBlur1, c), rgbmRange), 1.)).rgb * h(n, m);\n  l += (vec4(d(texture2D(TextureBloomBlur2, c), rgbmRange), 1.)).rgb * h(o, m);\n  l += (vec4(d(texture2D(TextureBloomBlur3, c), rgbmRange), 1.)).rgb * h(u, m);\n  l += (vec4(d(texture2D(TextureBloomBlur4, c), rgbmRange), 1.)).rgb * h(v, m);\n  l += (vec4(d(texture2D(TextureBloomBlur5, c), rgbmRange), 1.)).rgb * h(A, m);\n  vec4 B;\n  if(enableAA == 1.) {\n    \n  } else {\n    B = texture2D(TextureInput, c);\n  }\n  B.rgb = mix(vec3(.0), B.rgb, sign(B.a));\n  vec4 C = texture2D(TextureSource, c);\n#ifdef HAS_NOAA_TEX\nvec4 D = texture2D(noAaTextureSource, c);\n  C = D + C * (1. - D.a);\n#endif\nvec4 E = vec4(.0);\n#ifdef HAS_POINT_TEX\nE = texture2D(pointTextureSource, c);\n#endif\nfloat F = sqrt((l.r + l.g + l.b) / 3.);\n  vec4 G = vec4(linearTosRGB(l * bloomFactor), F);\n  return E + (B + C * (1. - B.a)) * (1. - E.a) + G;\n}\nvoid main(void) {\n  c = gl_FragCoord.xy / outputSize.xy;\n  vec4 e = k();\n  gl_FragColor = e;\n}",
                extraCommandProps: {
                    viewport: e
                }
            });
        }
    }
}

class kt extends Et {
    constructor() {
        const e = [];
        super({
            vert: Mt,
            frag: "precision highp float;\n#include <gl2_frag>\n#define SHADER_NAME COPY_DEPTH\nuniform sampler2D TextureDepth;\nuniform vec2 textureSize;\n#include <common_pack_float>\nvoid main(void) {\n  vec2 c = gl_FragCoord.xy / textureSize.xy;\n  float d = texture2D(TextureDepth, c).r;\n  glFragColor = common_encodeDepth(d);\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}",
            uniforms: [ {
                name: "textureSize",
                type: "function",
                fn: (t, n) => (e[0] = n.TextureDepth.width, e[1] = n.TextureDepth.height, e)
            } ],
            extraCommandProps: {
                viewport: {
                    x: 0,
                    y: 0,
                    width: (e, t) => t.TextureDepth.width,
                    height: (e, t) => t.TextureDepth.height
                }
            }
        }), this.version = 300;
    }
    getMeshCommand(e, t) {
        return this.commands.copy_depth || (this.commands.copy_depth = this.createREGLCommand(e, null, t.getElements())), 
        this.commands.copy_depth;
    }
}

class Bt {
    static getUniformDeclares() {
        const t = [ [ 0, 0, 0, 0 ], [ 0, 0, 0, 0 ] ], r = new Array(16);
        return [ {
            name: "invProjMatrix",
            type: "function",
            fn: (t, n) => e.invert(r, n.projMatrix)
        }, {
            name: "outputFovInfo",
            type: "array",
            length: 2,
            fn: function(e, r) {
                const i = Math.tan(.5 * r.fov), o = r.outSize[0] / r.outSize[1] * i;
                return n.set(t[0], o, i, o, -i), n.set(t[1], -o, i, -o, -i), t;
            }
        }, {
            name: "reprojViewProjMatrix",
            type: "function",
            fn: (t, n) => e.multiply([], n.prevProjViewMatrix, n.cameraWorldMatrix)
        } ];
    }
    static getDefines() {
        return {
            HAS_SSR: 1
        };
    }
    constructor(e) {
        this._regl = e, this._renderer = new Ve(e), this._inputRGBM = 0;
    }
    setup(e) {
        this._initShaders(), this._createTextures(e);
    }
    getSSRUniforms(e, t, n) {
        if (!this._depthCopy) return null;
        const r = this._depthCopy;
        return {
            TextureDepth: r,
            TextureReflected: this.getMipmapTexture(),
            ssrFactor: t || 1,
            ssrQuality: n || 2,
            outSize: [ r.width, r.height ],
            fov: e.getFov() * Math.PI / 180,
            prevProjViewMatrix: this._projViewMatrix || e.projViewMatrix,
            cameraWorldMatrix: e.cameraWorldMatrix
        };
    }
    genMipMap(t, n, r) {
        return this.setup(t), this._mipmap(t), this.copyDepthTex(n), this._projViewMatrix || (this._projViewMatrix = []), 
        e.copy(this._projViewMatrix, r), delete this._depthCopied, this._outputTex;
    }
    getPrevProjViewMatrix() {
        return this._projViewMatrix;
    }
    copyDepthTex(e) {
        if (this._depthCopied) return null;
        if (this.setup(e), this._depthCopy) e.width === this._depthCopy.width && e.height === this._depthCopy.height || this._depthCopyFBO.resize(e.width, e.height); else {
            this._depthCopy = this._regl.texture({
                min: "nearest",
                mag: "nearest",
                mipmap: !1,
                type: "uint8",
                width: e.width,
                height: e.height
            });
            this._depthCopyFBO = this._regl.framebuffer({
                width: e.width,
                height: e.height,
                colors: [ this._depthCopy ],
                colorFormat: "rgba"
            });
        }
        return this._renderer.render(this._copyDepthShader, {
            TextureDepth: e
        }, null, this._depthCopyFBO), this._depthCopied = !0, this._depthCopy;
    }
    _mipmap(e) {
        const t = this._targetFBO, n = Math.ceil(.5 * e.width), r = Math.ceil(.5 * e.height);
        t.width === n && t.height === r || t.resize(n, r);
        let o = this._blurUniforms;
        o || (o = this._blurUniforms = {
            rgbmRange: 7,
            outputSize: [ 0, 0 ]
        }), o.TextureInput = e, o.inputRGBM = +this._inputRGBM, i.set(o.outputSize, t.width, t.height), 
        this._renderer.render(this._ssrQuadShader, o, null, t);
    }
    getMipmapTexture() {
        return this._outputTex || (this._outputTex = this._renderer.regl.texture({
            type: "uint8",
            width: 2,
            height: 2
        })), this._outputTex;
    }
    dispose() {
        this._copyDepthShader && (this._ssrQuadShader.dispose(), this._copyDepthShader.dispose(), 
        this._targetFBO.destroy(), delete this._copyDepthShader), this._depthCopy && (this._depthCopyFBO.destroy(), 
        delete this._depthCopy, delete this._depthCopyFBO);
    }
    _initShaders() {
        if (!this._copyDepthShader) {
            this._copyDepthShader = new kt;
            this._ssrQuadShader = new Et({
                vert: Mt,
                frag: "#version 100\nprecision mediump float;\nuniform sampler2D TextureInput;\nuniform vec2 outputSize;\n#define SHADER_NAME QUAD\nvec2 c;\nvoid main(void) {\n  c = gl_FragCoord.xy / outputSize.xy;\n  vec4 d = texture2D(TextureInput, c.xy);\n  gl_FragColor = d;\n}",
                extraCommandProps: {
                    viewport: {
                        x: 0,
                        y: 0,
                        width: (e, t) => t.outputSize[0],
                        height: (e, t) => t.outputSize[1]
                    }
                }
            });
        }
    }
    _createTextures(e) {
        if (!this._targetFBO) {
            const t = this._regl;
            this._outputTex && this._outputTex.destroy(), this._outputTex = t.texture({
                min: "linear",
                mag: "linear",
                type: "uint8",
                width: e.width,
                height: e.height
            }), this._targetFBO = t.framebuffer({
                width: e.width,
                height: e.height,
                colors: [ this._outputTex ],
                depth: !1,
                stencil: !1
            });
        }
    }
}

class zt extends yt {
    constructor(t) {
        const n = [];
        super({
            vert: "#define SHADER_NAME HEATMAP\nuniform mat4 projViewModelMatrix;\nuniform float extrudeScale;\nuniform float heatmapIntensity;\nattribute vec3 aPosition;\nvarying vec2 vExtrude;\n#ifdef HAS_HEAT_WEIGHT\nattribute highp float aWeight;\nvarying highp float weight;\n#else\nuniform highp float heatmapWeight;\n#endif\nuniform mediump float heatmapRadius;\nconst highp float c = 1. / 255. / 16.;\n#define GAUSS_COEF 0.3989422804014327\nvoid main(void) {\n  \n#ifdef HAS_HEAT_WEIGHT\nhighp float d = aWeight / 255.;\n  weight = d;\n#else\nhighp float d = heatmapWeight;\n#endif\nmediump float e = heatmapRadius;\n  vec2 f = vec2(mod(aPosition.xy, 2.) * 2. - 1.);\n  float h = sqrt(-2. * log(c / d / heatmapIntensity / GAUSS_COEF)) / 3.;\n  vExtrude = h * f;\n  vec2 i = vExtrude * e * extrudeScale;\n  vec4 j = vec4(floor(aPosition.xy * .5) + i, aPosition.z, 1);\n  gl_Position = projViewModelMatrix * j;\n}",
            frag: "#define SHADER_NAME HEATMAP\nprecision mediump float;\nuniform highp float heatmapIntensity;\nvarying vec2 vExtrude;\n#ifdef HAS_HEAT_WEIGHT\nvarying highp float weight;\n#else\nuniform highp float heatmapWeight;\n#endif\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n  \n#ifdef HAS_HEAT_WEIGHT\nhighp float c = weight;\n#else\nhighp float c = heatmapWeight;\n#endif\nfloat d = -.5 * 3. * 3. * dot(vExtrude, vExtrude);\n  float e = c * heatmapIntensity * GAUSS_COEF * exp(d);\n  gl_FragColor = vec4(e, 1., 1., 1.);\n}",
            uniforms: [ {
                name: "extrudeScale",
                type: "function",
                fn: function(e, t) {
                    return t.resolution / t.dataResolution * t.tileRatio;
                }
            }, {
                name: "projViewModelMatrix",
                type: "function",
                fn: function(t, r) {
                    return e.multiply(n, r.projViewMatrix, r.modelMatrix);
                }
            } ],
            extraCommandProps: v({}, t && t.extraCommandProps || {}, {
                blend: {
                    enable: !0,
                    func: {
                        src: "one",
                        dst: "one"
                    },
                    equation: "add"
                }
            })
        });
    }
}

var Gt = [ -1, 1, -1, -1, -1, -1, 1, -1, -1, 1, -1, -1, 1, 1, -1, -1, 1, -1, -1, -1, 1, -1, -1, -1, -1, 1, -1, -1, 1, -1, -1, 1, 1, -1, -1, 1, 1, -1, -1, 1, -1, 1, 1, 1, 1, 1, 1, 1, 1, 1, -1, 1, -1, -1, -1, -1, 1, -1, 1, 1, 1, 1, 1, 1, 1, 1, 1, -1, 1, -1, -1, 1, -1, 1, -1, 1, 1, -1, 1, 1, 1, 1, 1, 1, -1, 1, 1, -1, 1, -1, -1, -1, -1, -1, -1, 1, 1, -1, -1, 1, -1, -1, -1, -1, 1, 1, -1, 1 ], Vt = "#define SHADER_NAME SKYBOX\n#if __VERSION__ == 100\n#ifdef GL_EXT_shader_texture_lod\n#extension GL_EXT_shader_texture_lod : enable\n#define textureCubeLod(tex, uv, lod) textureCubeLodEXT(tex, uv, lod)\n#else\n#define textureCubeLod(tex, uv, lod) textureCube(tex, uv, lod)\n#endif\n#else\n#define textureCubeLod(tex, uv, lod) textureLod(tex, uv, lod)\n#endif\nprecision highp float;\n#define saturate(x)        clamp(x, 0.0, 1.0)\n#include <gl2_frag>\n#include <hsv_frag>\nuniform vec3 hsv;\nvarying vec3 vWorldPos;\n#ifdef USE_AMBIENT\nuniform vec3 diffuseSPH[9];\n#else\nuniform samplerCube cubeMap;\nuniform float bias;\nuniform float size;\n#endif\nuniform float environmentExposure;\nuniform float backgroundIntensity;\nvec4 c(const in samplerCube d, const in vec3 e, const in float f, const in float h) {\n  vec3 i = e;\n  return textureCubeLod(d, i, h);\n}\nvec3 j(const in vec3 k, const in vec3 l[9]) {\n  float x = k.x;\n  float y = k.y;\n  float z = k.z;\n  vec3 m = (l[0] + l[1] * x + l[2] * y + l[3] * z + l[4] * z * x + l[5] * y * z + l[6] * y * x + l[7] * (3. * z * z - 1.) + l[8] * (x * x - y * y));\n  return max(m, vec3(.0));\n}\nfloat n(const in vec2 o) {\n  vec3 u = fract(vec3(o.xyx) * .1031);\n  u += dot(u, u.yzx + 19.19);\n  return fract((u.x + u.y) * u.z);\n}\n#if defined(TONE_MAPPING)\nconst float v = 1.;\nvec3 A(vec3 B) {\n  vec3 a = B * (B + .0245786) - .000090537;\n  vec3 b = B * (.983729 * B + .4329510) + .238081;\n  return a / b;\n}\nvec3 C(vec3 D) {\n  const mat3 E = mat3(vec3(.59719, .07600, .02840), vec3(.35458, .90834, .13383), vec3(.04823, .01566, .83777));\n  const mat3 F = mat3(vec3(1.60475, -.10208, -.00327), vec3(-.53108, 1.10813, -.07276), vec3(-.07367, -.00605, 1.07602));\n  D *= v / .6;\n  D = E * D;\n  D = A(D);\n  D = F * D;\n  return saturate(D);\n}\nvec3 G(vec3 D) {\n  return C(D);\n}\nvec4 H(in vec4 I) {\n  return vec4(mix(pow(I.rgb, vec3(.41666)) * 1.055 - vec3(.055), I.rgb * 12.92, vec3(lessThanEqual(I.rgb, vec3(.0031308)))), I.a);\n}\nvec4 J(vec4 I) {\n  return (H(I));\n}\n#endif\nvoid main() {\n  vec4 K;\n#ifdef USE_AMBIENT\nvec3 k = normalize(vWorldPos + mix(-.5 / 255., .5 / 255., n(gl_FragCoord.xy)) * 2.);\n  K = vec4(j(k, diffuseSPH), 1.);\n#else\nK = c(cubeMap, vWorldPos, size, bias);\n#endif\nK.rgb *= environmentExposure;\n  K.rgb *= backgroundIntensity;\n  glFragColor = K;\n  if(length(hsv) > .0) {\n    glFragColor.rgb = hsv_apply(clamp(glFragColor.rgb, .0, 1.), hsv);\n  }\n#if defined(TONE_MAPPING)\nglFragColor.rgb = G(glFragColor.rgb);\n  glFragColor = J(glFragColor);\n#endif\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}";

class Ut extends yt {
    constructor() {
        super({
            vert: "#include <gl2_vert>\nattribute vec3 aPosition;\nuniform mat4 projMatrix;\nuniform mat4 viewMatrix;\nuniform mat3 transformMatrix;\nvarying vec3 vWorldPos;\nvoid main() {\n  vWorldPos = aPosition;\n  mat4 c = mat4(mat3(viewMatrix) * transformMatrix);\n  vec4 d = projMatrix * c * vec4(vWorldPos, 1.);\n  gl_Position = d.xyww;\n}",
            frag: Vt,
            extraCommandProps: {
                depth: {
                    enable: !0,
                    range: [ 1, 1 ],
                    func: "lequal"
                },
                viewport: {
                    x: 0,
                    y: 0,
                    width: (e, t) => t.resolution[0],
                    height: (e, t) => t.resolution[1]
                }
            }
        }), this.version = 300;
    }
    setMode(e, t) {
        const n = {};
        return e && (n.TONE_MAPPING = 1), 0 === t && (n.USE_AMBIENT = 1), this._skyboxMesh ? this._skyboxMesh[0].setDefines(n) : this._meshDefines = n, 
        this;
    }
    draw(e) {
        return this._skyboxMesh || this._createSkyboxMesh(e), super.draw(e, this._skyboxMesh);
    }
    _createSkyboxMesh(e) {
        const t = new Z({
            aPosition: new Int8Array(Gt)
        }, null, Gt.length / 3);
        t.generateBuffers(e), this._skyboxMesh = [ new Be(t) ], this._meshDefines && (this._skyboxMesh[0].setDefines(this._meshDefines), 
        delete this._meshDefines);
    }
    dispose() {
        if (this._skyboxMesh) {
            const e = this._skyboxMesh[0];
            e.geometry.dispose(), e.dispose();
        }
        return delete this._skyboxMesh, super.dispose();
    }
}

class jt extends yt {
    constructor(t, n) {
        const r = {
            blend: {
                enable: !0,
                func: {
                    src: "one",
                    dst: "one minus src alpha"
                },
                equation: "add"
            },
            viewport: t
        };
        n && n.extraCommandProps && v(r, n.extraCommandProps);
        const i = [];
        super({
            vert: "#define SHADER_NAME HEATMAP_DISPLAY\nuniform mat4 projViewModelMatrix;\nattribute vec3 aPosition;\nvoid main() {\n  gl_Position = projViewModelMatrix * vec4(aPosition, 1.);\n}",
            frag: "#define SHADER_NAME HEATMAP_DISPLAY\nprecision mediump float;\nuniform sampler2D inputTexture;\nuniform sampler2D colorRamp;\nuniform vec2 textureOutputSize;\nuniform float heatmapOpacity;\nvoid main() {\n  vec2 c = gl_FragCoord.xy / textureOutputSize.xy;\n  float t = texture2D(inputTexture, c).r;\n  vec4 d = texture2D(colorRamp, vec2(t, .5));\n  gl_FragColor = d * heatmapOpacity;\n}",
            uniforms: [ {
                name: "projViewModelMatrix",
                type: "function",
                fn: function(t, n) {
                    return e.multiply(i, n.projViewMatrix, n.modelMatrix);
                }
            } ],
            extraCommandProps: r
        });
    }
}

class Xt extends yt {
    constructor(e = {}) {
        super({
            vert: "precision highp float;\nprecision highp sampler2D;\nconst float c = 3.141592653589793;\nuniform mat4 projMatrix;\nuniform mat4 viewMatrix;\nuniform mat4 modelMatrix;\nattribute vec3 aPosition;\nattribute vec2 aTexCoord;\nattribute vec3 aNormal;\nvarying vec2 vuv;\nvarying vec3 vpos;\nvarying vec3 vnormal;\nvarying mat3 vtbnMatrix;\nvec4 d(mat4 e, mat4 f, vec3 h) {\n  return e * modelMatrix * f * vec4(h, 1.);\n}\nvec3 i(in vec3 h, in vec3 j) {\n  return normalize(h + j);\n}\nmat3 k(in vec3 l) {\n  vec3 t = normalize(cross(vec3(.0, .0, 1.), l));\n  vec3 b = normalize(cross(l, t));\n  return mat3(t, b, l);\n}\nvoid m() {\n  \n}\nvoid main(void) {\n  vuv = aTexCoord;\n  vpos = (modelMatrix * vec4(aPosition, 1.)).xyz;\n  vnormal = aNormal;\n  vtbnMatrix = k(vnormal);\n  gl_Position = d(projMatrix, viewMatrix, vpos);\n  m();\n}",
            frag: "precision highp float;\nprecision highp sampler2D;\nuniform sampler2D texWaveNormal;\nuniform sampler2D texWavePerturbation;\nuniform vec3 octaveTextureRepeat;\nuniform vec4 waveParams;\nuniform vec2 waveDirection;\nuniform vec4 waterColor;\nuniform vec3 lightingDirection;\nuniform vec3 lightingIntensity;\nuniform vec3 camPos;\nuniform float timeElapsed;\nvarying vec2 vuv;\nvarying vec3 vpos;\nvarying vec3 vnormal;\nvarying mat3 vtbnMatrix;\nconst vec2 c = vec2(6. / 25., 5. / 24.);\nvec2 d(sampler2D e, vec2 f) {\n  return 2. * texture2D(e, f).rg - 1.;\n}\nfloat h(vec2 f) {\n  return texture2D(texWavePerturbation, f).b;\n}\nvec3 i(sampler2D e, vec2 f) {\n  return 2. * texture2D(e, f).rgb - 1.;\n}\nfloat j(vec2 f, float k) {\n  return fract(k);\n}\nfloat l(vec2 f, float k) {\n  float m = j(f, k);\n  return 1. - abs(1. - 2. * m);\n}\nvec3 n(sampler2D o, vec2 f, float k, float u) {\n  float v = waveParams[2];\n  float A = waveParams[3];\n  vec2 B = d(o, f) * v;\n  float m = j(f, k + u);\n  float C = l(f, k + u);\n  vec2 D = f;\n  D -= B * (m + A);\n  D += u;\n  D += (k - m) * c;\n  return vec3(D, C);\n}\nconst float E = .3737;\nconst float F = 7.77;\nvec3 G(sampler2D H, sampler2D I, vec2 f, vec2 J, float k) {\n  float K = waveParams[0];\n  vec2 L = k * -J;\n  float M = h(f * E) * F;\n  vec3 N = n(I, f + L, k + M, .0);\n  vec3 O = n(I, f + L, k + M, .5);\n  vec3 P = i(H, N.xy) * N.z;\n  vec3 Q = i(H, O.xy) * O.z;\n  vec3 R = normalize(P + Q);\n  R.xy *= K;\n  R.z = sqrt(1. - dot(R.xy, R.xy));\n  return R;\n}\nvec3 S(vec2 f, float k) {\n  float T = waveParams[1];\n  return G(texWaveNormal, texWavePerturbation, f * T, waveDirection, k);\n}\nconst float U = 3.141592653589793;\nconst float V = 1. / U;\nconst float W = .3183098861837907;\nconst float X = 1.570796326794897;\nstruct PBRShadingWater {\n  float NdotL;\n  float NdotV;\n  float NdotH;\n  float VdotH;\n  float LdotH;\n  float VdotN;\n};\nfloat Y = 2.2;\nvec3 Z(float ba, vec3 bb, float bc) {\n  return bb + (bc - bb) * pow(1. - ba, 5.);\n}\nfloat bd(float be, float bf) {\n  float bg = bf * bf;\n  float bh = be * be;\n  float bi = pow((bh * (bg - 1.) + 1.), Y) * U;\n  return bg / bi;\n}\nfloat bj(float bk) {\n  return .25 / (bk * bk);\n}\nvec3 bl(in PBRShadingWater bm, float bf, vec3 bn, float bo) {\n  vec3 bp = Z(bm.VdotH, bn, bo);\n  float bq = bd(bm.NdotH, bf);\n  float br = bj(bm.LdotH);\n  return (bq * br) * bp;\n}\nvec3 bs(const vec3 x) {\n  return (x * (2.51 * x + .03)) / (x * (2.43 * x + .59) + .14);\n}\nconst float bt = 2.2;\nconst float bu = .4545454545;\nvec4 bv(vec4 bw) {\n  return vec4(pow(bw.rgb, vec3(bu)), bw.w);\n}\nvec3 bx(vec3 bw) {\n  return pow(bw, vec3(bt));\n}\nconst vec3 by = vec3(.02, 1., 5.);\nconst vec2 bz = vec2(.02, .1);\nconst float bf = .06;\nconst vec3 bA = vec3(0, .6, .9);\nconst vec3 bB = vec3(.72, .92, 1.);\nPBRShadingWater bC;\nvec3 bD(in float bE, in vec3 bF, in vec3 bG) {\n  float bH = pow((1. - bE), by[2]);\n  return mix(bG, bF, bH);\n}\nvec3 bI(in vec3 bJ, in vec3 bK, in vec3 bL, vec3 bw, in vec3 bM, in vec3 bN, in float bO) {\n  vec3 bP = bx(bw);\n  vec3 bQ = normalize(bL + bK);\n  bC.NdotL = clamp(dot(bJ, bL), .0, 1.);\n  bC.NdotV = clamp(dot(bJ, bK), .001, 1.);\n  bC.VdotN = clamp(dot(bK, bJ), .001, 1.);\n  bC.NdotH = clamp(dot(bJ, bQ), .0, 1.);\n  bC.VdotH = clamp(dot(bK, bQ), .0, 1.);\n  bC.LdotH = clamp(dot(bL, bQ), .0, 1.);\n  float bR = max(dot(bN, bK), .0);\n  vec3 bS = bx(bB);\n  vec3 bT = bx(bA);\n  vec3 bB = bD(bR, bS, bT);\n  float bU = max(dot(bN, bL), .0);\n  bB *= .1 + bU * .9;\n  float bV = clamp(bO, .8, 1.);\n  vec3 bW = Z(bC.VdotN, vec3(by[0]), by[1]) * bB * bV;\n  vec3 bX = bP * mix(bB, bU * bM * V, 2. / 3.) * bV;\n  vec3 bY = vec3(.0);\n  if(bR > .0 && bU > .0) {\n    vec3 bZ = bl(bC, bf, vec3(bz[0]), bz[1]);\n    vec3 ca = bM * V * bO;\n    bY = bC.NdotL * ca * bZ;\n  }\n  return bs(bW + bX + bY);\n}\nvoid main() {\n  vec3 bN = vnormal;\n  vec3 cb = S(vuv, timeElapsed);\n  vec3 bJ = normalize(vtbnMatrix * cb);\n  vec3 bK = -normalize(vpos - camPos);\n  vec3 bL = normalize(-lightingDirection);\n  float bO = 1.;\n  vec4 cc = vec4(bI(bJ, bK, bL, waterColor.rgb, lightingIntensity, bN, bO), waterColor.w);\n  gl_FragColor = bv(cc);\n}",
            defines: e.defines || {},
            extraCommandProps: e.extraCommandProps || {}
        });
    }
}

class Wt extends Et {
    constructor() {
        super({
            vert: Mt,
            frag: "precision highp float;\nuniform sampler2D texture;\nuniform vec2 size;\nuniform float enableSharpen;\nuniform float sharpFactor;\nuniform float pixelRatio;\nvec2 c;\nvec3 d(const in vec3 e, const float f) {\n  vec2 h = pixelRatio / size.xy;\n  float i = .0;\n  vec4 j = texture2D(texture, c + h * vec2(-1., -1.));\n  j.rgb = mix(vec3(.0), j.rgb, sign(j.a));\n  i += mix(.0, 1., sign(j.a));\n  vec4 k = texture2D(texture, c + h * vec2(1.));\n  k.rgb = mix(vec3(.0), k.rgb, sign(k.a));\n  i += mix(.0, 1., sign(k.a));\n  vec4 l = texture2D(texture, c + h * vec2(1., -1.));\n  l.rgb = mix(vec3(.0), l.rgb, sign(l.a));\n  i += mix(.0, 1., sign(l.a));\n  vec4 m = texture2D(texture, c + h * vec2(-1., 1.));\n  m.rgb = mix(vec3(.0), m.rgb, sign(m.a));\n  i += mix(.0, 1., sign(m.a));\n  return e + f * (i * e - j.rgb - l.rgb - m.rgb - k.rgb);\n}\nvoid main() {\n  c = gl_FragCoord.xy / size;\n  vec4 e = texture2D(texture, c);\n  if(enableSharpen == 1.) {\n    e.rgb = d(e.rgb, sharpFactor);\n  }\n  gl_FragColor = e;\n}",
            extraCommandProps: {
                viewport: {
                    x: 0,
                    y: 0,
                    width: (e, t) => t.size[0],
                    height: (e, t) => t.size[1]
                }
            }
        });
    }
    getMeshCommand(e, t) {
        return this.commands.copy || (this.commands.copy = this.createREGLCommand(e, null, t.getElements())), 
        this.commands.copy;
    }
}

class qt extends yt {
    constructor(t = {}) {
        const n = [], r = t.uniforms, i = [ {
            name: "modelViewMatrix",
            type: "function",
            fn: function(t, r) {
                return e.multiply(n, r.viewMatrix, r.modelMatrix);
            }
        } ];
        r && i.push(...r), super({
            vert: "attribute vec3 aPosition;\nuniform mat4 projMatrix;\nuniform mat4 modelMatrix;\nuniform mat4 positionMatrix;\nuniform mat4 modelViewMatrix;\n#include <get_output>\nvoid main() {\n  vec4 c = getPosition(aPosition);\n  mat4 d = getPositionMatrix();\n  gl_Position = projMatrix * modelViewMatrix * d * c;\n}",
            frag: "precision mediump float;\nuniform vec4 lineColor;\nuniform float lineOpacity;\nvoid main() {\n  gl_FragColor = lineColor;\n  gl_FragColor.a *= lineOpacity;\n}",
            uniforms: i,
            defines: t.defines || {},
            extraCommandProps: t.extraCommandProps || {}
        });
    }
}

const Kt = [], Jt = [];

class Yt extends yt {
    constructor(t = {}) {
        const n = [], i = t.uniforms, o = [ {
            name: "viewMatrixInverse",
            type: "function",
            fn: (t, n) => e.invert(Kt, n.viewMatrix)
        }, {
            name: "modelViewMatrix",
            type: "function",
            fn: function(t, r) {
                return e.multiply(n, r.viewMatrix, r.modelMatrix);
            }
        }, {
            name: "environmentTransform",
            type: "function",
            fn: (e, t) => r.fromRotation(Jt, Math.PI * (t.environmentOrientation || 0) / 180)
        } ];
        i && o.push(...i), super({
            vert: "precision mediump float;\n#include <gl2_vert>\nattribute vec3 aPosition;\n#include <line_extrusion_vert>\n#ifdef HAS_MAP\nuniform vec2 uvScale;\nuniform vec2 uvOffset;\nattribute vec2 aTexCoord;\nvarying vec2 vTexCoord;\n#ifdef HAS_I3S_UVREGION\nattribute vec4 uvRegion;\nvarying vec4 vUvRegion;\n#endif\n#endif\n#if defined(HAS_COLOR)\nattribute vec4 aColor;\n#elif defined(HAS_COLOR0)\n#if COLOR0_SIZE == 3\nattribute vec3 aColor0;\n#else\nattribute vec4 aColor0;\n#endif\nvarying vec4 vColor;\n#endif\nuniform mat4 projMatrix;\nuniform mat3 modelNormalMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 modelMatrix;\nuniform mat4 positionMatrix;\nuniform vec2 halton;\nuniform vec2 outSize;\nuniform mat4 projViewMatrix;\n#include <get_output>\n#include <heatmap_render_vert>\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_vert>\n#endif\nvarying vec3 vViewPosition;\nvoid main() {\n  \n#ifdef IS_LINE_EXTRUSION\nvec4 c = getPosition(getLineExtrudePosition(aPosition));\n#else\nvec4 c = getPosition(aPosition);\n#endif\nmat4 d = getPositionMatrix();\n  mat4 e = projMatrix;\n  e[2].xy += halton.xy / outSize.xy;\n#ifdef HAS_MASK_EXTENT\ngl_Position = e * getMaskPosition(d * c, modelMatrix);\n#else\ngl_Position = e * modelViewMatrix * d * c;\n#endif\nvec4 f = modelViewMatrix * d * c;\n  vViewPosition = -f.xyz;\n#ifdef HAS_MAP\nvec2 h = decode_getTexcoord(aTexCoord);\n  vTexCoord = h * uvScale + uvOffset;\n#endif\n#if defined(HAS_COLOR)\nvColor = aColor / 255.;\n#elif defined(HAS_COLOR0)\n#if COLOR0_SIZE == 3\nvColor = vec4(aColor0 / 255., 1.);\n#else\nvColor = aColor0 / 255.;\n#endif\n#endif\n}",
            frag: "#if __VERSION__ == 100\n#if defined(GL_EXT_shader_texture_lod)\n#extension GL_EXT_shader_texture_lod : enable\n#define textureCubeLod(tex, uv, lod) textureCubeLodEXT(tex, uv, lod)\n#else\n#define textureCubeLod(tex, uv, lod) textureCube(tex, uv, lod)\n#endif\n#if defined(GL_OES_standard_derivatives)\n#extension GL_OES_standard_derivatives : enable\n#endif\n#else\n#define textureCubeLod(tex, uv, lod) textureLod(tex, uv, lod)\n#endif\n#define saturate(x)        clamp(x, 0.0, 1.0)\nprecision mediump float;\n#include <gl2_frag>\n#include <hsv_frag>\nuniform vec3 hsv;\n#define GET_BASEMAP(UV) (texture2D(baseColorTexture, (UV)))\nuniform mat4 viewMatrix;\nuniform mat4 projMatrix;\nuniform vec3 cameraPosition;\n#if defined(HAS_IBL_LIGHTING)\nuniform mat4 viewMatrixInverse;\n#endif\nuniform vec4 baseColorFactor;\nuniform vec3 emissiveFactor;\nuniform vec3 specularFactor;\nuniform float opacity;\nuniform float envRotationSin;\nuniform float envRotationCos;\nuniform float rgbmRange;\n#if defined(HAS_MAP)\n#include <computeTexcoord_frag>\n#endif\n#ifdef HAS_BASECOLOR_MAP\nuniform sampler2D baseColorTexture;\n#endif\n#ifdef HAS_NORMAL_MAP\nuniform sampler2D normalTexture;\nvec3 c(vec3 d, vec3 e) {\n  vec3 f = dFdx(d.xyz);\n  vec3 h = dFdy(d.xyz);\n  vec3 i = normalize(f - h);\n  vec3 j = normalize(-f + h);\n  vec3 k = normalize(e);\n  vec3 l = texture2D(normalTexture, computeTexCoord(vTexCoord)).rgb * 2. - 1.;\n  mat3 m = mat3(i, j, k);\n  return normalize(m * l);\n}\n#endif\n#ifdef HAS_EMISSIVE_MAP\nuniform sampler2D emissiveTexture;\n#endif\n#ifdef SHADING_MODEL_SPECULAR_GLOSSINESS\nuniform vec4 diffuseFactor;\n#ifdef HAS_DIFFUSE_MAP\nuniform sampler2D diffuseTexture;\n#endif\n#ifdef HAS_SPECULARGLOSSINESS_MAP\nuniform sampler2D specularGlossinessTexture;\n#endif\n#endif\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_frag>\n#endif\n#if defined(HAS_COLOR) || defined(HAS_COLOR0)\nvarying vec4 vColor;\n#endif\n#ifdef GAMMA_INPUT\nvec3 n(vec3 o) {\n  return o * o;\n}\nfloat n(float o) {\n  return o * o;\n}\n#else\nvec3 n(vec3 o) {\n  return o;\n}\nfloat n(float o) {\n  return o;\n}\n#endif\nvec3 u() {\n  \n#ifdef SHADING_MODEL_SPECULAR_GLOSSINESS\n#ifdef HAS_SPECULARGLOSSINESS_MAP\nreturn texture2D(specularGlossinessTexture, computeTexCoord(vTexCoord)).rgb;\n#else\nreturn specularFactor;\n#endif\n#else\nreturn specularFactor;\n#endif\n}\nvec3 v() {\n  \n#ifdef HAS_EMISSIVE_MAP\nreturn texture2D(emissiveTexture, computeTexCoord(vTexCoord)).rgb;\n#else\nreturn emissiveFactor;\n#endif\n}\n#if defined(TONEMAP_OUTPUT)\n#if TONEMAP_OUTPUT > 0\nuniform float exposureBias;\nfloat A(vec3 rgb) {\n  return dot(rgb, vec3(.299, .587, .114));\n}\nfloat B(vec3 rgb) {\n  return dot(rgb, vec3(.212671, .715160, .072169));\n}\nvec3 C(vec3 xyz) {\n  vec3 D = vec3(3.240479, -1.53715, -.498535);\n  vec3 E = vec3(-.969256, 1.875992, .041556);\n  vec3 F = vec3(.055648, -.204043, 1.057311);\n  vec3 rgb;\n  rgb.b = dot(xyz, F);\n  rgb.g = dot(xyz, E);\n  rgb.r = dot(xyz, D);\n  return rgb;\n}\nvec3 H(vec3 rgb) {\n  vec3 I = vec3(.412453, .35758, .180423);\n  vec3 J = vec3(.212671, .71516, .0721688);\n  vec3 K = vec3(.0193338, .119194, .950227);\n  vec3 xyz;\n  xyz.x = dot(rgb, I);\n  xyz.y = dot(rgb, J);\n  xyz.z = dot(rgb, K);\n  return xyz;\n}\nvec3 L(vec3 xyz) {\n  float M = xyz.x + xyz.y + xyz.z;\n  M = 1. / M;\n  vec3 O;\n  O.z = xyz.y;\n  O.x = xyz.x * M;\n  O.y = xyz.y * M;\n  return O;\n}\nvec3 P(vec3 O) {\n  float x = O.x;\n  float y = O.y;\n  float J = O.z;\n  vec3 xyz;\n  xyz.y = J;\n  xyz.x = x * (J / y);\n  xyz.z = (1. - x - y) * (J / y);\n  return xyz;\n}\nfloat Q(float x) {\n  float U = pow(x, 1.60525727);\n  float V = ((1.05542877 * 4.68037409) * U) / (4.68037409 * U + 1.);\n  return clamp(V, .0, 1.);\n}\nconst float W = 1. / .18;\nfloat ba(float x) {\n  x *= W;\n  const float bb = .2;\n  const float F = .34;\n  const float bc = .002;\n  const float bd = 1.68;\n  const float be = .0005;\n  const float bf = .252;\n  const float bg = 1. / .833837;\n  return ((x * (bb * x + bc * F) + bd * be) / (x * (bb * x + F) + bd * bf) - be / bf) * bg;\n}\nvec3 bh(vec3 x) {\n  x *= W;\n  const float bb = .27;\n  const float F = .29;\n  const float bc = .052;\n  const float bd = .2;\n  const float bf = .18;\n  const float bg = 1. / .897105;\n  return ((x * (bb * x + bc * F)) / (x * (bb * x + F) + bd * bf)) * bg;\n}\nvec3 bi(vec3 x) {\n  vec3 bj = x.rgb;\n  bj = min(bj, vec3(3.));\n  float bk = B(bj);\n  if(bk > .0) {\n    float bl = Q(bk);\n    bj = bj * (bl / bk);\n    bj = clamp(bj, vec3(.0), vec3(1.));\n  }\n  float bm = 1. / 2.2;\n  bj = pow(bj, vec3(bm));\n  return bj;\n}\n#endif\n#endif\n#if defined(IRR_RGBM) || defined(ENV_RGBM) || defined(ENV_GAMMA) || defined(IRR_GAMMA)\nuniform float envMapExposure;\n#endif\nuniform vec4 themingColor;\nuniform mat3 environmentTransform;\nvec3 bn(vec3 bo, vec3 bp) {\n  \n#if defined(HAS_SHADOWMAP)\nfloat bq = dot(shadowLightDir, bp);\n  float br = (bq + 1.) / 2.;\n  br = min(1., br * 1.5);\n  float bs = 1.;\n  vec3 bt = bo * min(bs, br);\n  return bt;\n#else\nreturn bo;\n#endif\n}\n#ifdef HAS_IBL_LIGHTING\nuniform float reflectivity;\nuniform vec3 hdrHSV;\nuniform samplerCube prefilterMap;\nuniform vec3 diffuseSPH[9];\nuniform vec2 prefilterMiplevel;\nuniform vec2 prefilterSize;\n#else\nuniform vec3 ambientColor;\n#endif\n#if defined(HAS_IBL_LIGHTING)\nvec3 bu(const in vec3 bv) {\n  vec3 bw = environmentTransform * bv;\n  float x = bw.x;\n  float y = bw.y;\n  float z = bw.z;\n  vec3 bt = (diffuseSPH[0] + diffuseSPH[1] * x + diffuseSPH[2] * y + diffuseSPH[3] * z + diffuseSPH[4] * z * x + diffuseSPH[5] * y * z + diffuseSPH[6] * y * x + diffuseSPH[7] * (3. * z * z - 1.) + diffuseSPH[8] * (x * x - y * y));\n  if(length(hdrHSV) > .0) {\n    bt = hsv_apply(bt, hdrHSV);\n  }\n  return max(bt, vec3(.0));\n}\nvec3 bx(const in vec4 by, const in float bz) {\n  if(bz <= .0)\n    return by.rgb;\n  return bz * by.rgb * by.a;\n}\nfloat bA(const in float bB) {\n  return bB;\n}\nvec3 bC(const in float bD, const in vec3 D) {\n  vec3 bE = D;\n  float bF = prefilterMiplevel.x;\n  float bG = min(bF, bA(bD) * prefilterMiplevel.y);\n  vec3 bH = bx(textureCubeLod(prefilterMap, bE, bG), rgbmRange);\n  if(length(hdrHSV) > .0) {\n    return hsv_apply(bH, hdrHSV);\n  } else {\n    return bH;\n  }\n}\nvec3 bI(const in vec3 k, const in vec3 D, const in float bJ) {\n  float bK = 1. - bJ;\n  float bL = bK * (sqrt(bK) + bJ);\n  return mix(k, D, bL);\n}\nvec3 bM(const in vec3 bv, const in vec3 bN, const in float bO, const in vec3 bP) {\n  vec3 D = reflect(-bN, bv);\n  D = bI(bv, D, bO);\n  vec3 bQ = bC(bO, environmentTransform * D);\n  float bR = clamp(1. + dot(D, bP), .0, 1.);\n  bQ *= bR * bR;\n  return bQ;\n}\n#else\nvec3 bM(const in vec3 bv, const in vec3 bN, const in float bO, const in vec3 bP) {\n  return ambientColor;\n}\n#endif\nvarying highp vec3 vViewPosition;\nvec3 bS(vec3 bT, float bU) {\n  float bV = max(1. - bU, .0);\n  return bT + (1. - bT) * pow(bV, 5.);\n}\nfloat bW(float bT, float bU) {\n  float bV = max(1. - bU, .0);\n  return bT + (1. - bT) * pow(bV, 5.);\n}\n#include <srgb_frag>\nvoid main() {\n  glFragColor = vec4(vec3(1.), opacity);\n#ifdef HAS_BASECOLOR_MAP\nvec4 bX = GET_BASEMAP(computeTexCoord(vTexCoord));\n#ifdef GAMMA_INPUT\nbX.xyz *= bX.xyz;\n#endif\nglFragColor = glFragColor * bX;\n#endif\n#ifdef ALPHATEST\nif(glFragColor.a < ALPHATEST)\n    discard;\n  \n#endif\nfloat bY = 1.;\n  vec3 bZ = dFdx(vViewPosition);\n  vec3 ca = dFdy(vViewPosition);\n  vec3 bv = normalize(cross(bZ, ca));\n  vec3 cb;\n  if(projMatrix[3][3] == .0) {\n    cb = normalize(vViewPosition);\n  } else {\n    cb = vec3(.0, .0, 1.);\n  }\n  bv = faceforward(bv, -cb, bv);\n  vec3 cc = bv;\n#ifdef HAS_NORMAL_MAP\nbv = c(-vViewPosition, bv);\n#endif\nvec3 cd = vec3(.0);\n  vec3 ce = vec3(.0);\n#ifdef HAS_IBL_LIGHTING\nvec3 bp = mat3(viewMatrixInverse) * bv;\n  vec3 cf = glFragColor.rgb * bu(bp) * .5;\n  cf = bn(cf, bp);\n  cd += n(baseColorFactor.rgb) * cf;\n#endif\nvec3 cg = v();\n#ifdef METAL\nglFragColor.xyz = glFragColor.xyz * (n(cg) + cd + n(baseColorFactor.rgb) + ce);\n#else\nglFragColor.xyz = glFragColor.xyz * (n(cg) + cd + n(baseColorFactor.rgb)) + ce;\n#endif\nvec3 ch;\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nfloat ci = shadow_computeShadow();\n  ch = shadow_blend(ch, ci).rgb;\n#endif\n#ifdef HAS_COLOR\nglFragColor = glFragColor * vColor;\n#endif\nglFragColor.rgb += ch;\n  glFragColor.rgb = linearTosRGB(glFragColor.rgb);\n#if defined(HAS_IBL_LIGHTING)\nvec3 cj;\n#if defined(HAS_NORMAL_MAP)\n#ifdef ENVMAP_MODE_REFLECTION\ncj = reflect(-cb, bv);\n#else\ncj = refract(-cb, bv, 1.);\n#endif\n#else\ncj = reflect(-cb, bv);\n#endif\ncj = mat3(viewMatrixInverse) * cj;\n  float ck = 1.;\n  vec3 cl;\n#ifdef HAS_IBL_LIGHTING\ncl = vec3(.0);\n#elif\ncl = ambientColor;\n#endif\ncl *= ck;\n  float bV = dot(cb, bv);\n  if(bV < -1e-2 || reflectivity == .0)\n    bV = 1.;\n  else\n    bV = max(1e-6, bV);\n  vec3 cm;\n  vec3 cn = u();\n#ifdef METAL\ncm = n(cn);\n#else\ncm = bS(n(cn), bV) * (1. - envRotationSin);\n  glFragColor.a = mix(glFragColor.a, bW(glFragColor.a, bV), reflectivity) * envRotationCos;\n  float co = pow(1. - bV * .5, 5.);\n  float cp = (28. / 23.) * (1. - co) * (1. - co);\n  glFragColor.rgb *= cp * (1. - n(cn));\n#endif\nglFragColor.rgb += cl.rgb * bY * cm.rgb;\n#endif\n#if defined(TONEMAP_OUTPUT)\n#if TONEMAP_OUTPUT == 1\nglFragColor.rgb = bi(exposureBias * glFragColor.rgb);\n#elif TONEMAP_OUTPUT == 2\nglFragColor.rgb = bh(exposureBias * glFragColor.rgb);\n#endif\n#endif\nglFragColor.rgb = mix(glFragColor.rgb, themingColor.rgb, themingColor.a);\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}",
            uniforms: o,
            defines: t.defines || {},
            extraCommandProps: t.extraCommandProps || {}
        }), this.version = 300;
    }
}

class Zt extends Et {
    constructor() {
        super({
            vert: Mt,
            frag: "#if __VERSION__ == 100\n#ifdef GL_OES_standard_derivatives\n#extension GL_OES_standard_derivatives : enable\n#endif\n#endif\nprecision mediump float;\n#include <gl2_frag>\nvarying vec2 vTexCoord;\nuniform sampler2D sceneMap;\nuniform sampler2D scanEffectMap;\nvoid main() {\n  vec4 c = texture2D(sceneMap, vTexCoord);\n  vec4 d = texture2D(scanEffectMap, vTexCoord);\n  glFragColor = c + d;\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}",
            extraCommandProps: {
                viewport: {
                    x: 0,
                    y: 0,
                    width: (e, t) => t.resolution[0],
                    height: (e, t) => t.resolution[1]
                }
            }
        });
    }
}

const $t = [];

class Qt {
    constructor(e, t, n) {
        this._regl = e, this._layer = n, this._viewport = t, this._init();
    }
    _init() {
        this._shader = new yt({
            vert: "attribute vec3 aPosition;\nuniform mat4 projMatrix;\nuniform mat4 modelMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 positionMatrix;\nvarying vec4 vWorldPosition;\n#include <get_output>\nvoid main() {\n  vec4 c = getPosition(aPosition);\n  mat4 d = getPositionMatrix();\n  vec4 e = modelMatrix * d * c;\n  gl_Position = projMatrix * modelViewMatrix * d * c;\n  vWorldPosition = e;\n}",
            frag: "precision mediump float;\nvarying vec4 vWorldPosition;\nuniform vec2 fogDist;\nuniform vec3 cameraPosition;\nuniform float rainDepth;\nvoid main() {\n  vec3 c = vec3(vWorldPosition[0] - cameraPosition[0], vWorldPosition[1] - cameraPosition[1], vWorldPosition[2] - cameraPosition[2]);\n  float d = length(c);\n  float e = clamp(1. - (d - fogDist.x) / (fogDist.y - fogDist.x), .0, 1.);\n  if(vWorldPosition[2] < rainDepth) {\n    gl_FragColor = vec4(e, .0, .0, 1.);\n  } else {\n    gl_FragColor = vec4(e, 1., .0, 1.);\n  }\n}",
            uniforms: [ {
                name: "modelViewMatrix",
                type: "function",
                fn: function(t, n) {
                    return e.multiply($t, n.viewMatrix, n.modelMatrix);
                }
            } ],
            extraCommandProps: {
                viewport: this._viewport
            }
        });
        const t = this._layer.getRenderer().createFBOInfo();
        this._fbo = this._regl.framebuffer(t), this._scene = new Ze, this.renderer = new Ve(this._regl);
    }
    render(e, t) {
        this._resize(), this.renderer.clear({
            color: [ 0, 0, 0, 1 ],
            depth: 1,
            framebuffer: this._fbo
        }), this._scene.setMeshes(e);
        return this.renderer.render(this._shader, {
            projMatrix: t.projMatrix,
            viewMatrix: t.viewMatrix,
            cameraPosition: t.cameraPosition,
            fogDist: t.fogDist,
            rainDepth: t.rainDepth
        }, this._scene, this._fbo), this._fbo;
    }
    dispose() {
        this._fbo && this._fbo.destroy(), this._shader && this._shader.dispose();
    }
    _resize() {
        const e = m(this._viewport.width.data) ? this._viewport.width.data() : this._viewport.width, t = m(this._viewport.height.data) ? this._viewport.height.data() : this._viewport.height;
        !this._fbo || this._fbo.width === e && this._fbo.height === t || this._fbo.resize(e, t);
    }
}

class en extends Et {
    constructor() {
        super({
            vert: Mt,
            frag: "#if __VERSION__ == 100\n#ifdef GL_OES_standard_derivatives\n#extension GL_OES_standard_derivatives : enable\n#endif\n#endif\nprecision mediump float;\n#include <gl2_frag>\nvarying vec2 vTexCoord;\n#ifdef HAS_RAIN\nuniform sampler2D ripplesMap;\n#endif\n#ifdef HAS_SNOW\nuniform sampler2D normalMap;\n#endif\n#ifdef HAS_FOG\nuniform vec3 fogColor;\n#endif\nuniform sampler2D sceneMap;\nuniform sampler2D mixFactorMap;\nuniform float time;\nuniform vec2 resolution;\nuniform float snowIntensity;\nfloat c(float a, float b, float w) {\n  return a + w * (b - a);\n}\n#define HASHSCALE1 .1031\n#define HASHSCALE3 vec3(.1031, .1030, .0973)\n#define HASHSCALE4 vec3(.1031, .1030, .0973, .1099)\nfloat d = .5;\nfloat e = .2;\nfloat f = .5;\nfloat h = 20.;\nfloat i(float p) {\n  vec3 j = fract(vec3(p) * HASHSCALE1);\n  j += dot(j, j.yzx + 19.19);\n  return fract((j.x + j.y) * j.z);\n}\nvec2 k(vec2 p) {\n  vec3 j = fract(vec3(p.xyx) * HASHSCALE3);\n  j += dot(j, j.yzx + 19.19);\n  return fract((j.xx + j.yz) * j.zy);\n}\nvec2 l(vec2 m) {\n  float x = fract(sin(dot(m.xy, vec2(122.9898, 783.233))) * 43758.5453);\n  float y = fract(sin(dot(m.xy, vec2(457.6537, 537.2793))) * 37573.5913);\n  return vec2(x, y);\n}\nvec3 n(vec2 o, float u) {\n  vec3 v = vec3(.0);\n  o = o * (2. + u);\n  float A = e * snowIntensity;\n  float B = o.y * (((i(u) * 2. - 1.) * .5 + 1.) * A);\n  float C = (f * time);\n  o += vec2(B, C);\n  vec2 D = k(floor(o) + 31.1759 * u);\n  o = fract(o);\n  o -= (D * 2. - 1.) * .35;\n  o -= .5;\n  float r = length(o);\n  float E = .05 * (1. + .3 * sin(time * d));\n  float F = smoothstep(E, -E, r);\n  vec3 G = vec3(F) * D.x;\n  return G;\n}\nvec3 H() {\n  vec3 v = vec3(0);\n  vec2 o = gl_FragCoord.xy / resolution.xy;\n  o *= vec2(resolution.x / resolution.y, 1.);\n  float I = h * snowIntensity;\n  for(float J = 0.; J < I; J++) {\n    v += n(o, J);\n  }\n  return v;\n}\nvec3 K(vec4 L, vec4 M, float N) {\n  float O = M.b;\n  vec3 P = vec3(1.);\n  if(N < 1.) {\n    float r = c(.5, P.x, O);\n    float g = c(.5, P.y, O);\n    float b = c(.5, P.z, O);\n    return vec3(r, g, b);\n  } else {\n    float r = c(L.r, P.x, O);\n    float g = c(L.g, P.y, O);\n    float b = c(L.b, P.z, O);\n    return vec3(r, g, b);\n  }\n}\nvoid main() {\n  vec4 L = texture2D(sceneMap, vTexCoord);\n  glFragColor = L;\n  vec4 Q = texture2D(mixFactorMap, vTexCoord);\n#ifdef HAS_RAIN\nvec4 R = texture2D(ripplesMap, vTexCoord);\n  if(Q.g < 1.) {\n    L = mix(L, R, .4);\n  }\n  glFragColor = L;\n#endif\n#ifdef HAS_SNOW\nvec3 S = H();\n  glFragColor = vec4(L.rgb + S, L.a);\n#endif\n#ifdef HAS_FOG\nfloat T = Q.r;\n  vec3 U = mix(fogColor, glFragColor.rgb, T);\n  glFragColor = vec4(U, L.a);\n#endif\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}",
            extraCommandProps: {
                viewport: {
                    x: 0,
                    y: 0,
                    width: (e, t) => t.resolution[0],
                    height: (e, t) => t.resolution[1]
                }
            }
        });
    }
}

const tn = [], nn = [ .03, .03, .03 ], rn = [], on = [], an = [], sn = e.fromRotationTranslation([], o.fromEuler([], 90, 0, 0), [ 0, 0, 0 ]);

class cn {
    constructor(e, t) {
        this._regl = e, this._viewport = t, this._init();
    }
    _init() {
        this._shader = new yt({
            vert: "#include <gl2_vert>\nattribute vec3 aPosition;\nattribute vec3 aNormal;\nattribute vec2 aTexCoord;\nuniform mat4 projMatrix;\nuniform mat4 modelMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 positionMatrix;\nvarying vec2 vTexCoord;\n#include <get_output>\nvoid main() {\n  vec4 c = getPosition(aPosition);\n  mat4 d = getPositionMatrix();\n  gl_Position = projMatrix * modelViewMatrix * d * c;\n  vTexCoord = aTexCoord;\n}",
            frag: "#if __VERSION__ == 100\n#ifdef GL_OES_standard_derivatives\n#extension GL_OES_standard_derivatives : enable\n#endif\n#endif\nprecision mediump float;\n#include <gl2_frag>\nvarying vec2 vTexCoord;\nuniform float rippleRadius;\nuniform float density;\nuniform float time;\nvec3 c(vec2 p) {\n  vec3 q = vec3(dot(p, vec2(127.1, 311.7)), dot(p, vec2(269.5, 183.3)), dot(p, vec2(419.2, 371.9)));\n  return fract(sin(q) * 43758.5453);\n}\nfloat d(in vec2 x) {\n  vec2 e = x * density / 4000.0;\n  vec2 p = floor(e);\n  vec2 f = fract(e);\n  float h = .0;\n  for(int i = -4; i <= 4; i++)\n    for(int k = -4; k <= 4; k++) {\n      vec2 g = vec2(float(k), float(i));\n      vec3 l = c(p + g);\n      vec2 r = g - f + l.xy;\n      float m = sqrt(dot(r, r));\n      float n = max(mix(smoothstep(.99, .999, max(cos(m - time * 2. + (l.x + l.y) * 5.), 0.)), 0., m), 0.);\n      h += n;\n    }\n  return h;\n}\nvoid main() {\n  vec2 u = vTexCoord;\n  float A = 24. / (rippleRadius * .01);\n  float f = d(A * u) * smoothstep(.0, .4, sin(u.x * 3.151592) * sin(u.y * 3.141592));\n  vec3 B = vec3(-dFdx(f), -dFdy(f), -dFdy(f));\n  glFragColor = vec4(B, 1.);\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}",
            uniforms: [ {
                name: "modelViewMatrix",
                type: "function",
                fn: function(t, n) {
                    return e.multiply(tn, n.viewMatrix, n.modelMatrix);
                }
            } ],
            extraCommandProps: {
                viewport: this._viewport
            }
        }), this._shader.version = 300, this._fbo = this._regl.framebuffer({
            color: this._regl.texture({
                width: this._viewport.width(),
                height: this._viewport.height(),
                wrap: "clamp",
                mag: "linear",
                min: "linear"
            }),
            depth: !0
        }), this._scene = new Ze, this.renderer = new Ve(this._regl);
    }
    _transformRipples(n) {
        const r = n.coordinateToPointAtRes(n.getCenter(), n.getGLRes()), i = n.getGLScale() / n.getGLScale(this._fixZoom), a = t.set(on, i, i, i), s = t.multiply(a, nn, a), c = e.identity(an);
        e.fromRotationTranslationScale(c, o.fromEuler(rn, 0, 0, 0), [ r.x, r.y, 0 ], s), 
        e.multiply(c, c, sn), this._mesh.setLocalTransform(c);
    }
    _createRipplesMask(e) {
        this._fixZoom = e.getZoom();
        const t = 800 * Math.pow(2, 16.685648411389433 - this._fixZoom), n = {};
        n.POSITION = [ -t, 0, -t, t, 0, -t, -t, 0, t, t, 0, t ], n.NORMAL = [ 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0 ], 
        n.TEXCOORD_0 = [ 0, 0, 1, 0, 0, 1, 1, 1 ];
        const r = new Z(n, [ 3, 1, 0, 0, 2, 3 ], 0, {
            positionAttribute: "POSITION",
            normalAttribute: "NORMAL",
            uv0Attribute: "TEXCOORD_0"
        });
        r.generateBuffers(this._regl);
        const i = new Ce;
        return new Be(r, i);
    }
    render(e, t) {
        this._resize(), this.renderer.clear({
            color: [ 0, 0, 0, 1 ],
            depth: 1,
            framebuffer: this._fbo
        }), this._mesh = this._mesh || this._createRipplesMask(e), this._scene.setMeshes(this._mesh), 
        this._transformRipples(e);
        return this.renderer.render(this._shader, {
            projMatrix: t.projMatrix,
            viewMatrix: t.viewMatrix,
            time: t.time,
            rippleRadius: t.rippleRadius,
            density: t.density
        }, this._scene, this._fbo), this._fbo;
    }
    dispose() {
        this._fbo && this._fbo.destroy(), this._shader && this._shader.dispose();
    }
    _resize() {
        const e = m(this._viewport.width.data) ? this._viewport.width.data() : this._viewport.width, t = m(this._viewport.height.data) ? this._viewport.height.data() : this._viewport.height;
        !this._fbo || this._fbo.width === e && this._fbo.height === t || this._fbo.resize(e, t);
    }
}

var ln = "attribute vec3 aPosition;\nuniform mat4 positionMatrix;\nuniform mat4 projViewModelMatrix;\n#ifdef HAS_TEXTURE\nattribute vec2 aTexCoord;\nvarying vec2 uv;\nvarying vec4 vPos;\n#endif\n#include <get_output>\nvoid main() {\n  mat4 c = getPositionMatrix();\n  vec4 d = c * getPosition(aPosition);\n  gl_Position = projViewModelMatrix * d;\n#ifdef HAS_TEXTURE\nuv = aTexCoord;\n  vPos = getPosition(aPosition);\n#endif\n}";

const fn = [ 0, 0, 0, 1 ];

class dn {
    constructor(e, t) {
        this.regl = e, this._viewport = t, this.renderer = new Ve(e), this._init();
    }
    _init() {
        this._maskColorFbo = this.renderer.regl.framebuffer({
            color: this.renderer.regl.texture({
                width: 1,
                height: 1,
                wrap: "clamp",
                mag: "linear",
                min: "linear"
            }),
            depth: !0
        }), this._maskModeFbo = this.renderer.regl.framebuffer({
            color: this.renderer.regl.texture({
                width: 1,
                height: 1,
                wrap: "clamp",
                mag: "nearest",
                min: "nearest"
            }),
            depth: !0
        });
        const t = [ {
            name: "projViewModelMatrix",
            type: "function",
            fn: (t, n) => e.multiply([], n.projViewMatrix, n.modelMatrix)
        } ];
        this._maskColorShader = new yt({
            vert: ln,
            frag: "#ifdef GL_ES\nprecision highp float;\n#endif\nuniform vec4 maskColor;\n#ifdef HAS_TEXTURE\nuniform sampler2D maskTexture;\nvarying vec2 uv;\nuniform vec3 mask_position0;\nuniform vec3 mask_position1;\nuniform vec3 mask_position2;\nuniform vec3 mask_position3;\nvarying vec4 vPos;\nvec2 c(vec2 d, vec2 a, vec2 b, vec2 e, vec2 f) {\n  vec2 h = vec2(.5);\n  for(int i = 0; i < 10; i++) {\n    float j = h.x;\n    float k = h.y;\n    vec2 l = (1. - j) * (1. - k) * a + j * (1. - k) * b + j * k * e + (1. - j) * k * f;\n    vec2 m = d - l;\n    if(length(m) < .001)\n      break;\n    vec2 n = -(1. - k) * a + (1. - k) * b + k * e - k * f;\n    vec2 o = -(1. - j) * a - j * b + j * e + (1. - j) * f;\n    float A = n.x * o.y - n.y * o.x;\n    if(abs(A) > .0001) {\n      vec2 B = vec2((m.x * o.y - m.y * o.x) / A, (m.y * n.x - m.x * n.y) / A);\n      h += B;\n    }\n    h = clamp(h, .0, 1.);\n  }\n  return h;\n}\n#endif\nvoid main() {\n  \n#ifdef HAS_TEXTURE\nvec2 d = vPos.xy;\n  vec2 C = c(d, mask_position0.xy, mask_position1.xy, mask_position2.xy, mask_position3.xy);\n  gl_FragColor = texture2D(maskTexture, C);\n  gl_FragColor.a *= maskColor.a;\n#else\nif(maskColor.a == .0) {\n    discard;\n  }\n  gl_FragColor = maskColor;\n#endif\n}",
            uniforms: t,
            extraCommandProps: {
                viewport: this._viewport
            }
        }), this._maskModeShader = new yt({
            vert: ln,
            frag: "#ifdef GL_ES\nprecision highp float;\n#endif\nuniform float maskMode;\n#ifdef HAS_MASK_FLAT\nuniform float flatHeight;\n#endif\n#ifdef HAS_MASK_COLOR\nuniform vec2 heightRange;\n#endif\nvoid main() {\n  \n#if defined(HAS_MASK_FLAT)\ngl_FragColor = vec4(maskMode, flatHeight, .0, 1.);\n#elif defined(HAS_MASK_COLOR)\ngl_FragColor = vec4(maskMode, .0, heightRange.x, heightRange.y);\n#else\ngl_FragColor = vec4(maskMode, .0, .0, .0);\n#endif\n}",
            uniforms: t,
            extraCommandProps: {
                viewport: this._viewport
            }
        }), this._scene = new Ze;
    }
    render(e, t) {
        this._resize(), this.renderer.clear({
            color: fn,
            depth: 1,
            framebuffer: this._maskColorFbo
        }), this.renderer.clear({
            color: fn,
            depth: 1,
            framebuffer: this._maskModeFbo
        }), this._scene.setMeshes(e);
        const n = {
            projViewMatrix: t
        };
        return this.renderer.render(this._maskColorShader, n, this._scene, this._maskColorFbo), 
        this.renderer.render(this._maskModeShader, n, this._scene, this._maskModeFbo), {
            colorExtent: this._maskColorFbo,
            modeExtent: this._maskModeFbo
        };
    }
    _resize() {
        const e = m(this._viewport.width) ? this._viewport.width() : this._viewport.width.data(), t = m(this._viewport.height) ? this._viewport.height() : this._viewport.height.data();
        !this._maskColorFbo || this._maskColorFbo.width === e && this._maskColorFbo.height === t || (this._maskColorFbo.resize(e, t), 
        this._maskModeFbo.resize(e, t));
    }
    dispose() {
        this._maskColorFbo && (this._maskColorFbo.destroy(), delete this._maskColorFbo), 
        this._maskModeFbo && (this._maskModeFbo.destroy(), delete this._maskModeFbo), this._maskColorShader && (this._maskColorShader.dispose(), 
        delete this._maskColorShader), this._maskModeShader && (this._maskModeShader.dispose(), 
        delete this._maskModeShader);
    }
}

const un = "\n#ifdef GL_ES\n  precision highp float;\n#endif\nuniform mat3 ring;\n\nuniform float effectTime;\nvarying vec4 vWorldPosition;\n\nvec3 hsb2rgb(in vec3 c) {\n    vec3 rgb = clamp(abs(mod(c.x * 6.0 + vec3(0.0,4.0,2.0), 6.0)-3.0)-1.0, 0.0, 1.0 );\n    rgb = rgb*rgb*(3.0-2.0*rgb);\n    return c.z * mix( vec3(1.0), rgb, c.y);\n}\n\nvec4 glowring(vec4 worldPos, vec2 center, float radius, float speed, vec3 effectColor, float direction, float height) {\n  vec2 dir = vec2(worldPos.xy) - center;\n  float len = length(dir);\n  if (len > radius) {\n    return vec4(0.0);\n  } else {\n    vec2 uv = vec2(0.0);\n    if (direction == 0.0) {\n      vec2 lefttop = vec2(center.x - radius, center.y + radius);\n      vec2 rightbottom = vec2(center.x + radius, center.y - radius);\n      uv = vec2(abs(worldPos.x - lefttop.x) / (2.0 * radius), abs(worldPos.y - rightbottom.y) / (2.0 * radius));\n      uv.x -= 0.5;\n      uv.y -= 0.5;\n    } else {\n      if (worldPos.z < 0.1) {\n        return vec4(0.0);\n      }\n      uv = vec2(0.0, worldPos.z / height);\n    }\n    float itime = (effectTime / 2.0) * speed;\n    float r = length(uv) * 3.0;\n    vec3 color = hsb2rgb(effectColor);\n\n    float a = pow(r, 2.0);\n    float b = sin(r * 0.8 - 1.6);\n    float c = sin(r - 0.010);\n    float s = sin(a - itime * 3.0 + b) * c;\n    float t = abs(1.0 / (s * 10.8)) - 0.01;\n    color *= t;\n    vec4 newColor = vec4(color, t);\n    return newColor;\n  }\n}\n\nvoid main() {\n    vec4 color = vec4(0.0);\n    gl_FragColor = color;\n}\n", hn = [];

class mn {
    constructor(e, t, n) {
        this._regl = e, this._layer = n, this._viewport = t, this._init(), this._effectsLength = 0;
    }
    _init() {
        const e = this._layer.getRenderer().createFBOInfo();
        this._fbo = this._regl.framebuffer(e), this._scene = new Ze, this.renderer = new Ve(this._regl);
    }
    render(t, n) {
        this._resize(), this.renderer.clear({
            color: [ 0, 0, 0, 1 ],
            depth: 1,
            framebuffer: this._fbo
        }), this._scene.setMeshes(t);
        const r = n.effectInfos;
        if (!this._shader || r.length !== this._effectsLength) {
            this._shader && this._shader.dispose();
            const t = this._createFragSource(r);
            this._shader = new yt({
                vert: "#include <gl2_vert>\n#define SHADER_NAME SCANEFFECT\nprecision highp float;\nattribute vec3 aPosition;\nuniform mat4 projMatrix;\nuniform mat4 modelMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 positionMatrix;\n#include <line_extrusion_vert>\n#include <get_output>\nvarying vec4 vWorldPosition;\nvoid main()\n{\n    mat4 localPositionMatrix = getPositionMatrix();\n    #ifdef IS_LINE_EXTRUSION\n        vec3 linePosition = getLineExtrudePosition(aPosition);\n        //linePixelScale = tileRatio * resolution / tileResolution\n        vec4 localVertex = getPosition(linePosition);\n    #else\n        vec4 localVertex = getPosition(aPosition);\n    #endif\n    vec4 worldPosition = modelMatrix * localPositionMatrix * localVertex;\n    vWorldPosition = worldPosition;\n    gl_Position = projMatrix * modelViewMatrix * localPositionMatrix * localVertex;\n}\n",
                frag: t,
                uniforms: [ {
                    name: "modelViewMatrix",
                    type: "function",
                    fn: function(t, n) {
                        return e.multiply(hn, n.viewMatrix, n.modelMatrix);
                    }
                } ],
                extraCommandProps: {
                    viewport: this._viewport
                }
            }), this._effectsLength = r.length;
        }
        const i = {
            projMatrix: n.projMatrix,
            viewMatrix: n.viewMatrix,
            effectTime: n.effectTime,
            minAltitude: 0
        };
        return this._updateUniforms(i, r), this.renderer.render(this._shader, i, this._scene, this._fbo), 
        this._fbo;
    }
    _createFragSource(e) {
        let t = "";
        for (let n = 0; n < e.length; n++) t += `uniform mat3 ring${n};\n`;
        t = un.replace("uniform mat3 ring;", t);
        let n = "";
        for (let t = 0; t < e.length; t++) n += `\n                vec2 center${t} = vec2(ring${t}[0][0], ring${t}[0][1]);\n                float radius${t} = ring${t}[0][2];\n                float speed${t} = ring${t}[1][0];\n                vec3 color${t} = vec3(ring${t}[1][1], ring${t}[1][2], ring${t}[2][0]);\n                float direction${t} = ring${t}[2][1];\n                float height${t} = ring${t}[2][2];\n                vec4 ringColor${t} = glowring(vWorldPosition, center${t}, radius${t}, speed${t}, color${t}, direction${t}, height${t});\n                color += ringColor${t};\n            `;
        return n += "gl_FragColor = color;", t = t.replace("gl_FragColor = color;", n), 
        t;
    }
    _updateUniforms(e, t) {
        for (let n = 0; n < t.length; n++) e[`ring${n}`] = t[n];
    }
    dispose() {
        this._fbo && this._fbo.destroy(), this._shader && this._shader.dispose();
    }
    _resize() {
        const e = m(this._viewport.width.data) ? this._viewport.width.data() : this._viewport.width, t = m(this._viewport.height.data) ? this._viewport.height.data() : this._viewport.height;
        !this._fbo || this._fbo.width === e && this._fbo.height === t || this._fbo.resize(e, t);
    }
}

const vn = [], _n = {
    width: 4,
    type: "float"
};

class gn {
    constructor(e, t, n) {
        this._regl = e, this.joints = t, this.inverseBindMatrices = [], this.jointMatrices = [], 
        this.jointData = new Float32Array(16 * t.length);
        for (let e = 0; e < t.length; ++e) this.inverseBindMatrices.push(new Float32Array(n.buffer, n.byteOffset + 16 * Float32Array.BYTES_PER_ELEMENT * e, 16)), 
        this.jointMatrices.push(new Float32Array(this.jointData.buffer, 16 * Float32Array.BYTES_PER_ELEMENT * e, 16));
        this.jointTextureSize = [ 4, 6 ];
    }
    update(t, n, r) {
        e.invert(vn, t);
        for (let t = 0; t < this.joints.length; ++t) {
            const r = this.jointMatrices[t];
            e.multiply(r, vn, n[this.joints[t].nodeIndex]), e.multiply(r, r, this.inverseBindMatrices[t]);
        }
        _n.height = this.joints.length, _n.data = this.jointData;
        const i = _n;
        return r ? r(i) : r = this._regl.texture(i), r;
    }
}

const xn = [ 0, 0, 0 ], pn = [ 0, 0, 0, 1 ], bn = [ 1, 1, 1 ], yn = [];

class An {
    constructor(e = [ 0, 0, 0 ], t = [ 0, 0, 0, 1 ], n = [ 1, 1, 1 ]) {
        this.translation = e, this.rotation = t, this.scale = n;
    }
    getMatrix() {
        return e.fromRotationTranslationScale(yn, this.rotation, this.translation, this.scale);
    }
    decompose(t) {
        e.getTranslation(this.translation, t), e.getRotation(this.rotation, t), e.getScaling(this.scale, t);
    }
    update(e) {
        e && (e.translation && !t.equals(e.translation, xn) && t.copy(this.translation, e.translation), 
        e.rotation && !o.equals(e.rotation, pn) && o.copy(this.rotation, e.rotation), e.scale && !t.equals(e.scale, bn) && t.copy(this.scale, e.scale));
    }
}

class Sn {
    constructor(e) {
        this._init(e);
    }
    _init(e) {
        this.bbox = e.bbox, this.geometry = e.geometry, this.nodeMatrix = e.nodeMatrix, 
        this.materialInfo = e.materialInfo, this.extraInfo = e.extraInfo, this.animationMatrix = e.animationMatrix, 
        this.morphWeights = e.morphWeights, this.skin = e.skin, this.nodeIndex = e.nodeIndex;
    }
    copyEdgeGeometry() {
        this.copyGeometry || (this.copyGeometry = this._copyEdgeGeometry(this.geometry));
    }
    createCopyBarycentric() {
        this.copyGeometry && !this.copyGeometry.data.aBarycentric && (this.copyGeometry.buildUniqueVertex(), 
        this.copyGeometry.createBarycentric("aBarycentric"));
    }
    _copyEdgeGeometry(e) {
        const t = e.data, n = e.indices || e.elements, r = {};
        for (const n in t) if (n === e.desc.positionAttribute) if (p(t[n])) r[n] = t[n].slice(); else if (t[n].buffer && t[n].buffer.destroy) r[n] = {
            buffer: t[n].buffer
        }, p(t[n].array) && (r[n].array = t[n].array.slice()); else {
            const t = e._getAttributeData(n);
            r[n] = n !== e.desc.positionAttribute ? t : t.slice();
        }
        const i = void 0 !== n.length ? n.slice() : n, o = JSON.parse(JSON.stringify(e.desc)), a = new Se(r, i, 0, o);
        return a.properties = e.properties, a;
    }
}

let Tn = 0;

const Mn = [], On = [];

class Cn {
    constructor(e, t) {
        this.gltf = e, this.regl = t, this.geometries = [], t && (this._emptyTexture = t.texture({
            width: 2,
            height: 2
        }));
    }
    getMeshesInfo() {
        if (!this.gltf) return null;
        if (this.geometries.length) return this.geometries;
        this._createTextures(this.gltf.textures), this._createSkins(this.gltf.skins);
        return this.gltf.scenes[0].nodes.forEach((e => {
            this._parserNode(e, this.geometries);
        })), this._checkBaseColorFactor(), this.geometries;
    }
    getGLTFBBox() {
        if (!this.gltf) return null;
        const e = this.geometries;
        if (!e || !e.length) return null;
        const t = [ 1 / 0, 1 / 0, 1 / 0 ], n = [ -1 / 0, -1 / 0, -1 / 0 ];
        for (let r = 0; r < e.length; r++) {
            const i = e[r].bbox, o = i.min, a = i.max;
            o[0] < t[0] && (t[0] = o[0]), o[1] < t[1] && (t[1] = o[1]), o[2] < t[2] && (t[2] = o[2]), 
            a[0] > n[0] && (n[0] = a[0]), a[1] > n[1] && (n[1] = a[1]), a[2] > n[2] && (n[2] = a[2]);
        }
        return {
            min: t,
            max: n
        };
    }
    _createSkins(e) {
        if (e) {
            this._skinMap = {};
            for (let t = 0; t < e.length; t++) {
                const n = e[t];
                n.joints = n.joints.map((e => this.gltf.nodes[e])), this._skinMap[t] = new gn(this.regl, n.joints, n.inverseBindMatrices.array), 
                delete n.inverseBindMatrices;
            }
        }
    }
    _createTextures(e) {
        if (e) {
            this._textureMap = {};
            for (let t = 0; t < e.length; t++) {
                const n = e[t];
                this._textureMap[t] || (this._textureMap[t] = this._toTexture(n), delete n.image);
            }
        }
    }
    _checkBaseColorFactor() {
        if (!this._checkBaseColorFactorAlpha()) for (let e = 0; e < this.geometries.length; e++) {
            const t = this.geometries[e].materialInfo.baseColorFactor;
            t && 0 === t[3] && (t[3] = 1);
        }
    }
    _checkBaseColorFactorAlpha() {
        for (let e = 0; e < this.geometries.length; e++) {
            const t = this.geometries[e].materialInfo.baseColorFactor;
            if (t && t[3] > 0) return !0;
        }
        return !1;
    }
    dispose() {
        this._emptyTexture && this._emptyTexture.destroy();
        const e = this.getMeshesInfo();
        if (e) {
            e.forEach((e => {
                e.geometry.dispose();
                for (const t in e.materialInfo) {
                    const n = e.materialInfo[t];
                    n && n.destroy && !n[L] && n.destroy();
                }
            }));
            for (const e in this._textureMap) {
                const t = this._textureMap[e];
                t && t.destroy && !t[L] && t.destroy();
            }
            delete this.gltf;
        }
    }
    updateAnimation(e, t, n, r, i, o, a, s) {
        const c = this.gltf;
        if (!c) return;
        const l = f();
        if (Tn = c.animations ? l.GLTFLoader.getAnimationTimeSpan(c, r) : null, !Tn) return;
        e -= i;
        let d = 0;
        d = t || !t && this._isFirstLoop(e, n, r, i) ? e * n * .001 % (Tn.max - Tn.min) + Tn.min : e * n * .001 + Tn.min, 
        c.scenes[0].nodes.forEach((e => {
            this._updateNodeMatrix(r, d, e, null, o, s);
        }));
        for (const e in this.gltf.nodes) {
            const t = this.gltf.nodes[e], n = o[t.nodeIndex];
            if (t.skin && n) {
                const e = t.skin.update(n, o, a[t.nodeIndex] && a[t.nodeIndex].jointTexture);
                a[t.nodeIndex] || (a[t.nodeIndex] = {
                    jointTextureSize: t.skin.jointTextureSize,
                    numJoints: t.skin.joints.length
                }), a[t.nodeIndex].jointTexture = e;
            }
        }
    }
    _isFirstLoop(e, t, n, r) {
        const i = this.gltf;
        if (!r || !i) return !0;
        const o = f();
        return Tn = i.animations ? o.GLTFLoader.getAnimationTimeSpan(i, n) : null, e * t * .001 / (Tn.max - Tn.min) < 1;
    }
    hasSkinAnimation() {
        return !!this._isAnimation;
    }
    _updateNodeMatrix(t, n, r, i, o, a) {
        r.trs && (a ? a.indexOf(Number(r.nodeIndex)) > -1 && this._updateNodeTRS(r, n, t) : this._updateNodeTRS(r, n, t)), 
        o[r.nodeIndex] = i ? e.multiply(o[r.nodeIndex] || [], i, r.matrix || r.trs.getMatrix()) : e.copy(o[r.nodeIndex] || [], r.matrix || r.trs.getMatrix()), 
        r.children && r.children.forEach((e => {
            this._updateNodeMatrix(t, n, e, o[r.nodeIndex], o, a);
        }));
    }
    _updateNodeTRS(e, t, n) {
        const r = f().GLTFLoader.getAnimationClip(this.gltf, Number(e.nodeIndex), t, n);
        r.weights && this._updateMorph(e, r.weights), e.trs.update(r);
    }
    _updateMorph(e, t) {
        const n = t.length;
        if (!e.influencesList) {
            e.influencesList = [];
            for (let t = 0; t < n; t++) e.influencesList[t] = [ t, 0 ];
        }
        const r = e.influencesList;
        for (let e = 0; e < r.length; e++) {
            const n = r[e];
            n[0] = e, n[1] = t[e];
        }
        r.sort(Pn);
        const i = [];
        for (let e = 0; e < 8; e++) i[e] = [ e, 0 ];
        for (let e = 0; e < 8; e++) e < n && r[e][1] ? (i[e][0] = r[e][0], i[e][1] = r[e][1]) : (i[e][0] = Number.MAX_SAFE_INTEGER, 
        i[e][1] = 0);
        i.sort(En);
        e.geometries.forEach((e => {
            const t = e.properties.morphTargets;
            for (let n = 0; n < 8; n++) {
                const r = i[n], o = r[0], a = r[1];
                o !== Number.MAX_SAFE_INTEGER && a ? (e.updateData("POSITION" + n, t["POSITION_" + o].array), 
                e.properties.morphWeights[n] = a) : e.properties.morphWeights[n] = 0;
            }
        }));
    }
    _parserNode(t, n, r) {
        if (t.isParsed) return;
        t.nodeMatrix = t.nodeMatrix || e.identity([]), t.localMatrix = t.localMatrix || e.identity([]), 
        t.matrix ? (t.trs = new An, t.trs.decompose(t.matrix)) : t.trs = new An(t.translation, t.rotation, t.scale), 
        t.localMatrix = t.trs.getMatrix(), r ? e.multiply(t.nodeMatrix, r, t.matrix || t.localMatrix) : e.copy(t.nodeMatrix, t.matrix || t.localMatrix);
        const i = t.nodeMatrix;
        if (t.children) for (let e = 0; e < t.children.length; e++) {
            this._parserNode(t.children[e], n, i);
        }
        if (h(t.skin)) {
            this._isAnimation = !0;
            const e = t.skin;
            t.trs = new An, t.skin = this._skinMap[e];
        }
        if (h(t.mesh)) {
            t.mesh = this.gltf.meshes[t.mesh], t.mesh.node = t, t.geometries = t.geometries || [], 
            t.mesh.primitives.forEach((r => {
                const o = this._createMaterialInfo(r.material), a = function(e, t, n) {
                    const r = e.attributes, i = r.COLOR_0;
                    if (i && i.array instanceof Float32Array) {
                        const e = new Uint8Array(i.array.length);
                        for (let t = 0; t < e.length; t++) e[t] = Math.round(255 * i.array[t]);
                        i.array = e;
                    } else if (i && (i.array instanceof Uint16Array || i.array instanceof Int16Array || i.array instanceof Uint32Array || i.array instanceof Int32Array)) {
                        const e = new Uint8Array(i.array);
                        i.array = e;
                    }
                    n && r.TEXCOORD_0 && !r.TEXCOORD_0 && (r.TEXCOORD_1 = r.TEXCOORD_0);
                    const o = {};
                    for (const e in r) o[e] = v({}, r[e]), t && (o[e].buffer = he(t, r[e], {
                        dimension: r[e].itemSize
                    }));
                    if (e.morphTargets) {
                        const e = P(o.POSITION) ? o.POSITION.itemSize * o.POSITION.count : o.POSITION.array.length;
                        for (let t = 0; t < 8; t++) o[`POSITION${t}`] || (o[`POSITION${t}`] = new Float32Array(e).fill(0));
                        for (let e = 0; e < 4; e++) {
                            o[`NORMAL${e}`] || (o[`NORMAL${e}`] = new Float32Array(o.NORMAL.array ? o.NORMAL.array.length : o.NORMAL.length).fill(0));
                        }
                    }
                    let a = e.indices;
                    a && void 0 === a.bufferView && a.array && (a = a.array);
                    const s = new Z(o, a, 0, {
                        primitive: g(e.mode) ? ee(e.mode) : e.mode,
                        positionAttribute: "POSITION",
                        normalAttribute: "NORMAL",
                        uv0Attribute: "TEXCOORD_0",
                        uv1Attribute: "TEXCOORD_1",
                        color0Attribute: "COLOR_0"
                    });
                    e.morphTargets && (s.properties.morphWeights = []);
                    e.mode > 3 && !s.data.NORMAL && s.createNormal("NORMAL");
                    return s;
                }(r, this.regl, o.occlusionTexture);
                a.properties.morphTargets = r.morphTargets, t.geometries.push(a);
                let s = a.boundingBox.copy();
                s = s.transform(e.identity(Mn), i);
                const c = {
                    geometry: a,
                    bbox: s,
                    nodeMatrix: i,
                    materialInfo: o,
                    extraInfo: this._createExtralInfo(r.material),
                    animationMatrix: t.trs.getMatrix(),
                    morphWeights: t.weights,
                    nodeIndex: t.nodeIndex
                };
                t.skin && (c.skin = {
                    jointTextureSize: [ 4, 6 ],
                    numJoints: t.skin.joints.length,
                    jointTexture: t.skin.jointTexture
                });
                const l = new Sn(c);
                n.push(l);
            }));
        }
        t.isParsed = !0;
    }
    _createMaterialInfo(e) {
        const t = {};
        if (this.gltf.materials && this.gltf.materials[e]) {
            const n = this.gltf.materials[e], r = n.pbrMetallicRoughness;
            if (r) {
                const e = r.metallicRoughnessTexture, n = r.baseColorTexture;
                n && (t.baseColorTexture = this._getTexture(n), n.KHR_texture_transform && (t.khr_offset = n.KHR_texture_transform.offset || [ 0, 0 ], 
                t.khr_rotation = n.KHR_texture_transform.rotation || 0, t.khr_scale = n.KHR_texture_transform.scale || [ 1, 1 ])), 
                r.baseColorFactor && (t.baseColorFactor = r.baseColorFactor), e ? t.metallicRoughnessTexture = this._getTexture(e) : (t.metallicFactor = h(r.metallicFactor) ? r.metallicFactor : 1, 
                t.roughnessFactor = h(r.roughnessFactor) ? r.roughnessFactor : 1);
            }
            const i = n.extensions;
            if (i && i.KHR_materials_pbrSpecularGlossiness) {
                const e = i.KHR_materials_pbrSpecularGlossiness;
                t.name = "pbrSpecularGlossiness";
                for (const n in e) t[n] = h(e[n].index) ? this._getTexture(e[n]) : e[n];
            }
            n.normalTexture && (t.normalTexture = this._getTexture(n.normalTexture)), n.occlusionTexture && (t.occlusionTexture = this._getTexture(n.occlusionTexture)), 
            n.emissiveTexture && (t.emissiveTexture = this._getTexture(n.emissiveTexture)), 
            n.emissiveFactor && (t.emissiveFactor = n.emissiveFactor), t.alphaCutoff = n.alphaCutoff || .5, 
            t.doubleSided = n.doubleSided, t.alphaMode = n.alphaMode || "OPAQUE";
        }
        return t;
    }
    _createExtralInfo(e) {
        const t = {};
        if (this.gltf.materials && this.gltf.materials[e]) {
            const n = this.gltf.materials[e];
            t.doubleSided = n.doubleSided, t.alphaMode = n.alphaMode || "OPAQUE";
        }
        return t;
    }
    _getTexture(e) {
        const t = e.extensions, n = e.index;
        if (!h(n)) return null;
        t && t.KHR_texture_transform && (e.KHR_texture_transform = t.KHR_texture_transform);
        const r = this._textureMap[n];
        return r.texInfo = e, r;
    }
    _toTexture(e) {
        if (!e) return this._emptyTexture;
        const t = e.sampler || {};
        return new ct({
            width: e.image.width,
            height: e.image.height,
            data: e.image.array,
            mag: ae(t.magFilter) || "linear",
            min: ce(t.minFilter) || "linear mipmap linear",
            wrapS: fe(t.wrapS) || "repeat",
            wrapT: fe(t.wrapT) || "repeat"
        });
    }
    arrangeAlongLine(e, t, n, r, i, o) {
        const a = [], s = this._getRotationZ(e, t), c = (e.z || 0) - (t.z || 0), l = this._getRotationXY(n, c);
        let f = this._calBoxWidth(r, o);
        f /= i;
        const d = Math.sqrt(n * n + c * c), u = Math.floor(d / f);
        let h = o.direction || 0;
        if (1 === h ? h = 2 : 2 === h && (h = 1), u >= 1) {
            for (let n = 1; n <= u; n++) {
                const r = f * (n - .5) / d, i = {
                    coordinates: wn(e, t, r),
                    t: r,
                    scale: [ 1, 1, 1 ],
                    rotation: [ 0, 0, s ],
                    rotationZ: s,
                    rotationXY: l
                };
                a.push(i);
            }
            if (o.scaleVertex) {
                const n = (f * u + (d - f * u) / 2) / d, r = [ 1, 1, 1 ];
                r[h] = (d - f * u) / f;
                const i = {
                    coordinates: wn(e, t, n),
                    t: n,
                    scale: r,
                    rotation: [ 0, 0, s ],
                    rotationZ: s,
                    rotationXY: l
                };
                a.push(i);
            }
        } else if (o.scaleVertex) {
            const n = [ 1, 1, 1 ];
            n[h] = d / f;
            const r = {
                coordinates: wn(e, t, .5),
                t: .5,
                scale: n,
                rotation: [ 0, 0, s ],
                rotationZ: s,
                rotationXY: l
            };
            a.push(r);
        }
        return a;
    }
    calModelHeightScale(e, n) {
        const r = this.getGLTFBBox(), i = n / Math.abs(r.max[1] - r.min[1]);
        return t.set(e, i, i, i);
    }
    _calBoxWidth(e, n) {
        const r = this.getGLTFBBox(), i = n.direction || 0, o = t.sub(On, r.max, r.min);
        t.multiply(o, o, e);
        return o[i] + n.gapLength;
    }
    _getRotationZ(e, t) {
        return Math.atan2(e.y - t.y, e.x - t.x) / Math.PI * 180;
    }
    _getRotationXY(e, t) {
        return 180 * Math.atan(t / e) / Math.PI;
    }
}

function En(e, t) {
    return e[0] - t[0];
}

function Pn(e, t) {
    return Math.abs(t[1]) - Math.abs(e[1]);
}

function wn(e, t, n) {
    const r = In(e.x, t.x, n), i = In(e.y, t.y, n), o = In(e.z || 0, t.z || 0, n);
    return new e.constructor(r, i, o);
}

function In(e, t, n) {
    return e + n * (t - e);
}

function Rn(e, t) {
    const {Ajax: n} = f(), {fetchOptions: r, gltfLoaderOptions: i, urlModifier: o} = t, a = i || {};
    a.urlModifier = o;
    const s = e.lastIndexOf("/"), c = e.slice(0, s), l = e.slice(e.lastIndexOf(".")).toLowerCase();
    return ".gltf" === l ? n.getJSON(e, r, o).then((e => Hn(c, e, a))) : ".glb" === l ? n.getArrayBuffer(e, r, o).then((e => Hn(c, {
        buffer: e.data,
        byteOffset: 0
    }, a))) : null;
}

function Dn(e, t) {
    return new Cn(e, t);
}

function Hn(e, t, n) {
    const {GLTFLoader: r} = f();
    return new r(e, t, n).load();
}

var Fn = Object.freeze({
    __proto__: null,
    exportGLTFPack: Dn,
    load: Rn,
    loadGLTF: Hn
});

const Nn = [ -1, 0, -1, 1, 0, -1, -1, 0, 1, 1, 0, 1 ], Ln = [ 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0 ], kn = [ 3, 1, 0, 0, 2, 3 ], Bn = [ 0, 0, 1, 0, 0, 1, 1, 1 ], zn = {
    vertices: [ -.8111000061035156, 2.0102999210357666, -.8111000061035156, 0, .010300000198185444, -0, -.8111000061035156, 2.0102999210357666, .8111000061035156, -.8111000061035156, 2.0102999210357666, .8111000061035156, 0, .010300000198185444, -0, .8111000061035156, 2.0102999210357666, .8111000061035156, .8111000061035156, 2.0102999210357666, .8111000061035156, 0, .010300000198185444, -0, .8111000061035156, 2.0102999210357666, -.8111000061035156, .8111000061035156, 2.0102999210357666, -.8111000061035156, 0, .010300000198185444, -0, -.8111000061035156, 2.0102999210357666, -.8111000061035156, .8111000061035156, 2.0102999210357666, -.8111000061035156, -.8111000061035156, 2.0102999210357666, -.8111000061035156, 0, 2.9419000148773193, -0, .8111000061035156, 2.0102999210357666, .8111000061035156, .8111000061035156, 2.0102999210357666, -.8111000061035156, 0, 2.9419000148773193, -0, -.8111000061035156, 2.0102999210357666, -.8111000061035156, -.8111000061035156, 2.0102999210357666, .8111000061035156, 0, 2.9419000148773193, -0, -.8111000061035156, 2.0102999210357666, .8111000061035156, .8111000061035156, 2.0102999210357666, .8111000061035156, 0, 2.9419000148773193, -0 ],
    normals: [ -.9267006516456604, -.3758002817630768, -0, -.9267006516456604, -.3758002817630768, -0, -.9267006516456604, -.3758002817630768, -0, 0, -.3758002817630768, .9267006516456604, 0, -.3758002817630768, .9267006516456604, 0, -.3758002817630768, .9267006516456604, .9267006516456604, -.3758002817630768, -0, .9267006516456604, -.3758002817630768, -0, .9267006516456604, -.3758002817630768, -0, 0, -.3758002817630768, -.9267006516456604, 0, -.3758002817630768, -.9267006516456604, 0, -.3758002817630768, -.9267006516456604, 0, .656676173210144, -.7541726231575012, 0, .656676173210144, -.7541726231575012, 0, .656676173210144, -.7541726231575012, .7541726231575012, .656676173210144, -0, .7541726231575012, .656676173210144, -0, .7541726231575012, .656676173210144, -0, -.7541726231575012, .656676173210144, -0, -.7541726231575012, .656676173210144, -0, -.7541726231575012, .656676173210144, -0, 0, .656676173210144, .7541726231575012, 0, .656676173210144, .7541726231575012, 0, .656676173210144, .7541726231575012 ],
    indices: [ 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23 ]
}, Gn = [ "cube", "plane", "pyramid" ], Vn = {
    cube: {
        meshes: [ {
            primitives: [ {
                attributes: {
                    POSITION: {
                        array: new Int8Array([ 1, 1, 1, -1, 1, 1, -1, -1, 1, 1, -1, 1, 1, 1, 1, 1, -1, 1, 1, -1, -1, 1, 1, -1, 1, 1, 1, 1, 1, -1, -1, 1, -1, -1, 1, 1, -1, 1, 1, -1, 1, -1, -1, -1, -1, -1, -1, 1, -1, -1, -1, 1, -1, -1, 1, -1, 1, -1, -1, 1, 1, -1, -1, -1, -1, -1, -1, 1, -1, 1, 1, -1 ])
                    },
                    NORMAL: {
                        array: new Int8Array([ 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1 ])
                    },
                    TEXCOORD_0: {
                        array: new Int8Array([ 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1, 0, 0, 1, 1, 1 ])
                    }
                },
                indices: new Uint16Array([ 0, 1, 2, 0, 2, 3, 4, 5, 6, 4, 6, 7, 8, 9, 10, 8, 10, 11, 12, 13, 14, 12, 14, 15, 16, 17, 18, 16, 18, 19, 20, 21, 22, 20, 22, 23 ]),
                mode: 4
            } ]
        } ],
        scenes: [ {
            nodes: [ {
                mesh: 0,
                scale: [ 60, 60, 60 ]
            } ]
        } ]
    },
    "plane-cube": {
        meshes: [ {
            primitives: [ {
                attributes: {
                    POSITION: {
                        array: new Int8Array(Nn)
                    },
                    TEXCOORD_0: {
                        array: new Int8Array(Bn)
                    }
                },
                indices: new Uint16Array(kn),
                mode: 4
            } ]
        } ],
        scenes: [ {
            nodes: [ {
                mesh: 0,
                scale: [ 60, 60, 60 ],
                translation: [ 0, -60, 0 ]
            }, {
                mesh: 0,
                scale: [ 60, 60, 60 ],
                translation: [ 0, 60, 0 ]
            }, {
                mesh: 0,
                scale: [ 60, 60, 60 ],
                translation: [ 60, 0, 0 ],
                rotation: [ 0, 0, .7071067811865475, .7071067811865476 ]
            }, {
                mesh: 0,
                scale: [ 60, 60, 60 ],
                translation: [ -60, 0, 0 ],
                rotation: [ 0, 0, .7071067811865475, .7071067811865476 ]
            }, {
                mesh: 0,
                scale: [ 60, 60, 60 ],
                translation: [ 0, 0, 60 ],
                rotation: [ .7071067811865475, 0, 0, .7071067811865476 ]
            }, {
                mesh: 0,
                scale: [ 60, 60, 60 ],
                translation: [ 0, 0, -60 ],
                rotation: [ .7071067811865475, 0, 0, .7071067811865476 ]
            } ]
        } ]
    },
    plane: {
        meshes: [ {
            primitives: [ {
                attributes: {
                    POSITION: {
                        array: new Int8Array(Nn)
                    },
                    NORMAL: {
                        array: new Int8Array(Ln)
                    },
                    TEXCOORD_0: {
                        array: new Int8Array(Bn)
                    }
                },
                indices: new Uint16Array(kn),
                mode: 4
            } ]
        } ],
        scenes: [ {
            nodes: [ {
                mesh: 0,
                scale: [ 60, 60, 60 ]
            } ]
        } ]
    },
    pyramid: {
        meshes: [ {
            primitives: [ {
                attributes: {
                    POSITION: {
                        array: new Float32Array(zn.vertices)
                    },
                    NORMAL: {
                        array: new Float32Array(zn.normals)
                    },
                    TEXCOORD_0: {
                        array: new Float32Array(zn.uv)
                    }
                },
                indices: new Uint16Array(zn.indices),
                mode: 4
            } ]
        } ],
        scenes: [ {
            nodes: [ {
                mesh: 0,
                scale: [ 60, 60, 60 ]
            } ]
        } ]
    }
};

class Un {
    constructor(e, t) {
        this.regl = e, this.resourceMap = {}, this.options = t || {};
    }
    getGLTF(e) {
        return this.resourceMap[e];
    }
    loginGLTF(e, t) {
        if (this.resourceMap[e]) this.resourceMap[e].refCount += 1; else {
            if (Vn[e]) {
                const t = function(e) {
                    let t = null;
                    return Vn[e] && (t = {
                        meshes: Vn[e].meshes
                    }, t.scenes = JSON.parse(JSON.stringify(Vn[e].scenes))), t;
                }(e);
                this.resourceMap[e] = this._exportGLTFResource(t, e, !1);
            } else this.resourceMap[e] = t ? t(e).then((t => (this.resourceMap[e] = this._exportGLTFResource(t, e), 
            this.resourceMap[e]))) : this._loadGLTFModel(e);
            this.resourceMap[e].refCount = 1;
        }
    }
    logoutGLTF(e) {
        if (this.resourceMap[e] && (this.resourceMap[e].refCount -= 1, this.resourceMap[e].refCount < 1)) {
            const t = this.resourceMap[e].resources;
            if (t) for (let e = 0; e < t.length; e++) t[e].geometry.dispose(), t[e].copyGeometry && t[e].copyGeometry.dispose(), 
            t[e].material && t[e].material.dispose();
            this.resourceMap[e].gltfPack && this.resourceMap[e].gltfPack.dispose(), delete this.resourceMap[e];
        }
    }
    isSimpleModel(e) {
        return Vn[e];
    }
    addSimpleModel(e, t) {
        !function(e, t) {
            "string" == typeof e && Gn.indexOf(e) < 0 && (Vn[e] = t);
        }(e, t);
    }
    removeSimpleModel(e) {
        delete Vn[e];
    }
    _exportGLTFResource(e, t, n = !0) {
        if (!e) return null;
        const r = Dn(e, n ? this.regl : null), i = r.getMeshesInfo();
        return {
            bbox: r.getGLTFBBox(),
            gltfPack: r,
            resources: i,
            json: e.json,
            refCount: this.resourceMap[t] ? this.resourceMap[t].refCount : 0
        };
    }
    fetchGLTF(e) {
        return Rn(e, this.options).then((e => e));
    }
    _loadGLTFModel(e) {
        return this.fetchGLTF(e).then((t => (this.resourceMap[e] = this._exportGLTFResource(t, e), 
        this.resourceMap[e])));
    }
}

const jn = function() {
    const t = [ 0, 0, 0 ], n = 90 * Math.PI / 180, r = [ 0, 0, 0, 0 ], i = new Array(16);
    return function(o, a, s, c, l, f) {
        const d = [ e.lookAt([], t, [ 1, 0, 0 ], f && f[0] || [ 0, -1, 0 ]), e.lookAt([], t, [ -1, 0, 0 ], f && f[1] || [ 0, -1, 0 ]), e.lookAt([], t, [ 0, 1, 0 ], f && f[2] || [ 0, 0, 1 ]), e.lookAt([], t, [ 0, -1, 0 ], f && f[3] || [ 0, 0, -1 ]), e.lookAt([], t, [ 0, 0, 1 ], f && f[4] || [ 0, -1, 0 ]), e.lookAt([], t, [ 0, 0, -1 ], f && f[5] || [ 0, -1, 0 ]) ], u = {
            context: {
                viewMatrix: function(e, t, n) {
                    return d[n];
                },
                projMatrix: e.perspective(i, n, 1, .5, 1.1)
            }
        };
        a && (u.framebuffer = a.faces ? function(e, t, n) {
            return a.faces[n];
        } : a);
        return o(u)(6, ((e, t, n) => {
            const i = {
                color: r,
                depth: 1
            };
            a && (i.framebuffer = a.faces ? a.faces[n] : a), o.clear(i), s(c), l && l();
        })), a;
    };
}();

var Xn = {
    vertices: [ 1, 1, 1, -1, 1, 1, -1, -1, 1, 1, -1, 1, 1, 1, 1, 1, -1, 1, 1, -1, -1, 1, 1, -1, 1, 1, 1, 1, 1, -1, -1, 1, -1, -1, 1, 1, -1, 1, 1, -1, 1, -1, -1, -1, -1, -1, -1, 1, -1, -1, -1, 1, -1, -1, 1, -1, 1, -1, -1, 1, 1, -1, -1, -1, -1, -1, -1, 1, -1, 1, 1, -1 ],
    textures: [ 1, 1, 0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 0, 0, 1, 0 ],
    indices: [ 0, 1, 2, 0, 2, 3, 4, 5, 6, 4, 6, 7, 8, 9, 10, 8, 10, 11, 12, 13, 14, 12, 14, 15, 16, 17, 18, 16, 18, 19, 20, 21, 22, 20, 22, 23 ]
}, Wn = "#define SHADER_NAME CUBE_MAP\nattribute vec3 aPosition;\nvarying vec3 vWorldPos;\nuniform mat4 projMatrix;\nuniform mat4 viewMatrix;\nvoid main() {\n  vWorldPos = aPosition;\n  gl_Position = projMatrix * viewMatrix * vec4(vWorldPos, 1.);\n}", qn = "#define SHADER_NAME CUBEMAP\nprecision highp float;\nuniform samplerCube cubeMap;\nuniform float exposure;\nvarying vec3 vWorldPos;\n#ifdef ENCODE_RGBM\nvec4 c(const in vec3 d, const in float e) {\n  if(e <= .0)\n    return vec4(d, 1.);\n  vec4 f;\n  vec3 h = d / e;\n  f.a = clamp(max(max(h.r, h.g), max(h.b, 1e-6)), .0, 1.);\n  f.a = ceil(f.a * 255.) / 255.;\n  f.rgb = h / f.a;\n  return f;\n}\n#endif\nvoid main() {\n  vec4 i = textureCube(cubeMap, vWorldPos);\n  i.rgb *= exposure;\n#ifdef ENCODE_RGBM\ni = c(i.rgb, 7.);\n#endif\n#if __VERSION__ == 100\ngl_FragColor = i;\n#endif\n}", Kn = "precision highp float;\n#define PI 3.1415926\nvarying vec3 vWorldPos;\nuniform sampler2D equirectangularMap;\nconst vec2 c = vec2(.1591, .3183);\nvec2 d(vec3 e) {\n  vec2 f = vec2(atan(e.y, e.x), asin(e.z));\n  f *= c;\n  f += .5;\n  return f;\n}\nvoid main() {\n  vec2 f = d(normalize(vWorldPos));\n  vec4 h = texture2D(equirectangularMap, f);\n  gl_FragColor = vec4(h.rgb, 1.);\n}", Jn = "#define SHADER_NAME PBR_prefilter\nprecision highp float;\nvarying vec3 vWorldPos;\nuniform samplerCube environmentMap;\nuniform sampler2D distributionMap;\nuniform float roughness;\nuniform float resolution;\nconst float c = 3.14159265359;\nfloat d(vec3 e, vec3 f, float h) {\n  float a = h * h;\n  float i = a * a;\n  float j = max(dot(e, f), .0);\n  float k = j * j;\n  float l = i;\n  float m = (k * (i - 1.) + 1.);\n  m = c * m * m;\n  return l / m;\n}\nvec3 n(float o, vec3 e, float h) {\n  vec4 u = texture2D(distributionMap, vec2(h, o));\n  vec3 f = u.xyz;\n  float v = sign(u.w - .5);\n  float A = sign(u.w - 200.0 / 255. * clamp(v, .0, 1.) - .15);\n  f.x *= v;\n  f.y *= A;\n  vec3 B = abs(e.z) < .999 ? vec3(.0, .0, 1.) : vec3(1., .0, .0);\n  vec3 C = normalize(cross(B, e));\n  vec3 D = cross(e, C);\n  vec3 E = C * f.x + D * f.y + e * f.z;\n  return normalize(E);\n}\nvoid main() {\n  vec3 e = normalize(vWorldPos);\n  vec3 F = e;\n  vec3 G = F;\n  const int I = 1024;\n  vec3 J = vec3(.0);\n  float K = .0;\n  for(int L = 0; L < I; ++L) {\n    vec3 f = n(float(L) / float(I), e, roughness);\n    vec3 M = normalize(2. * dot(G, f) * f - G);\n    float O = max(dot(e, M), .0);\n    if(O > .0) {\n      J += textureCube(environmentMap, M).rgb * O;\n      K += O;\n    }\n  }\n  J = J / K;\n  gl_FragColor = vec4(J, 1.);\n}", Yn = "precision highp float;\nvarying vec2 vTexCoords;\nuniform sampler2D distributionMap;\nconst float c = 3.14159265359;\nvec4 d(float a, float b) {\n  a *= 65535.;\n  b *= 65535.;\n  vec4 rgba;\n  rgba[0] = mod(a, 255.);\n  rgba[1] = (a - rgba[0]) / 65280.0;\n  rgba[2] = mod(b, 255.);\n  rgba[3] = (b - rgba[2]) / 65280.0;\n  return rgba;\n}\nvec3 e(float f, vec3 h, float i) {\n  vec4 j = texture2D(distributionMap, vec2(i, f));\n  vec3 k = j.xyz;\n  float l = sign(j.w - .5);\n  float m = sign(j.w - clamp(l, .0, 1.) * 200.0 / 255. - .15);\n  k.x *= l;\n  k.y *= m;\n  vec3 n = abs(h.z) < .999 ? vec3(.0, .0, 1.) : vec3(1., .0, .0);\n  vec3 o = normalize(cross(n, h));\n  vec3 u = cross(h, o);\n  vec3 v = o * k.x + u * k.y + h * k.z;\n  return normalize(v);\n}\nfloat A(float B, float i) {\n  float a = i;\n  float C = (a * a) / 2.;\n  float D = B;\n  float E = B * (1. - C) + C;\n  return D / E;\n}\nfloat F(float B, float G, float i) {\n  float I = A(B, i);\n  float J = A(G, i);\n  return J * I;\n}\nvec2 K(float B, float i) {\n  vec3 L;\n  L.x = sqrt(1. - B * B);\n  L.y = .0;\n  L.z = B;\n  float M = .0;\n  float O = .0;\n  vec3 h = vec3(.0, .0, 1.);\n  const int P = 1024;\n  for(int Q = 0; Q < P; ++Q) {\n    vec3 k = e(float(Q) / float(P), h, i);\n    vec3 R = normalize(2. * dot(L, k) * k - L);\n    float G = max(R.z, .0);\n    float S = max(k.z, .0);\n    float T = max(dot(L, k), .0);\n    float B = max(dot(h, L), .0);\n    if(G > .0) {\n      float U = F(B, G, i);\n      float W = (U * T) / (S * B);\n      float X = pow(1. - T, 5.);\n      M += (1. - X) * W;\n      O += X * W;\n    }\n  }\n  M /= float(P);\n  O /= float(P);\n  return vec2(M, O);\n}\nvoid main() {\n  vec2 Y = K(vTexCoords.x, vTexCoords.y);\n  gl_FragColor = d(Y.x, Y.y);\n}", Zn = "attribute vec3 aPosition;\nattribute vec2 aTexCoord;\nvarying vec2 vTexCoords;\nvoid main() {\n  vTexCoords = aTexCoord;\n  gl_Position = vec4(aPosition, 1.);\n}";

/*!
 * from claygl
 * https://github.com/pissang/claygl/
 * License: BSD-2-Clause
 */
function $n(e, t) {
    const n = e[0], r = e[1], i = e[2];
    return 0 === t ? 1 : 1 === t ? n : 2 === t ? r : 3 === t ? i : 4 === t ? n * i : 5 === t ? r * i : 6 === t ? n * r : 7 === t ? 3 * i * i - 1 : n * n - r * r;
}

const Qn = {
    px: [ 2, 1, 0, -1, -1, 1 ],
    nx: [ 2, 1, 0, 1, -1, -1 ],
    py: [ 0, 2, 1, 1, -1, -1 ],
    ny: [ 0, 2, 1, 1, 1, 1 ],
    pz: [ 0, 1, 2, -1, -1, -1 ],
    nz: [ 0, 1, 2, 1, -1, 1 ]
}, er = [ "px", "nx", "py", "ny", "pz", "nz" ];

const tr = dt.compile(Vt);

function nr(e, t, n, r, i = 1, o = !1) {
    const a = e({
        frag: (o ? "#define ENCODE_RGBM\n" : "") + qn,
        vert: Wn,
        attributes: {
            aPosition: Xn.vertices
        },
        uniforms: {
            projMatrix: e.context("projMatrix"),
            viewMatrix: e.context("viewMatrix"),
            cubeMap: t,
            exposure: i
        },
        elements: Xn.indices
    }), s = [], c = e.texture({
        radius: n,
        min: "linear",
        mag: "linear",
        type: r ? "float" : "uint8",
        format: "rgba"
    }), l = e.framebuffer({
        radius: n,
        color: c
    });
    return jn(e, l, a, {
        size: n
    }, (function() {
        const t = e.read();
        if (r) {
            const e = new Uint16Array(t.length);
            for (let n = 0; n < t.length; n++) e[n] = Math.min(st.toHalfFloat(t[n]), 65504);
            s.push(e);
        } else s.push(t);
    })), a.destroy(), l.destroy(), s;
}

const rr = new Int8Array([ -1, 1, 0, -1, -1, 0, 1, 1, 0, 1, -1, 0 ]), ir = new Int8Array([ 0, 1, 0, 0, 1, 1, 1, 0 ]);

function or(e, t, n, r) {
    t = t || 256;
    const i = ar(n = n || 1024, r = r || 256), o = e.texture({
        data: i,
        width: r,
        height: n,
        min: "nearest",
        mag: "nearest"
    }), a = e.buffer(rr), s = e.buffer(ir), c = e.framebuffer({
        radius: t,
        colorType: "uint8",
        colorFormat: "rgba",
        min: "linear",
        mag: "linear"
    }), l = e({
        frag: Yn,
        vert: Zn,
        attributes: {
            aPosition: {
                buffer: a
            },
            aTexCoord: {
                buffer: s
            }
        },
        uniforms: {
            distributionMap: o
        },
        framebuffer: c,
        viewport: {
            x: 0,
            y: 0,
            width: t,
            height: t
        },
        count: rr.length / 3,
        primitive: "triangle strip"
    });
    return l(), l.destroy(), a.destroy(), s.destroy(), o.destroy(), c;
}

function ar(e, t) {
    const n = new Float32Array(e * t * 4);
    for (let r = 0; r < e; r++) {
        const {x: i, y: o} = sr(r, e);
        for (let e = 0; e < t; e++) {
            const a = e / t, s = a * a, c = 2 * Math.PI * i, l = Math.sqrt((1 - o) / (1 + (s * s - 1) * o)), f = Math.sqrt(1 - l * l), d = 4 * (r * t + e), u = f * Math.cos(c), h = f * Math.sin(c);
            n[d] = Math.abs(255 * u), n[d + 1] = Math.abs(255 * h), n[d + 2] = 255 * l, n[d + 3] = (u > 0 ? 200 : 0) + (h > 0 ? 55 : 0);
        }
    }
    return n;
}

function sr(e, t) {
    let n = (e << 16 | e >>> 16) >>> 0;
    return n = ((1431655765 & n) << 1 | (2863311530 & n) >>> 1) >>> 0, n = ((858993459 & n) << 2 | (3435973836 & n) >>> 2) >>> 0, 
    n = ((252645135 & n) << 4 | (4042322160 & n) >>> 4) >>> 0, n = (((16711935 & n) << 8 | (4278255360 & n) >>> 8) >>> 0) / 4294967296, 
    {
        x: e / t,
        y: n
    };
}

function cr(e) {
    return e._gl instanceof WebGL2RenderingContext || e.hasExtension("OES_texture_half_float");
}

var lr = Object.freeze({
    __proto__: null,
    createIBLMaps: function(e, n = {}) {
        const r = n.envTexture, i = n.envCubeSize || 512, o = n.sampleSize || 1024, a = n.roughnessLevels || 256, s = n.prefilterCubeSize || 256;
        let c, l = !1;
        if (Array.isArray(r)) {
            const t = e.cube({
                flipY: !0,
                faces: r
            });
            c = function(e, t, n) {
                const r = e({
                    frag: tr,
                    vert: Wn,
                    attributes: {
                        aPosition: Xn.vertices
                    },
                    uniforms: {
                        hsv: [ 0, 0, 0 ],
                        projMatrix: e.context("projMatrix"),
                        viewMatrix: e.context("viewMatrix"),
                        cubeMap: t,
                        bias: 0,
                        size: t.width,
                        environmentExposure: 1,
                        backgroundIntensity: 1
                    },
                    elements: Xn.indices
                }), i = e.cube({
                    width: n,
                    height: n,
                    min: "linear",
                    mag: "linear",
                    format: "rgba"
                }), o = e.framebufferCube({
                    radius: n,
                    color: i
                });
                return jn(e, o, r, {
                    size: n
                }, null, [ [ 0, 0, -1 ], [ 0, 0, -1 ], [ 0, 0, 1 ], [ 0, 0, 1 ], [ 0, -1, 0 ], [ 0, -1, 0 ] ]), 
                r.destroy(), o;
            }(e, t, i), t.destroy();
        } else c = function(e, t, n) {
            if (!cr(e)) throw new Error("HDR is not supported for lack of support for float 16 texture");
            n = n || 512;
            const r = e({
                frag: Kn,
                vert: Wn,
                attributes: {
                    aPosition: Xn.vertices
                },
                uniforms: {
                    projMatrix: e.context("projMatrix"),
                    viewMatrix: e.context("viewMatrix"),
                    equirectangularMap: t
                },
                elements: Xn.indices
            }), i = e.cube({
                width: n,
                height: n,
                min: "linear mipmap linear",
                mag: "linear",
                type: "float16",
                format: "rgba"
            }), o = e.framebufferCube({
                radius: n,
                color: i
            });
            return jn(e, o, r), r.destroy(), o;
        }(e, r, i), l = !0;
        const {prefilterMap: f, prefilterMipmap: d} = function(e, t, n, r, i, o) {
            const a = function(e, t, n, r, i, o) {
                r = r || 1024, i = i || 256;
                const a = ar(r, i), s = e.texture({
                    data: a,
                    width: i,
                    height: r,
                    min: "nearest",
                    mag: "nearest"
                }), c = e({
                    frag: Jn,
                    vert: Wn,
                    attributes: {
                        aPosition: Xn.vertices
                    },
                    uniforms: {
                        projMatrix: e.context("projMatrix"),
                        viewMatrix: e.context("viewMatrix"),
                        environmentMap: t,
                        distributionMap: s,
                        roughness: e.prop("roughness"),
                        resolution: n
                    },
                    elements: Xn.indices,
                    viewport: {
                        x: 0,
                        y: 0,
                        width: e.prop("size"),
                        height: e.prop("size")
                    }
                });
                let l = n;
                const f = e.texture({
                    radius: n,
                    min: "linear",
                    mag: "linear",
                    type: o ? "float" : "uint8"
                }), d = e.framebuffer({
                    radius: n,
                    color: f
                }), u = Math.log(l) / Math.log(2), h = [];
                for (let t = 0; t <= u; t++) {
                    let n = 0;
                    jn(e, d, c, {
                        roughness: t / (u - 1),
                        size: l
                    }, (function() {
                        const t = e.read({
                            framebuffer: d
                        });
                        let r = t;
                        if (o) {
                            r = new Uint16Array(t.length);
                            for (let e = 0; e < t.length; e++) r[e] = Math.min(st.toHalfFloat(t[e]), 65504);
                        }
                        h[n] || (h[n] = {
                            mipmap: []
                        }), h[n].mipmap.push(r), n++;
                    })), l /= 2, d.resize(l);
                }
                return s.destroy(), d.destroy(), c.destroy(), h;
            }(e, t, n, r, i, o), s = e.cube({
                radius: n,
                min: "linear",
                mag: "linear",
                type: o ? "float16" : "uint8",
                faces: a,
                format: "rgba"
            });
            return {
                prefilterMap: s,
                prefilterMipmap: a
            };
        }(e, c, s, o, a, l);
        let u;
        if (!n.ignoreSH) {
            const r = s;
            u = function(e, n, r) {
                const i = new Array(9), o = [], a = [], s = [];
                for (let c = 0; c < 9; c++) {
                    const l = [ 0, 0, 0 ];
                    for (let i = 0; i < er.length; i++) {
                        const f = e[i], d = [ 0, 0, 0 ];
                        let u = 0, h = 0;
                        const m = Qn[er[i]];
                        for (let e = 0; e < r; e++) for (let i = 0; i < n; i++) {
                            o[0] = i / (n - 1) * 2 - 1, o[1] = e / (r - 1) * 2 - 1, o[2] = -1, t.normalize(o, o), 
                            s[0] = o[m[0]] * m[3], s[1] = o[m[1]] * m[4], s[2] = o[m[2]] * m[5], a[0] = f[h++] / 255, 
                            a[1] = f[h++] / 255, a[2] = f[h++] / 255;
                            const l = f[h++] / 255 * 7;
                            a[0] *= l, a[1] *= l, a[2] *= l, t.scaleAndAdd(d, d, a, $n(s, c) * -o[2]), u += -o[2];
                        }
                        t.scaleAndAdd(l, l, d, 1 / u);
                    }
                    i[c] = t.scale(l, l, 1 / 6);
                }
                return i;
            }(nr(e, f, r, !1, n.environmentExposure, !0), r, r);
            const i = [];
            for (let e = 0; e < u.length; e++) i.push(...u[e]);
            u = i;
        }
        const h = {
            envMap: c,
            isHDR: l,
            prefilterMap: f
        };
        return u && (h.sh = u), "array" === n.format && (h.envMap = {
            width: c.width,
            height: c.height,
            faces: nr(e, c, i, l)
        }, h.prefilterMap = {
            width: f.width,
            height: f.height,
            faces: d
        }, c.destroy(), f.destroy()), h;
    },
    generateDFGLUT: or,
    supportFloat16: cr
});

const fr = {
    uvScale: [ 1, 1 ],
    uvOffset: [ 0, 0 ],
    uvRotation: 0,
    textureOrigin: null,
    textureWidth: null,
    baseColorFactor: [ 1, 1, 1, 1 ],
    emissiveFactor: [ 0, 0, 0 ],
    baseColorIntensity: 1,
    emitColorFactor: 1,
    occlusionFactor: 1,
    roughnessFactor: .4,
    metallicFactor: 0,
    normalMapFactor: 1,
    specularF0: .5,
    emitMultiplicative: 1,
    normalMapFlipY: 0,
    outputSRGB: 1,
    baseColorTexture: null,
    normalTexture: null,
    occlusionTexture: null,
    metallicRoughnessTexture: null,
    emissiveTexture: null,
    uvOrigin: [ 0, 0 ],
    noiseTexture: null,
    specularAAVariance: 20,
    specularAAThreshold: 20,
    hsv: [ 0, 0, 0 ],
    contrast: 1,
    bumpTexture: null,
    bumpScale: .05,
    bumpMinLayers: 5,
    bumpMaxLayers: 20,
    alphaTest: 0
};

class dr extends Ce {
    constructor(e) {
        const t = v({}, fr);
        (e.metallicRoughnessTexture || e.metallicRoughnessTexture) && (t.roughnessFactor = 1, 
        t.metallicFactor = 1), super(e, t);
    }
    appendDefines(e, t) {
        super.appendDefines(e, t);
        const n = this.uniforms;
        n.GAMMA_CORRECT_INPUT && (e.GAMMA_CORRECT_INPUT = 1), t.data[t.desc.colorAttribute] && (e.HAS_COLOR = 1);
        if (t.data[t.desc.color0Attribute] && (e.HAS_COLOR0 = 1, e.COLOR0_SIZE = t.getColor0Size()), 
        t.data[t.desc.tangentAttribute] ? e.HAS_TANGENT = 1 : t.data[t.desc.normalAttribute] && (e.HAS_NORMAL = 1), 
        t.data.aVertexColorType && (e.HAS_VERTEX_COLOR = 1), !t.data[t.desc.uv0Attribute]) return e;
        n.baseColorTexture && (e.HAS_ALBEDO_MAP = 1), n.metallicRoughnessTexture && (e.HAS_METALLICROUGHNESS_MAP = 1), 
        n.occlusionTexture && t.data[t.desc.uv1Attribute] && (e.HAS_AO_MAP = 1), n.emissiveTexture && (e.HAS_EMISSIVE_MAP = 1), 
        n.normalTexture && (e.HAS_NORMAL_MAP = 1), n.bumpTexture && (e.HAS_BUMP_MAP = 1), 
        n.skinTexture && (e.HAS_SKIN_MAP = 1), (e.HAS_ALBEDO_MAP || e.HAS_METALLICROUGHNESS_MAP || e.HAS_AO_MAP || e.HAS_EMISSIVE_MAP || e.HAS_NORMAL_MAP || e.HAS_BUMP_MAP || e.HAS_SKIN_MAP) && (e.HAS_MAP = 1), 
        n.noiseTexture && (e.HAS_RANDOM_TEX = 1), t.data[t.desc.tangentAttribute] ? e.HAS_TANGENT = 1 : t.data[t.desc.normalAttribute] && (e.HAS_NORMAL = 1);
        const r = n.alphaMode && n.alphaMode.toUpperCase();
        return "MASK" === r ? e.ALPHA_MODE = 1 : "OPAQUE" === r && (e.ALPHA_MODE = 2), e;
    }
}

class ur extends(Fe(dr)){}

function hr(e, t, n) {
    if (n.ambientUpdate) {
        const {iblTexes: r} = e, i = n.target;
        r ? (_r(r), e.iblTexes = vr(t, i)) : e.iblTexes = vr(t, i), i.getRenderer().setToRedraw();
    }
}

const mr = [ 0, 0 ];

function vr(e, t) {
    const n = t.getLightManager(), r = n && n.getAmbientResource();
    if (!r) return null;
    const i = r.isHDR;
    return {
        prefilterMap: e.cube({
            width: r.prefilterMap.width,
            height: r.prefilterMap.height,
            faces: r.prefilterMap.faces,
            min: "linear",
            mag: "linear",
            format: "rgba",
            type: i ? "float16" : "uint8"
        }),
        envMap: e.cube({
            width: r.envMap.width,
            height: r.envMap.height,
            faces: r.envMap.faces,
            min: "linear",
            mag: "linear",
            format: "rgba",
            type: i ? "float16" : "uint8"
        }),
        sh: r.sh
    };
}

function _r(e) {
    for (const t in e) e[t] && e[t].destroy && e[t].destroy(), delete e[t];
}

var gr = Object.freeze({
    __proto__: null,
    createIBLTextures: vr,
    disposeIBLTextures: _r,
    getIBLResOnCanvas: function(e) {
        const {dfgLUT: t, iblTexes: n} = e;
        return {
            dfgLUT: t,
            iblTexes: n
        };
    },
    getPBRUniforms: function(e, t, n, r, i) {
        const o = e.viewMatrix, a = e.projMatrix, s = e.cameraPosition, c = e.getRenderer().canvas, l = function(e, t) {
            const n = e.getLightManager(), r = n && n.getAmbientResource(), i = n && n.getAmbientLight() || {}, o = n && n.getDirectionalLight() || {};
            let a;
            if (r) {
                const e = t.prefilterMap.width, n = Math.log(e) / Math.log(2);
                a = {
                    prefilterMap: t.prefilterMap,
                    diffuseSPH: t.sh,
                    prefilterMiplevel: [ n, n ],
                    prefilterSize: [ e, e ],
                    hdrHSV: i.hsv || [ 0, 0, 0 ]
                };
            } else a = {
                ambientColor: i.color || [ .2, .2, .2 ]
            };
            return a.environmentExposure = g(i.exposure) ? i.exposure : 1, a.environmentOrientation = i.orientation || 0, 
            a.light0_diffuse = [ ...o.color || [ 1, 1, 1 ], 1 ], a.light0_viewDirection = o.direction || [ 1, 1, -1 ], 
            a;
        }(e, t), f = v({
            viewMatrix: o,
            projMatrix: a,
            projViewMatrix: e.projViewMatrix,
            cameraPosition: s,
            outSize: [ c.width, c.height ],
            cameraNearFar: [ e.cameraNear, e.cameraFar ]
        }, l);
        return f.brdfLUT = n, r && r.renderUniforms && v(f, r.renderUniforms), f.halton = i || mr, 
        f;
    },
    isSupported: function(e) {
        return e.hasExtension("EXT_shader_texture_lod");
    },
    loginIBLResOnCanvas: function(e, t, n) {
        if (!e.dfgLUT && (e.dfgLUT = or(t), e.dfgLUT.mtkRefCount = 0, n)) {
            const r = (...n) => hr.call(this, e, t, ...n);
            n.on("updatelights", r), e._iblResListener = r;
        }
        e.dfgLUT.mtkRefCount++;
        const r = n.getLightManager();
        return r && r.getAmbientResource() ? (e.iblTexes || (e.iblTexes = vr(t, n)), {
            dfgLUT: e.dfgLUT,
            iblTexes: e.iblTexes
        }) : {
            dfgLUT: e.dfgLUT,
            iblTexes: null
        };
    },
    logoutIBLResOnCanvas: function(e, t) {
        let n = !1;
        if (e.dfgLUT && (e.dfgLUT.mtkRefCount--, e.dfgLUT.mtkRefCount <= 0)) {
            if (n = !0, t) {
                t.off("updatelights", e._iblResListener);
            }
            e.dfgLUT.destroy(), delete e.dfgLUT;
        }
        e.iblTexes && n && (_r(e.iblTexes), delete e.iblTexes);
    }
});

class xr extends yt {
    constructor(t) {
        super({
            vert: "attribute vec3 aPosition;\nuniform mat4 lightProjViewModelMatrix;\nuniform mat4 positionMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 modelMatrix;\n#include <line_extrusion_vert>\n#include <get_output>\nvarying vec4 vPosition;\nvoid main() {\n  mat4 c = getPositionMatrix();\n#ifdef IS_LINE_EXTRUSION\nvec3 d = getLineExtrudePosition(aPosition);\n  vec4 e = getPosition(d);\n#else\nvec4 e = getPosition(aPosition);\n#endif\ngl_Position = lightProjViewModelMatrix * c * e;\n  vPosition = gl_Position;\n}",
            frag: "#define SHADER_NAME vsm_mapping\n#ifdef USE_VSM\n#extension GL_OES_standard_derivatives : enable\n#endif\nprecision highp float;\nvarying vec4 vPosition;\n#ifdef PACK_FLOAT\n#include <common_pack_float>\n#endif\nvoid main() {\n  \n#if defined(USE_VSM)\nfloat c = vPosition.z / vPosition.w;\n  c = c * .5 + .5;\n  float d = c;\n  float e = c * c;\n  float f = dFdx(c);\n  float h = dFdy(c);\n  e += .25 * (f * f + h * h);\n  gl_FragColor = vec4(d, e, c, .0);\n#endif\n#if defined(USE_ESM)\n#ifdef PACK_FLOAT\ngl_FragColor = common_encodeDepth(gl_FragCoord.z);\n#else\ngl_FragColor = vec4(gl_FragCoord.z, .0, .0, 1.);\n#endif\n#endif\n}",
            uniforms: [ {
                name: "lightProjViewModelMatrix",
                type: "function",
                fn: function(t, n) {
                    return e.multiply([], n.lightProjViewMatrix, n.modelMatrix);
                }
            } ],
            extraCommandProps: {},
            defines: t
        });
    }
    filter(e) {
        return e.castShadow;
    }
}

class pr extends Et {
    constructor({blurOffset: e}) {
        super({
            vert: Mt,
            frag: "precision highp float;\nvarying vec2 vTexCoord;\nuniform sampler2D textureSource;\nuniform vec2 resolution;\n#include <common_pack_float>\nvoid main() {\n  float c = .0;\n  float d = .0;\n  for(int x = -BOXBLUR_OFFSET; x <= BOXBLUR_OFFSET; ++x)\n    for(int y = -BOXBLUR_OFFSET; y <= BOXBLUR_OFFSET; ++y) {\n      vec2 e = vTexCoord.st + vec2(float(x) / resolution.x, float(y) / resolution.y);\n      e = clamp(e, .0, 1.);\n      float f = common_decodeDepth(texture2D(textureSource, e));\n      float s = max(.0, sign(1. - f));\n      d += sign(f) * s;\n      c += f;\n    }\n  float h = c / max(1., d);\n  gl_FragColor = common_encodeDepth(h);\n}",
            defines: {
                BOXBLUR_OFFSET: e || 2
            }
        }), this._blurOffset = e || 2;
    }
    getMeshCommand(e, t) {
        const n = "box_shadow_blur_" + this._blurOffset;
        return this.commands[n] || (this.commands[n] = this.createREGLCommand(e, null, t.getElements())), 
        this.commands[n];
    }
}

let br = null, yr = null;

class Ar {
    constructor(e, {width: t, height: n, blurOffset: r, defines: i}) {
        this.renderer = e, this.width = t || 512, this.height = n || 512, this.blurOffset = u(r) ? 2 : r, 
        this._init(i);
    }
    render(e, {cameraProjViewMatrix: t, lightDir: n, farPlane: r, cameraLookAt: i}) {
        return {
            lightProjViewMatrix: this._renderShadow(e, t, n, r, i),
            shadowMap: this.blurTex || this.depthTex,
            depthFBO: this.depthFBO,
            blurFBO: this.blurFBO
        };
    }
    resize(e, t) {
        return this.depthTex && (this.depthTex.resize(e, t), this.depthFBO.resize(e, t)), 
        this.width = e, this.blurFBO && (this.blurTex.resize(e, t), this.blurFBO.resize(e, t)), 
        this.height = t, this;
    }
    _renderShadow(e, t, n, r, i) {
        const o = this.renderer, a = br(t);
        if (r) for (let e = 4; e < 8; e++) a[e] = r[e - 4];
        const s = yr(i, a, n);
        return o.clear({
            color: [ 1, 0, 0, 1 ],
            depth: 1,
            framebuffer: this.depthFBO
        }), o.render(this.shadowMapShader, {
            lightProjViewMatrix: s
        }, e, this.depthFBO), this.blurFBO && (this.boxBlurShader || (this.boxBlurShader = new pr({
            blurOffset: this.blurOffset
        })), o.clear({
            color: [ 1, 0, 0, 1 ],
            depth: 1,
            framebuffer: this.blurFBO
        }), o.render(this.boxBlurShader, {
            resolution: [ this.depthTex.width, this.depthTex.height ],
            textureSource: this.depthTex
        }, null, this.blurFBO)), s;
    }
    _init(e) {
        const t = this.renderer.regl, n = "uint8", r = this.width, i = this.height;
        this.depthTex = t.texture({
            width: r,
            height: i,
            format: "rgb",
            type: n,
            min: "nearest",
            mag: "nearest"
        }), this.shadowMapShader = new xr(e), this.shadowMapShader.filter = e => e.castShadow, 
        this.depthFBO = t.framebuffer({
            color: this.depthTex
        }), this.blurOffset <= 0 || (this.blurTex = t.texture({
            width: r,
            height: i,
            format: "rgb",
            type: n,
            min: "linear",
            mag: "linear"
        }), this.blurFBO = t.framebuffer({
            color: this.blurTex
        }));
    }
    dispose() {
        this.depthTex && (this.depthTex.destroy(), this.depthFBO.destroy(), delete this.depthTex, 
        delete this.depthFBO), this.blurTex && (this.blurTex.destroy(), this.blurFBO.destroy(), 
        delete this.blurTex, delete this.blurFBO), this.shadowMapShader && (this.shadowMapShader.dispose(), 
        delete this.shadowMapShader), this.boxBlurShader && (this.boxBlurShader.dispose(), 
        delete this.boxBlurShader);
    }
}

br = function() {
    const t = [ [ -1, -1, -1, 1 ], [ 1, -1, -1, 1 ], [ 1, 1, -1, 1 ], [ -1, 1, -1, 1 ], [ -1, -1, 1, 1 ], [ 1, -1, 1, 1 ], [ 1, 1, 1, 1 ], [ -1, 1, 1, 1 ] ], r = new Array(16);
    return function(i) {
        e.invert(r, i);
        const o = [];
        for (let e = 0; e < t.length; e++) {
            const i = n.transformMat4([], t[e], r);
            n.scale(i, i, 1 / i[3]), o.push(i);
        }
        return o;
    };
}(), yr = function() {
    let r = new Array(4);
    const i = new Array(3), o = [ 0, 0, 0, 0 ], a = [ 0, 1, 0 ], s = new Array(3);
    let c = new Array(16), l = new Array(16);
    const f = new Array(16), d = [ 1, 1, 1 ], u = [ 0, 0, 0 ];
    return function(h, m, v) {
        n.set(o, ...h, 1), t.scale(i, v, -1), c = e.lookAt(c, t.add(s, o, t.normalize(s, i)), o, a), 
        n.transformMat4(r, m[0], c);
        let _ = r[2], g = r[2], x = r[0], p = r[0], b = r[1], y = r[1];
        for (let e = 1; e < 8; e++) r = n.transformMat4(r, m[e], c), r[2] > g && (g = r[2]), 
        r[2] < _ && (_ = r[2]), r[0] > p && (p = r[0]), r[0] < x && (x = r[0]), r[1] > y && (y = r[1]), 
        r[1] < b && (b = r[1]);
        l = e.ortho(l, -1, 1, -1, 1, -g, -_);
        const A = d[0] = 2 / (p - x), S = d[1] = -2 / (y - b);
        u[0] = -.5 * (x + p) * A, u[1] = -.5 * (b + y) * S, e.identity(f), e.translate(f, f, u), 
        e.scale(f, f, d);
        const T = e.multiply(l, f, l);
        return e.multiply(new Array(16), T, c);
    };
}();

class Sr extends yt {
    constructor(t) {
        super({
            vert: "#define SHADER_NAME SHADOW_DISPLAY\nattribute vec3 aPosition;\nuniform mat4 projMatrix;\nuniform mat4 modelViewMatrix;\nuniform vec2 halton;\nuniform vec2 globalTexSize;\nvarying vec4 vPosition;\n#include <vsm_shadow_vert>\nvoid main() {\n  vec4 c = vec4(aPosition, 1.);\n  vec4 d = modelViewMatrix * c;\n  mat4 e = projMatrix;\n  e[2].xy += halton.xy / globalTexSize.xy;\n  gl_Position = e * d;\n  vPosition = gl_Position;\n  shadow_computeShadowPars(c);\n}",
            frag: "#define SHADER_NAME SHADOW_DISPLAY\nprecision mediump float;\nuniform vec3 color;\n#include <vsm_shadow_frag>\nvoid main() {\n  float c = shadow_computeShadow();\n  float d = 1. - c;\n  gl_FragColor = vec4(color * d, d);\n}",
            uniforms: [ {
                name: "modelViewMatrix",
                type: "function",
                fn: function(t, n) {
                    const r = [];
                    return e.multiply(r, n.viewMatrix, n.modelMatrix), r;
                }
            } ],
            defines: t || {
                USE_ESM: 1
            },
            extraCommandProps: {
                depth: {
                    enable: !0,
                    mask: !1
                },
                viewport: {
                    x: 0,
                    y: 0,
                    width: (e, t) => t.globalTexSize[0],
                    height: (e, t) => t.globalTexSize[1]
                }
            }
        });
    }
    getMeshCommand(e, t) {
        return this.commands.shadow_display || (this.commands.shadow_display = this.createREGLCommand(e, null, t.getElements())), 
        this.commands.shadow_display;
    }
}

function Tr(e) {
    return 256 * e[2] * 256 + 256 * e[1] + e[0];
}

const Mr = new Uint8Array(4), Or = new Float32Array(Mr.buffer);

let Cr, Er;

const Pr = [ 1, 1 ], wr = "\n    vec3 unpack(highp float f) {\n        highp vec3 color;\n        color.b = floor(f / 65536.0);\n        color.g = floor((f - color.b * 65536.0) / 256.0);\n        color.r = f - floor(color.b * 65536.0) - floor(color.g * 256.0);\n        // now we have a vec3 with the 3 components in range [0..255]. Let's normalize it!\n        return color / 255.0;\n    }\n", Ir = `\n    precision highp float;\n\n    varying float vPickingId;\n    varying float vFbo_picking_visible;\n\n    uniform float fbo_picking_meshId;\n\n    ${wr}\n\n    void main() {\n        if (vFbo_picking_visible == 0.0) {\n            discard;\n            return;\n        }\n        gl_FragColor = vec4(unpack(vPickingId), fbo_picking_meshId / 255.0);\n    }\n`, Rr = `\n    precision highp float;\n\n    uniform int fbo_picking_meshId;\n    varying float vFbo_picking_visible;\n\n    ${wr}\n\n    void main() {\n        if (vFbo_picking_visible == 0.0) {\n            discard;\n            return;\n        }\n        gl_FragColor = vec4(unpack(float(fbo_picking_meshId)), 1.0);\n        // gl_FragColor = vec4(unpack(float(35)), 1.0);\n    }\n`, Dr = `\n    precision highp float;\n\n    varying float vPickingId;\n    varying float vFbo_picking_visible;\n\n    ${wr}\n\n    void main() {\n        if (vFbo_picking_visible == 0.0) {\n            discard;\n            return;\n        }\n        gl_FragColor = vec4(unpack(vPickingId), 1.0);\n    }\n`;

class Hr {
    constructor(e, {vert: t, uniforms: n, defines: r, extraCommandProps: i, enableStencil: o}, a, s) {
        this._renderer = e, this._fbo = a, this._map = s, this._clearFbo(a), this._vert = t, 
        this._uniforms = n, this._defines = r, this._extraCommandProps = v({}, i), delete this._extraCommandProps.blend, 
        o ? this._extraCommandProps.stencil = {
            enable: o,
            mask: 255,
            func: {
                cmp: "<",
                ref: 1,
                mask: 255
            },
            op: {
                fail: "keep",
                zfail: "keep",
                zpass: "replace"
            }
        } : delete this._extraCommandProps.stencil, this._currentMeshes = [], this._init();
    }
    _init() {
        const e = [];
        this._uniforms && e.push(...this._uniforms);
        const t = {
            ENABLE_PICKING: 1,
            HAS_PICKING_ID: 1
        };
        if (this._defines) for (const e in this._defines) t[e] = this._defines[e];
        const n = this._vert, r = this._extraCommandProps;
        this._shader0 = new yt({
            vert: n,
            frag: Ir,
            uniforms: e,
            defines: t,
            extraCommandProps: r
        }), this._shader2 = new yt({
            vert: n,
            frag: Dr,
            uniforms: e,
            defines: t,
            extraCommandProps: r
        });
        const i = {
            ENABLE_PICKING: 1,
            HAS_PICKING_ID: 1
        };
        if (this._defines) for (const e in this._defines) i[e] = this._defines[e];
        this._shader1 = new yt({
            vert: n,
            frag: Rr,
            uniforms: e,
            defines: i,
            extraCommandProps: r
        }), this._depthShader = new yt({
            vert: n,
            frag: "\n    #ifdef GL_ES\n        precision highp float;\n    #endif\n    #if __VERSION__ == 100 && defined(GL_EXT_frag_depth)\n        #extension GL_EXT_frag_depth : enable\n    #endif\n    #include <gl2_frag>\n    #include <common_pack_float>\n    varying float vFbo_picking_viewZ;\n    uniform float logDepthBufFC;\n    varying float vFbo_picking_fragDepth;\n\n    const float PackUpscale = 256. / 255.;\n    const float UnpackDownscale = 255. / 256.;\n    const vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );\n    const vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\n    const float ShiftRight8 = 1. / 256.;\n    vec4 packDepthToRGBA(const in float v ) {\n        vec4 r = vec4(fract(v * PackFactors), v);\n        r.yzw -= r.xyz * ShiftRight8;\n        return r * PackUpscale;\n    }\n\n    void main() {\n        float fragDepth = vFbo_picking_fragDepth > 1.0 ? vFbo_picking_fragDepth : vFbo_picking_viewZ + 1.0;\n        #if __VERSION__ == 300 || __VERSION__ == 100 && defined(GL_EXT_frag_depth)\n            gl_FragDepthEXT = log2(fragDepth) * logDepthBufFC * 0.5;\n        #endif\n        vec4 depthColor = packDepthToRGBA(fragDepth - 1.0);\n        glFragColor = common_unpackFloat(dot(depthColor, UnpackFactors));\n        #if __VERSION__ == 100\n            gl_FragColor = glFragColor;\n        #endif\n    }\n",
            uniforms: e,
            defines: i,
            extraCommandProps: r
        }), this._scene = new Ze, this._scene1 = new Ze;
    }
    filter() {
        return !0;
    }
    render(e, t, n = !1) {
        if (!e || !e.length) return this;
        const r = this._fbo;
        n && this.clear(), e = e.filter((e => e && e.isValid && e.isValid())), this._scene.setMeshes(e);
        const i = this._getShader(e, n);
        i.filter = this.filter, this._currentShader && i !== this._currentShader && this.clear(), 
        this._currentShader = i, e.forEach(((e, t) => {
            e.setUniform("fbo_picking_meshId", t + this._currentMeshes.length);
        }));
        for (let t = 0; t < e.length; t++) this._currentMeshes.push(e[t]);
        return this._renderer.render(i, t, this._scene, r), this;
    }
    pickAll(e, t, n, r, i) {
        n = Nr(n);
        const {meshIds: o, pickingIds: a, coords: s, points: c} = this._pick(e, t, n, r, i), l = [];
        if (a && o) {
            const e = {};
            for (let t = 0; t < o.length; t++) {
                const n = `${a[t]}_${o[t]}`;
                null == o[t] || null == a[t] || e[n] || (e[n] = !0, l.push({
                    meshId: o[t],
                    pickingId: a[t],
                    point: c[t] || null,
                    coordinate: s[t] || null
                }));
            }
        }
        return l;
    }
    pick(e, t, n, r, i = {}) {
        n = Nr(n);
        const {meshIds: o, pickingIds: a, width: s, coords: c, points: l} = this._pick(e, t, n, r, i);
        if (a && o) {
            const e = [];
            for (let t = 0; t <= n[0]; t++) e.push(t), t > 0 && e.push(-t);
            for (let t = 0; t < e.length; t++) for (let r = 0; r < e.length; r++) {
                const i = (e[r] + n[1]) * s + (e[t] + n[0]);
                if (null != o[i]) return {
                    meshId: o[i],
                    pickingId: a[i],
                    point: l[i] || null,
                    coordinate: c[i] || null
                };
            }
        }
        return {
            pickingId: null,
            meshId: null,
            point: null
        };
    }
    _pick(e, t, n, r, i = {}) {
        const o = this._currentShader, a = this._currentMeshes;
        if (!o || !a || !a.length) return {
            pickingId: null,
            meshId: null,
            point: null
        };
        e = Math.round(e), t = Math.round(t);
        const s = this._fbo;
        if (e <= 2 || e >= s.width - 2 || t <= 2 || t >= s.height - 2) return {
            pickingId: null,
            meshId: null,
            point: null
        };
        const {px: c, py: l, width: f, height: d} = this._getParams(e, t, n, s), u = new Uint8Array(4 * f * d), h = this._renderer.regl.read({
            data: u,
            x: c,
            y: l,
            framebuffer: s,
            width: f,
            height: d
        }), m = [];
        let v = [];
        for (let e = 0; e < h.length; e += 4) {
            const {pickingId: t, meshId: n} = this._packData(h.subarray(e, e + 4), o);
            m.push(n), v.push(t);
        }
        const _ = {}, g = m.filter((e => null != e && !_[e] && (_[e] = 1, !0))).map((e => a[e]));
        let x;
        for (let e = 0; e < g.length; e++) if (g[e] && g[e].geometry) {
            x = g[e];
            break;
        }
        if (!x) return {
            pickingId: null,
            meshId: null,
            point: null
        };
        const p = x.geometry.desc.pickingIdAttribute;
        m.length && o === this._shader1 && (void 0 !== x.getUniform("uPickingId") || x.geometry.data[p]) && (v = this._getPickingId(c, l, f, d, u, g, r));
        const b = [], y = [];
        if (m.length && i.returnPoint) {
            const {viewMatrix: n, projMatrix: o} = i, a = this._pickDepth(c, l, f, d, u, g, r);
            for (let r = 0; r < a.length; r++) if (a[r] && null != m[r]) {
                const i = this._getWorldPos(e, t, a[r], n, o), s = this._convertPickPoint(i);
                b.push(i), y.push(s);
            } else b.push(null), y.push(null);
        }
        return {
            meshIds: m,
            pickingIds: v,
            coords: y,
            points: b,
            width: f,
            height: d
        };
    }
    _convertPickPoint(e) {
        const t = this._map;
        if (!t) return null;
        const n = t.getGLRes();
        if (!Cr) {
            const e = t.getCenter();
            Er = new e.constructor(0, 0, 0);
            const n = t.coordToPoint(e);
            Cr = new n.constructor(0, 0);
        }
        Cr.set(e[0], e[1]);
        const r = t.pointAtResToCoord(Cr, n, Er), i = t.pointAtResToAltitude(e[2], n);
        return [ r.x, r.y, i ];
    }
    clear() {
        return this._fbo && this._clearFbo(this._fbo), this._currentMeshes = [], delete this._currentShader, 
        this;
    }
    getMeshAt(e) {
        return this._currentMeshes ? this._currentMeshes[e] : null;
    }
    getRenderedMeshes() {
        return this._currentMeshes;
    }
    dispose() {
        this.clear(), this._shader0 && this._shader0.dispose(), this._shader1 && this._shader1.dispose(), 
        this._shader2 && this._shader2.dispose(), this._scene && this._scene.clear(), this._scene1 && this._scene1.clear();
    }
    _getWorldPos(t, n, r, i, o) {
        const a = this._fbo, s = [], c = a.width / 2 || 1, l = a.height / 2 || 1, f = [ (t - c) / c, (l - n) / l, 0, 1 ], d = [ (t - c) / c, (l - n) / l, 1, 1 ], u = e.invert(s, o), h = [], m = [];
        Fr(h, f, u), Fr(m, d, u);
        const v = -h[2], _ = (r - v) / (-m[2] - v), g = e.multiply(s, o, i), p = e.invert(s, g), b = Fr(f, f, p), y = Fr(d, d, p);
        return [ x(b[0], y[0], _), x(b[1], y[1], _), x(b[2], y[2], _) ];
    }
    _getPickingId(e, t, n, r, i, o, a) {
        const s = this._renderer.regl, c = this._getFBO1();
        this._clearFbo(c), this._scene1.setMeshes(o), this._renderer.render(this._shader2, a, this._scene1, c);
        const l = s.read({
            data: i,
            x: e,
            y: t,
            framebuffer: c,
            width: n,
            height: r
        }), f = [];
        for (let e = 0; e < l.length; e += 4) f.push(Tr(l.subarray(e, e + 4)));
        return f;
    }
    _pickDepth(e, t, n, r, i, o, a) {
        const s = this._renderer.regl, c = this._getFBO1();
        this._scene1.setMeshes(o), this._clearFbo(c), a.logDepthBufFC = 2 / (Math.log(this._map.cameraFar + 1) / Math.LN2), 
        this._renderer.render(this._depthShader, a, this._scene1, c);
        const l = s.read({
            data: i,
            x: e,
            y: t,
            framebuffer: c,
            width: n,
            height: r
        }), f = [];
        for (let e = 0; e < l.length; e += 4) f.push((d = l.subarray(e, e + 4), Mr[0] = d[3], 
        Mr[1] = d[2], Mr[2] = d[1], Mr[3] = d[0], Or[0]));
        var d;
        return f;
    }
    _packData(e, t) {
        if (255 === e[0] && 255 === e[1] && 255 === e[2] && 255 === e[3]) return {
            meshId: null,
            pickingId: null
        };
        let n = null, r = null;
        return t === this._shader1 ? r = Tr(e) : t === this._shader0 ? (r = e[3], n = Tr(e)) : (r = null, 
        n = Tr(e)), {
            meshId: r,
            pickingId: n
        };
    }
    _clearFbo(e) {
        this._renderer.regl.clear({
            color: [ 1, 1, 1, 1 ],
            depth: 1,
            stencil: 255,
            framebuffer: e
        });
    }
    _getShader(e, t) {
        return t && e.length < 256 ? this._shader0 : this._shader1;
    }
    _getFBO1() {
        const e = this._renderer.regl, t = this._fbo;
        return this._fbo1 ? this._fbo1.width === t.width && this._fbo1.height === t.height || this._fbo1.resize(t.width, t.height) : this._fbo1 = e.framebuffer(t.width, t.height), 
        this._fbo1;
    }
    _getParams(e, t, n, r) {
        const i = n[0], o = n[1];
        t = r.height - t;
        let a = 2 * i + 1, s = 2 * o + 1;
        const c = (e -= i) + a, l = (t -= o) + s;
        return c > r.width && (a -= c - r.width), l > r.height && (s -= l - r.height), {
            px: e = e < 0 ? 0 : e,
            py: t = t < 0 ? 0 : t,
            width: a,
            height: s
        };
    }
    getPickingVert() {
        return this._vert;
    }
    getUniformDeclares() {
        return this._uniforms;
    }
}

function Fr(e, t, n) {
    const r = t[0], i = t[1], o = t[2], a = 1 / (n[3] * r + n[7] * i + n[11] * o + n[15]);
    return e[0] = (n[0] * r + n[4] * i + n[8] * o + n[12]) * a, e[1] = (n[1] * r + n[5] * i + n[9] * o + n[13]) * a, 
    e[2] = (n[2] * r + n[6] * i + n[10] * o + n[14]) * a, e;
}

function Nr(e) {
    return g(e) && (Pr[0] = Pr[1] = e, e = Pr), e;
}

const Lr = e => e && e.geometry && void 0 === e.geometry.properties.shaderHash, kr = [], Br = [], zr = [ {
    name: "modelViewMatrix",
    type: "function",
    fn: (t, n) => e.multiply(kr, n.viewMatrix, n.modelMatrix)
}, {
    name: "modelViewProjMatrix",
    type: "function",
    fn: (t, n) => {
        const r = e.multiply(kr, n.viewMatrix, n.modelMatrix);
        return e.multiply(kr, n.projMatrix, r);
    }
}, {
    name: "modelMatrixInverse",
    type: "function",
    fn: (t, n) => e.invert(kr, n.modelMatrix)
}, {
    name: "projMatrixInverse",
    type: "function",
    fn: (t, n) => e.invert(kr, n.projMatrix)
}, {
    name: "modelViewMatrixInverse",
    type: "function",
    fn: (t, n) => (e.multiply(kr, n.viewMatrix, n.modelMatrix), e.invert(kr, kr))
}, {
    name: "modelViewProjMatrixInverse",
    type: "function",
    fn: (t, n) => {
        const r = e.multiply(kr, n.viewMatrix, n.modelMatrix);
        return e.multiply(kr, n.projMatrix, r), e.invert(kr, kr);
    }
}, {
    name: "modelInverseTransposeMatrix",
    type: "function",
    fn: (e, t) => {
        const n = r.fromMat4(Br, t.modelMatrix), i = r.transpose(n, n);
        return r.invert(i, i);
    }
}, {
    name: "modelViewInverseTransposeMatrix",
    type: "function",
    fn: (t, n) => {
        const i = e.multiply(kr, n.viewMatrix, n.modelMatrix), o = r.fromMat4(Br, i), a = r.transpose(o, o);
        return r.invert(a, a);
    }
} ], Gr = {
    LOCAL: "positionMatrix",
    MODEL: "modelMatrix",
    VIEW: "viewMatrix",
    PROJECTION: "projMatrix",
    MODELVIEW: "modelViewMatrix",
    MODELVIEWPROJECTION: "modelViewProjMatrix",
    MODELINVERSE: "modelMatrixInverse",
    VIEWINVERSE: "viewMatrixInverse",
    PROJECTIONINVERSE: "projMatrixInverse",
    MODELVIEWINVERSE: "modelViewMatrixInverse",
    MODELVIEWPROJECTIONINVERSE: "modelViewProjMatrixInverse",
    MODELINVERSETRANSPOSE: "modelInverseTransposeMatrix",
    MODELVIEWINVERSETRANSPOSE: "modelViewInverseTransposeMatrix",
    VIEWPORT: "viewport",
    JOINTMATRIX: "jointMatrix",
    ALPHACUTOFF: "alphaCutoff"
};

class Vr {
    constructor(e, t, n) {
        this._regl = e, this._khrShaders = {}, this._commandProps = t, this._resLoader = n;
    }
    getExcludeFilter() {
        return Lr;
    }
    forEachShader(e) {
        for (const t in this._khrShaders) {
            const n = this._khrShaders[t];
            e(n.shader, n.filter, n.uniformSemantics);
        }
    }
    createMesh(e, t, n, r) {
        const i = t.extensions.KHR_techniques_webgl, o = t.materials[e.material].extensions.KHR_techniques_webgl, {technique: a, values: s} = o, c = i.techniques[a], l = i.programs[c.program], f = i.shaders[l.vertexShader], d = i.shaders[l.fragmentShader];
        d.content = function(e) {
            if (e && e.indexOf("precision") < 0) return "precision mediump float;\n" + e;
            return e;
        }(d.content);
        const u = w(f.content) + "-" + w(d.content);
        this._khrShaders[u] || (this._khrShaders[u] = this._createTechniqueShader(u, i, a, this._commandProps, r));
        const {attributeSemantics: h} = this._khrShaders[u], m = this._createGeometry(e, h, n, u), _ = v({}, s);
        for (const e in s) if (c.uniforms[e] && 35678 === c.uniforms[e].type) {
            _[e] = this._getTexture(t.textures[s[e].index]);
        }
        return {
            geometry: m,
            material: new Ce(_)
        };
    }
    _createGeometry(e, t, n, r) {
        const i = e.attributes, o = "COLOR_0";
        if (i[o]) {
            const e = i[o].array || i[o];
            if (e instanceof Float32Array) {
                const t = new Uint8Array(e.length);
                for (let n = 0; n < t.length; n++) t[n] = Math.round(255 * e[n]);
                i[o].array ? (i[o].array = t, i[o].componentType = 5121) : i[o] = t;
            }
        }
        const a = {};
        for (const e in i) {
            const n = he(this._regl, i[e], {
                dimension: i[e].itemSize
            }), r = t[e] || e;
            a[r] = {
                buffer: n
            }, i[e].quantization && (a[r].quantization = i[e].quantization), r === t.POSITION && (a[r].array = i[e].array);
        }
        const s = new Z(a, e.indices.array ? e.indices.array : e.indices, 0, {
            positionAttribute: t.POSITION,
            normalAttribute: t.NORMAL,
            uv0Attribute: t.TEXCOORD_0,
            uv1Attribute: t.TEXCOORD_1,
            color0Attribute: t.COLOR_0,
            tangentAttribute: t.TANGENT,
            textureCoordMatrixAttribute: t.TextureCoordMatrix,
            primitive: void 0 === e.mode ? "triangles" : ee(e.mode)
        });
        s.generateBuffers(this._regl, {
            excludeElementsInVAO: n
        }), s.properties.shaderHash = r;
        const c = s.data[s.desc.positionAttribute];
        return c && c.array && delete c.array, s;
    }
    _getTexture(e) {
        const t = {
            type: e.type ? ne(e.type) : "uint8",
            format: e.format ? ie(e.format) : "rgba",
            flipY: !!e.flipY
        }, n = e.image;
        n.array ? t.data = n.array : n.mipmap && (t.mipmap = n.mipmap), t.width = n.width, 
        t.height = n.height;
        const r = e.sampler || e.texture.sampler;
        return r && (r.magFilter && (t.mag = ae(r.magFilter)), r.minFilter && (t.min = ce(r.minFilter)), 
        r.wrapS && (t.wrapS = fe(r.wrapS)), r.wrapT && (t.wrapT = fe(r.wrapT))), new ct(t, this._resLoader);
    }
    _createTechniqueShader(e, t, n, r, i) {
        const {techniques: o, programs: a, shaders: s} = t, c = o[n], l = a[c.program], f = s[l.vertexShader].content, d = s[l.fragmentShader].content, u = {};
        for (const e in c.uniforms) {
            const t = c.uniforms[e];
            t.semantic && (u[t.semantic] = e);
        }
        const h = zr.slice();
        for (const e in u) {
            h.push({
                name: u[e],
                type: "function",
                fn: (t, n) => n[Gr[e]]
            });
        }
        const m = new yt({
            vert: f,
            frag: d,
            uniforms: h,
            extraCommandProps: r
        });
        i && (m.version = 300);
        const v = {};
        for (const e in c.attributes) {
            v[c.attributes[e].semantic] = e;
        }
        return {
            shader: m,
            filter: t => t && t.geometry && t.geometry.properties.shaderHash === e,
            uniformSemantics: u,
            attributeSemantics: v
        };
    }
    dispose() {
        for (const e in this._khrShaders) {
            const {shader: t} = this._khrShaders[e];
            t.dispose();
        }
        this._khrShaders = {};
    }
}

function Ur(e, t, n, r, i) {
    let o;
    if (i === function(e, t, n, r) {
        let i = 0;
        for (let o = t, a = n - r; o < n; o += r) i += (e[a] - e[o]) * (e[o + 1] + e[a + 1]), 
        a = o;
        return i;
    }(e, t, n, r) > 0) for (let i = t; i < n; i += r) o = di(i / r | 0, e[i], e[i + 1], o); else for (let i = n - r; i >= t; i -= r) o = di(i / r | 0, e[i], e[i + 1], o);
    return o && oi(o, o.next) && (ui(o), o = o.next), o;
}

function jr(e, t) {
    if (!e) return e;
    t || (t = e);
    let n, r = e;
    do {
        if (n = !1, r.steiner || !oi(r, r.next) && 0 !== ii(r.prev, r, r.next)) r = r.next; else {
            if (ui(r), r = t = r.prev, r === r.next) break;
            n = !0;
        }
    } while (n || r !== t);
    return t;
}

function Xr(e, t, n, r, i, o, a) {
    if (!e) return;
    !a && o && function(e, t, n, r) {
        let i = e;
        do {
            0 === i.z && (i.z = Qr(i.x, i.y, t, n, r)), i.prevZ = i.prev, i.nextZ = i.next, 
            i = i.next;
        } while (i !== e);
        i.prevZ.nextZ = null, i.prevZ = null, function(e) {
            let t, n = 1;
            do {
                let r, i = e;
                e = null;
                let o = null;
                for (t = 0; i; ) {
                    t++;
                    let a = i, s = 0;
                    for (let e = 0; e < n && (s++, a = a.nextZ, a); e++) ;
                    let c = n;
                    for (;s > 0 || c > 0 && a; ) 0 !== s && (0 === c || !a || i.z <= a.z) ? (r = i, 
                    i = i.nextZ, s--) : (r = a, a = a.nextZ, c--), o ? o.nextZ = r : e = r, r.prevZ = o, 
                    o = r;
                    i = a;
                }
                o.nextZ = null, n *= 2;
            } while (t > 1);
        }(i);
    }(e, r, i, o);
    let s = e;
    for (;e.prev !== e.next; ) {
        const c = e.prev, l = e.next;
        if (o ? qr(e, r, i, o) : Wr(e)) t.push(c.i, e.i, l.i), ui(e), e = l.next, s = l.next; else if ((e = l) === s) {
            a ? 1 === a ? Xr(e = Kr(jr(e), t), t, n, r, i, o, 2) : 2 === a && Jr(e, t, n, r, i, o) : Xr(jr(e), t, n, r, i, o, 1);
            break;
        }
    }
}

function Wr(e) {
    const t = e.prev, n = e, r = e.next;
    if (ii(t, n, r) >= 0) return !1;
    const i = t.x, o = n.x, a = r.x, s = t.y, c = n.y, l = r.y, f = Math.min(i, o, a), d = Math.min(s, c, l), u = Math.max(i, o, a), h = Math.max(s, c, l);
    let m = r.next;
    for (;m !== t; ) {
        if (m.x >= f && m.x <= u && m.y >= d && m.y <= h && ni(i, s, o, c, a, l, m.x, m.y) && ii(m.prev, m, m.next) >= 0) return !1;
        m = m.next;
    }
    return !0;
}

function qr(e, t, n, r) {
    const i = e.prev, o = e, a = e.next;
    if (ii(i, o, a) >= 0) return !1;
    const s = i.x, c = o.x, l = a.x, f = i.y, d = o.y, u = a.y, h = Math.min(s, c, l), m = Math.min(f, d, u), v = Math.max(s, c, l), _ = Math.max(f, d, u), g = Qr(h, m, t, n, r), x = Qr(v, _, t, n, r);
    let p = e.prevZ, b = e.nextZ;
    for (;p && p.z >= g && b && b.z <= x; ) {
        if (p.x >= h && p.x <= v && p.y >= m && p.y <= _ && p !== i && p !== a && ni(s, f, c, d, l, u, p.x, p.y) && ii(p.prev, p, p.next) >= 0) return !1;
        if (p = p.prevZ, b.x >= h && b.x <= v && b.y >= m && b.y <= _ && b !== i && b !== a && ni(s, f, c, d, l, u, b.x, b.y) && ii(b.prev, b, b.next) >= 0) return !1;
        b = b.nextZ;
    }
    for (;p && p.z >= g; ) {
        if (p.x >= h && p.x <= v && p.y >= m && p.y <= _ && p !== i && p !== a && ni(s, f, c, d, l, u, p.x, p.y) && ii(p.prev, p, p.next) >= 0) return !1;
        p = p.prevZ;
    }
    for (;b && b.z <= x; ) {
        if (b.x >= h && b.x <= v && b.y >= m && b.y <= _ && b !== i && b !== a && ni(s, f, c, d, l, u, b.x, b.y) && ii(b.prev, b, b.next) >= 0) return !1;
        b = b.nextZ;
    }
    return !0;
}

function Kr(e, t) {
    let n = e;
    do {
        const r = n.prev, i = n.next.next;
        !oi(r, i) && ai(r, n, n.next, i) && li(r, i) && li(i, r) && (t.push(r.i, n.i, i.i), 
        ui(n), ui(n.next), n = e = i), n = n.next;
    } while (n !== e);
    return jr(n);
}

function Jr(e, t, n, r, i, o) {
    let a = e;
    do {
        let e = a.next.next;
        for (;e !== a.prev; ) {
            if (a.i !== e.i && ri(a, e)) {
                let s = fi(a, e);
                return a = jr(a, a.next), s = jr(s, s.next), Xr(a, t, n, r, i, o, 0), void Xr(s, t, n, r, i, o, 0);
            }
            e = e.next;
        }
        a = a.next;
    } while (a !== e);
}

function Yr(e, t) {
    let n = e.x - t.x;
    if (0 === n && (n = e.y - t.y, 0 === n)) {
        n = (e.next.y - e.y) / (e.next.x - e.x) - (t.next.y - t.y) / (t.next.x - t.x);
    }
    return n;
}

function Zr(e, t) {
    const n = function(e, t) {
        let n = t;
        const r = e.x, i = e.y;
        let o, a = -1 / 0;
        if (oi(e, n)) return n;
        do {
            if (oi(e, n.next)) return n.next;
            if (i <= n.y && i >= n.next.y && n.next.y !== n.y) {
                const e = n.x + (i - n.y) * (n.next.x - n.x) / (n.next.y - n.y);
                if (e <= r && e > a && (a = e, o = n.x < n.next.x ? n : n.next, e === r)) return o;
            }
            n = n.next;
        } while (n !== t);
        if (!o) return null;
        const s = o, c = o.x, l = o.y;
        let f = 1 / 0;
        n = o;
        do {
            if (r >= n.x && n.x >= c && r !== n.x && ti(i < l ? r : a, i, c, l, i < l ? a : r, i, n.x, n.y)) {
                const t = Math.abs(i - n.y) / (r - n.x);
                li(n, e) && (t < f || t === f && (n.x > o.x || n.x === o.x && $r(o, n))) && (o = n, 
                f = t);
            }
            n = n.next;
        } while (n !== s);
        return o;
    }(e, t);
    if (!n) return t;
    const r = fi(n, e);
    return jr(r, r.next), jr(n, n.next);
}

function $r(e, t) {
    return ii(e.prev, e, t.prev) < 0 && ii(t.next, e, e.next) < 0;
}

function Qr(e, t, n, r, i) {
    return (e = 1431655765 & ((e = 858993459 & ((e = 252645135 & ((e = 16711935 & ((e = (e - n) * i | 0) | e << 8)) | e << 4)) | e << 2)) | e << 1)) | (t = 1431655765 & ((t = 858993459 & ((t = 252645135 & ((t = 16711935 & ((t = (t - r) * i | 0) | t << 8)) | t << 4)) | t << 2)) | t << 1)) << 1;
}

function ei(e) {
    let t = e, n = e;
    do {
        (t.x < n.x || t.x === n.x && t.y < n.y) && (n = t), t = t.next;
    } while (t !== e);
    return n;
}

function ti(e, t, n, r, i, o, a, s) {
    return (i - a) * (t - s) >= (e - a) * (o - s) && (e - a) * (r - s) >= (n - a) * (t - s) && (n - a) * (o - s) >= (i - a) * (r - s);
}

function ni(e, t, n, r, i, o, a, s) {
    return !(e === a && t === s) && ti(e, t, n, r, i, o, a, s);
}

function ri(e, t) {
    return e.next.i !== t.i && e.prev.i !== t.i && !function(e, t) {
        let n = e;
        do {
            if (n.i !== e.i && n.next.i !== e.i && n.i !== t.i && n.next.i !== t.i && ai(n, n.next, e, t)) return !0;
            n = n.next;
        } while (n !== e);
        return !1;
    }(e, t) && (li(e, t) && li(t, e) && function(e, t) {
        let n = e, r = !1;
        const i = (e.x + t.x) / 2, o = (e.y + t.y) / 2;
        do {
            n.y > o != n.next.y > o && n.next.y !== n.y && i < (n.next.x - n.x) * (o - n.y) / (n.next.y - n.y) + n.x && (r = !r), 
            n = n.next;
        } while (n !== e);
        return r;
    }(e, t) && (ii(e.prev, e, t.prev) || ii(e, t.prev, t)) || oi(e, t) && ii(e.prev, e, e.next) > 0 && ii(t.prev, t, t.next) > 0);
}

function ii(e, t, n) {
    return (t.y - e.y) * (n.x - t.x) - (t.x - e.x) * (n.y - t.y);
}

function oi(e, t) {
    return e.x === t.x && e.y === t.y;
}

function ai(e, t, n, r) {
    const i = ci(ii(e, t, n)), o = ci(ii(e, t, r)), a = ci(ii(n, r, e)), s = ci(ii(n, r, t));
    return i !== o && a !== s || (!(0 !== i || !si(e, n, t)) || (!(0 !== o || !si(e, r, t)) || (!(0 !== a || !si(n, e, r)) || !(0 !== s || !si(n, t, r)))));
}

function si(e, t, n) {
    return t.x <= Math.max(e.x, n.x) && t.x >= Math.min(e.x, n.x) && t.y <= Math.max(e.y, n.y) && t.y >= Math.min(e.y, n.y);
}

function ci(e) {
    return e > 0 ? 1 : e < 0 ? -1 : 0;
}

function li(e, t) {
    return ii(e.prev, e, e.next) < 0 ? ii(e, t, e.next) >= 0 && ii(e, e.prev, t) >= 0 : ii(e, t, e.prev) < 0 || ii(e, e.next, t) < 0;
}

function fi(e, t) {
    const n = hi(e.i, e.x, e.y), r = hi(t.i, t.x, t.y), i = e.next, o = t.prev;
    return e.next = t, t.prev = e, n.next = i, i.prev = n, r.next = n, n.prev = r, o.next = r, 
    r.prev = o, r;
}

function di(e, t, n, r) {
    const i = hi(e, t, n);
    return r ? (i.next = r.next, i.prev = r, r.next.prev = i, r.next = i) : (i.prev = i, 
    i.next = i), i;
}

function ui(e) {
    e.next.prev = e.prev, e.prev.next = e.next, e.prevZ && (e.prevZ.nextZ = e.nextZ), 
    e.nextZ && (e.nextZ.prevZ = e.prevZ);
}

function hi(e, t, n) {
    return {
        i: e,
        x: t,
        y: n,
        prev: null,
        next: null,
        z: 0,
        prevZ: null,
        nextZ: null,
        steiner: !1
    };
}

const mi = {
    parseHDR: it
}, vi = {
    PBRHelper: lr,
    StandardMaterial: dr,
    StandardSpecularGlossinessMaterial: ur,
    StandardShader: class extends yt {
        constructor(t = {}) {
            let n = t.extraCommandProps || {};
            const i = t.uniforms;
            n = v({}, n);
            const o = t.defines || {}, a = [], s = [], c = [], l = [], f = [], d = [ {
                name: "modelNormalMatrix",
                type: "function",
                fn: (e, t) => r.fromMat4(a, t.modelMatrix)
            }, {
                name: "modelViewNormalMatrix",
                type: "function",
                fn: (t, n) => {
                    const i = e.multiply(s, n.viewMatrix, n.modelMatrix), o = e.invert(i, i), a = e.transpose(o, o);
                    return r.fromMat4(c, a);
                }
            }, {
                name: "modelViewMatrix",
                type: "function",
                fn: (t, n) => e.multiply(l, n.viewMatrix, n.modelMatrix)
            }, {
                name: "environmentTransform",
                type: "function",
                fn: (e, t) => r.fromRotation(f, Math.PI * (t.environmentOrientation || 0) / 180)
            } ];
            i && d.push(...i);
            super({
                vert: t.vert || "#include <gl2_vert>\n#define SHADER_NAME PBR\nprecision highp float;\nattribute vec3 aPosition;\n#if defined(HAS_MAP)\nattribute vec2 aTexCoord;\nuniform vec2 uvOrigin;\nuniform vec2 uvScale;\nuniform vec2 uvOffset;\nuniform float uvRotation;\n#ifdef HAS_I3S_UVREGION\nattribute vec4 uvRegion;\nvarying vec4 vUvRegion;\n#endif\n#if defined(HAS_AO_MAP)\nattribute vec2 aTexCoord1;\nvarying vec2 vTexCoord1;\n#endif\n#endif\nvec3 c;\nvec3 d;\nvec4 e;\nuniform mat4 modelMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 positionMatrix;\nuniform mat4 projMatrix;\nuniform mediump vec3 cameraPosition;\nuniform mat3 modelNormalMatrix;\n#ifdef HAS_SSR\nuniform mat3 modelViewNormalMatrix;\nvarying vec3 vViewNormal;\n#ifdef HAS_TANGENT\nvarying vec4 vViewTangent;\n#endif\n#endif\nvarying vec3 vModelNormal;\nvarying vec4 vViewVertex;\n#if defined(HAS_TANGENT)\nvarying vec4 vModelTangent;\nvarying vec3 vModelBiTangent;\n#endif\nvarying vec3 vModelVertex;\n#if defined(HAS_MAP)\nvarying vec2 vTexCoord;\n#endif\n#if defined(HAS_COLOR)\nattribute vec4 aColor;\nvarying vec4 vColor;\n#endif\n#ifdef HAS_OPACITY\nattribute float aOpacity;\n#endif\nvarying float vOpacity;\n#include <highlight_vert>\n#if defined(HAS_COLOR0)\n#if COLOR0_SIZE == 3\nattribute vec3 aColor0;\nvarying vec3 vColor0;\n#else\nattribute vec4 aColor0;\nvarying vec4 vColor0;\n#endif\n#endif\n#include <line_extrusion_vert>\n#include <get_output>\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_vert>\n#endif\n#include <heatmap_render_vert>\n#include <vertex_color_vert>\n#if defined(HAS_BUMP_MAP) && defined(HAS_TANGENT)\nvarying vec3 vTangentViewPos;\nvarying vec3 vTangentFragPos;\n#if __VERSION__ == 100\nmat3 f(in mat3 h) {\n  vec3 i = h[0];\n  vec3 j = h[1];\n  vec3 k = h[2];\n  return mat3(vec3(i.x, j.x, k.x), vec3(i.y, j.y, k.y), vec3(i.z, j.z, k.z));\n}\n#else\nmat3 f(in mat3 h) {\n  return transpose(h);\n}\n#endif\n#endif\nvoid l(const highp vec4 q, out highp vec3 m) {\n  m = vec3(.0, .0, 1.) + vec3(2., -2., -2.) * q.x * q.zwx + vec3(2., 2., -2.) * q.y * q.wzy;\n}\nvoid l(const highp vec4 q, out highp vec3 m, out highp vec3 t) {\n  l(q, m);\n  t = vec3(1., .0, .0) + vec3(-2., 2., -2.) * q.y * q.yxw + vec3(-2., 2., 2.) * q.z * q.zwx;\n}\nconst float o = .5;\nvec2 u(vec2 v, float A) {\n  return vec2(cos(A) * (v.x - o) + sin(A) * (v.y - o) + o, cos(A) * (v.y - o) - sin(A) * (v.x - o) + o);\n}\n#if defined(HAS_MAP)\nvec2 B(vec2 v) {\n  vec2 C = decode_getTexcoord(v);\n#ifdef HAS_RANDOM_TEX\nvec2 D = uvOrigin;\n  vec2 E = C * uvScale + uvOffset;\n  return mod(D, 1.) + E;\n#else\nvec2 D = uvOrigin;\n  vec2 E = C * uvScale;\n  if(uvRotation != .0) {\n    D = u(D, uvRotation);\n    E = u(E, uvRotation);\n  }\n  return mod(D, 1.) + E + uvOffset;\n#endif\n}\n#endif\n#ifdef PICKING_MODE\n#include <fbo_picking_vert>\n#endif\n#include <excavate_vert>\nvoid main() {\n  mat4 F = getPositionMatrix();\n#ifdef IS_LINE_EXTRUSION\nvec3 G = getLineExtrudePosition(aPosition);\n  vec4 H = getPosition(G);\n#else\nvec4 H = getPosition(aPosition);\n#endif\nvModelVertex = (modelMatrix * H).xyz;\n  vec4 I = F * H;\n  vec4 J = modelViewMatrix * I;\n  vViewVertex = J;\n#ifdef HAS_MASK_EXTENT\ngl_Position = projMatrix * getMaskPosition(I, modelMatrix);\n#else\ngl_Position = projMatrix * J;\n#endif\n#ifdef PICKING_MODE\nfloat K = 1.;\n#if defined(HAS_COLOR)\nK *= aColor.a;\n#endif\n#if defined(HAS_COLOR0) && COLOR0_SIZE == 4\nK *= aColor0.a;\n#endif\nfbo_picking_setData(gl_Position.w, K != .0);\n#else\n#if defined(HAS_MAP)\nvTexCoord = B(aTexCoord);\n#ifdef HAS_AO_MAP\nvTexCoord1 = B(aTexCoord1);\n#endif\n#ifdef HAS_I3S_UVREGION\nvUvRegion = uvRegion / 65535.;\n#endif\n#endif\n#if defined(HAS_TANGENT) || defined(HAS_NORMAL)\nmat3 L = mat3(F);\n  mat3 M = modelNormalMatrix * L;\n#if defined(HAS_TANGENT)\nvec3 t;\n  l(aTangent, d, t);\n  vModelTangent = vec4(M * t, aTangent.w);\n#else\nd = decode_getNormal(aNormal);\n#endif\nvec3 N = d;\n  vModelNormal = M * N;\n#else\nd = vec3(.0);\n  vModelNormal = vec3(.0);\n#endif\n#if defined(HAS_TANGENT)\nvModelBiTangent = cross(vModelNormal, vModelTangent.xyz) * sign(aTangent.w);\n#endif\n#ifdef HAS_SSR\nmat3 O = modelViewNormalMatrix * L;\n  vViewNormal = O * d;\n#if defined(HAS_TANGENT)\nvec4 P = vec4(t, aTangent.w);\n  vViewTangent = vec4(O * P.xyz, P.w);\n#endif\n#endif\n#if defined(HAS_COLOR)\nvColor = aColor / 255.;\n#endif\n#ifdef HAS_OPACITY\nvOpacity = aOpacity / 255.;\n#else\nvOpacity = 1.;\n#endif\nhighlight_setVarying();\n#if defined(HAS_COLOR0)\nvColor0 = aColor0 / 255.;\n#endif\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nshadow_computeShadowPars(I);\n#endif\n#ifdef HAS_HEATMAP\nheatmap_compute(projMatrix * modelViewMatrix * F, H);\n#endif\n#if defined(HAS_BUMP_MAP) && defined(HAS_TANGENT)\nmat3 Q = f(mat3(vModelTangent.xyz, vModelBiTangent, vModelNormal));\n  vTangentViewPos = Q * cameraPosition;\n  vTangentFragPos = Q * vModelVertex;\n#endif\n#ifdef HAS_VERTEX_COLOR\nvertexColor_update();\n#endif\n#ifdef HAS_EXCAVATE_ANALYSIS\nvCoordinateTexcoord = getCoordinateTexcoord();\n  vHeight = getWorldHeight();\n#endif\n#endif\n}",
                frag: t.frag || "#define PI 3.141593\n#define RECIPROCAL_PI 1.0\n#if __VERSION__ == 100\n#if defined(GL_EXT_shader_texture_lod)\n#extension GL_EXT_shader_texture_lod : enable\n#define textureCubeLod(tex, uv, lod) textureCubeLodEXT(tex, uv, lod)\n#else\n#define textureCubeLod(tex, uv, lod) textureCube(tex, uv, lod)\n#endif\n#if defined(GL_OES_standard_derivatives)\n#extension GL_OES_standard_derivatives : enable\n#endif\n#else\n#define textureCubeLod(tex, uv, lod) textureLod(tex, uv, lod)\n#endif\n#define saturate(x)        clamp(x, 0.0, 1.0)\nprecision mediump float;\n#include <gl2_frag>\n#include <hsv_frag>\n#include <srgb_frag>\nuniform vec3 hsv;\nuniform float contrast;\nstruct MaterialUniforms {\n  vec2 roughnessMetalness;\n  vec3 albedo;\n  float alpha;\n  vec3 normal;\n  vec3 emit;\n  float ao;\n  vec3 specularColor;\n  float glossiness;\n  vec4 skinColor;\n} c;\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_frag>\n#endif\nuniform vec3 cameraPosition;\nuniform float alphaTest;\n#if defined(SHADING_MODEL_SPECULAR_GLOSSINESS)\nuniform vec4 diffuseFactor;\nuniform vec3 specularFactor;\nuniform float glossinessFactor;\n#if defined(HAS_DIFFUSE_MAP)\nuniform sampler2D diffuseTexture;\n#endif\n#if defined(HAS_SPECULARGLOSSINESS_MAP)\nuniform sampler2D specularGlossinessTexture;\n#endif\n#endif\nuniform vec3 emissiveFactor;\nuniform vec4 baseColorFactor;\nuniform float baseColorIntensity;\nuniform float emitColorFactor;\nuniform float occlusionFactor;\nuniform float environmentExposure;\nuniform float roughnessFactor;\nuniform float metallicFactor;\nuniform float normalMapFactor;\nuniform float specularF0;\nuniform int emitMultiplicative;\nuniform int normalMapFlipY;\nuniform int outputSRGB;\nuniform mat3 environmentTransform;\n#if defined(HAS_ALBEDO_MAP)\nuniform sampler2D baseColorTexture;\n#endif\n#if defined(HAS_METALLICROUGHNESS_MAP)\nuniform sampler2D metallicRoughnessTexture;\n#endif\n#if defined(HAS_EMISSIVE_MAP)\nuniform sampler2D emissiveTexture;\n#endif\n#if defined(HAS_AO_MAP)\nuniform sampler2D occlusionTexture;\nvarying vec2 vTexCoord1;\n#endif\n#if defined(HAS_NORMAL_MAP) && defined(HAS_TANGENT)\nuniform sampler2D normalTexture;\n#endif\n#if defined(HAS_SKIN_MAP)\nuniform sampler2D skinTexture;\n#endif\n#if defined(ALPHA_MODE) && ALPHA_MODE == 1\nuniform float alphaCutoff;\n#endif\n#ifdef HAS_RANDOM_TEX\nuniform highp vec2 uvOrigin;\nuniform sampler2D noiseTexture;\n#endif\nuniform sampler2D brdfLUT;\n#if defined(HAS_IBL_LIGHTING)\nuniform vec3 hdrHSV;\nuniform samplerCube prefilterMap;\nuniform vec3 diffuseSPH[9];\nuniform vec2 prefilterMiplevel;\nuniform vec2 prefilterSize;\n#else\nuniform vec3 ambientColor;\n#endif\nuniform vec2 cameraNearFar;\nuniform vec3 light0_viewDirection;\nuniform vec4 light0_diffuse;\n#ifdef HAS_SSR\nvarying vec3 vViewNormal;\n#if defined(HAS_TANGENT)\nvarying vec4 vViewTangent;\n#endif\n#endif\nvarying vec3 vModelVertex;\nvarying vec4 vViewVertex;\n#if defined(HAS_MAP)\n#include <computeTexcoord_frag>\n#endif\nvarying vec3 vModelNormal;\n#if defined(HAS_TANGENT)\nvarying vec4 vModelTangent;\nvarying vec3 vModelBiTangent;\n#endif\n#if defined(HAS_COLOR0)\n#if COLOR0_SIZE == 3\nvarying vec3 vColor0;\n#else\nvarying vec4 vColor0;\n#endif\n#endif\n#if defined(HAS_COLOR)\nvarying vec4 vColor;\n#elif defined(IS_LINE_EXTRUSION)\nuniform vec4 lineColor;\n#else\nuniform vec4 polygonFill;\n#endif\n#ifdef HAS_LAYER_OPACITY\nuniform float layerOpacity;\n#endif\nvarying float vOpacity;\n#ifdef HAS_INSTANCE_COLOR\nvarying vec4 vInstanceColor;\n#endif\n#ifdef IS_LINE_EXTRUSION\nuniform float lineOpacity;\n#else\nuniform float polygonOpacity;\n#endif\n#ifdef HAS_PATTERN\nuniform sampler2D linePatternFile;\nuniform vec2 atlasSize;\nuniform float flipY;\nuniform float currentTime;\nuniform float animSpeedScale;\n#ifdef HAS_PATTERN_ANIM\nvarying float vLinePatternAnimSpeed;\n#else\nuniform float linePatternAnimSpeed;\n#endif\n#ifdef HAS_PATTERN_GAP\nvarying float vLinePatternGap;\n#else\nuniform float linePatternGap;\n#endif\nuniform vec4 linePatternGapColor;\nuniform vec2 uvScale;\nvarying float vPatternHeight;\nvarying float vLinesofar;\nvarying vec4 vTexInfo;\nvarying float vNormalY;\nvec2 d(vec2 e) {\n  vec2 f = mod(e, 1.);\n  vec2 h = vTexInfo.xy;\n  vec2 i = vTexInfo.zw;\n  return (h + f * i) / atlasSize;\n}\n#endif\n#include <heatmap_render_frag>\n#include <snow_frag>\n#include <mask_frag>\n#include <terrain_normal_frag>\n#include <vertex_color_frag>\n#include <excavate_frag>\n#ifdef HAS_RANDOM_TEX\nconst float j = .5;\nvec2 k(vec2 f, float l) {\n  return vec2(cos(l) * (f.x - j) + sin(l) * (f.y - j) + j, cos(l) * (f.y - j) - sin(l) * (f.x - j) + j);\n}\nfloat m(vec3 n) {\n  return n.x + n.y + n.z;\n}\n#endif\nvec4 o(sampler2D u, in vec2 f) {\n  \n#ifdef HAS_RANDOM_TEX\nhighp vec2 A = uvOrigin;\n  highp vec2 B = f + A - mod(A, 1.);\n  float C = texture2D(noiseTexture, .005 * B).x;\n  vec2 D = dFdx(B);\n  vec2 E = dFdx(B);\n  float F = C * 8.;\n  float G = fract(F);\n#if 1\nfloat H = floor(F);\n  float I = H + 1.;\n#else\nfloat H = floor(F + .5);\n  float I = floor(F);\n  G = min(G, 1. - G) * 2.;\n#endif\nvec2 J = sin(vec2(3., 7.) * H);\n  vec2 K = sin(vec2(3., 7.) * I);\n  float L = .5;\n  vec4 M = texture2DGradEXT(u, f + L * J, D, E);\n  vec4 N = texture2DGradEXT(u, f + L * K, D, E);\n  return mix(M, N, smoothstep(.2, .8, G - .1 * m(M.xyz - N.xyz)));\n#else\nreturn texture2D(u, f);\n#endif\n}\n#if defined(HAS_BUMP_MAP) && defined(HAS_TANGENT)\nuniform sampler2D bumpTexture;\nuniform float bumpScale;\nuniform float bumpMaxLayers;\nuniform float bumpMinLayers;\nvec2 O(vec2 f, vec3 P) {\n  float Q = mix(bumpMaxLayers, bumpMinLayers, abs(dot(vec3(.0, .0, 1.), P)));\n  float R = 1. / Q;\n  float S = .0;\n  vec2 T = P.xy * bumpScale / (P.z * Q);\n  vec2 U = f;\n  float V = o(bumpTexture, U).r;\n  for(int W = 0; W < 30; W++) {\n    S += R;\n    U -= T;\n    V = o(bumpTexture, U).r;\n    if(V < S) {\n      break;\n    }\n  }\n  vec2 X = U + T;\n  float Y = V - S;\n  float Z = o(bumpTexture, X).r - S + R;\n  return mix(U, X, Y / (Y - Z));\n}\nvarying vec3 vTangentViewPos;\nvarying vec3 vTangentFragPos;\n#endif\n#define SHADER_NAME PBR\nvec3 ba() {\n  return c.albedo;\n}\nfloat bb() {\n  return c.alpha;\n}\nfloat bc() {\n  return c.roughnessMetalness.y;\n}\nfloat bd() {\n  \n#if defined(SHADING_MODEL_SPECULAR_GLOSSINESS)\nreturn 1. - c.glossiness;\n#else\nreturn c.roughnessMetalness.x;\n#endif\n}\nvec3 be() {\n  return c.emit;\n}\nvec4 bf() {\n  return c.skinColor;\n}\nvec3 bg() {\n  return c.normal;\n}\nfloat bh() {\n  return c.ao;\n}\nfloat bi(const in vec4 bj) {\n  return bj.r + bj.g / 255.;\n}\nvec3 bk(const in float bl, in vec3 bm, const in vec3 t, const in vec3 b, in vec3 bn) {\n  bm.xy = bl * bm.xy;\n  mat3 bo = mat3(t, b, bn);\n  return normalize(bo * bm);\n}\nfloat bp(const float bq, const vec3 bm, const vec3 br) {\n  float bs = clamp(dot(bm, br), 0., 1.);\n  float a = bq * bq;\n  float bt = a * a;\n  float bu = (bs * bt - bs) * bs + 1.;\n  return bt / (PI * bu * bu);\n}\nvec3 bv(const vec3 bw, const float bx, const in vec3 by, const in vec3 br) {\n  float bz = clamp(dot(by, br), 0., 1.);\n  bz = pow(1. - bz, 5.);\n  return bx * bz + (1. - bz) * bw;\n}\nfloat bA(const in vec3 bm, const in vec3 bB, const in float bq, const float bC) {\n  float bD = clamp(dot(bm, bB), 0., 1.);\n  float a = bq * bq;\n  float bE = bD * (bC * (1. - a) + a);\n  float bF = bC * (bD * (1. - a) + a);\n  return .5 / (bF + bE);\n}\nvec3 bG(const float bq, const vec3 bm, const vec3 bB, const vec3 by, const vec3 bH, const float bC, const float bx) {\n  vec3 br = normalize(bB + by);\n  float bI = bp(bq, bm, br);\n  float bJ = bA(bm, bB, bq, bC);\n  vec3 bK = bv(bH, bx, by, br);\n  return (bI * bJ * PI) * bK;\n}\nvec3 bL(const in vec3 bM) {\n  return RECIPROCAL_PI * bM;\n}\nvoid bN(const in vec3 bm, const in vec3 bB, const in float bC, const in float bq, const in vec3 bO, const in vec3 bH, const in vec3 bP, const in vec3 by, const in float bx, out vec3 bQ, out vec3 bR) {\n  if(bC <= .0) {\n    bR = bQ = vec3(.0);\n    return;\n  }\n  vec3 a = bC * bP;\n  vec3 bS = bG(bq, bm, bB, by, bH, bC, bx);\n  bR = a * bS;\n  bQ = a * bL(bO);\n}\n#if defined(HAS_IBL_LIGHTING)\nvec3 bT(const in vec3 bm) {\n  vec3 bn = environmentTransform * bm;\n  float x = bn.x;\n  float y = bn.y;\n  float z = bn.z;\n  vec3 bU = (diffuseSPH[0] + diffuseSPH[1] * x + diffuseSPH[2] * y + diffuseSPH[3] * z + diffuseSPH[4] * z * x + diffuseSPH[5] * y * z + diffuseSPH[6] * y * x + diffuseSPH[7] * (3. * z * z - 1.) + diffuseSPH[8] * (x * x - y * y));\n  if(length(hdrHSV) > .0) {\n    bU = hsv_apply(bU, hdrHSV);\n  }\n  return max(bU, vec3(.0));\n}\nvec3 bV(const in float bq, const in vec3 bW) {\n  vec3 bX = bW;\n  float bY = prefilterMiplevel.x;\n  float bZ = min(bY, bq * prefilterMiplevel.y);\n  vec3 ca = textureCubeLod(prefilterMap, bX, bZ).rgb;\n  if(length(hdrHSV) > .0) {\n    return hsv_apply(ca, hdrHSV);\n  } else {\n    return ca;\n  }\n}\nvec3 cb(const in vec3 cc, const in vec3 bB, const in float bq, const in vec3 cd, const in vec3 bO) {\n  float ce = 1. - bq;\n  vec3 bW = mix(cc, reflect(-bB, cc), ce * (sqrt(ce) + bq));\n  float bl = clamp(1. + dot(bW, cd), .0, 1.);\n  vec3 cf = bV(bq, environmentTransform * bW) * bl * bl;\n  return cf;\n}\n#else\nvec3 cb(const in vec3 bm, const in vec3 cg, const in float bq, const in vec3 cd, const in vec3 bO) {\n  return ambientColor * bL(bO);\n}\n#endif\nvec3 ch(const in vec3 ci, const in float bq, const in float bD, const in float bx) {\n  vec4 rgba = texture2D(brdfLUT, vec2(bD, bq)) * vec4(255., 65280.0, 255., 65280.0);\n  float b = (rgba[3] + rgba[2]);\n  float a = (rgba[1] + rgba[0]);\n  return (ci * a + b * bx) / 65535.;\n}\nvec3 cj(const in vec3 bm, const in vec3 cg, const in float bD, const in float bq, const in vec3 bH, const in vec3 cd, const in float bx, const in vec3 bO) {\n  return cb(bm, cg, bq, cd, bO) * ch(bH, bq, bD, bx);\n}\nfloat ck(const in float cl, const in float bD) {\n  float bu = bD + cl;\n  return clamp(bu * bu - 1. + cl, .0, 1.);\n}\nvoid cm() {\n  \n#ifdef HAS_MAP\nvec2 f = computeTexCoord(vTexCoord);\n#endif\n#ifdef HAS_UV_FLIP\nf.y = 1. - f.y;\n#endif\n#if defined(HAS_BUMP_MAP) && defined(HAS_TANGENT)\nf = O(f, normalize(vTangentViewPos - vTangentFragPos));\n#endif\nc.albedo = baseColorIntensity * baseColorFactor.rgb;\n  c.alpha = baseColorFactor.a * vOpacity;\n#if defined(HAS_PATTERN)\nfloat cn = vLinesofar;\n  vec2 i = vTexInfo.zw;\n#ifdef HAS_PATTERN_GAP\nfloat co = vLinePatternGap;\n#else\nfloat co = linePatternGap;\n#endif\n#ifdef HAS_PATTERN_ANIM\nfloat cp = vLinePatternAnimSpeed;\n#else\nfloat cp = linePatternAnimSpeed;\n#endif\nfloat cq = ceil(i.x * vPatternHeight / i.y);\n  float cr = cq * (1. + co);\n  cp /= animSpeedScale;\n  cn += mod(currentTime * -cp * .2, cr);\n  float cs = mod(cn / cr, 1.);\n  float ct = mod(flipY * vNormalY, 1.);\n  vec2 f = d(vec2(cs * (1. + co) * uvScale[0], ct * uvScale[1]));\n  vec4 cu = texture2D(linePatternFile, f);\n  float cv = clamp(sign(1. / (1. + co) - cs) + .000001, .0, 1.);\n  cu = mix(linePatternGapColor, cu, cv);\n#ifdef IS_SQUARE_TUBE\nfloat n = clamp(sign(abs(vNormalY) - .999999), .0, 1.);\n  cu = mix(cu, vec4(1.), n);\n#endif\nc.albedo *= cu.rgb;\n  c.alpha *= cu.a;\n#endif\n#if defined(HAS_ALBEDO_MAP)\nvec4 cw = o(baseColorTexture, f);\n  c.albedo *= sRGBToLinear(cw.rgb);\n  c.alpha *= cw.a;\n#endif\n#if defined(HAS_SKIN_MAP)\nvec4 cx = o(skinTexture, f);\n  c.skinColor = cx;\n#endif\n#if defined(HAS_COLOR0)\nc.albedo *= vColor0.rgb;\n#if COLOR0_SIZE == 4\nc.alpha *= vColor0.a;\n#endif\n#endif\n#if defined(HAS_COLOR)\nc.albedo *= vColor.rgb;\n  c.alpha *= vColor.a;\n#elif defined(IS_LINE_EXTRUSION)\nc.albedo *= lineColor.rgb;\n  c.alpha *= lineColor.a;\n#else\nc.albedo *= polygonFill.rgb;\n  c.alpha *= polygonFill.a;\n#endif\n#if defined(HAS_INSTANCE_COLOR)\nc.albedo *= vInstanceColor.rgb;\n  c.alpha *= vInstanceColor.a;\n#endif\n#if defined(HAS_METALLICROUGHNESS_MAP)\nc.roughnessMetalness = o(metallicRoughnessTexture, f).gb * vec2(roughnessFactor, metallicFactor);\n#else\nc.roughnessMetalness = vec2(roughnessFactor, metallicFactor);\n#endif\nc.emit = emissiveFactor;\n#if defined(HAS_EMISSIVE_MAP)\nif(emitMultiplicative == 1) {\n    c.emit *= sRGBToLinear(o(emissiveTexture, f).rgb);\n  } else {\n    c.emit += sRGBToLinear(o(emissiveTexture, f).rgb);\n  }\n#endif\nc.emit *= emitColorFactor;\n#if defined(HAS_AO_MAP)\nvec2 cy = computeTexCoord(vTexCoord1);\n  c.ao = o(occlusionTexture, cy).r;\n#else\nc.ao = 1.;\n#endif\nc.ao *= occlusionFactor;\n#if defined(HAS_NORMAL_MAP) && defined(HAS_TANGENT)\nvec3 cz = o(normalTexture, f).xyz * 2. - 1.;\n  cz.y = normalMapFlipY == 1 ? -cz.y : cz.y;\n  c.normal = cz;\n#else\nc.normal = normalize(vModelNormal);\n#endif\n#if defined(HAS_TERRAIN_NORMAL) && defined(HAS_TANGENT)\nvec3 cz = convertTerrainHeightToNormalMap(f);\n  cz.y = normalMapFlipY == 1 ? -cz.y : cz.y;\n  c.normal = cz;\n#endif\n#if defined(SHADING_MODEL_SPECULAR_GLOSSINESS)\nc.albedo *= diffuseFactor.rgb;\n  c.alpha *= diffuseFactor.a;\n#if defined(HAS_DIFFUSE_MAP)\nvec4 cA = o(diffuseTexture, f);\n  c.albedo *= sRGBToLinear(cA.rgb);\n  c.alpha *= cA.a;\n#endif\nc.specularColor = specularFactor;\n  c.glossiness = glossinessFactor;\n#if defined(HAS_SPECULARGLOSSINESS_MAP)\nvec4 cB = o(specularGlossinessTexture, f);\n  c.specularColor *= sRGBToLinear(cB.rgb);\n  c.glossiness *= cB.a;\n#endif\n#endif\n}\nvec3 cC(const vec3 x) {\n  const float a = 2.51;\n  const float b = .03;\n  const float cD = 2.43;\n  const float bu = .59;\n  const float cE = .14;\n  return (x * (a * x + b)) / (x * (cD * x + bu) + cE);\n}\nvec3 cF(vec3 cG) {\n  cG = cC(cG);\n  return cG = pow(cG, vec3(1. / 2.2));\n}\nuniform float specularAAVariance;\nuniform float specularAAThreshold;\nfloat cH(float bq, const vec3 cI) {\n  \n#if defined(GL_OES_standard_derivatives) || __VERSION__ == 300\nvec3 cJ = dFdx(cI);\n  vec3 cK = dFdy(cI);\n  float cL = specularAAVariance * (dot(cJ, cJ) + dot(cK, cK));\n  float cM = min(2. * cL, specularAAThreshold);\n  float cN = saturate(bq * bq + cM);\n  return sqrt(cN);\n#else\nreturn bq;\n#endif\n}\n#ifdef HAS_SSR\nuniform sampler2D TextureDepth;\nuniform highp vec2 outSize;\nuniform float ssrFactor;\nuniform float ssrQuality;\nuniform sampler2D TextureReflected;\nuniform highp mat4 projMatrix;\nuniform mat4 invProjMatrix;\nuniform vec4 outputFovInfo[2];\nuniform mat4 reprojViewProjMatrix;\nvec3 cO(const in mat4 cP, const in vec3 cQ) {\n  vec4 cR = cP * vec4(cQ, 1.);\n  return vec3(.5 + .5 * cR.xy / cR.w, cR.w);\n}\nvec3 cS(const in float cT, const in vec2 f) {\n  return texture2D(TextureReflected, f).rgb;\n}\nfloat cU(float cV) {\n  highp mat4 cP = projMatrix;\n  highp float z = cV * 2. - 1.;\n  return -cP[3].z / (z + cP[2].z);\n}\nfloat cW(const vec2 f) {\n  float cV = bi(texture2D(TextureDepth, f));\n  return cV;\n}\nfloat cX(const in vec2 cY, const in float cZ) {\n  vec3 da = vec3(.06711056, .00583715, 52.9829189);\n  return fract(da.z * fract(dot(cY.xy + cZ * vec2(47., 17.) * .695, da.xy))) * .5;\n}\nvec3 db(const in float cZ, const in vec3 dc, const in vec3 dd, const in vec3 de, const in vec3 cg, const in float df) {\n  vec2 dg;\n  dg.x = cX(gl_FragCoord.yx, cZ);\n  dg.y = fract(dg.x * 52.9829189);\n  dg.y = mix(dg.y, 1., .7);\n  float dh = 2. * 3.14159 * dg.x;\n  float di = pow(max(dg.y, .000001), df / (2. - df));\n  float dj = sqrt(1. - di * di);\n  vec3 dk = vec3(dj * cos(dh), dj * sin(dh), di);\n  dk = dk.x * dc + dk.y * dd + dk.z * de;\n  return normalize((2. * dot(cg, dk)) * dk - cg);\n}\nfloat dl(const in float cZ) {\n  return (cX(gl_FragCoord.xy, cZ) - .5);\n}\nvec3 dm(const in vec3 dn, const in float dp, const in vec3 dq) {\n  vec3 dr = cO(projMatrix, vViewVertex.xyz + dq * dp);\n  dr.z = 1. / dr.z;\n  dr -= dn;\n  float ds = min(1., .99 * (1. - dn.x) / max(1e-5, dr.x));\n  float dt = min(1., .99 * (1. - dn.y) / max(1e-5, dr.y));\n  float dw = min(1., .99 * dn.x / max(1e-5, -dr.x));\n  float dx = min(1., .99 * dn.y / max(1e-5, -dr.y));\n  return dr * min(ds, dt) * min(dw, dx);\n}\nfloat dy(const in vec3 dn, const in vec3 dr, inout float dz, inout float dA) {\n  float dB = (dA + dz) * .5;\n  vec3 dC = dn + dr * dB;\n  float z = cW(dC.xy);\n  float cV = cU(z);\n  float dD = -1. / dC.z;\n  dz = cV > dD ? dz : dB;\n  dA = cV > dD ? dB : dA;\n  return dB;\n}\nvec4 dE(const in vec3 dn, const in float dp, in float dF, const in vec3 dq, const in float bq, const in float cZ) {\n  int dG = 20;\n  float dH = 1. / float(dG);\n  dF *= dH;\n  vec3 dr = dm(dn, dp, dq);\n  float dI = dH;\n  vec3 dJ = vec3(.0, dI, 1.);\n  vec3 dC;\n  float z, cV, dD, dK, dL, dM;\n  bool dN;\n  float dO = 1.;\n  float dB;\n  for(int W = 0; W < dG; W++) {\n    dC = dn + dr * dJ.y;\n    z = cW(dC.xy);\n    cV = cU(z);\n    dD = -1. / dC.z;\n    float dP = clamp(sign(.999 - z), .0, 1.);\n    dK = dP * (dD - cV);\n    dK *= clamp(sign(abs(dK) - dp * dH * dH), .0, 1.);\n    dN = abs(dK + dF) < dF;\n    dL = clamp(dJ.x / (dJ.x - dK), .0, 1.);\n    dM = dN ? dJ.y + dL * dH - dH : 1.;\n    dJ.z = min(dJ.z, dM);\n    dJ.x = dK;\n    if(dN) {\n      float dz = dJ.y - dH;\n      float dA = dJ.y;\n      dB = dy(dn, dr, dz, dA);\n      dB = dy(dn, dr, dz, dA);\n      dB = dy(dn, dr, dz, dA);\n      dO = dB;\n      break;\n    }\n    dJ.y += dH;\n  }\n  return vec4(dn + dr * dO, 1. - dO);\n}\nvec4 dQ(in vec4 dR, const in float dS, const in vec3 dT, const in vec3 dU, const in float bq) {\n  vec4 dV = mix(outputFovInfo[0], outputFovInfo[1], dR.x);\n  dR.xyz = vec3(mix(dV.xy, dV.zw, dR.y), 1.) * -1. / dR.z;\n  dR.xyz = (reprojViewProjMatrix * vec4(dR.xyz, 1.)).xyw;\n  dR.xy /= dR.z;\n  float dW = clamp(6. - 6. * max(abs(dR.x), abs(dR.y)), .0, 1.);\n  dR.xy = .5 + .5 * dR.xy;\n  vec3 dX = dU * cS(bq * (1. - dR.w), dR.xy);\n  return vec4(mix(dT, dX, dS * dW), 1.);\n}\nvec3 ssr(const in vec3 dT, const in vec3 dU, const in float bq, const in vec3 bm, const in vec3 cg) {\n  float dY = .0;\n  vec4 bU = vec4(.0);\n  float df = bq * bq;\n  df = df * df;\n  vec3 dZ = abs(bm.z) < .999 ? vec3(.0, .0, 1.) : vec3(1., .0, .0);\n  vec3 dc = normalize(cross(dZ, bm));\n  vec3 dd = cross(bm, dc);\n  float dS = ssrFactor * clamp(-4. * dot(cg, bm) + 3.8, .0, 1.);\n  dS *= clamp(4.7 - bq * 5., .0, 1.);\n  vec3 dn = cO(projMatrix, vViewVertex.xyz);\n  dn.z = 1. / dn.z;\n  vec3 dq = db(dY, dc, dd, bm, cg, df);\n  float dp = mix(cameraNearFar.y + vViewVertex.z, -vViewVertex.z - cameraNearFar.x, dq.z * .5 + .5);\n  float dF = .5 * dp;\n  vec4 dR;\n  if(dot(dq, bm) > .001 && dS > .0) {\n    dR = dE(dn, dp, dF, dq, bq, dY);\n    if(dR.w > .0)\n      bU += dQ(dR, dS, dT, dU, bq);\n    \n  }\n  return bU.w > .0 ? bU.rgb / bU.w : dT;\n}\n#endif\n#include <highlight_frag>\nvec4 ea(in vec4 eb) {\n  return vec4(mix(pow(eb.rgb, vec3(.41666)) * 1.055 - vec3(.055), eb.rgb * 12.92, vec3(lessThanEqual(eb.rgb, vec3(.0031308)))), eb.a);\n}\nvec4 ec(vec4 eb) {\n  return (ea(eb));\n}\nvoid main() {\n  cm();\n  vec3 cg = normalize(cameraPosition - vModelVertex.xyz);\n#if defined(HAS_DOUBLE_SIDE)\nvec3 cd = gl_FrontFacing ? normalize(vModelNormal) : -normalize(vModelNormal);\n#else\nvec3 cd = normalize(vModelNormal);\n#endif\n#if defined(HAS_TANGENT)\nvec4 ed;\n  ed = vModelTangent;\n#if defined(HAS_DOUBLE_SIDE)\ned.xyz = gl_FrontFacing ? normalize(ed.xyz) : -normalize(ed.xyz);\n#else\ned.xyz = normalize(ed.xyz);\n#endif\nvec3 ee = normalize(vModelBiTangent);\n#endif\nfloat bw = .08 * specularF0;\n  float ef = bc();\n  vec3 bO = ba();\n#if defined(SHADING_MODEL_SPECULAR_GLOSSINESS)\nvec3 eg = c.specularColor;\n#else\nvec3 eg = mix(vec3(bw), bO, ef);\n#endif\nbO *= 1. - ef;\n  float eh = clamp(50.0 * eg.g, .0, 1.);\n  float ei = bd();\n  if(specularAAVariance > .0) {\n    ei = cH(ei, cd);\n  }\n  vec3 ej = be();\n  vec3 ek = bg();\n  vec3 el = vec3(ek);\n#if defined(HAS_TANGENT) && (defined(HAS_NORMAL_MAP) || defined(HAS_TERRAIN_NORMAL))\nel = bk(normalMapFactor, el, ed.xyz, ee, cd);\n#endif\nvec3 cA = vec3(.0);\n  vec3 bH = vec3(.0);\n#if defined(HAS_IBL_LIGHTING)\ncA = bO * bT(el) * .5;\n#else\ncA = bO * ambientColor;\n#endif\nfloat bD = dot(el, cg);\n  bH = cj(el, cg, bD, ei, eg, cd, eh, bO);\n  float em;\n  float en = 1.;\n  float eo = bh();\n  cA *= environmentExposure * eo;\n#ifdef HAS_IBL_LIGHTING\nen = ck(eo, bD);\n#endif\n#ifdef HAS_SSR\nvec3 ep = normalize(gl_FrontFacing ? vViewNormal : -vViewNormal);\n  vec3 eq = ep;\n#if defined(HAS_TANGENT) && (defined(HAS_NORMAL_MAP) || defined(HAS_TERRAIN_NORMAL))\nvec4 er;\n  er = vViewTangent;\n  er = gl_FrontFacing ? er : -er;\n  er.xyz = normalize(er.xyz);\n  vec3 es = normalize(cross(ep, er.xyz)) * er.w;\n  eq = bk(normalMapFactor, ek, er.xyz, es, ep);\n#endif\nbH = ssr(bH, eg * en, ei, eq, -normalize(vViewVertex.xyz));\n#endif\nbH *= environmentExposure * en;\n  vec3 et, eu;\n  vec3 ev = vModelNormal;\n  vec3 ew = -light0_viewDirection;\n  float ex = saturate(dot(ew, el));\n  bN(el, cg, ex, max(.045, ei), bO, eg, light0_diffuse.rgb, ew, eh, eu, et);\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nfloat ey = shadow_computeShadow();\n  eu = shadow_blend(eu, ey).rgb;\n  et = shadow_blend(et, ey).rgb;\n#endif\ncA += eu;\n  bH += et;\n  cA += ej;\n  vec3 ez = bH + cA;\n  if(outputSRGB == 1)\n    ez = linearTosRGB(ez);\n  \n#ifdef HAS_SKIN_MAP\nvec4 eA = bf();\n  ez.rgb = ez.rgb * (1. - eA.a) + eA.rgb * eA.a;\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nez.rgb = shadow_blend(ez.rgb, ey).rgb;\n#endif\n#endif\nfloat eB = bb();\n  if(eB < alphaTest) {\n    discard;\n  }\n#if defined(ALPHA_MODE)\n#if ALPHA_MODE == 1\nif(eB < alphaCutoff) {\n    discard;\n  } else {\n    eB = 1.;\n  }\n#else\neB = 1.;\n#endif\n#endif\n#if defined(IS_LINE_EXTRUSION)\neB *= lineOpacity;\n#else\neB *= polygonOpacity;\n#endif\nglFragColor = vec4(ez * eB, eB);\n#ifdef HAS_VERTEX_COLOR\nglFragColor *= vertexColor_get();\n#endif\n#ifdef HAS_EXCAVATE_ANALYSIS\nglFragColor = excavateColor(glFragColor);\n#endif\n#ifdef HAS_HEATMAP\nglFragColor = heatmap_getColor(glFragColor);\n#endif\n#ifdef HAS_SNOW\nglFragColor.rgb = snow(glFragColor, bg(), 1.);\n#endif\nif(contrast != 1.) {\n    glFragColor = contrastMatrix(contrast) * glFragColor;\n  }\n  if(length(hsv) > .0) {\n    glFragColor = hsv_apply(glFragColor, hsv);\n  }\n#ifdef OUTPUT_NORMAL\nglFragColor = vec4(cd, 1.);\n#endif\nglFragColor = highlight_blendColor(glFragColor);\n#ifdef HAS_LAYER_OPACITY\nglFragColor *= layerOpacity;\n#endif\n#ifdef HAS_MASK_EXTENT\nglFragColor = setMask(glFragColor);\n#endif\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}",
                uniforms: d,
                extraCommandProps: n,
                defines: o
            }), this.version = 300;
        }
        getGeometryDefines(e) {
            const t = {};
            return e.data[e.desc.tangentAttribute] ? t.HAS_TANGENT = 1 : e.data[e.desc.normalAttribute] && (t.HAS_NORMAL = 1), 
            e.data[e.desc.colorAttribute] && (t.HAS_COLOR = 1), e.data[e.desc.color0Attribute] && (t.HAS_COLOR0 = 1, 
            t.COLOR0_SIZE = e.getColor0Size()), t;
        }
    },
    StandardDepthShader: class extends yt {
        constructor(t = {}) {
            const n = [];
            super({
                vert: "#define SHADER_NAME depth_vert\nprecision highp float;\nattribute vec3 aPosition;\n#include <line_extrusion_vert>\nuniform mat4 modelViewMatrix;\nuniform mat4 positionMatrix;\nuniform mat4 projMatrix;\nuniform vec2 outSize;\nuniform vec2 halton;\n#include <get_output>\nvoid main() {\n  mat4 c = getPositionMatrix();\n#ifdef IS_LINE_EXTRUSION\nvec4 d = getPosition(getLineExtrudePosition(aPosition));\n#else\nvec4 d = getPosition(aPosition);\n#endif\nvec4 e = modelViewMatrix * c * d;\n  mat4 f = projMatrix;\n  f[2].xy += halton.xy / outSize.xy;\n  gl_Position = f * e;\n}",
                frag: "#define SHADER_NAME depth_frag\nprecision highp float;\nvoid main() {\n  gl_FragColor = vec4(1., .0, .0, 1.);\n}",
                uniforms: [ {
                    name: "modelViewMatrix",
                    type: "function",
                    fn: (t, r) => e.multiply(n, r.viewMatrix, r.modelMatrix)
                } ],
                extraCommandProps: t.extraCommandProps,
                defines: t.defines
            });
        }
    },
    PBRUtils: gr
}, _i = function(e, t, n = 2) {
    const r = t && t.length, i = r ? t[0] * n : e.length;
    let o = Ur(e, 0, i, n, !0);
    const a = [];
    if (!o || o.next === o.prev) return a;
    let s, c, l;
    if (r && (o = function(e, t, n, r) {
        const i = [];
        for (let n = 0, o = t.length; n < o; n++) {
            const a = Ur(e, t[n] * r, n < o - 1 ? t[n + 1] * r : e.length, r, !1);
            a === a.next && (a.steiner = !0), i.push(ei(a));
        }
        i.sort(Yr);
        for (let e = 0; e < i.length; e++) n = Zr(i[e], n);
        return n;
    }(e, t, o, n)), e.length > 80 * n) {
        s = 1 / 0, c = 1 / 0;
        let t = -1 / 0, r = -1 / 0;
        for (let o = n; o < i; o += n) {
            const n = e[o], i = e[o + 1];
            n < s && (s = n), i < c && (c = i), n > t && (t = n), i > r && (r = i);
        }
        l = Math.max(t - s, r - c), l = 0 !== l ? 32767 / l : 0;
    }
    return Xr(o, a, n, s, c, l, 0), a;
};

_i.flatten = function(e) {
    const t = [], n = [], r = e[0][0].length;
    let i = 0, o = 0;
    for (const a of e) {
        for (const e of a) for (let n = 0; n < r; n++) t.push(e[n]);
        o && (i += o, n.push(i)), o = a.length;
    }
    return {
        vertices: t,
        holes: n,
        dimensions: r
    };
};

export { G as AbstractTexture, Lt as BloomPass, j as BoundingBox, wt as BoxBlurShader, k as Constants, Wt as CopyShader, Se as EdgeGeometry, qt as EdgeShader, dn as ExtentPass, Hr as FBORayPicking, Qt as FogPass, en as FogShader, Pt as FxaaShader, Fn as GLTFHelper, Un as GLTFManager, Z as Geometry, mi as HDR, jt as HeatmapDisplayShader, zt as HeatmapShader, ze as InstancedMesh, Ft as Jitter, Vr as KHRTechniquesWebglManager, Ce as Material, Be as Mesh, yt as MeshShader, Ie as PhongMaterial, St as PhongShader, Ne as PhongSpecularGlossinessMaterial, lt as Plane, Tt as PointLineShader, It as PostProcessShader, Et as QuadShader, ve as REGLHelper, cn as RainRipplesPass, Ve as Renderer, Xe as ResourceLoader, mn as ScanEffectPass, Zt as ScanEffectShader, Ze as Scene, pt as Shader, dt as ShaderLib, Sr as ShadowDisplayShader, xr as ShadowMapShader, Ar as ShadowPass, Ut as SkyboxShader, Bt as SsrPass, De as StandardLiteMaterial, Yt as StandardLiteShader, ct as Texture2D, F as Util, Xt as WaterShader, Pe as WireFrameMaterial, At as WireframeShader, _i as earcut, vi as pbr };
//# sourceMappingURL=reshadergl.es.js.map
